/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * SportSchool API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '../custom-instance';
/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type AccountDeletionStatusResponseBalance = number | string;

export type AccountDeletionStatusResponseBlockReason = null | string;

export interface AccountDeletionStatusResponse {
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  balance: AccountDeletionStatusResponseBalance;
  hasOverdueBalance: boolean;
  hasOverpayment: boolean;
  canDelete: boolean;
  blockReason: AccountDeletionStatusResponseBlockReason;
  hasPassword: boolean;
  isGoogleUser: boolean;
  confirmationType: string;
}

export type AddExternalMediaRequestTitle = null | string;

export type AddExternalMediaRequestDescription = null | string;

export type AddExternalMediaRequestVirtualFolder = null | string;

export interface AddExternalMediaRequest {
  externalUrl: string;
  title: AddExternalMediaRequestTitle;
  description: AddExternalMediaRequestDescription;
  virtualFolder: AddExternalMediaRequestVirtualFolder;
}

export interface AddTournamentStaffRequest {
  memberId: string;
}

export type AdminAddCampParticipantRequestPriceOptionId = null | string;

export type AdminAddCampParticipantRequestAddonIds = null | string[];

export type AdminAddCampParticipantRequestDiet = null | string;

export type AdminAddCampParticipantRequestRoomMatePreference = null | string;

export type AdminAddCampParticipantRequestNotes = null | string;

export type AdminAddCampParticipantRequestGuardianName = null | string;

export type AdminAddCampParticipantRequestGuardianPhone = null | string;

export interface AdminAddCampParticipantRequest {
  memberId: string;
  priceOptionId: AdminAddCampParticipantRequestPriceOptionId;
  addonIds: AdminAddCampParticipantRequestAddonIds;
  medicalClearanceDeclared: boolean;
  diet: AdminAddCampParticipantRequestDiet;
  roomMatePreference: AdminAddCampParticipantRequestRoomMatePreference;
  notes: AdminAddCampParticipantRequestNotes;
  guardianName: AdminAddCampParticipantRequestGuardianName;
  guardianPhone: AdminAddCampParticipantRequestGuardianPhone;
  overrideCapacity: boolean;
}

export type AdminMakeUpCreditResponseRedeemedForSessionId = null | string;

export type AdminMakeUpCreditResponseRedeemedForSessionTitle = null | string;

export type AdminMakeUpCreditResponseRedeemedForSessionStartsAt = null | string;

export interface AdminMakeUpCreditResponse {
  id: string;
  studentMemberId: string;
  studentFirstName: string;
  studentLastName: string;
  studentEmail: string;
  status: CreditStatus;
  issuedAt: string;
  expiresAt: string;
  redeemedForSessionId: AdminMakeUpCreditResponseRedeemedForSessionId;
  redeemedForSessionTitle?: AdminMakeUpCreditResponseRedeemedForSessionTitle;
  redeemedForSessionStartsAt?: AdminMakeUpCreditResponseRedeemedForSessionStartsAt;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type AdminSubscriptionListItemStudentBalance = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type AdminSubscriptionListItemDuration = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type AdminSubscriptionListItemSubscriptionAmount = number | string;

export type AdminSubscriptionListItemResignationDate = null | string;

export type AdminSubscriptionListItemLastGeneratedBillDate = null | string;

export type AdminSubscriptionListItemLastGeneratedBillMonth = null | string;

export interface AdminSubscriptionListItem {
  subscriptionId: string;
  studentMemberId: string;
  studentFirstName: string;
  studentLastName: string;
  studentEmail: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  studentBalance: AdminSubscriptionListItemStudentBalance;
  scheduleId: string;
  groupName: string;
  dayOfWeek: DayOfWeek;
  startTime: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  duration: AdminSubscriptionListItemDuration;
  coachName: string;
  locationName: string;
  registrationDate: string;
  subscriptionStart: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  subscriptionAmount: AdminSubscriptionListItemSubscriptionAmount;
  resignationDate: AdminSubscriptionListItemResignationDate;
  status: SubscriptionStatus;
  isCorporate?: boolean;
  lastGeneratedBillDate?: AdminSubscriptionListItemLastGeneratedBillDate;
  lastGeneratedBillMonth?: AdminSubscriptionListItemLastGeneratedBillMonth;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type AgingBucketAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type AgingBucketCount = number | string;

export interface AgingBucket {
  key: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: AgingBucketAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  count: AgingBucketCount;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type AppliedCouponDetailDtoDiscountAmount = number | string;

export interface AppliedCouponDetailDto {
  couponId: string;
  code: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  discountAmount: AppliedCouponDetailDtoDiscountAmount;
  couponType: CouponType;
}

export interface AssignTournamentGroupEntriesRequest {
  assignments: TournamentGroupEntryAssignment[];
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type AttachmentResponseSize = number | string;

export type AttachmentResponseTitle = null | string;

export type AttachmentResponseAltText = null | string;

export type AttachmentResponseDescription = null | string;

export type AttachmentResponseExternalUrl = null | string;

export type AttachmentResponseVirtualFolder = null | string;

export interface AttachmentResponse {
  id: string;
  schoolId: string;
  fileName: string;
  contentType: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  size: AttachmentResponseSize;
  publicUrl: string;
  createdAt: string;
  title?: AttachmentResponseTitle;
  altText?: AttachmentResponseAltText;
  description?: AttachmentResponseDescription;
  mediaType?: MediaType;
  externalUrl?: AttachmentResponseExternalUrl;
  virtualFolder?: AttachmentResponseVirtualFolder;
}

export type AttachmentUsageItemDate = null | string;

export interface AttachmentUsageItem {
  kind: AttachmentUsageKind;
  entityId: string;
  name: string;
  date?: AttachmentUsageItemDate;
}

export type AttachmentUsageKind = typeof AttachmentUsageKind[keyof typeof AttachmentUsageKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttachmentUsageKind = {
  SchoolLogo: 'SchoolLogo',
  SchoolInstruction: 'SchoolInstruction',
  Promo: 'Promo',
  ScheduleBanner: 'ScheduleBanner',
  SessionBanner: 'SessionBanner',
  EmailTemplate: 'EmailTemplate',
  MailingCampaign: 'MailingCampaign',
  NotificationTemplate: 'NotificationTemplate',
  Regulation: 'Regulation',
  MemberPhoto: 'MemberPhoto',
  LocationDescription: 'LocationDescription',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type AttachmentUsagesResponseSessionCount = number | string;

export interface AttachmentUsagesResponse {
  items: AttachmentUsageItem[];
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sessionCount: AttachmentUsagesResponseSessionCount;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type AttendancePointPresent = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type AttendancePointAbsent = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type AttendancePointOccupancy = null | number | string;

export interface AttendancePoint {
  period: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  present: AttendancePointPresent;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  absent: AttendancePointAbsent;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  occupancy: AttendancePointOccupancy;
}

export type AttendanceResponseConfirmedAt = null | string;

export interface AttendanceResponse {
  id: string;
  enrollmentId: string;
  studentMemberId: string;
  status: AttendanceStatus;
  markedAt: string;
  confirmedAt: AttendanceResponseConfirmedAt;
}

export type AttendanceStatus = typeof AttendanceStatus[keyof typeof AttendanceStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttendanceStatus = {
  Present: 'Present',
  Absent: 'Absent',
  NoShow: 'NoShow',
} as const;

export type AttendanceSyncEntryStatus = null | AttendanceStatus;

export interface AttendanceSyncEntry {
  enrollmentId: string;
  status: AttendanceSyncEntryStatus;
  markedAt: string;
}

export type AttendanceSyncOutcome = typeof AttendanceSyncOutcome[keyof typeof AttendanceSyncOutcome];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttendanceSyncOutcome = {
  Applied: 'Applied',
  Stale: 'Stale',
  Rejected: 'Rejected',
} as const;

export type AttendanceSyncResultErrorCode = null | string;

export type AttendanceSyncResultAttendance = null | AttendanceResponse;

export interface AttendanceSyncResult {
  enrollmentId: string;
  outcome: AttendanceSyncOutcome;
  errorCode: AttendanceSyncResultErrorCode;
  attendance: AttendanceSyncResultAttendance;
}

export type AvailableCampResponseSummary = null | string;

export type AvailableCampResponseBannerUrl = null | string;

export interface AvailableCampResponse {
  id: string;
  name: string;
  slug: string;
  summary: AvailableCampResponseSummary;
  bannerUrl: AvailableCampResponseBannerUrl;
  startsAt: string;
  endsAt: string;
  venueName: string;
  registrationState: CampRegistrationState;
  myParticipants: MyCampParticipantResponse[];
  paymentInstructions: CampPaymentInstructionsResponse;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type BillingAdminMetricsResponseTotalPaid = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type BillingAdminMetricsResponseTotalCharged = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BillingAdminMetricsResponseUnpaidBillsCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type BillingAdminMetricsResponseUnpaidAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BillingAdminMetricsResponseTotalBillsCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BillingAdminMetricsResponseTotalPaymentsCount = number | string;

export interface BillingAdminMetricsResponse {
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalPaid: BillingAdminMetricsResponseTotalPaid;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalCharged: BillingAdminMetricsResponseTotalCharged;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  unpaidBillsCount: BillingAdminMetricsResponseUnpaidBillsCount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  unpaidAmount: BillingAdminMetricsResponseUnpaidAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  totalBillsCount: BillingAdminMetricsResponseTotalBillsCount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  totalPaymentsCount: BillingAdminMetricsResponseTotalPaymentsCount;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type BillingCollectionPointBilled = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type BillingCollectionPointCollected = number | string;

export interface BillingCollectionPoint {
  month: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  billed: BillingCollectionPointBilled;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  collected: BillingCollectionPointCollected;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type BillResponseAmount = number | string;

export type BillResponseDueDate = null | string;

export type BillResponseEnrollmentId = null | string;

export type BillResponseMonthlySubscriptionId = null | string;

export type BillResponsePaymentId = null | string;

export type BillResponseSessionId = null | string;

export type BillResponseScheduleId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type BillResponsePaidAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type BillResponseRemainingAmount = number | string;

export type BillResponsePayments = null | PaymentResponse[];

export type BillResponseStudentName = null | string;

export type BillResponseBillingMonth = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type BillResponseUnitPrice = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BillResponseSessionCount = null | number | string;

export type BillResponseOriginalBillId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type BillResponseUnitEquipmentSurcharge = null | number | string;

export interface BillResponse {
  id: string;
  schoolId: string;
  studentMemberId: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: BillResponseAmount;
  description: string;
  status: BillStatus;
  createdAt: string;
  dueDate?: BillResponseDueDate;
  enrollmentId?: BillResponseEnrollmentId;
  monthlySubscriptionId?: BillResponseMonthlySubscriptionId;
  paymentId?: BillResponsePaymentId;
  sessionId?: BillResponseSessionId;
  scheduleId?: BillResponseScheduleId;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  paidAmount?: BillResponsePaidAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  remainingAmount?: BillResponseRemainingAmount;
  payments?: BillResponsePayments;
  studentName?: BillResponseStudentName;
  type?: BillType;
  billingMonth?: BillResponseBillingMonth;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  unitPrice?: BillResponseUnitPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sessionCount?: BillResponseSessionCount;
  originalBillId?: BillResponseOriginalBillId;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  unitEquipmentSurcharge?: BillResponseUnitEquipmentSurcharge;
}

export type BillStatus = typeof BillStatus[keyof typeof BillStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BillStatus = {
  Pending: 'Pending',
  PartiallyPaid: 'PartiallyPaid',
  Paid: 'Paid',
  Cancelled: 'Cancelled',
} as const;

export type BillType = typeof BillType[keyof typeof BillType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BillType = {
  MonthlySubscription: 'MonthlySubscription',
  SingleSession: 'SingleSession',
  CourseFee: 'CourseFee',
  Other: 'Other',
  Correction: 'Correction',
  Camp: 'Camp',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardAmericanoStandingsRowPosition = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardAmericanoStandingsRowPlayed = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardAmericanoStandingsRowWon = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardAmericanoStandingsRowDrawn = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardAmericanoStandingsRowLost = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardAmericanoStandingsRowPointsWon = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardAmericanoStandingsRowPointsLost = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardAmericanoStandingsRowByes = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardAmericanoStandingsRowByeScore = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardAmericanoStandingsRowScore = number | string;

export interface BoardAmericanoStandingsRow {
  entryId: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  position: BoardAmericanoStandingsRowPosition;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  played: BoardAmericanoStandingsRowPlayed;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  won: BoardAmericanoStandingsRowWon;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  drawn: BoardAmericanoStandingsRowDrawn;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  lost: BoardAmericanoStandingsRowLost;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pointsWon: BoardAmericanoStandingsRowPointsWon;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pointsLost: BoardAmericanoStandingsRowPointsLost;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  byes: BoardAmericanoStandingsRowByes;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  byeScore: BoardAmericanoStandingsRowByeScore;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  score: BoardAmericanoStandingsRowScore;
}

export type BoardCategoryShortName = null | string;

export type BoardCategoryColor = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardCategorySortOrder = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardCategoryRubbersToWin = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardCategoryQualifiersPerGroup = number | string;

export interface BoardCategory {
  id: string;
  name: string;
  shortName: BoardCategoryShortName;
  color: BoardCategoryColor;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sortOrder: BoardCategorySortOrder;
  format: TournamentFormat;
  entryType: TournamentEntryType;
  status: TournamentCategoryStatus;
  matchFormat: TournamentMatchFormat;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  rubbersToWin: BoardCategoryRubbersToWin;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  qualifiersPerGroup: BoardCategoryQualifiersPerGroup;
  americanoSettings: TournamentAmericanoSettings;
  entries: BoardEntry[];
  groups: BoardGroup[];
  matches: BoardMatch[];
  finalRanking: BoardRankingRow[];
  americanoStandings: BoardAmericanoStandingsRow[];
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardCourtNumber = number | string;

export type BoardCourtCurrentGameId = null | string;

export interface BoardCourt {
  id: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  number: BoardCourtNumber;
  name: string;
  isActive: boolean;
  currentGameId: BoardCourtCurrentGameId;
}

export type BoardEntryClubName = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardEntrySeed = null | number | string;

export type BoardEntryGroupId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardEntryGroupSlot = null | number | string;

export interface BoardEntry {
  id: string;
  displayName: string;
  clubName: BoardEntryClubName;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  seed: BoardEntrySeed;
  groupId: BoardEntryGroupId;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  groupSlot: BoardEntryGroupSlot;
  status: TournamentEntryStatus;
  players: BoardEntryPlayer[];
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardEntryPlayerRacketNumber = number | string;

export interface BoardEntryPlayer {
  playerId: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  racketNumber: BoardEntryPlayerRacketNumber;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardGameOrder = number | string;

export type BoardGameHomePlayer1Id = null | string;

export type BoardGameHomePlayer2Id = null | string;

export type BoardGameAwayPlayer1Id = null | string;

export type BoardGameAwayPlayer2Id = null | string;

export type BoardGameWinner = null | TournamentSide;

export type BoardGameCourtId = null | string;

export type BoardGameCalledAt = null | string;

export type BoardGameStartedAt = null | string;

export type BoardGameFinishedAt = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardGameQueueOrder = number | string;

export type BoardGameEstimatedStartAt = null | string;

export type BoardGameEstimatedCourtId = null | string;

export type BoardGamePlannedSlotStart = null | string;

export interface BoardGame {
  id: string;
  matchId: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  order: BoardGameOrder;
  kind: TournamentGameKind;
  label: string;
  homePlayer1Id: BoardGameHomePlayer1Id;
  homePlayer2Id: BoardGameHomePlayer2Id;
  awayPlayer1Id: BoardGameAwayPlayer1Id;
  awayPlayer2Id: BoardGameAwayPlayer2Id;
  sets: TournamentSetScore[];
  status: TournamentGameStatus;
  winner: BoardGameWinner;
  courtId: BoardGameCourtId;
  calledAt: BoardGameCalledAt;
  startedAt: BoardGameStartedAt;
  finishedAt: BoardGameFinishedAt;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  queueOrder: BoardGameQueueOrder;
  estimatedStartAt: BoardGameEstimatedStartAt;
  estimatedCourtId: BoardGameEstimatedCourtId;
  plannedSlotStart: BoardGamePlannedSlotStart;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardGroupSortOrder = number | string;

export interface BoardGroup {
  id: string;
  name: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sortOrder: BoardGroupSortOrder;
  isLocked: boolean;
  isComplete: boolean;
  hasUnresolvedTie: boolean;
  standings: BoardStandingsRow[];
}

export type BoardMatchGroupId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardMatchRound = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardMatchBracketRound = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardMatchBracketSlot = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardMatchPlacementFrom = null | number | string;

export type BoardMatchHomeEntryId = null | string;

export type BoardMatchAwayEntryId = null | string;

export type BoardMatchHomeSource = null | BoardSlotSource;

export type BoardMatchAwaySource = null | BoardSlotSource;

export type BoardMatchWinner = null | TournamentSide;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardMatchHomeRubbers = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardMatchAwayRubbers = number | string;

export type BoardMatchAllowedCourtIds = null | string[];

export interface BoardMatch {
  id: string;
  stage: TournamentMatchStage;
  groupId: BoardMatchGroupId;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  round: BoardMatchRound;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  bracketRound: BoardMatchBracketRound;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  bracketSlot: BoardMatchBracketSlot;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  placementFrom: BoardMatchPlacementFrom;
  homeEntryId: BoardMatchHomeEntryId;
  awayEntryId: BoardMatchAwayEntryId;
  homeSource: BoardMatchHomeSource;
  awaySource: BoardMatchAwaySource;
  status: TournamentMatchStatus;
  winner: BoardMatchWinner;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  homeRubbers: BoardMatchHomeRubbers;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  awayRubbers: BoardMatchAwayRubbers;
  allowedCourtIds: BoardMatchAllowedCourtIds;
  games: BoardGame[];
}

export type BoardPlayerClubName = null | string;

export interface BoardPlayer {
  id: string;
  name: string;
  clubName: BoardPlayerClubName;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardRankingRowPlace = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardRankingRowPlaceTo = null | number | string;

export interface BoardRankingRow {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  place: BoardRankingRowPlace;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  placeTo: BoardRankingRowPlaceTo;
  entryId: string;
}

export type BoardSlotSourceGroupId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardSlotSourcePosition = null | number | string;

export type BoardSlotSourceMatchId = null | string;

export interface BoardSlotSource {
  kind: SlotSourceKind;
  groupId: BoardSlotSourceGroupId;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  position: BoardSlotSourcePosition;
  matchId: BoardSlotSourceMatchId;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardStandingsRowPosition = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardStandingsRowPlayed = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardStandingsRowWon = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardStandingsRowLost = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardStandingsRowMatchPoints = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardStandingsRowRubbersWon = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardStandingsRowRubbersLost = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardStandingsRowSetsWon = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardStandingsRowSetsLost = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardStandingsRowPointsWon = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type BoardStandingsRowPointsLost = number | string;

export interface BoardStandingsRow {
  entryId: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  position: BoardStandingsRowPosition;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  played: BoardStandingsRowPlayed;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  won: BoardStandingsRowWon;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  lost: BoardStandingsRowLost;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  matchPoints: BoardStandingsRowMatchPoints;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  rubbersWon: BoardStandingsRowRubbersWon;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  rubbersLost: BoardStandingsRowRubbersLost;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  setsWon: BoardStandingsRowSetsWon;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  setsLost: BoardStandingsRowSetsLost;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pointsWon: BoardStandingsRowPointsWon;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pointsLost: BoardStandingsRowPointsLost;
  tieUnresolved: boolean;
}

export interface BoardTimeBlock {
  id: string;
  name: string;
  startsAt: string;
  endsAt: string;
  courtIds: string[];
}

export type BookingApprovalStatus = typeof BookingApprovalStatus[keyof typeof BookingApprovalStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BookingApprovalStatus = {
  NotRequired: 'NotRequired',
  Pending: 'Pending',
  Approved: 'Approved',
  Rejected: 'Rejected',
  Expired: 'Expired',
} as const;

export interface BulkMarkAttendanceRequest {
  entries: AttendanceSyncEntry[];
}

export interface BulkTransferStudentGroupRequest {
  studentMemberIds: string[];
  targetScheduleId: string;
  allowOverbooking?: boolean;
}

export type CallTournamentGameRequestCourtId = null | string;

export interface CallTournamentGameRequest {
  courtId: CallTournamentGameRequestCourtId;
}

export type CampAddonApprovalStatus = typeof CampAddonApprovalStatus[keyof typeof CampAddonApprovalStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampAddonApprovalStatus = {
  NotRequired: 'NotRequired',
  Pending: 'Pending',
  Approved: 'Approved',
  Rejected: 'Rejected',
} as const;

export type CampAddonResponseDescription = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampAddonResponsePrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampAddonResponseCapacity = null | number | string;

export interface CampAddonResponse {
  id: string;
  name: string;
  description: CampAddonResponseDescription;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  price: CampAddonResponsePrice;
  unit: CampAddonUnit;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  capacity: CampAddonResponseCapacity;
  requiresApproval: boolean;
  priceOnRequest: boolean;
}

export type CampAddonUnit = typeof CampAddonUnit[keyof typeof CampAddonUnit];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampAddonUnit = {
  PerStay: 'PerStay',
  PerNight: 'PerNight',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampAddonUsageResponseCapacity = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampAddonUsageResponseUsed = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampAddonUsageResponsePendingApproval = number | string;

export interface CampAddonUsageResponse {
  addonId: string;
  name: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  capacity: CampAddonUsageResponseCapacity;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  used: CampAddonUsageResponseUsed;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pendingApproval: CampAddonUsageResponsePendingApproval;
}

export type CampBillKind = typeof CampBillKind[keyof typeof CampBillKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampBillKind = {
  Deposit: 'Deposit',
  Balance: 'Balance',
  Full: 'Full',
  LateFee: 'LateFee',
  Correction: 'Correction',
  Replaced: 'Replaced',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampBillResponseAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampBillResponsePaidAmount = number | string;

export type CampBillResponseDueDate = null | string;

export interface CampBillResponse {
  billId: string;
  kind: CampBillKind;
  title: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: CampBillResponseAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  paidAmount: CampBillResponsePaidAmount;
  status: BillStatus;
  dueDate: CampBillResponseDueDate;
}

export type CampCancellationResponsePayerEmail = null | string;

export type CampCancellationResponseCancellationRequestedAt = null | string;

export type CampCancellationResponsePreferredRefundMethod = null | CampRefundMethod;

export type CampCancellationResponseRefundBankAccount = null | string;

export type CampCancellationResponseCancellationNote = null | string;

export type CampCancellationResponseCancelledAt = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampCancellationResponseRefundAmount = null | number | string;

export type CampCancellationResponseRefundMethod = null | CampRefundMethod;

export interface CampCancellationResponse {
  participantId: string;
  firstName: string;
  lastName: string;
  payerName: string;
  payerEmail: CampCancellationResponsePayerEmail;
  status: CampParticipantStatus;
  cancellationRequestedAt: CampCancellationResponseCancellationRequestedAt;
  preferredRefundMethod: CampCancellationResponsePreferredRefundMethod;
  refundBankAccount: CampCancellationResponseRefundBankAccount;
  cancellationNote: CampCancellationResponseCancellationNote;
  refundPreview: CampRefundPreviewResponse;
  hasOnlinePayment: boolean;
  cancelledAt: CampCancellationResponseCancelledAt;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  refundAmount: CampCancellationResponseRefundAmount;
  refundMethod: CampCancellationResponseRefundMethod;
}

export type CampDeclaredPaymentMethod = typeof CampDeclaredPaymentMethod[keyof typeof CampDeclaredPaymentMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampDeclaredPaymentMethod = {
  BankTransfer: 'BankTransfer',
  Blik: 'Blik',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampParticipantAddonResponseQuantity = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampParticipantAddonResponsePrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampParticipantAddonResponseTotal = number | string;

export interface CampParticipantAddonResponse {
  addonId: string;
  name: string;
  unit: CampAddonUnit;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  quantity: CampParticipantAddonResponseQuantity;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  price: CampParticipantAddonResponsePrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  total: CampParticipantAddonResponseTotal;
  priceOnRequest: boolean;
  approvalStatus: CampAddonApprovalStatus;
}

export type CampParticipantExportFormat = typeof CampParticipantExportFormat[keyof typeof CampParticipantExportFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampParticipantExportFormat = {
  Xlsx: 'Xlsx',
  Csv: 'Csv',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampParticipantListResponseCapacity = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampParticipantListResponsePlacesTaken = number | string;

export interface CampParticipantListResponse {
  items: CampParticipantResponse[];
  statusCounts: CampParticipantStatusCountResponse[];
  addonUsage: CampAddonUsageResponse[];
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  capacity: CampParticipantListResponseCapacity;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  placesTaken: CampParticipantListResponsePlacesTaken;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampParticipantPaymentsResponseTotalPrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampParticipantPaymentsResponsePaidAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampParticipantPaymentsResponseRemainingAmount = number | string;

export type CampParticipantPaymentsResponsePendingDeclaration = null | CampPaymentDeclarationSummaryResponse;

export interface CampParticipantPaymentsResponse {
  participantId: string;
  firstName: string;
  lastName: string;
  payerName: string;
  status: CampParticipantStatus;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalPrice: CampParticipantPaymentsResponseTotalPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  paidAmount: CampParticipantPaymentsResponsePaidAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  remainingAmount: CampParticipantPaymentsResponseRemainingAmount;
  bills: CampBillResponse[];
  pendingDeclaration: CampParticipantPaymentsResponsePendingDeclaration;
}

export type CampParticipantResponseEmail = null | string;

export type CampParticipantResponsePhoneNumber = null | string;

export type CampParticipantResponseDateOfBirth = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampParticipantResponseAge = null | number | string;

export type CampParticipantResponsePayerEmail = null | string;

export type CampParticipantResponsePayerPhone = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampParticipantResponseWaitlistPosition = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampParticipantResponseCampPrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampParticipantResponseTotalPrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampParticipantResponseDepositAmount = number | string;

export type CampParticipantResponseBalanceDueDateOverride = null | string;

export type CampParticipantResponseDiet = null | string;

export type CampParticipantResponseRoomMatePreference = null | string;

export type CampParticipantResponseNotes = null | string;

export type CampParticipantResponseGuardianName = null | string;

export type CampParticipantResponseGuardianPhone = null | string;

export type CampParticipantResponseRegistrationNotes = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampParticipantResponseTermsVersion = null | number | string;

export type CampParticipantResponseRemovedAt = null | string;

export type CampParticipantResponseRemovedReason = null | CampRemovalReason;

export type CampParticipantResponseRestoredAt = null | string;

export type CampParticipantResponseOfferSentAt = null | string;

export type CampParticipantResponseOfferExpiresAt = null | string;

export interface CampParticipantResponse {
  id: string;
  registrationId: string;
  memberId: string;
  firstName: string;
  lastName: string;
  email: CampParticipantResponseEmail;
  phoneNumber: CampParticipantResponsePhoneNumber;
  dateOfBirth: CampParticipantResponseDateOfBirth;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  age: CampParticipantResponseAge;
  payerMemberId: string;
  payerName: string;
  payerEmail: CampParticipantResponsePayerEmail;
  payerPhone: CampParticipantResponsePayerPhone;
  status: CampParticipantStatus;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  waitlistPosition: CampParticipantResponseWaitlistPosition;
  priceOptionId: string;
  priceOptionName: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  campPrice: CampParticipantResponseCampPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalPrice: CampParticipantResponseTotalPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  depositAmount: CampParticipantResponseDepositAmount;
  balanceDueDateOverride: CampParticipantResponseBalanceDueDateOverride;
  addons: CampParticipantAddonResponse[];
  medicalClearanceDeclared: boolean;
  diet: CampParticipantResponseDiet;
  roomMatePreference: CampParticipantResponseRoomMatePreference;
  notes: CampParticipantResponseNotes;
  guardianName: CampParticipantResponseGuardianName;
  guardianPhone: CampParticipantResponseGuardianPhone;
  registrationNotes: CampParticipantResponseRegistrationNotes;
  submittedAt: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  termsVersion: CampParticipantResponseTermsVersion;
  createdByAdmin: boolean;
  removedAt: CampParticipantResponseRemovedAt;
  removedReason: CampParticipantResponseRemovedReason;
  restoredAt: CampParticipantResponseRestoredAt;
  offerSentAt: CampParticipantResponseOfferSentAt;
  offerExpiresAt: CampParticipantResponseOfferExpiresAt;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampParticipantStateResponseWaitlistPosition = null | number | string;

export type CampParticipantStateResponseOfferExpiresAt = null | string;

export interface CampParticipantStateResponse {
  participantId: string;
  status: CampParticipantStatus;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  waitlistPosition: CampParticipantStateResponseWaitlistPosition;
  offerExpiresAt: CampParticipantStateResponseOfferExpiresAt;
}

export type CampParticipantStatus = typeof CampParticipantStatus[keyof typeof CampParticipantStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampParticipantStatus = {
  Waitlisted: 'Waitlisted',
  PendingDeposit: 'PendingDeposit',
  Confirmed: 'Confirmed',
  Paid: 'Paid',
  Cancelled: 'Cancelled',
  Removed: 'Removed',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampParticipantStatusCountResponseCount = number | string;

export interface CampParticipantStatusCountResponse {
  status: CampParticipantStatus;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  count: CampParticipantStatusCountResponseCount;
}

export type CampPayerResponseDateOfBirth = null | string;

export interface CampPayerResponse {
  memberId: string;
  firstName: string;
  lastName: string;
  dateOfBirth: CampPayerResponseDateOfBirth;
}

export type CampPaymentDeclarationResponsePayerEmail = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampPaymentDeclarationResponseAmount = number | string;

export type CampPaymentDeclarationResponseReviewedAt = null | string;

export type CampPaymentDeclarationResponseRejectionReason = null | string;

export interface CampPaymentDeclarationResponse {
  id: string;
  participantId: string;
  participantName: string;
  payerName: string;
  payerEmail: CampPaymentDeclarationResponsePayerEmail;
  billId: string;
  billTitle: string;
  method: CampDeclaredPaymentMethod;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: CampPaymentDeclarationResponseAmount;
  paidOn: string;
  declaredAt: string;
  status: CampPaymentDeclarationStatus;
  reviewedAt: CampPaymentDeclarationResponseReviewedAt;
  rejectionReason: CampPaymentDeclarationResponseRejectionReason;
}

export type CampPaymentDeclarationStatus = typeof CampPaymentDeclarationStatus[keyof typeof CampPaymentDeclarationStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampPaymentDeclarationStatus = {
  Pending: 'Pending',
  Confirmed: 'Confirmed',
  Rejected: 'Rejected',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampPaymentDeclarationSummaryResponseAmount = number | string;

export type CampPaymentDeclarationSummaryResponseRejectionReason = null | string;

export interface CampPaymentDeclarationSummaryResponse {
  id: string;
  billId: string;
  method: CampDeclaredPaymentMethod;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: CampPaymentDeclarationSummaryResponseAmount;
  paidOn: string;
  declaredAt: string;
  status: CampPaymentDeclarationStatus;
  rejectionReason: CampPaymentDeclarationSummaryResponseRejectionReason;
}

export type CampPaymentInstructionsResponseRecipientName = null | string;

export type CampPaymentInstructionsResponseBankName = null | string;

export type CampPaymentInstructionsResponseAccountNumber = null | string;

export type CampPaymentInstructionsResponseBlikPhoneNumber = null | string;

export interface CampPaymentInstructionsResponse {
  allowOnlinePayment: boolean;
  allowBankTransfer: boolean;
  allowBlik: boolean;
  recipientName: CampPaymentInstructionsResponseRecipientName;
  bankName: CampPaymentInstructionsResponseBankName;
  accountNumber: CampPaymentInstructionsResponseAccountNumber;
  blikPhoneNumber: CampPaymentInstructionsResponseBlikPhoneNumber;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampPaymentsResponseTotalPaid = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampPaymentsResponseTotalRemaining = number | string;

export interface CampPaymentsResponse {
  declarations: CampPaymentDeclarationResponse[];
  participants: CampParticipantPaymentsResponse[];
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalPaid: CampPaymentsResponseTotalPaid;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalRemaining: CampPaymentsResponseTotalRemaining;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampPriceOptionResponseMinAge = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampPriceOptionResponseMaxAge = null | number | string;

export interface CampPriceOptionResponse {
  id: string;
  name: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  minAge: CampPriceOptionResponseMinAge;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxAge: CampPriceOptionResponseMaxAge;
  tiers: CampPriceTierResponse[];
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampPriceTierResponsePrice = number | string;

export type CampPriceTierResponseValidUntil = null | string;

export interface CampPriceTierResponse {
  id: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  price: CampPriceTierResponsePrice;
  validUntil: CampPriceTierResponseValidUntil;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampQuoteAddonResponseQuantity = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampQuoteAddonResponseUnitPrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampQuoteAddonResponseTotal = number | string;

export interface CampQuoteAddonResponse {
  addonId: string;
  name: string;
  unit: CampAddonUnit;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  quantity: CampQuoteAddonResponseQuantity;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  unitPrice: CampQuoteAddonResponseUnitPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  total: CampQuoteAddonResponseTotal;
  priceOnRequest: boolean;
  requiresApproval: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampQuoteParticipantResponseAge = null | number | string;

export type CampQuoteParticipantResponseTierValidUntil = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampQuoteParticipantResponseCampPrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampQuoteParticipantResponseTotal = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampQuoteParticipantResponseDeposit = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampQuoteParticipantResponseBalance = number | string;

export interface CampQuoteParticipantResponse {
  memberId: string;
  firstName: string;
  lastName: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  age: CampQuoteParticipantResponseAge;
  isMinor: boolean;
  priceOptionId: string;
  priceOptionName: string;
  eligiblePriceOptionIds: string[];
  tierId: string;
  tierValidUntil: CampQuoteParticipantResponseTierValidUntil;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  campPrice: CampQuoteParticipantResponseCampPrice;
  addons: CampQuoteAddonResponse[];
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  total: CampQuoteParticipantResponseTotal;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  deposit: CampQuoteParticipantResponseDeposit;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  balance: CampQuoteParticipantResponseBalance;
  waitlisted: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampQuoteResponseTotal = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampQuoteResponseDeposit = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampQuoteResponseBalance = number | string;

export type CampQuoteResponseBalanceDueDate = null | string;

export interface CampQuoteResponse {
  participants: CampQuoteParticipantResponse[];
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  total: CampQuoteResponseTotal;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  deposit: CampQuoteResponseDeposit;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  balance: CampQuoteResponseBalance;
  payInFull: boolean;
  depositDueDate: string;
  balanceDueDate: CampQuoteResponseBalanceDueDate;
  guardianRequired: boolean;
  medicalDeclarationRequired: boolean;
}

export type CampRefundBasis = typeof CampRefundBasis[keyof typeof CampRefundBasis];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampRefundBasis = {
  PaidAmount: 'PaidAmount',
  CampPrice: 'CampPrice',
} as const;

export type CampRefundMethod = typeof CampRefundMethod[keyof typeof CampRefundMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampRefundMethod = {
  Gateway: 'Gateway',
  BankTransfer: 'BankTransfer',
  Blik: 'Blik',
  StudentBalance: 'StudentBalance',
  None: 'None',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampRefundPreviewResponseDaysBeforeStart = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampRefundPreviewResponsePaidAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampRefundPreviewResponseSuggestedAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampRefundPreviewResponseRuleMinDaysBeforeStart = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampRefundPreviewResponseRuleRefundPercent = null | number | string;

export type CampRefundPreviewResponseRuleBasis = null | CampRefundBasis;

export type CampRefundPreviewResponseRuleDeductDeposit = null | boolean;

export interface CampRefundPreviewResponse {
  participantId: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  daysBeforeStart: CampRefundPreviewResponseDaysBeforeStart;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  paidAmount: CampRefundPreviewResponsePaidAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  suggestedAmount: CampRefundPreviewResponseSuggestedAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  ruleMinDaysBeforeStart: CampRefundPreviewResponseRuleMinDaysBeforeStart;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  ruleRefundPercent: CampRefundPreviewResponseRuleRefundPercent;
  ruleBasis: CampRefundPreviewResponseRuleBasis;
  ruleDeductDeposit: CampRefundPreviewResponseRuleDeductDeposit;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampRefundRuleResponseMinDaysBeforeStart = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampRefundRuleResponseRefundPercent = number | string;

export interface CampRefundRuleResponse {
  id: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  minDaysBeforeStart: CampRefundRuleResponseMinDaysBeforeStart;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  refundPercent: CampRefundRuleResponseRefundPercent;
  basis: CampRefundBasis;
  deductDeposit: boolean;
}

export type CampRegistrationAddonResponseDescription = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampRegistrationAddonResponsePrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampRegistrationAddonResponseCapacity = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampRegistrationAddonResponsePlacesLeft = null | number | string;

export interface CampRegistrationAddonResponse {
  id: string;
  name: string;
  description: CampRegistrationAddonResponseDescription;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  price: CampRegistrationAddonResponsePrice;
  unit: CampAddonUnit;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  capacity: CampRegistrationAddonResponseCapacity;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  placesLeft: CampRegistrationAddonResponsePlacesLeft;
  requiresApproval: boolean;
  priceOnRequest: boolean;
}

export type CampRegistrationPageResponseSummary = null | string;

export type CampRegistrationPageResponseDescription = null | string;

export type CampRegistrationPageResponseBannerUrl = null | string;

export type CampRegistrationPageResponseWebsiteUrl = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampRegistrationPageResponseNights = number | string;

export type CampRegistrationPageResponseArrivalInfo = null | string;

export type CampRegistrationPageResponseDepartureInfo = null | string;

export type CampRegistrationPageResponseVenueAddress = null | string;

export type CampRegistrationPageResponseContactName = null | string;

export type CampRegistrationPageResponseContactEmail = null | string;

export type CampRegistrationPageResponseContactPhone = null | string;

export type CampRegistrationPageResponseRegistrationOpensAt = null | string;

export type CampRegistrationPageResponseRegistrationClosesAt = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampRegistrationPageResponseCapacity = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampRegistrationPageResponsePlacesLeft = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampRegistrationPageResponseMinAge = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampRegistrationPageResponseDepositAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampRegistrationPageResponseDepositDueDays = number | string;

export type CampRegistrationPageResponseBalanceDueDate = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampRegistrationPageResponseLateFeePercent = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampRegistrationPageResponseLateFeeGraceDays = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampRegistrationPageResponseTermsVersion = null | number | string;

export type CampRegistrationPageResponseTermsPublishedAt = null | string;

export type CampRegistrationPageResponseTermsContent = null | string;

export interface CampRegistrationPageResponse {
  id: string;
  name: string;
  slug: string;
  summary: CampRegistrationPageResponseSummary;
  description: CampRegistrationPageResponseDescription;
  bannerUrl: CampRegistrationPageResponseBannerUrl;
  websiteUrl: CampRegistrationPageResponseWebsiteUrl;
  startsAt: string;
  endsAt: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  nights: CampRegistrationPageResponseNights;
  arrivalInfo: CampRegistrationPageResponseArrivalInfo;
  departureInfo: CampRegistrationPageResponseDepartureInfo;
  venueName: string;
  venueAddress: CampRegistrationPageResponseVenueAddress;
  contactName: CampRegistrationPageResponseContactName;
  contactEmail: CampRegistrationPageResponseContactEmail;
  contactPhone: CampRegistrationPageResponseContactPhone;
  registrationState: CampRegistrationState;
  registrationOpensAt: CampRegistrationPageResponseRegistrationOpensAt;
  registrationClosesAt: CampRegistrationPageResponseRegistrationClosesAt;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  capacity: CampRegistrationPageResponseCapacity;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  placesLeft: CampRegistrationPageResponsePlacesLeft;
  waitlistOnly: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  minAge: CampRegistrationPageResponseMinAge;
  minorsRequireGuardian: boolean;
  requiresMedicalClearance: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  depositAmount: CampRegistrationPageResponseDepositAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  depositDueDays: CampRegistrationPageResponseDepositDueDays;
  depositRefundable: boolean;
  balanceDueDate: CampRegistrationPageResponseBalanceDueDate;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  lateFeePercent: CampRegistrationPageResponseLateFeePercent;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  lateFeeGraceDays: CampRegistrationPageResponseLateFeeGraceDays;
  allowOnlinePayment: boolean;
  allowBankTransfer: boolean;
  allowBlik: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  termsVersion: CampRegistrationPageResponseTermsVersion;
  termsPublishedAt: CampRegistrationPageResponseTermsPublishedAt;
  termsContent: CampRegistrationPageResponseTermsContent;
  priceOptions: CampPriceOptionResponse[];
  addons: CampRegistrationAddonResponse[];
  refundRules: CampRefundRuleResponse[];
  payer: CampPayerResponse;
  myParticipants: MyCampParticipantResponse[];
  paymentInstructions: CampPaymentInstructionsResponse;
}

export type CampRegistrationParticipantRequestPriceOptionId = null | string;

export type CampRegistrationParticipantRequestAddonIds = null | string[];

export type CampRegistrationParticipantRequestDiet = null | string;

export type CampRegistrationParticipantRequestRoomMatePreference = null | string;

export type CampRegistrationParticipantRequestNotes = null | string;

export interface CampRegistrationParticipantRequest {
  memberId: string;
  priceOptionId: CampRegistrationParticipantRequestPriceOptionId;
  addonIds: CampRegistrationParticipantRequestAddonIds;
  medicalClearanceDeclared: boolean;
  diet: CampRegistrationParticipantRequestDiet;
  roomMatePreference: CampRegistrationParticipantRequestRoomMatePreference;
  notes: CampRegistrationParticipantRequestNotes;
}

export type CampRegistrationRequestGuardianName = null | string;

export type CampRegistrationRequestGuardianPhone = null | string;

export type CampRegistrationRequestNotes = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampRegistrationRequestAcceptedTermsVersion = null | number | string;

export interface CampRegistrationRequest {
  participants: CampRegistrationParticipantRequest[];
  guardianName: CampRegistrationRequestGuardianName;
  guardianPhone: CampRegistrationRequestGuardianPhone;
  notes: CampRegistrationRequestNotes;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  acceptedTermsVersion: CampRegistrationRequestAcceptedTermsVersion;
  acceptTerms: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampRegistrationResultResponseTermsVersion = null | number | string;

export interface CampRegistrationResultResponse {
  registrationId: string;
  submittedAt: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  termsVersion: CampRegistrationResultResponseTermsVersion;
  depositDueDate: string;
  participants: MyCampParticipantResponse[];
}

export type CampRegistrationState = typeof CampRegistrationState[keyof typeof CampRegistrationState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampRegistrationState = {
  Open: 'Open',
  NotYetOpen: 'NotYetOpen',
  Closed: 'Closed',
  Unavailable: 'Unavailable',
} as const;

export type CampRemovalReason = typeof CampRemovalReason[keyof typeof CampRemovalReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampRemovalReason = {
  DepositNotPaid: 'DepositNotPaid',
  BalanceNotPaid: 'BalanceNotPaid',
  Admin: 'Admin',
} as const;

export type CampResponseSummary = null | string;

export type CampResponseDescription = null | string;

export type CampResponseBannerUrl = null | string;

export type CampResponseWebsiteUrl = null | string;

export type CampResponseArrivalInfo = null | string;

export type CampResponseDepartureInfo = null | string;

export type CampResponseLocationId = null | string;

export type CampResponseVenueAddress = null | string;

export type CampResponseContactName = null | string;

export type CampResponseContactEmail = null | string;

export type CampResponseContactPhone = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampResponseCapacity = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampResponseMinAge = null | number | string;

export type CampResponseRegistrationOpensAt = null | string;

export type CampResponseRegistrationClosesAt = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampResponseDepositAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampResponseDepositDueDays = number | string;

export type CampResponseBalanceDueDate = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampResponseLateFeePercent = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampResponseLateFeeGraceDays = number | string;

export type CampResponseBlikPhoneNumber = null | string;

export type CampResponseSchoolBlikPhoneNumber = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampResponseCurrentTermsVersion = null | number | string;

export type CampResponsePromoId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampResponsePlacesTaken = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampResponseWaitlistCount = number | string;

export interface CampResponse {
  id: string;
  name: string;
  slug: string;
  summary: CampResponseSummary;
  description: CampResponseDescription;
  bannerUrl: CampResponseBannerUrl;
  websiteUrl: CampResponseWebsiteUrl;
  startsAt: string;
  endsAt: string;
  arrivalInfo: CampResponseArrivalInfo;
  departureInfo: CampResponseDepartureInfo;
  locationId: CampResponseLocationId;
  venueName: string;
  venueAddress: CampResponseVenueAddress;
  contactName: CampResponseContactName;
  contactEmail: CampResponseContactEmail;
  contactPhone: CampResponseContactPhone;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  capacity: CampResponseCapacity;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  minAge: CampResponseMinAge;
  minorsRequireGuardian: boolean;
  requiresMedicalClearance: boolean;
  registrationOpensAt: CampResponseRegistrationOpensAt;
  registrationClosesAt: CampResponseRegistrationClosesAt;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  depositAmount: CampResponseDepositAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  depositDueDays: CampResponseDepositDueDays;
  depositRefundable: boolean;
  balanceDueDate: CampResponseBalanceDueDate;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  lateFeePercent: CampResponseLateFeePercent;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  lateFeeGraceDays: CampResponseLateFeeGraceDays;
  autoRemoveUnpaid: boolean;
  allowOnlinePayment: boolean;
  allowBankTransfer: boolean;
  allowBlik: boolean;
  blikPhoneNumber: CampResponseBlikPhoneNumber;
  schoolBlikPhoneNumber: CampResponseSchoolBlikPhoneNumber;
  status: CampStatus;
  termsDraft: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  currentTermsVersion: CampResponseCurrentTermsVersion;
  termsOutdated: boolean;
  termsVersions: CampTermsVersionSummaryResponse[];
  priceOptions: CampPriceOptionResponse[];
  addons: CampAddonResponse[];
  refundRules: CampRefundRuleResponse[];
  promoId: CampResponsePromoId;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  placesTaken: CampResponsePlacesTaken;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  waitlistCount: CampResponseWaitlistCount;
}

export type CampStatus = typeof CampStatus[keyof typeof CampStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampStatus = {
  Draft: 'Draft',
  Published: 'Published',
  RegistrationClosed: 'RegistrationClosed',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
} as const;

export type CampSummaryResponseBannerUrl = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampSummaryResponseCapacity = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampSummaryResponseCurrentTermsVersion = null | number | string;

export interface CampSummaryResponse {
  id: string;
  name: string;
  slug: string;
  startsAt: string;
  endsAt: string;
  venueName: string;
  status: CampStatus;
  bannerUrl: CampSummaryResponseBannerUrl;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  capacity: CampSummaryResponseCapacity;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  currentTermsVersion: CampSummaryResponseCurrentTermsVersion;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampTermsAddonSnapshotPrice = number | string;

export interface CampTermsAddonSnapshot {
  name?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  price?: CampTermsAddonSnapshotPrice;
  unit?: CampAddonUnit;
  priceOnRequest?: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampTermsPriceOptionSnapshotMinAge = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampTermsPriceOptionSnapshotMaxAge = null | number | string;

export interface CampTermsPriceOptionSnapshot {
  name?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  minAge?: CampTermsPriceOptionSnapshotMinAge;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxAge?: CampTermsPriceOptionSnapshotMaxAge;
  tiers?: CampTermsPriceTierSnapshot[];
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampTermsPriceTierSnapshotPrice = number | string;

export type CampTermsPriceTierSnapshotValidUntil = null | string;

export interface CampTermsPriceTierSnapshot {
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  price?: CampTermsPriceTierSnapshotPrice;
  validUntil?: CampTermsPriceTierSnapshotValidUntil;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampTermsRefundRuleSnapshotMinDaysBeforeStart = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampTermsRefundRuleSnapshotRefundPercent = number | string;

export interface CampTermsRefundRuleSnapshot {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  minDaysBeforeStart?: CampTermsRefundRuleSnapshotMinDaysBeforeStart;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  refundPercent?: CampTermsRefundRuleSnapshotRefundPercent;
  basis?: CampRefundBasis;
  deductDeposit?: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampTermsSnapshotDepositAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampTermsSnapshotDepositDueDays = number | string;

export type CampTermsSnapshotBalanceDueDate = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CampTermsSnapshotLateFeePercent = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampTermsSnapshotLateFeeGraceDays = number | string;

export type CampTermsSnapshotAllowOnlinePayment = null | boolean;

export type CampTermsSnapshotAllowBankTransfer = null | boolean;

export type CampTermsSnapshotAllowBlik = null | boolean;

export interface CampTermsSnapshot {
  startsAt?: string;
  endsAt?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  depositAmount?: CampTermsSnapshotDepositAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  depositDueDays?: CampTermsSnapshotDepositDueDays;
  depositRefundable?: boolean;
  balanceDueDate?: CampTermsSnapshotBalanceDueDate;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  lateFeePercent?: CampTermsSnapshotLateFeePercent;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  lateFeeGraceDays?: CampTermsSnapshotLateFeeGraceDays;
  allowOnlinePayment?: CampTermsSnapshotAllowOnlinePayment;
  allowBankTransfer?: CampTermsSnapshotAllowBankTransfer;
  allowBlik?: CampTermsSnapshotAllowBlik;
  priceOptions?: CampTermsPriceOptionSnapshot[];
  addons?: CampTermsAddonSnapshot[];
  refundRules?: CampTermsRefundRuleSnapshot[];
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CampTermsVersionSummaryResponseVersion = number | string;

export interface CampTermsVersionSummaryResponse {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  version: CampTermsVersionSummaryResponseVersion;
  publishedAt: string;
}

export interface CancelAbsenceRequest {
  enrollmentId: string;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CancelCampParticipantRequestRefundAmount = number | string;

export interface CancelCampParticipantRequest {
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  refundAmount: CancelCampParticipantRequestRefundAmount;
  refundMethod: CampRefundMethod;
}

export interface CancelIndividualBookingRequest {
  acceptLateFee?: boolean;
}

export type CancelIndividualSlotRequestReason = null | string;

export interface CancelIndividualSlotRequest {
  reason: CancelIndividualSlotRequestReason;
}

export type CancelSessionRequestReason = null | string;

export interface CancelSessionRequest {
  reason: CancelSessionRequestReason;
}

export interface ChangeCampStatusRequest {
  status: CampStatus;
}

export interface ChangeTournamentStatusRequest {
  status: TournamentStatus;
}

export type ClaimWaitlistResponseEnrollmentId = null | string;

export type ClaimWaitlistResponseMonthlySubscriptionId = null | string;

export type ClaimWaitlistResponsePaymentId = null | string;

export interface ClaimWaitlistResponse {
  success: boolean;
  message: string;
  enrollmentId: ClaimWaitlistResponseEnrollmentId;
  monthlySubscriptionId: ClaimWaitlistResponseMonthlySubscriptionId;
  paymentId: ClaimWaitlistResponsePaymentId;
}

export type ClassKind = typeof ClassKind[keyof typeof ClassKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClassKind = {
  Group: 'Group',
  Individual: 'Individual',
} as const;

export type CoachCancelIndividualBookingRequestReason = null | string;

export interface CoachCancelIndividualBookingRequest {
  charge?: boolean;
  reason?: CoachCancelIndividualBookingRequestReason;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CoachCashSettlementItemAmount = number | string;

export type CoachCashSettlementItemDescription = null | string;

export interface CoachCashSettlementItem {
  paymentId: string;
  studentMemberId: string;
  studentName: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: CoachCashSettlementItemAmount;
  type: PaymentType;
  description: CoachCashSettlementItemDescription;
  recordedAt: string;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CoachCashSettlementSummaryYear = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CoachCashSettlementSummaryMonth = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CoachCashSettlementSummaryTotalCashAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CoachCashSettlementSummaryTotalBankTransferAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CoachCashSettlementSummaryTotalAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CoachCashSettlementSummaryTotalPaymentsCount = number | string;

export interface CoachCashSettlementSummary {
  coachMemberId: string;
  coachFirstName: string;
  coachLastName: string;
  coachEmail: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  year: CoachCashSettlementSummaryYear;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  month: CoachCashSettlementSummaryMonth;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalCashAmount: CoachCashSettlementSummaryTotalCashAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalBankTransferAmount: CoachCashSettlementSummaryTotalBankTransferAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalAmount: CoachCashSettlementSummaryTotalAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  totalPaymentsCount: CoachCashSettlementSummaryTotalPaymentsCount;
  payments: CoachCashSettlementItem[];
}

export type CoachIndividualBookingResponseSessionId = null | string;

export type CoachIndividualBookingResponseScheduleId = null | string;

export type CoachIndividualBookingResponseCoachMemberId = null | string;

export type CoachIndividualBookingResponseStartsAt = null | string;

export type CoachIndividualBookingResponseDayOfWeek = null | DayOfWeek;

export type CoachIndividualBookingResponseStartTime = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CoachIndividualBookingResponseDuration = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CoachIndividualBookingResponsePricePerSession = number | string;

export interface CoachIndividualBookingResponse {
  bookingId: string;
  bookingType: IndividualBookingType;
  sessionId: CoachIndividualBookingResponseSessionId;
  scheduleId: CoachIndividualBookingResponseScheduleId;
  coachMemberId: CoachIndividualBookingResponseCoachMemberId;
  coachName: string;
  locationName: string;
  startsAt: CoachIndividualBookingResponseStartsAt;
  dayOfWeek: CoachIndividualBookingResponseDayOfWeek;
  startTime: CoachIndividualBookingResponseStartTime;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  duration: CoachIndividualBookingResponseDuration;
  courtBookingMode: CourtBookingMode;
  booking: IndividualBookingSummary;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  pricePerSession: CoachIndividualBookingResponsePricePerSession;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type CoachIndividualReportSummaryTotalHours = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CoachIndividualReportSummaryTotalSessions = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CoachIndividualReportSummaryCashToHandOver = number | string;

export interface CoachIndividualReportSummary {
  cash: IndividualChannelTotals;
  transfer: IndividualChannelTotals;
  unpaid: IndividualChannelTotals;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  totalHours: CoachIndividualReportSummaryTotalHours;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  totalSessions: CoachIndividualReportSummaryTotalSessions;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  cashToHandOver: CoachIndividualReportSummaryCashToHandOver;
}

export type CoachPublicResponseFirstName = null | string;

export type CoachPublicResponseLastName = null | string;

export type CoachPublicResponseEmail = null | string;

export interface CoachPublicResponse {
  id: string;
  firstName: CoachPublicResponseFirstName;
  lastName: CoachPublicResponseLastName;
  email: CoachPublicResponseEmail;
}

export interface CoachRacketStringingAccessResponse {
  memberId: string;
  canManageRacketStringing: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CoachRecordPaymentRequestAmount = number | string;

export type CoachRecordPaymentRequestDescription = null | string;

export interface CoachRecordPaymentRequest {
  studentMemberId: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: CoachRecordPaymentRequestAmount;
  type: PaymentType;
  description: CoachRecordPaymentRequestDescription;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CoachReportBracketDetailBracketIndex = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type CoachReportBracketDetailHours = number | string;

export interface CoachReportBracketDetail {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  bracketIndex: CoachReportBracketDetailBracketIndex;
  label: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  hours: CoachReportBracketDetailHours;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CoachSessionReportDetailEnrolledCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CoachSessionReportDetailMaxParticipants = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type CoachSessionReportDetailOccupancyPercentage = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type CoachSessionReportDetailHours = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CoachSessionReportDetailPartySize = null | number | string;

export type CoachSessionReportDetailPaymentChannel = null | IndividualPaymentChannel;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CoachSessionReportDetailAmount = null | number | string;

export interface CoachSessionReportDetail {
  sessionId: string;
  title: string;
  startsAt: string;
  endsAt: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  enrolledCount: CoachSessionReportDetailEnrolledCount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxParticipants: CoachSessionReportDetailMaxParticipants;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  occupancyPercentage: CoachSessionReportDetailOccupancyPercentage;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  hours: CoachSessionReportDetailHours;
  status?: SessionStatus;
  kind?: ClassKind;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  partySize?: CoachSessionReportDetailPartySize;
  paymentChannel?: CoachSessionReportDetailPaymentChannel;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount?: CoachSessionReportDetailAmount;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type CoachSessionsReportItemTotalHours = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type CoachSessionsReportItemGroupHours = number | string;

export type CoachSessionsReportItemIndividual = null | CoachIndividualReportSummary;

export interface CoachSessionsReportItem {
  coachMemberId: string;
  firstName: string;
  lastName: string;
  email: string;
  brackets: CoachReportBracketDetail[];
  sessions: CoachSessionReportDetail[];
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  totalHours: CoachSessionsReportItemTotalHours;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  groupHours?: CoachSessionsReportItemGroupHours;
  individual?: CoachSessionsReportItemIndividual;
}

export interface CoachSessionsReportResponse {
  thresholds: string[];
  items: CoachSessionsReportItem[];
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CoachStatisticsRowSessions = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type CoachStatisticsRowHours = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CoachStatisticsRowUniqueStudents = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type CoachStatisticsRowAttendanceRate = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type CoachStatisticsRowOccupancy = null | number | string;

export interface CoachStatisticsRow {
  memberId: string;
  name: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sessions: CoachStatisticsRowSessions;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  hours: CoachStatisticsRowHours;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  uniqueStudents: CoachStatisticsRowUniqueStudents;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  attendanceRate: CoachStatisticsRowAttendanceRate;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  occupancy: CoachStatisticsRowOccupancy;
}

export interface CoachTournamentAccessResponse {
  memberId: string;
  canManageTournaments: boolean;
}

export type CompanionDtoFirstName = null | string;

export type CompanionDtoLastName = null | string;

export interface CompanionDto {
  firstName: CompanionDtoFirstName;
  lastName: CompanionDtoLastName;
}

export type CouponType = typeof CouponType[keyof typeof CouponType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CouponType = {
  Amount: 'Amount',
  Percentage: 'Percentage',
  DropInSubscriptionRate: 'DropInSubscriptionRate',
} as const;

export type CourtBookingMode = typeof CourtBookingMode[keyof typeof CourtBookingMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourtBookingMode = {
  SchoolReserved: 'SchoolReserved',
  SelfBooked: 'SelfBooked',
} as const;

export type CreateCampRequestLocationId = null | string;

export type CreateCampRequestVenueName = null | string;

export type CreateCampRequestVenueAddress = null | string;

export interface CreateCampRequest {
  name: string;
  startsAt: string;
  endsAt: string;
  locationId: CreateCampRequestLocationId;
  venueName: CreateCampRequestVenueName;
  venueAddress: CreateCampRequestVenueAddress;
}

export type CreateChildRequestDateOfBirth = null | string;

export type CreateChildRequestSkillLevelId = null | string;

export type CreateChildRequestNotes = null | string;

export interface CreateChildRequest {
  firstName: string;
  lastName: string;
  dateOfBirth: CreateChildRequestDateOfBirth;
  gender: Gender;
  skillLevelId: CreateChildRequestSkillLevelId;
  notes: CreateChildRequestNotes;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CreateCustomBillRequestAmount = number | string;

export type CreateCustomBillRequestDueDate = null | string;

export interface CreateCustomBillRequest {
  studentMemberId: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: CreateCustomBillRequestAmount;
  description: string;
  dueDate?: CreateCustomBillRequestDueDate;
}

export interface CreateEmailTemplateRequest {
  name: string;
  htmlContent: string;
  isDefault: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CreateIndividualBookingRequestPartySize = number | string;

export type CreateIndividualBookingRequestCompanions = null | CompanionDto[];

export type CreateIndividualBookingRequestStudentMemberId = null | string;

export interface CreateIndividualBookingRequest {
  sessionId: string;
  bookingType: IndividualBookingType;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  partySize: CreateIndividualBookingRequestPartySize;
  companions: CreateIndividualBookingRequestCompanions;
  paymentMethod: IndividualPaymentMethod;
  regulationId: string;
  acceptRegulation: boolean;
  confirmCourtSelfBooking: boolean;
  studentMemberId?: CreateIndividualBookingRequestStudentMemberId;
}

export type CreateIndividualSlotRequestCoachMemberId = null | string;

export type CreateIndividualSlotRequestStartsAt = null | string;

export type CreateIndividualSlotRequestDayOfWeek = null | DayOfWeek;

export type CreateIndividualSlotRequestStartTime = null | string;

export type CreateIndividualSlotRequestStartDate = null | string;

export type CreateIndividualSlotRequestEndDate = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CreateIndividualSlotRequestDuration = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CreateIndividualSlotRequestMaxPartySize = number | string;

export type CreateIndividualSlotRequestCourtBookingMode = null | CourtBookingMode;

export type CreateIndividualSlotRequestCourtBookingUrl = null | string;

export type CreateIndividualSlotRequestAdditionalInformation = null | string;

export interface CreateIndividualSlotRequest {
  coachMemberId: CreateIndividualSlotRequestCoachMemberId;
  locationId: string;
  isRecurring: boolean;
  startsAt: CreateIndividualSlotRequestStartsAt;
  dayOfWeek: CreateIndividualSlotRequestDayOfWeek;
  startTime: CreateIndividualSlotRequestStartTime;
  startDate: CreateIndividualSlotRequestStartDate;
  endDate: CreateIndividualSlotRequestEndDate;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  duration: CreateIndividualSlotRequestDuration;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxPartySize?: CreateIndividualSlotRequestMaxPartySize;
  courtBookingMode?: CreateIndividualSlotRequestCourtBookingMode;
  courtBookingUrl?: CreateIndividualSlotRequestCourtBookingUrl;
  allowOnlinePayment?: boolean;
  allowOnSitePayment?: boolean;
  allowFixedSlot?: boolean;
  additionalInformation?: CreateIndividualSlotRequestAdditionalInformation;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CreateLocationRequestCourtCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CreateLocationRequestMaxParticipants = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type CreateLocationRequestLatitude = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type CreateLocationRequestLongitude = null | number | string;

export type CreateLocationRequestCourtBookingUrl = null | string;

export type CreateLocationRequestDescription = null | string;

export interface CreateLocationRequest {
  name: string;
  alias: string;
  address: string;
  district: string;
  postalCode: string;
  city: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  courtCount: CreateLocationRequestCourtCount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxParticipants: CreateLocationRequestMaxParticipants;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  latitude?: CreateLocationRequestLatitude;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  longitude?: CreateLocationRequestLongitude;
  isIndividualOnly?: boolean;
  defaultCourtBookingMode?: CourtBookingMode;
  courtBookingUrl?: CreateLocationRequestCourtBookingUrl;
  description?: CreateLocationRequestDescription;
}

export type CreateMailingCampaignRequestEmailTemplateId = null | string;

export type CreateMailingCampaignRequestTargetId = null | string;

export type CreateMailingCampaignRequestScheduledFor = null | string;

export interface CreateMailingCampaignRequest {
  subject: string;
  body: string;
  emailTemplateId: CreateMailingCampaignRequestEmailTemplateId;
  targetType: string;
  targetId: CreateMailingCampaignRequestTargetId;
  status: string;
  scheduledFor: CreateMailingCampaignRequestScheduledFor;
}

export interface CreateMailingWorkflowRequest {
  name: string;
  triggerType: string;
  isEnabled: boolean;
  workflowDataJson: string;
}

export type CreateMaintenancePeriodRequestReason = null | string;

export interface CreateMaintenancePeriodRequest {
  startDate: string;
  endDate: string;
  reason: CreateMaintenancePeriodRequestReason;
}

export type CreateOneTimeSessionRequestCoachMemberId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CreateOneTimeSessionRequestMaxParticipants = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CreateOneTimeSessionRequestDropInPrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CreateOneTimeSessionRequestEquipmentSurcharge = number | string;

export type CreateOneTimeSessionRequestTitle = null | string;

export type CreateOneTimeSessionRequestDescription = null | string;

export type CreateOneTimeSessionRequestBannerUrl = null | string;

export type CreateOneTimeSessionRequestInfoUrl = null | string;

export type CreateOneTimeSessionRequestAdditionalInformation = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CreateOneTimeSessionRequestCorporateSlotsCount = number | string;

export type CreateOneTimeSessionRequestTags = null | string[];

export type CreateOneTimeSessionRequestSecondCoachMemberId = null | string;

export interface CreateOneTimeSessionRequest {
  locationId: string;
  coachMemberId: CreateOneTimeSessionRequestCoachMemberId;
  skillLevelId: string;
  equipmentType: EquipmentType;
  startsAt: string;
  endsAt: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxParticipants: CreateOneTimeSessionRequestMaxParticipants;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  dropInPrice: CreateOneTimeSessionRequestDropInPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  equipmentSurcharge: CreateOneTimeSessionRequestEquipmentSurcharge;
  title: CreateOneTimeSessionRequestTitle;
  description: CreateOneTimeSessionRequestDescription;
  isPromoted?: boolean;
  bannerUrl?: CreateOneTimeSessionRequestBannerUrl;
  infoUrl?: CreateOneTimeSessionRequestInfoUrl;
  additionalInformation?: CreateOneTimeSessionRequestAdditionalInformation;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  corporateSlotsCount?: CreateOneTimeSessionRequestCorporateSlotsCount;
  disableMakeups?: boolean;
  tags?: CreateOneTimeSessionRequestTags;
  secondCoachMemberId?: CreateOneTimeSessionRequestSecondCoachMemberId;
}

export type CreatePriceListItemRequestValidTo = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CreatePriceListItemRequestDuration = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CreatePriceListItemRequestDropInPrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CreatePriceListItemRequestMonthlyBasePrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CreatePriceListItemRequestEquipmentSurcharge = number | string;

export type CreatePriceListItemRequestGrandfatheringUntil = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CreatePriceListItemRequestPartySizeFrom = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CreatePriceListItemRequestPartySizeTo = null | number | string;

export interface CreatePriceListItemRequest {
  validFrom: string;
  validTo: CreatePriceListItemRequestValidTo;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  duration: CreatePriceListItemRequestDuration;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  dropInPrice: CreatePriceListItemRequestDropInPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  monthlyBasePrice: CreatePriceListItemRequestMonthlyBasePrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  equipmentSurcharge: CreatePriceListItemRequestEquipmentSurcharge;
  grandfatheringUntil?: CreatePriceListItemRequestGrandfatheringUntil;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  partySizeFrom?: CreatePriceListItemRequestPartySizeFrom;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  partySizeTo?: CreatePriceListItemRequestPartySizeTo;
}

export type CreatePriceListRequestEquipmentName = null | string;

export interface CreatePriceListRequest {
  name: string;
  equipmentName?: CreatePriceListRequestEquipmentName;
  kind?: ClassKind;
}

export type CreatePromoRequestTargetUrl = null | string;

export type CreatePromoRequestPublishEndDate = null | string;

export interface CreatePromoRequest {
  title: string;
  imageUrl: string;
  targetUrl: CreatePromoRequestTargetUrl;
  publishStartDate: string;
  publishEndDate: CreatePromoRequestPublishEndDate;
  isActive?: boolean;
}

export type CreateRacketStringingOrderRequestTension = null | string;

export type CreateRacketStringingOrderRequestStringType = null | string;

export type CreateRacketStringingOrderRequestNotes = null | string;

export type CreateRacketStringingOrderRequestContactEmail = null | string;

export interface CreateRacketStringingOrderRequest {
  racketModel: string;
  gripColor: string;
  tension: CreateRacketStringingOrderRequestTension;
  stringType: CreateRacketStringingOrderRequestStringType;
  notes: CreateRacketStringingOrderRequestNotes;
  contactEmail?: CreateRacketStringingOrderRequestContactEmail;
}

export type CreateScheduleRequestName = null | string;

export type CreateScheduleRequestCoachMemberId = null | string;

export type CreateScheduleRequestPriceListId = null | string;

export type CreateScheduleRequestPricingModelId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CreateScheduleRequestDuration = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CreateScheduleRequestMaxParticipants = number | string;

export type CreateScheduleRequestEndDate = null | string;

export type CreateScheduleRequestBannerUrl = null | string;

export type CreateScheduleRequestInfoUrl = null | string;

export type CreateScheduleRequestAdditionalInformation = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CreateScheduleRequestCustomDropInPrice = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CreateScheduleRequestCustomMonthlyPrice = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CreateScheduleRequestCustomEquipmentSurcharge = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CreateScheduleRequestCorporateSlotsCount = number | string;

export type CreateScheduleRequestTags = null | string[];

export type CreateScheduleRequestSecondCoachMemberId = null | string;

export interface CreateScheduleRequest {
  name: CreateScheduleRequestName;
  locationId: string;
  coachMemberId: CreateScheduleRequestCoachMemberId;
  priceListId: CreateScheduleRequestPriceListId;
  pricingModelId: CreateScheduleRequestPricingModelId;
  skillLevelId: string;
  dayOfWeek: DayOfWeek;
  startTime: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  duration: CreateScheduleRequestDuration;
  equipmentType: EquipmentType;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxParticipants: CreateScheduleRequestMaxParticipants;
  startDate: string;
  endDate?: CreateScheduleRequestEndDate;
  recurrencePattern?: string;
  isPromoted?: boolean;
  isPrivate?: boolean;
  bannerUrl?: CreateScheduleRequestBannerUrl;
  infoUrl?: CreateScheduleRequestInfoUrl;
  additionalInformation?: CreateScheduleRequestAdditionalInformation;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  customDropInPrice?: CreateScheduleRequestCustomDropInPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  customMonthlyPrice?: CreateScheduleRequestCustomMonthlyPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  customEquipmentSurcharge?: CreateScheduleRequestCustomEquipmentSurcharge;
  isCoursePaidOnce?: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  corporateSlotsCount?: CreateScheduleRequestCorporateSlotsCount;
  disableMakeups?: boolean;
  tags?: CreateScheduleRequestTags;
  secondCoachMemberId?: CreateScheduleRequestSecondCoachMemberId;
}

export type CreateSchoolHolidaysRequestName = null | string;

export interface CreateSchoolHolidaysRequest {
  dates: string[];
  name: CreateSchoolHolidaysRequestName;
}

export interface CreateSchoolHolidaysResponse {
  holidays: SchoolHolidayResponse[];
  impact: SchoolHolidayImpactResponse;
}

export type CreateSchoolRequestAddress = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CreateSchoolRequestMakeUpCreditExpiryDays = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CreateSchoolRequestSubscriptionBillingDay = number | string;

export interface CreateSchoolRequest {
  name: string;
  alias: string;
  address: CreateSchoolRequestAddress;
  sportType: SportType;
  timezone: string;
  currency: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  makeUpCreditExpiryDays?: CreateSchoolRequestMakeUpCreditExpiryDays;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  subscriptionBillingDay?: CreateSchoolRequestSubscriptionBillingDay;
}

export interface CreateSkillLevelRequest {
  namePl: string;
  nameEn: string;
  color: string;
  category?: SkillLevelCategory;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type CreateSubscriptionRequestForceAmount = null | number | string;

export type CreateSubscriptionRequestPaymentType = null | PaymentType;

export interface CreateSubscriptionRequest {
  studentMemberId: string;
  scheduleId: string;
  billingMonth: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  forceAmount?: CreateSubscriptionRequestForceAmount;
  markAsPaid?: boolean;
  paymentType?: CreateSubscriptionRequestPaymentType;
}

export type CreateSubscriptionSuspensionRequestReason = null | string;

export interface CreateSubscriptionSuspensionRequest {
  startDate: string;
  endDate: string;
  reason?: CreateSubscriptionSuspensionRequestReason;
}

export interface CreateTournamentFromSessionRequest {
  sessionId: string;
  name: string;
  format: TournamentFormat;
}

export type CreateTournamentRequestLocationId = null | string;

export type CreateTournamentRequestVenueName = null | string;

export type CreateTournamentRequestVenueAddress = null | string;

export type CreateTournamentRequestOrganizerName = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CreateTournamentRequestCourtCount = null | number | string;

export type CreateTournamentRequestDescription = null | string;

export interface CreateTournamentRequest {
  name: string;
  startsAt: string;
  locationId: CreateTournamentRequestLocationId;
  venueName: CreateTournamentRequestVenueName;
  venueAddress: CreateTournamentRequestVenueAddress;
  organizerName: CreateTournamentRequestOrganizerName;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  courtCount: CreateTournamentRequestCourtCount;
  description: CreateTournamentRequestDescription;
}

export type CreditStatus = typeof CreditStatus[keyof typeof CreditStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreditStatus = {
  Available: 'Available',
  Redeemed: 'Redeemed',
  Expired: 'Expired',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CsvImportErrorRowNumber = number | string;

export type CsvImportErrorEmail = null | string;

export type CsvImportErrorName = null | string;

export interface CsvImportError {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  rowNumber: CsvImportErrorRowNumber;
  email: CsvImportErrorEmail;
  name: CsvImportErrorName;
  errorMessage: string;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CsvImportResultTotalRecords = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CsvImportResultSuccessCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type CsvImportResultErrorCount = number | string;

export interface CsvImportResult {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  totalRecords: CsvImportResultTotalRecords;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  successCount: CsvImportResultSuccessCount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  errorCount: CsvImportResultErrorCount;
  errors: CsvImportError[];
}

export type DayOfWeek = typeof DayOfWeek[keyof typeof DayOfWeek];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DayOfWeek = {
  Sunday: 'Sunday',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type DebtorRowAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type DebtorRowBillCount = number | string;

export type DebtorRowOldestDueDate = null | string;

export interface DebtorRow {
  memberId: string;
  name: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: DebtorRowAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  billCount: DebtorRowBillCount;
  oldestDueDate: DebtorRowOldestDueDate;
}

export interface DeclareCampPaymentRequest {
  method: CampDeclaredPaymentMethod;
  paidOn: string;
}

export type DefineRegulationRequestIntroMessage = null | string;

export interface DefineRegulationRequest {
  title: string;
  content: string;
  introMessage: DefineRegulationRequestIntroMessage;
  publishedAt: string;
  effectiveAt: string;
  language: string;
  type?: RegulationType;
}

export type DeleteAccountRequestPassword = null | string;

export type DeleteAccountRequestGoogleIdToken = null | string;

export type DeleteAccountRequestConfirmationText = null | string;

export interface DeleteAccountRequest {
  password?: DeleteAccountRequestPassword;
  googleIdToken?: DeleteAccountRequestGoogleIdToken;
  confirmationText?: DeleteAccountRequestConfirmationText;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type DetachFromFamilyPreviewResponseOpenBillsCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type DetachFromFamilyPreviewResponseActiveGroupEnrollmentsCount = number | string;

export interface DetachFromFamilyPreviewResponse {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  openBillsCount: DetachFromFamilyPreviewResponseOpenBillsCount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  activeGroupEnrollmentsCount: DetachFromFamilyPreviewResponseActiveGroupEnrollmentsCount;
}

export interface DetachFromFamilyRequest {
  email: string;
  sendInvitation?: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type DiscountCouponResponseDiscountPercent = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type DiscountCouponResponseInitialAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type DiscountCouponResponseRemainingAmount = number | string;

export type DiscountCouponResponseStudentMemberId = null | string;

export type DiscountCouponResponseStudentName = null | string;

export type DiscountCouponResponseUsedForEnrollmentId = null | string;

export type DiscountCouponResponseUsedForBillId = null | string;

export type DiscountCouponResponseRedeemedAt = null | string;

export type DiscountCouponResponseUsedAt = null | string;

export type DiscountCouponResponseUsages = null | DiscountCouponUsageResponse[];

export interface DiscountCouponResponse {
  id: string;
  schoolId: string;
  code: string;
  couponType: CouponType;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  discountPercent: DiscountCouponResponseDiscountPercent;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  initialAmount: DiscountCouponResponseInitialAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  remainingAmount: DiscountCouponResponseRemainingAmount;
  status: DiscountCouponStatus;
  studentMemberId: DiscountCouponResponseStudentMemberId;
  studentName: DiscountCouponResponseStudentName;
  createdAt: string;
  expiresAt: string;
  usedForEnrollmentId: DiscountCouponResponseUsedForEnrollmentId;
  usedForBillId: DiscountCouponResponseUsedForBillId;
  redeemedAt: DiscountCouponResponseRedeemedAt;
  usedAt: DiscountCouponResponseUsedAt;
  usages?: DiscountCouponResponseUsages;
}

export type DiscountCouponStatus = typeof DiscountCouponStatus[keyof typeof DiscountCouponStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscountCouponStatus = {
  Active: 'Active',
  Redeemed: 'Redeemed',
  PartiallyUsed: 'PartiallyUsed',
  Used: 'Used',
  Expired: 'Expired',
} as const;

export type DiscountCouponUsageResponseStudentName = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type DiscountCouponUsageResponseAmountUsed = number | string;

export type DiscountCouponUsageResponseEnrollmentId = null | string;

export type DiscountCouponUsageResponseBillId = null | string;

export interface DiscountCouponUsageResponse {
  id: string;
  discountCouponId: string;
  studentMemberId: string;
  studentName: DiscountCouponUsageResponseStudentName;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amountUsed: DiscountCouponUsageResponseAmountUsed;
  usedAt: string;
  enrollmentId: DiscountCouponUsageResponseEnrollmentId;
  billId: DiscountCouponUsageResponseBillId;
}

export interface EmailTemplateResponse {
  id: string;
  schoolId: string;
  name: string;
  htmlContent: string;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type EnrollmentListResponseTotalCount = number | string;

export interface EnrollmentListResponse {
  items: EnrollmentResponse[];
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  totalCount: EnrollmentListResponseTotalCount;
}

export type EnrollmentPaymentStatus = typeof EnrollmentPaymentStatus[keyof typeof EnrollmentPaymentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollmentPaymentStatus = {
  Unpaid: 'Unpaid',
  Pending: 'Pending',
  Paid: 'Paid',
  Failed: 'Failed',
  Cancelled: 'Cancelled',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentPriceCalculationResponseBasePriceSingle = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentPriceCalculationResponseEquipPriceSingle = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type EnrollmentPriceCalculationResponseSessionCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentPriceCalculationResponseTotalBasePrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentPriceCalculationResponseTotalEquipPrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentPriceCalculationResponseTotalPrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentPriceCalculationResponseSavingsPercent = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentPriceCalculationResponseMakeUpDiscountAmount = number | string;

export type EnrollmentPriceCalculationResponseFirstSessionDate = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentPriceCalculationResponseDiscountPercent = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentPriceCalculationResponseDiscountAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentPriceCalculationResponseOriginalBasePriceSingle = number | string;

export type EnrollmentPriceCalculationResponseAppliedCoupons = null | AppliedCouponDetailDto[];

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentPriceCalculationResponseOverpaymentAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentPriceCalculationResponseOverpaymentDeduction = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentPriceCalculationResponseOriginalTotalPrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentPriceCalculationResponseVouchersAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentPriceCalculationResponseVouchersDeduction = number | string;

export type EnrollmentPriceCalculationResponseNextMonthStr = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentPriceCalculationResponseNextMonthTotalPrice = null | number | string;

export type EnrollmentPriceCalculationResponseWaitlistReason = null | string;

export interface EnrollmentPriceCalculationResponse {
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  basePriceSingle: EnrollmentPriceCalculationResponseBasePriceSingle;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  equipPriceSingle: EnrollmentPriceCalculationResponseEquipPriceSingle;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sessionCount: EnrollmentPriceCalculationResponseSessionCount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalBasePrice: EnrollmentPriceCalculationResponseTotalBasePrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalEquipPrice: EnrollmentPriceCalculationResponseTotalEquipPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalPrice: EnrollmentPriceCalculationResponseTotalPrice;
  billingMonthStr: string;
  billingMonth: string;
  isNextMonth: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  savingsPercent: EnrollmentPriceCalculationResponseSavingsPercent;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  makeUpDiscountAmount?: EnrollmentPriceCalculationResponseMakeUpDiscountAmount;
  isMakeUpCompensatory?: boolean;
  firstSessionDate?: EnrollmentPriceCalculationResponseFirstSessionDate;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  discountPercent?: EnrollmentPriceCalculationResponseDiscountPercent;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  discountAmount?: EnrollmentPriceCalculationResponseDiscountAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  originalBasePriceSingle?: EnrollmentPriceCalculationResponseOriginalBasePriceSingle;
  isCouponApplied?: boolean;
  isFirstSession?: boolean;
  appliedCoupons?: EnrollmentPriceCalculationResponseAppliedCoupons;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  overpaymentAmount?: EnrollmentPriceCalculationResponseOverpaymentAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  overpaymentDeduction?: EnrollmentPriceCalculationResponseOverpaymentDeduction;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  originalTotalPrice?: EnrollmentPriceCalculationResponseOriginalTotalPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  vouchersAmount?: EnrollmentPriceCalculationResponseVouchersAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  vouchersDeduction?: EnrollmentPriceCalculationResponseVouchersDeduction;
  nextMonthStr?: EnrollmentPriceCalculationResponseNextMonthStr;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  nextMonthTotalPrice?: EnrollmentPriceCalculationResponseNextMonthTotalPrice;
  isWaitlistRequired?: boolean;
  waitlistReason?: EnrollmentPriceCalculationResponseWaitlistReason;
}

export type EnrollmentResponseMakeUpCreditId = null | string;

export type EnrollmentResponsePaymentId = null | string;

export type EnrollmentResponseSession = null | EnrollmentSessionResponse;

export type EnrollmentResponseAttendanceStatus = null | AttendanceStatus;

export type EnrollmentResponseStudentName = null | string;

export type EnrollmentResponseTransferredFrom = null | EnrollmentTransferInfo;

export type EnrollmentResponseTransferredTo = null | EnrollmentTransferInfo;

export type EnrollmentResponseSuspendedUntil = null | string;

export type EnrollmentResponseSuspensionReason = null | string;

export type EnrollmentResponseSubscriptionStartDate = null | string;

export type EnrollmentResponseSubscriptionResignationDate = null | string;

export interface EnrollmentResponse {
  id: string;
  schoolId: string;
  sessionId: string;
  studentMemberId: string;
  type: EnrollmentType;
  status: EnrollmentStatus;
  isOverbooking: boolean;
  makeUpCreditId: EnrollmentResponseMakeUpCreditId;
  enrolledAt: string;
  paymentId?: EnrollmentResponsePaymentId;
  isApproved?: boolean;
  session?: EnrollmentResponseSession;
  isPaid?: boolean;
  attendanceStatus?: EnrollmentResponseAttendanceStatus;
  studentName?: EnrollmentResponseStudentName;
  paymentStatus?: EnrollmentPaymentStatus;
  transferredFrom?: EnrollmentResponseTransferredFrom;
  transferredTo?: EnrollmentResponseTransferredTo;
  suspendedUntil?: EnrollmentResponseSuspendedUntil;
  suspensionReason?: EnrollmentResponseSuspensionReason;
  subscriptionStartDate?: EnrollmentResponseSubscriptionStartDate;
  subscriptionResignationDate?: EnrollmentResponseSubscriptionResignationDate;
}

export type EnrollmentSessionResponseTitle = null | string;

export type EnrollmentSessionResponseSkillLevelName = null | string;

export type EnrollmentSessionResponseScheduleId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentSessionResponseDropInPrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type EnrollmentSessionResponseEquipmentSurcharge = number | string;

export type EnrollmentSessionResponseCoachName = null | string;

export type EnrollmentSessionResponseDayOfWeek = null | DayOfWeek;

export type EnrollmentSessionResponseStartTime = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type EnrollmentSessionResponseDuration = null | number | string;

export interface EnrollmentSessionResponse {
  id: string;
  startsAt: string;
  title: EnrollmentSessionResponseTitle;
  skillLevelName: EnrollmentSessionResponseSkillLevelName;
  locationId: string;
  type: string;
  isScheduleActive: boolean;
  status: SessionStatus;
  scheduleId?: EnrollmentSessionResponseScheduleId;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  dropInPrice?: EnrollmentSessionResponseDropInPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  equipmentSurcharge?: EnrollmentSessionResponseEquipmentSurcharge;
  coachName?: EnrollmentSessionResponseCoachName;
  dayOfWeek?: EnrollmentSessionResponseDayOfWeek;
  startTime?: EnrollmentSessionResponseStartTime;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  duration?: EnrollmentSessionResponseDuration;
}

export type EnrollmentStatus = typeof EnrollmentStatus[keyof typeof EnrollmentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollmentStatus = {
  Active: 'Active',
  Cancelled: 'Cancelled',
  Absent: 'Absent',
} as const;

export type EnrollmentTransferInfoLocationName = null | string;

export interface EnrollmentTransferInfo {
  sessionId: string;
  startsAt: string;
  locationName: EnrollmentTransferInfoLocationName;
}

export type EnrollmentType = typeof EnrollmentType[keyof typeof EnrollmentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollmentType = {
  DropIn: 'DropIn',
  Monthly: 'Monthly',
  MakeUp: 'MakeUp',
  Manual: 'Manual',
} as const;

export type EnrollMonthlyRequestSpecificSessionId = null | string;

export type EnrollMonthlyRequestPaymentType = null | PaymentType;

export type EnrollMonthlyRequestResignationDate = null | string;

export interface EnrollMonthlyRequest {
  studentMemberId: string;
  scheduleId: string;
  startDateOption: string;
  specificSessionId?: EnrollMonthlyRequestSpecificSessionId;
  paymentType?: EnrollMonthlyRequestPaymentType;
  isZeroPayment?: boolean;
  resignationDate?: EnrollMonthlyRequestResignationDate;
  allowOverbooking?: boolean;
}

export type EnrollStudentGroupRequestPaymentType = null | PaymentType;

export type EnrollStudentGroupRequestResignationDate = null | string;

export interface EnrollStudentGroupRequest {
  studentMemberId: string;
  scheduleId: string;
  startDate: string;
  paymentType?: EnrollStudentGroupRequestPaymentType;
  markAsPaid?: boolean;
  isCorporate?: boolean;
  allowOverbooking?: boolean;
  resignationDate?: EnrollStudentGroupRequestResignationDate;
}

export type EnrollStudentRequestMakeUpCreditId = null | string;

export type EnrollStudentRequestPaymentType = null | PaymentType;

export type EnrollStudentRequestDiscountCouponId = null | string;

export interface EnrollStudentRequest {
  sessionId: string;
  studentMemberId: string;
  type: EnrollmentType;
  makeUpCreditId?: EnrollStudentRequestMakeUpCreditId;
  paymentType?: EnrollStudentRequestPaymentType;
  discountCouponId?: EnrollStudentRequestDiscountCouponId;
  isZeroPayment?: boolean;
  useMakeUpCredit?: boolean;
  useGiftVouchers?: boolean;
}

export type EquipmentType = typeof EquipmentType[keyof typeof EquipmentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EquipmentType = {
  Synthetic: 'Synthetic',
  Feather: 'Feather',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type GameDayRuleResponseSessionOrdinal = number | string;

export interface GameDayRuleResponse {
  oddMonthDays: DayOfWeek[];
  evenMonthDays: DayOfWeek[];
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sessionOrdinal: GameDayRuleResponseSessionOrdinal;
}

export type GameDaySessionDtoScheduleId = null | string;

export type GameDaySessionDtoTitle = null | string;

export type GameDaySessionDtoLocationName = null | string;

export interface GameDaySessionDto {
  sessionId: string;
  scheduleId: GameDaySessionDtoScheduleId;
  startsAt: string;
  endsAt: string;
  title: GameDaySessionDtoTitle;
  locationName: GameDaySessionDtoLocationName;
  isGameDay: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type GameDaySuggestionRequestYear = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type GameDaySuggestionRequestMonth = number | string;

export type GameDaySuggestionRequestDays = null | DayOfWeek[];

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type GameDaySuggestionRequestSessionOrdinal = null | number | string;

export interface GameDaySuggestionRequest {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  year: GameDaySuggestionRequestYear;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  month: GameDaySuggestionRequestMonth;
  days?: GameDaySuggestionRequestDays;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sessionOrdinal?: GameDaySuggestionRequestSessionOrdinal;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type GameDaySuggestionResponseYear = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type GameDaySuggestionResponseMonth = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type GameDaySuggestionResponseSessionOrdinal = number | string;

export interface GameDaySuggestionResponse {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  year: GameDaySuggestionResponseYear;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  month: GameDaySuggestionResponseMonth;
  days: DayOfWeek[];
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sessionOrdinal: GameDaySuggestionResponseSessionOrdinal;
  sessions: GameDaySessionDto[];
}

export type GatewayTransactionResultProviderTransactionId = null | string;

export type GatewayTransactionResultRedirectUrl = null | string;

export type GatewayTransactionResultErrorMessage = null | string;

export interface GatewayTransactionResult {
  isSuccess: boolean;
  providerTransactionId: GatewayTransactionResultProviderTransactionId;
  redirectUrl: GatewayTransactionResultRedirectUrl;
  errorMessage: GatewayTransactionResultErrorMessage;
}

export type Gender = typeof Gender[keyof typeof Gender];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Gender = {
  NotSet: 'NotSet',
  Male: 'Male',
  Female: 'Female',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type GenerateCouponsRequestDiscountPercent = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type GenerateCouponsRequestInitialAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type GenerateCouponsRequestQuantity = number | string;

export type GenerateCouponsRequestStudentMemberId = null | string;

export type GenerateCouponsRequestCustomCode = null | string;

export interface GenerateCouponsRequest {
  expiresAt: string;
  couponType?: CouponType;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  discountPercent?: GenerateCouponsRequestDiscountPercent;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  initialAmount?: GenerateCouponsRequestInitialAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  quantity?: GenerateCouponsRequestQuantity;
  studentMemberId?: GenerateCouponsRequestStudentMemberId;
  customCode?: GenerateCouponsRequestCustomCode;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type GenerateTournamentAmericanoGamesRequestGamesPerPlayer = number | string;

export interface GenerateTournamentAmericanoGamesRequest {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  gamesPerPlayer: GenerateTournamentAmericanoGamesRequestGamesPerPlayer;
}

export type GroupStatisticsRowLocationName = null | string;

export type GroupStatisticsRowCoachName = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type GroupStatisticsRowSessions = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type GroupStatisticsRowMaxParticipants = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type GroupStatisticsRowOccupancy = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type GroupStatisticsRowAttendanceRate = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type GroupStatisticsRowActiveSubscribers = number | string;

export interface GroupStatisticsRow {
  scheduleId: string;
  name: string;
  locationName: GroupStatisticsRowLocationName;
  coachName: GroupStatisticsRowCoachName;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sessions: GroupStatisticsRowSessions;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxParticipants: GroupStatisticsRowMaxParticipants;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  occupancy: GroupStatisticsRowOccupancy;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  attendanceRate: GroupStatisticsRowAttendanceRate;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  activeSubscribers: GroupStatisticsRowActiveSubscribers;
}

export type IFormFile = Blob;

export interface ImportTournamentEntriesRequest {
  text: string;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type ImportTournamentEntriesResponseImported = number | string;

export interface ImportTournamentEntriesResponse {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  imported: ImportTournamentEntriesResponseImported;
  errors: string[];
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type IndividualBillInfoAmount = number | string;

export type IndividualBillInfoBillingMonth = null | string;

export interface IndividualBillInfo {
  billId: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: IndividualBillInfoAmount;
  status: BillStatus;
  description: string;
  billingMonth: IndividualBillInfoBillingMonth;
}

export type IndividualBookingSummaryStudentEmail = null | string;

export type IndividualBookingSummaryStudentPhone = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type IndividualBookingSummaryPartySize = number | string;

export type IndividualBookingSummaryPaymentMethod = null | IndividualPaymentMethod;

export type IndividualBookingSummaryApprovalDeadline = null | string;

export type IndividualBookingSummaryCourtSelfBookingConfirmedAt = null | string;

export interface IndividualBookingSummary {
  bookingId: string;
  bookingType: IndividualBookingType;
  studentMemberId: string;
  studentName: string;
  studentEmail: IndividualBookingSummaryStudentEmail;
  studentPhone: IndividualBookingSummaryStudentPhone;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  partySize: IndividualBookingSummaryPartySize;
  companions: CompanionDto[];
  paymentMethod: IndividualBookingSummaryPaymentMethod;
  approvalStatus: BookingApprovalStatus;
  approvalDeadline: IndividualBookingSummaryApprovalDeadline;
  courtSelfBookingConfirmedAt: IndividualBookingSummaryCourtSelfBookingConfirmedAt;
  createdAt: string;
}

export type IndividualBookingType = typeof IndividualBookingType[keyof typeof IndividualBookingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IndividualBookingType = {
  Single: 'Single',
  FixedSlot: 'FixedSlot',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type IndividualChannelTotalsHours = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type IndividualChannelTotalsSessions = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type IndividualChannelTotalsAmount = number | string;

export interface IndividualChannelTotals {
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  hours: IndividualChannelTotalsHours;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sessions: IndividualChannelTotalsSessions;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: IndividualChannelTotalsAmount;
}

export type IndividualClassSettingsResponseIndividualPriceListId = null | string;

export type IndividualClassSettingsResponseBlikPhoneNumber = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type IndividualClassSettingsResponseFreeCancellationHours = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type IndividualClassSettingsResponseApprovalTimeoutHours = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type IndividualClassSettingsResponseBookingMinLeadHours = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type IndividualClassSettingsResponseBookingHorizonDays = number | string;

export type IndividualClassSettingsResponseCurrentRegulationId = null | string;

export interface IndividualClassSettingsResponse {
  isEnabled: boolean;
  individualPriceListId: IndividualClassSettingsResponseIndividualPriceListId;
  blikPhoneNumber: IndividualClassSettingsResponseBlikPhoneNumber;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  freeCancellationHours: IndividualClassSettingsResponseFreeCancellationHours;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  approvalTimeoutHours: IndividualClassSettingsResponseApprovalTimeoutHours;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  bookingMinLeadHours: IndividualClassSettingsResponseBookingMinLeadHours;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  bookingHorizonDays: IndividualClassSettingsResponseBookingHorizonDays;
  canManageSlots: boolean;
  isAdmin: boolean;
  currentRegulationId: IndividualClassSettingsResponseCurrentRegulationId;
}

export interface IndividualCoachResponse {
  memberId: string;
  fullName: string;
  canOfferIndividualClasses: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type IndividualOccurrenceResponseLateCancellationFee = number | string;

export interface IndividualOccurrenceResponse {
  enrollmentId: string;
  sessionId: string;
  startsAt: string;
  endsAt: string;
  status: EnrollmentStatus;
  isLateCancellation: boolean;
  canCancelFree: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  lateCancellationFee: IndividualOccurrenceResponseLateCancellationFee;
}

export type IndividualPaymentChannel = typeof IndividualPaymentChannel[keyof typeof IndividualPaymentChannel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IndividualPaymentChannel = {
  Cash: 'Cash',
  Transfer: 'Transfer',
  Unpaid: 'Unpaid',
} as const;

export type IndividualPaymentMethod = typeof IndividualPaymentMethod[keyof typeof IndividualPaymentMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IndividualPaymentMethod = {
  Online: 'Online',
  OnSite: 'OnSite',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type IndividualPricePreviewResponsePartySize = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type IndividualPricePreviewResponsePricePerSession = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type IndividualPricePreviewResponseFirstMonthSessionCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type IndividualPricePreviewResponseEstimatedTotal = number | string;

export interface IndividualPricePreviewResponse {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  partySize: IndividualPricePreviewResponsePartySize;
  bookingType: IndividualBookingType;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  pricePerSession: IndividualPricePreviewResponsePricePerSession;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  firstMonthSessionCount: IndividualPricePreviewResponseFirstMonthSessionCount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  estimatedTotal: IndividualPricePreviewResponseEstimatedTotal;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type IndividualPriceTierResponsePartySizeFrom = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type IndividualPriceTierResponsePartySizeTo = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type IndividualPriceTierResponseSinglePrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type IndividualPriceTierResponseFixedSlotPrice = number | string;

export interface IndividualPriceTierResponse {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  partySizeFrom: IndividualPriceTierResponsePartySizeFrom;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  partySizeTo: IndividualPriceTierResponsePartySizeTo;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  singlePrice: IndividualPriceTierResponseSinglePrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  fixedSlotPrice: IndividualPriceTierResponseFixedSlotPrice;
}

export type IndividualScheduleResponseCoachMemberId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type IndividualScheduleResponseDuration = number | string;

export type IndividualScheduleResponseEndDate = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type IndividualScheduleResponseMaxPartySize = number | string;

export type IndividualScheduleResponseCourtBookingMode = null | CourtBookingMode;

export type IndividualScheduleResponseCourtBookingUrl = null | string;

export type IndividualScheduleResponseAdditionalInformation = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type IndividualScheduleResponseActiveFixedSlots = number | string;

export interface IndividualScheduleResponse {
  scheduleId: string;
  coachMemberId: IndividualScheduleResponseCoachMemberId;
  coachName: string;
  locationId: string;
  locationName: string;
  dayOfWeek: DayOfWeek;
  startTime: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  duration: IndividualScheduleResponseDuration;
  startDate: string;
  endDate: IndividualScheduleResponseEndDate;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxPartySize: IndividualScheduleResponseMaxPartySize;
  courtBookingMode: IndividualScheduleResponseCourtBookingMode;
  courtBookingUrl: IndividualScheduleResponseCourtBookingUrl;
  allowOnlinePayment: boolean;
  allowOnSitePayment: boolean;
  allowFixedSlot: boolean;
  additionalInformation: IndividualScheduleResponseAdditionalInformation;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  activeFixedSlots: IndividualScheduleResponseActiveFixedSlots;
}

export type IndividualSlotResponseScheduleId = null | string;

export type IndividualSlotResponseCoachMemberId = null | string;

export type IndividualSlotResponseLocationAddress = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type IndividualSlotResponseDuration = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type IndividualSlotResponseMaxPartySize = number | string;

export type IndividualSlotResponseCourtBookingUrl = null | string;

export type IndividualSlotResponseAdditionalInformation = null | string;

export type IndividualSlotResponseBooking = null | IndividualBookingSummary;

export interface IndividualSlotResponse {
  sessionId: string;
  scheduleId: IndividualSlotResponseScheduleId;
  coachMemberId: IndividualSlotResponseCoachMemberId;
  coachName: string;
  locationId: string;
  locationName: string;
  locationAddress: IndividualSlotResponseLocationAddress;
  startsAt: string;
  endsAt: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  duration: IndividualSlotResponseDuration;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxPartySize: IndividualSlotResponseMaxPartySize;
  courtBookingMode: CourtBookingMode;
  courtBookingUrl: IndividualSlotResponseCourtBookingUrl;
  allowOnlinePayment: boolean;
  allowOnSitePayment: boolean;
  isRecurring: boolean;
  isFixedSlotAvailable: boolean;
  additionalInformation: IndividualSlotResponseAdditionalInformation;
  status: SessionStatus;
  isBooked: boolean;
  priceTiers: IndividualPriceTierResponse[];
  booking: IndividualSlotResponseBooking;
}

export interface InviteAndEnrollRequest {
  sessionId: string;
  email: string;
  firstName: string;
  lastName: string;
  isZeroPayment?: boolean;
}

export interface InviteCampFriendRequest {
  email: string;
}

export type InviteUserByEmailRequestFirstName = null | string;

export type InviteUserByEmailRequestLastName = null | string;

export interface InviteUserByEmailRequest {
  email: string;
  firstName: InviteUserByEmailRequestFirstName;
  lastName: InviteUserByEmailRequestLastName;
  roles: SchoolRole;
  createKeyCloakAccount?: boolean;
  sendInvitationEmail?: boolean;
}

export type InvoiceResponseProviderInvoiceNumber = null | string;

export type InvoiceResponseProviderInvoiceUrl = null | string;

export type InvoiceResponseProviderErrorMessage = null | string;

export type InvoiceResponseSentAt = null | string;

export type InvoiceResponseKsefStatus = null | string;

export interface InvoiceResponse {
  id: string;
  schoolId: string;
  studentMemberId: string;
  paymentId: string;
  providerInvoiceNumber: InvoiceResponseProviderInvoiceNumber;
  providerInvoiceUrl: InvoiceResponseProviderInvoiceUrl;
  status: InvoiceStatus;
  providerErrorMessage: InvoiceResponseProviderErrorMessage;
  createdAt: string;
  sentAt: InvoiceResponseSentAt;
  ksefStatus?: InvoiceResponseKsefStatus;
}

export type InvoiceStatus = typeof InvoiceStatus[keyof typeof InvoiceStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceStatus = {
  Pending: 'Pending',
  Issued: 'Issued',
  Failed: 'Failed',
} as const;

export type IssueManualCreditRequestExpiresAt = null | string;

export interface IssueManualCreditRequest {
  expiresAt?: IssueManualCreditRequestExpiresAt;
}

export type JoinWaitlistRequestSessionId = null | string;

export type JoinWaitlistRequestScheduleId = null | string;

export type JoinWaitlistRequestMakeUpCreditId = null | string;

export type JoinWaitlistRequestExpiresAt = null | string;

export type JoinWaitlistRequestPreferredPaymentType = null | PaymentType;

export interface JoinWaitlistRequest {
  studentMemberId: string;
  sessionId: JoinWaitlistRequestSessionId;
  scheduleId: JoinWaitlistRequestScheduleId;
  preferredType: EnrollmentType;
  makeUpCreditId?: JoinWaitlistRequestMakeUpCreditId;
  expiresAt?: JoinWaitlistRequestExpiresAt;
  preferredPaymentType?: JoinWaitlistRequestPreferredPaymentType;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type LocationStatisticsRowSessions = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type LocationStatisticsRowHours = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type LocationStatisticsRowParticipants = number | string;

export interface LocationStatisticsRow {
  locationId: string;
  name: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sessions: LocationStatisticsRowSessions;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  hours: LocationStatisticsRowHours;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  participants: LocationStatisticsRowParticipants;
}

export type MailingCampaignDetailResponseEmailTemplateId = null | string;

export type MailingCampaignDetailResponseTargetId = null | string;

export type MailingCampaignDetailResponseScheduledFor = null | string;

export type MailingCampaignDetailResponseSentAt = null | string;

export interface MailingCampaignDetailResponse {
  id: string;
  schoolId: string;
  subject: string;
  body: string;
  emailTemplateId: MailingCampaignDetailResponseEmailTemplateId;
  targetType: string;
  targetId: MailingCampaignDetailResponseTargetId;
  status: string;
  scheduledFor: MailingCampaignDetailResponseScheduledFor;
  sentAt: MailingCampaignDetailResponseSentAt;
  createdAt: string;
  updatedAt: string;
  recipients: MailingRecipientResponse[];
}

export type MailingCampaignResponseEmailTemplateId = null | string;

export type MailingCampaignResponseTargetId = null | string;

export type MailingCampaignResponseScheduledFor = null | string;

export type MailingCampaignResponseSentAt = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type MailingCampaignResponseTotalRecipients = number | string;

export interface MailingCampaignResponse {
  id: string;
  schoolId: string;
  subject: string;
  body: string;
  emailTemplateId: MailingCampaignResponseEmailTemplateId;
  targetType: string;
  targetId: MailingCampaignResponseTargetId;
  status: string;
  scheduledFor: MailingCampaignResponseScheduledFor;
  sentAt: MailingCampaignResponseSentAt;
  createdAt: string;
  updatedAt: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  totalRecipients: MailingCampaignResponseTotalRecipients;
}

export type MailingRecipientResponseMemberId = null | string;

export type MailingRecipientResponseErrorMessage = null | string;

export type MailingRecipientResponseSentAt = null | string;

export interface MailingRecipientResponse {
  id: string;
  memberId: MailingRecipientResponseMemberId;
  emailAddress: string;
  fullName: string;
  status: string;
  errorMessage: MailingRecipientResponseErrorMessage;
  sentAt: MailingRecipientResponseSentAt;
}

export interface MailingWorkflowResponse {
  id: string;
  schoolId: string;
  name: string;
  triggerType: string;
  isEnabled: boolean;
  workflowDataJson: string;
  createdAt: string;
  updatedAt: string;
}

export type MaintenancePeriodResponseReason = null | string;

export interface MaintenancePeriodResponse {
  id: string;
  locationId: string;
  startDate: string;
  endDate: string;
  reason: MaintenancePeriodResponseReason;
}

export type MakeUpCreditResponseRedeemedForSessionId = null | string;

export type MakeUpCreditResponseRedeemedForSessionTitle = null | string;

export type MakeUpCreditResponseRedeemedForSessionStartsAt = null | string;

export type MakeUpCreditResponseStudentName = null | string;

export type MakeUpCreditResponseSourceSessionId = null | string;

export type MakeUpCreditResponseSourceSessionTitle = null | string;

export type MakeUpCreditResponseSourceSessionStartsAt = null | string;

export interface MakeUpCreditResponse {
  id: string;
  studentMemberId: string;
  status: CreditStatus;
  issuedAt: string;
  expiresAt: string;
  redeemedForSessionId: MakeUpCreditResponseRedeemedForSessionId;
  redeemedForSessionTitle?: MakeUpCreditResponseRedeemedForSessionTitle;
  redeemedForSessionStartsAt?: MakeUpCreditResponseRedeemedForSessionStartsAt;
  studentName?: MakeUpCreditResponseStudentName;
  sourceSessionId?: MakeUpCreditResponseSourceSessionId;
  sourceSessionTitle?: MakeUpCreditResponseSourceSessionTitle;
  sourceSessionStartsAt?: MakeUpCreditResponseSourceSessionStartsAt;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type MakeUpCreditStatisticsIssued = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type MakeUpCreditStatisticsRedeemed = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type MakeUpCreditStatisticsExpired = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type MakeUpCreditStatisticsAvailableNow = number | string;

export interface MakeUpCreditStatistics {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  issued: MakeUpCreditStatisticsIssued;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  redeemed: MakeUpCreditStatisticsRedeemed;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  expired: MakeUpCreditStatisticsExpired;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  availableNow: MakeUpCreditStatisticsAvailableNow;
}

export interface ManualEnrollRequest {
  sessionId: string;
  studentMemberId: string;
}

export type MarkAttendanceRequestMarkedAt = null | string;

export interface MarkAttendanceRequest {
  enrollmentId: string;
  status: AttendanceStatus;
  markedAt?: MarkAttendanceRequestMarkedAt;
}

export interface MarkIndividualBillPaidRequest {
  method: OnSitePaymentMethod;
}

export type MediaType = typeof MediaType[keyof typeof MediaType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaType = {
  Image: 'Image',
  Document: 'Document',
  ExternalVideo: 'ExternalVideo',
} as const;

export type MemberLiteResponseUserId = null | string;

export type MemberLiteResponseFirstName = null | string;

export type MemberLiteResponseLastName = null | string;

export type MemberLiteResponseEmail = null | string;

export interface MemberLiteResponse {
  id: string;
  userId: MemberLiteResponseUserId;
  firstName: MemberLiteResponseFirstName;
  lastName: MemberLiteResponseLastName;
  email: MemberLiteResponseEmail;
  roles: SchoolRole;
  isActive: boolean;
}

export type MemberLoginStatus = typeof MemberLoginStatus[keyof typeof MemberLoginStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberLoginStatus = {
  All: 'All',
  LoggedIn: 'LoggedIn',
  NeverLoggedIn: 'NeverLoggedIn',
} as const;

export type MemberResponseUserId = null | string;

export type MemberResponseFirstName = null | string;

export type MemberResponseLastName = null | string;

export type MemberResponseEmail = null | string;

export type MemberResponseSkillLevelId = null | string;

export type MemberResponseSkillLevelName = null | string;

export type MemberResponseSkillCategory = null | SkillCategory;

export type MemberResponseDateOfBirth = null | string;

export type MemberResponseBio = null | string;

export type MemberResponsePhotoUrl = null | string;

export type MemberResponseNotes = null | string;

export type MemberResponsePhoneNumber = null | string;

export type MemberResponseHealthDeclarationAcceptedAt = null | string;

export type MemberResponseRegulationsAcceptedAt = null | string;

export type MemberResponseImageConsentAcceptedAt = null | string;

export type MemberResponseLastLoginAt = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type MemberResponsePaymentDueDay = null | number | string;

export type MemberResponseParentId = null | string;

export type MemberResponsePreferredUiVersion = null | string;

export type MemberResponseUiVersionChangedAt = null | string;

export type MemberResponseInvoiceDetails = null | StudentInvoiceDetailsResponse;

export interface MemberResponse {
  id: string;
  userId: MemberResponseUserId;
  firstName: MemberResponseFirstName;
  lastName: MemberResponseLastName;
  email: MemberResponseEmail;
  roles: SchoolRole;
  roleNames: string[];
  isActive: boolean;
  joinedAt: string;
  isPending: boolean;
  skillLevelId: MemberResponseSkillLevelId;
  skillLevelName: MemberResponseSkillLevelName;
  skillCategory: MemberResponseSkillCategory;
  dateOfBirth: MemberResponseDateOfBirth;
  bio: MemberResponseBio;
  photoUrl: MemberResponsePhotoUrl;
  notes: MemberResponseNotes;
  gender: Gender;
  phoneNumber: MemberResponsePhoneNumber;
  receiveEmails: boolean;
  receivePush: boolean;
  healthDeclarationAccepted: boolean;
  healthDeclarationAcceptedAt: MemberResponseHealthDeclarationAcceptedAt;
  regulationsAccepted: boolean;
  regulationsAcceptedAt: MemberResponseRegulationsAcceptedAt;
  imageConsentAccepted: boolean;
  imageConsentAcceptedAt: MemberResponseImageConsentAcceptedAt;
  lastLoginAt: MemberResponseLastLoginAt;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  paymentDueDay?: MemberResponsePaymentDueDay;
  parentId?: MemberResponseParentId;
  preferredUiVersion?: MemberResponsePreferredUiVersion;
  uiVersionChangedAt?: MemberResponseUiVersionChangedAt;
  isBetaTester?: boolean;
  hasPushToken?: boolean;
  invoiceDetails?: MemberResponseInvoiceDetails;
  canManageTournaments?: boolean;
  canManageRacketStringing?: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type MembersListResponseTotalCount = number | string;

export interface MembersListResponse {
  items: MemberResponse[];
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  totalCount: MembersListResponseTotalCount;
}

export interface MergeMembersRequest {
  targetMemberId: string;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type MobileAppStatisticsUsers = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type MobileAppStatisticsIos = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type MobileAppStatisticsAndroid = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type MobileAppStatisticsUnknown = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type MobileAppStatisticsMembersWithAccount = number | string;

export interface MobileAppStatistics {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  users: MobileAppStatisticsUsers;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  ios: MobileAppStatisticsIos;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  android: MobileAppStatisticsAndroid;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  unknown: MobileAppStatisticsUnknown;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  membersWithAccount: MobileAppStatisticsMembersWithAccount;
}

export interface MoveToFamilyRequest {
  familyAdminMemberId: string;
  useParentEmail?: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type MyCampParticipantResponseWaitlistPosition = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type MyCampParticipantResponseTotalPrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type MyCampParticipantResponseDepositAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type MyCampParticipantResponseTermsVersion = null | number | string;

export type MyCampParticipantResponseDepositDueDate = null | string;

export type MyCampParticipantResponseBalanceDueDate = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type MyCampParticipantResponsePaidAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type MyCampParticipantResponseRemainingAmount = number | string;

export type MyCampParticipantResponseNextBillId = null | string;

export type MyCampParticipantResponsePendingDeclaration = null | CampPaymentDeclarationSummaryResponse;

export type MyCampParticipantResponseCancellationRequestedAt = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type MyCampParticipantResponseRefundAmount = null | number | string;

export type MyCampParticipantResponseRefundMethod = null | CampRefundMethod;

export type MyCampParticipantResponseOfferExpiresAt = null | string;

export interface MyCampParticipantResponse {
  participantId: string;
  memberId: string;
  firstName: string;
  lastName: string;
  status: CampParticipantStatus;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  waitlistPosition: MyCampParticipantResponseWaitlistPosition;
  priceOptionName: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalPrice: MyCampParticipantResponseTotalPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  depositAmount: MyCampParticipantResponseDepositAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  termsVersion: MyCampParticipantResponseTermsVersion;
  depositDueDate: MyCampParticipantResponseDepositDueDate;
  balanceDueDate: MyCampParticipantResponseBalanceDueDate;
  addonNames: string[];
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  paidAmount: MyCampParticipantResponsePaidAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  remainingAmount: MyCampParticipantResponseRemainingAmount;
  bills: CampBillResponse[];
  nextBillId: MyCampParticipantResponseNextBillId;
  pendingDeclaration: MyCampParticipantResponsePendingDeclaration;
  cancellationRequestedAt: MyCampParticipantResponseCancellationRequestedAt;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  refundAmount: MyCampParticipantResponseRefundAmount;
  refundMethod: MyCampParticipantResponseRefundMethod;
  offerExpiresAt: MyCampParticipantResponseOfferExpiresAt;
}

export type MyIndividualBookingResponseSessionId = null | string;

export type MyIndividualBookingResponseScheduleId = null | string;

export type MyIndividualBookingResponseLocationAddress = null | string;

export type MyIndividualBookingResponseStartsAt = null | string;

export type MyIndividualBookingResponseEndsAt = null | string;

export type MyIndividualBookingResponseDayOfWeek = null | DayOfWeek;

export type MyIndividualBookingResponseStartTime = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type MyIndividualBookingResponseDuration = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type MyIndividualBookingResponsePartySize = number | string;

export type MyIndividualBookingResponsePaymentMethod = null | IndividualPaymentMethod;

export type MyIndividualBookingResponseRejectionReason = null | string;

export type MyIndividualBookingResponseStatus = null | EnrollmentStatus;

export type MyIndividualBookingResponseCourtBookingUrl = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type MyIndividualBookingResponsePricePerSession = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type MyIndividualBookingResponseLateCancellationFee = number | string;

export type MyIndividualBookingResponseResignationDate = null | string;

export interface MyIndividualBookingResponse {
  bookingId: string;
  bookingType: IndividualBookingType;
  studentMemberId: string;
  studentName: string;
  sessionId: MyIndividualBookingResponseSessionId;
  scheduleId: MyIndividualBookingResponseScheduleId;
  coachName: string;
  locationName: string;
  locationAddress: MyIndividualBookingResponseLocationAddress;
  startsAt: MyIndividualBookingResponseStartsAt;
  endsAt: MyIndividualBookingResponseEndsAt;
  dayOfWeek: MyIndividualBookingResponseDayOfWeek;
  startTime: MyIndividualBookingResponseStartTime;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  duration: MyIndividualBookingResponseDuration;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  partySize: MyIndividualBookingResponsePartySize;
  companions: CompanionDto[];
  paymentMethod: MyIndividualBookingResponsePaymentMethod;
  approvalStatus: BookingApprovalStatus;
  rejectionReason: MyIndividualBookingResponseRejectionReason;
  status: MyIndividualBookingResponseStatus;
  isLateCancellation: boolean;
  courtBookingMode: CourtBookingMode;
  courtBookingUrl: MyIndividualBookingResponseCourtBookingUrl;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  pricePerSession: MyIndividualBookingResponsePricePerSession;
  canCancelFree: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  lateCancellationFee: MyIndividualBookingResponseLateCancellationFee;
  resignationDate: MyIndividualBookingResponseResignationDate;
  bills: IndividualBillInfo[];
  upcomingOccurrences: IndividualOccurrenceResponse[];
  createdAt: string;
}

export interface MySchoolMembershipDto {
  id: string;
  name: string;
  alias: string;
  roles: string[];
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type NamedCountCount = number | string;

export interface NamedCount {
  key: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  count: NamedCountCount;
}

export type NipSearchResultCompanyName = null | string;

export type NipSearchResultStreet = null | string;

export type NipSearchResultPostalCode = null | string;

export type NipSearchResultCity = null | string;

export type NipSearchResultCountry = null | string;

export type NipSearchResultErrorMessage = null | string;

export interface NipSearchResult {
  isSuccess: boolean;
  companyName: NipSearchResultCompanyName;
  street: NipSearchResultStreet;
  postalCode: NipSearchResultPostalCode;
  city: NipSearchResultCity;
  country: NipSearchResultCountry;
  errorMessage: NipSearchResultErrorMessage;
}

export type NotificationResponsePayload = null | string;

export type NotificationResponseReadAt = null | string;

export interface NotificationResponse {
  id: string;
  schoolId: string;
  title: string;
  body: string;
  payload: NotificationResponsePayload;
  isRead: boolean;
  readAt: NotificationResponseReadAt;
  createdAt: string;
  showOnDashboard: boolean;
}

export interface NotificationTemplateResponse {
  id: string;
  schoolId: string;
  notificationType: string;
  isEnabled: boolean;
  sendPush: boolean;
  sendEmail: boolean;
  titleTemplate: string;
  bodyTemplate: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type OccupancyHeatmapCellDayOfWeek = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type OccupancyHeatmapCellHour = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type OccupancyHeatmapCellSessions = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type OccupancyHeatmapCellOccupancy = number | string;

export interface OccupancyHeatmapCell {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  dayOfWeek: OccupancyHeatmapCellDayOfWeek;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  hour: OccupancyHeatmapCellHour;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sessions: OccupancyHeatmapCellSessions;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  occupancy: OccupancyHeatmapCellOccupancy;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type OnSiteBillResponseAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type OnSiteBillResponseRemainingAmount = number | string;

export type OnSiteBillResponseSessionStartsAt = null | string;

export interface OnSiteBillResponse {
  billId: string;
  studentMemberId: string;
  studentName: string;
  description: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: OnSiteBillResponseAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  remainingAmount: OnSiteBillResponseRemainingAmount;
  status: BillStatus;
  createdAt: string;
  sessionStartsAt: OnSiteBillResponseSessionStartsAt;
  coachName: string;
}

export type OnSitePaymentMethod = typeof OnSitePaymentMethod[keyof typeof OnSitePaymentMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OnSitePaymentMethod = {
  Cash: 'Cash',
  Blik: 'Blik',
} as const;

export type PaymentGatewayConfigResponseClientSecret = null | string;

export type PaymentGatewayConfigResponseExtraKey = null | string;

export interface PaymentGatewayConfigResponse {
  id: string;
  schoolId: string;
  providerName: string;
  posId: string;
  clientId: string;
  clientSecret: PaymentGatewayConfigResponseClientSecret;
  extraKey: PaymentGatewayConfigResponseExtraKey;
  isActive: boolean;
  isSandbox: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type PaymentResponseAmount = number | string;

export type PaymentResponseDescription = null | string;

export type PaymentResponseInvoiceId = null | string;

export type PaymentResponseInvoiceNumber = null | string;

export type PaymentResponseExternalTransactionId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type PaymentResponseAllocatedAmount = null | number | string;

export type PaymentResponsePayUrl = null | string;

export interface PaymentResponse {
  id: string;
  schoolId: string;
  studentMemberId: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: PaymentResponseAmount;
  type: PaymentType;
  status: PaymentStatus;
  description: PaymentResponseDescription;
  recordedAt: string;
  invoiceId?: PaymentResponseInvoiceId;
  invoiceNumber?: PaymentResponseInvoiceNumber;
  externalTransactionId?: PaymentResponseExternalTransactionId;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  allocatedAmount?: PaymentResponseAllocatedAmount;
  payUrl?: PaymentResponsePayUrl;
}

export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentStatus = {
  Pending: 'Pending',
  Completed: 'Completed',
  Failed: 'Failed',
  Refunded: 'Refunded',
  Cancelled: 'Cancelled',
} as const;

export type PaymentType = typeof PaymentType[keyof typeof PaymentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentType = {
  Cash: 'Cash',
  BankTransfer: 'BankTransfer',
  Online: 'Online',
  Voucher: 'Voucher',
  Balance: 'Balance',
  Blik: 'Blik',
} as const;

export type PayStudentBalanceRequestReturnUrl = null | string;

export type PayStudentBalanceRequestDescription = null | string;

export interface PayStudentBalanceRequest {
  studentMemberId: string;
  type: PaymentType;
  returnUrl?: PayStudentBalanceRequestReturnUrl;
  description?: PayStudentBalanceRequestDescription;
  enableAutoPay?: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type PayStudentBalanceWithVouchersResponseAmountCovered = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type PayStudentBalanceWithVouchersResponseRemainingDebt = number | string;

export type PayStudentBalanceWithVouchersResponsePaymentId = null | string;

export interface PayStudentBalanceWithVouchersResponse {
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amountCovered: PayStudentBalanceWithVouchersResponseAmountCovered;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  remainingDebt: PayStudentBalanceWithVouchersResponseRemainingDebt;
  paymentId: PayStudentBalanceWithVouchersResponsePaymentId;
}

export type PendingEnrollmentResponseStudentEmail = null | string;

export type PendingEnrollmentResponseStudentSkillLevelId = null | string;

export type PendingEnrollmentResponseStudentSkillLevelName = null | string;

export interface PendingEnrollmentResponse {
  enrollmentId: string;
  sessionId: string;
  studentMemberId: string;
  studentName: string;
  studentEmail: PendingEnrollmentResponseStudentEmail;
  sessionTitle: string;
  skillLevelName: string;
  sessionStartsAt: string;
  type: EnrollmentType;
  enrolledAt: string;
  studentSkillLevelId: PendingEnrollmentResponseStudentSkillLevelId;
  studentSkillLevelName: PendingEnrollmentResponseStudentSkillLevelName;
  isPaid?: boolean;
  paymentStatus?: EnrollmentPaymentStatus;
}

export interface PlaceholderInfo {
  token: string;
  description: string;
  example: string;
}

export type PriceListItemResponseValidTo = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type PriceListItemResponseDuration = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type PriceListItemResponseDropInPrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type PriceListItemResponseMonthlyBasePrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type PriceListItemResponseEquipmentSurcharge = number | string;

export type PriceListItemResponseGrandfatheringUntil = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type PriceListItemResponsePartySizeFrom = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type PriceListItemResponsePartySizeTo = null | number | string;

export interface PriceListItemResponse {
  id: string;
  priceListId: string;
  validFrom: string;
  validTo: PriceListItemResponseValidTo;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  duration: PriceListItemResponseDuration;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  dropInPrice: PriceListItemResponseDropInPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  monthlyBasePrice: PriceListItemResponseMonthlyBasePrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  equipmentSurcharge: PriceListItemResponseEquipmentSurcharge;
  grandfatheringUntil?: PriceListItemResponseGrandfatheringUntil;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  partySizeFrom?: PriceListItemResponsePartySizeFrom;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  partySizeTo?: PriceListItemResponsePartySizeTo;
}

export type PromoResponseTargetUrl = null | string;

export type PromoResponsePublishEndDate = null | string;

export interface PromoResponse {
  id: string;
  schoolId: string;
  displayKey: string;
  title: string;
  imageUrl: string;
  targetUrl: PromoResponseTargetUrl;
  publishStartDate: string;
  publishEndDate: PromoResponsePublishEndDate;
  isActive: boolean;
  isCurrentlyPublished: boolean;
  createdAt: string;
  updatedAt: string;
}

export type PromoteCampParticipantRequestDueDate = null | string;

export interface PromoteCampParticipantRequest {
  overrideCapacity: boolean;
  dueDate: PromoteCampParticipantRequestDueDate;
}

export type ProvisionSchoolRequestAddress = null | string;

export type ProvisionSchoolRequestAdminFirstName = null | string;

export type ProvisionSchoolRequestAdminLastName = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type ProvisionSchoolRequestMakeUpCreditExpiryDays = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type ProvisionSchoolRequestSubscriptionBillingDay = number | string;

export interface ProvisionSchoolRequest {
  name: string;
  alias: string;
  address: ProvisionSchoolRequestAddress;
  sportType: SportType;
  timezone: string;
  currency: string;
  adminEmail: string;
  adminFirstName: ProvisionSchoolRequestAdminFirstName;
  adminLastName: ProvisionSchoolRequestAdminLastName;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  makeUpCreditExpiryDays?: ProvisionSchoolRequestMakeUpCreditExpiryDays;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  subscriptionBillingDay?: ProvisionSchoolRequestSubscriptionBillingDay;
}

export type PublicCampTermsResponseSchoolLogoUrl = null | string;

export type PublicCampTermsResponseVenueAddress = null | string;

export type PublicCampTermsResponseWebsiteUrl = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type PublicCampTermsResponseVersion = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type PublicCampTermsResponseLatestVersion = number | string;

export interface PublicCampTermsResponse {
  schoolName: string;
  schoolLogoUrl: PublicCampTermsResponseSchoolLogoUrl;
  timezone: string;
  campName: string;
  campSlug: string;
  venueName: string;
  venueAddress: PublicCampTermsResponseVenueAddress;
  websiteUrl: PublicCampTermsResponseWebsiteUrl;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  version: PublicCampTermsResponseVersion;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  latestVersion: PublicCampTermsResponseLatestVersion;
  publishedAt: string;
  content: string;
  snapshot: CampTermsSnapshot;
  versions: CampTermsVersionSummaryResponse[];
}

export interface PublicCoachResponse {
  id: string;
  fullName: string;
}

export interface RacketStringerResponse {
  id: string;
  fullName: string;
  isActive: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type RacketStringingOrderListResponseTotalCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type RacketStringingOrderListResponsePage = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type RacketStringingOrderListResponsePageSize = number | string;

export interface RacketStringingOrderListResponse {
  items: RacketStringingOrderResponse[];
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  totalCount: RacketStringingOrderListResponseTotalCount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  page: RacketStringingOrderListResponsePage;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pageSize: RacketStringingOrderListResponsePageSize;
}

export type RacketStringingOrderResponsePlayerFirstName = null | string;

export type RacketStringingOrderResponsePlayerLastName = null | string;

export type RacketStringingOrderResponsePlayerPhoneNumber = null | string;

export type RacketStringingOrderResponsePlayerNotes = null | string;

export type RacketStringingOrderResponseStringerName = null | string;

export type RacketStringingOrderResponseHandedToStringerAt = null | string;

export type RacketStringingOrderResponseHandedOverByName = null | string;

export type RacketStringingOrderResponseCompletedAt = null | string;

export type RacketStringingOrderResponseStaffNotes = null | string;

export interface RacketStringingOrderResponse {
  id: string;
  memberId: string;
  playerFirstName: RacketStringingOrderResponsePlayerFirstName;
  playerLastName: RacketStringingOrderResponsePlayerLastName;
  playerPhoneNumber: RacketStringingOrderResponsePlayerPhoneNumber;
  contactEmail: string;
  racketModel: string;
  gripColor: string;
  tension: string;
  stringType: string;
  playerNotes: RacketStringingOrderResponsePlayerNotes;
  status: RacketStringingStatus;
  stringerName: RacketStringingOrderResponseStringerName;
  handedToStringerAt: RacketStringingOrderResponseHandedToStringerAt;
  handedOverByName: RacketStringingOrderResponseHandedOverByName;
  completedAt: RacketStringingOrderResponseCompletedAt;
  isPaid: boolean;
  staffNotes: RacketStringingOrderResponseStaffNotes;
  createdAt: string;
  updatedAt: string;
}

export type RacketStringingSettingsResponseInstructions = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type RacketStringingSettingsResponsePrice = null | number | string;

export interface RacketStringingSettingsResponse {
  instructions: RacketStringingSettingsResponseInstructions;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  price: RacketStringingSettingsResponsePrice;
  currency: string;
  defaultTension: string;
  defaultStringType: string;
}

export type RacketStringingStatus = typeof RacketStringingStatus[keyof typeof RacketStringingStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RacketStringingStatus = {
  Submitted: 'Submitted',
  AtStringer: 'AtStringer',
  Ready: 'Ready',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
} as const;

export type RecipientPreviewItemDtoRole = null | string;

export interface RecipientPreviewItemDto {
  id: string;
  fullName: string;
  email: string;
  role: RecipientPreviewItemDtoRole;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type RecipientPreviewResponseTotalCount = number | string;

export interface RecipientPreviewResponse {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  totalCount: RecipientPreviewResponseTotalCount;
  recipients: RecipientPreviewItemDto[];
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type RecordCampPaymentRequestAmount = null | number | string;

export interface RecordCampPaymentRequest {
  method: PaymentType;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: RecordCampPaymentRequestAmount;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type RecordCoachPaymentRequestAmount = number | string;

export type RecordCoachPaymentRequestDescription = null | string;

export interface RecordCoachPaymentRequest {
  studentMemberId: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: RecordCoachPaymentRequestAmount;
  description: RecordCoachPaymentRequestDescription;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type RecordPaymentRequestAmount = number | string;

export type RecordPaymentRequestDescription = null | string;

export type RecordPaymentRequestBillId = null | string;

export type RecordPaymentRequestRecordedByMemberId = null | string;

export interface RecordPaymentRequest {
  studentMemberId: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: RecordPaymentRequestAmount;
  type: PaymentType;
  description: RecordPaymentRequestDescription;
  billId?: RecordPaymentRequestBillId;
  recordedByMemberId?: RecordPaymentRequestRecordedByMemberId;
}

export type RedeemCouponRequestStudentMemberId = null | string;

export interface RedeemCouponRequest {
  code: string;
  studentMemberId?: RedeemCouponRequestStudentMemberId;
}

export interface RedeemCreditRequest {
  creditId: string;
  sessionId: string;
}

export interface RefundPaymentRequest {
  forceManual?: boolean;
}

export interface RegisterDomainRequest {
  domain: string;
}

export type RegisterPushTokenRequestPlatform = null | string;

export type RegisterPushTokenRequestDeviceInfo = null | string;

export interface RegisterPushTokenRequest {
  token: string;
  platform?: RegisterPushTokenRequestPlatform;
  deviceInfo?: RegisterPushTokenRequestDeviceInfo;
}

export type RegulationResponseIntroMessage = null | string;

export interface RegulationResponse {
  id: string;
  schoolId: string;
  language: string;
  title: string;
  content: string;
  introMessage: RegulationResponseIntroMessage;
  publishedAt: string;
  effectiveAt: string;
  isNotified: boolean;
  createdAt: string;
  updatedAt: string;
  type?: RegulationType;
}

export type RegulationType = typeof RegulationType[keyof typeof RegulationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegulationType = {
  General: 'General',
  IndividualClasses: 'IndividualClasses',
} as const;

export type RejectCampPaymentDeclarationRequestReason = null | string;

export interface RejectCampPaymentDeclarationRequest {
  reason: RejectCampPaymentDeclarationRequestReason;
}

export type RejectIndividualBookingRequestReason = null | string;

export interface RejectIndividualBookingRequest {
  reason: RejectIndividualBookingRequestReason;
}

export type RemoveCampParticipantRequestReason = null | string;

export interface RemoveCampParticipantRequest {
  reason: RemoveCampParticipantRequestReason;
}

export interface ReorderSkillLevelsRequest {
  skillLevelIds: string[];
}

export interface ReorderTournamentQueueRequest {
  gameIds: string[];
}

export interface ReportAbsenceRequest {
  enrollmentId: string;
}

export type RequestCampCancellationRequestPreferredRefundMethod = null | CampRefundMethod;

export type RequestCampCancellationRequestRefundBankAccount = null | string;

export type RequestCampCancellationRequestNote = null | string;

export interface RequestCampCancellationRequest {
  preferredRefundMethod: RequestCampCancellationRequestPreferredRefundMethod;
  refundBankAccount: RequestCampCancellationRequestRefundBankAccount;
  note: RequestCampCancellationRequestNote;
}

export interface RequestSubstitutionRequest {
  sessionId: string;
  targetCoachMemberId: string;
}

export type ResignationPreviewResponseLastSessionDate = null | string;

export interface ResignationPreviewResponse {
  currentMonth: string;
  nextBillingMonth: string;
  effectiveResignationDate: string;
  isPastDeadline: boolean;
  lastSessionDate: ResignationPreviewResponseLastSessionDate;
  resignationRule: ResignationRule;
}

export type ResignationRule = typeof ResignationRule[keyof typeof ResignationRule];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResignationRule = {
  Standard: 'Standard',
  OneMonthNotice: 'OneMonthNotice',
} as const;

export type ResignStudentGroupRequestResignationDate = null | string;

export interface ResignStudentGroupRequest {
  studentMemberId: string;
  scheduleId: string;
  resignationDate?: ResignStudentGroupRequestResignationDate;
}

export interface RespondToSubstitutionRequest {
  accept: boolean;
}

export interface RespondToUnavailabilityRequest {
  approve: boolean;
}

export type RestoreCampParticipantRequestDueDate = null | string;

export interface RestoreCampParticipantRequest {
  overrideCapacity: boolean;
  dueDate: RestoreCampParticipantRequestDueDate;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type RevenuePointOnline = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type RevenuePointBankTransfer = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type RevenuePointCash = number | string;

export interface RevenuePoint {
  period: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  online: RevenuePointOnline;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  bankTransfer: RevenuePointBankTransfer;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  cash: RevenuePointCash;
}

export type ScheduleEnrollmentResponseResignationDate = null | string;

export type ScheduleEnrollmentResponseStudentFirstName = null | string;

export type ScheduleEnrollmentResponseStudentLastName = null | string;

export type ScheduleEnrollmentResponseStudentEmail = null | string;

export interface ScheduleEnrollmentResponse {
  id: string;
  schoolId: string;
  studentMemberId: string;
  scheduleId: string;
  startDate: string;
  resignationDate: ScheduleEnrollmentResponseResignationDate;
  createdAt: string;
  updatedAt: string;
  studentFirstName?: ScheduleEnrollmentResponseStudentFirstName;
  studentLastName?: ScheduleEnrollmentResponseStudentLastName;
  studentEmail?: ScheduleEnrollmentResponseStudentEmail;
  isApproved?: boolean;
  isCorporate?: boolean;
}

export type ScheduleResponseCoachMemberId = null | string;

export type ScheduleResponsePriceListId = null | string;

export type ScheduleResponsePricingModelId = null | string;

export type ScheduleResponseSkillLevelName = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type ScheduleResponseDuration = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type ScheduleResponseMaxParticipants = number | string;

export type ScheduleResponseEndDate = null | string;

export type ScheduleResponseBannerUrl = null | string;

export type ScheduleResponseInfoUrl = null | string;

export type ScheduleResponseAdditionalInformation = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type ScheduleResponseCustomDropInPrice = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type ScheduleResponseCustomMonthlyPrice = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type ScheduleResponseCustomEquipmentSurcharge = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type ScheduleResponseCorporateSlotsCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type ScheduleResponseActiveSubscribersCount = number | string;

export type ScheduleResponseTags = null | string[];

export type ScheduleResponseSecondCoachMemberId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type ScheduleResponseAvailableSpots = number | string;

export interface ScheduleResponse {
  id: string;
  schoolId: string;
  name: string;
  locationId: string;
  coachMemberId: ScheduleResponseCoachMemberId;
  priceListId: ScheduleResponsePriceListId;
  pricingModelId: ScheduleResponsePricingModelId;
  skillLevelId: string;
  skillLevelName: ScheduleResponseSkillLevelName;
  dayOfWeek: DayOfWeek;
  startTime: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  duration: ScheduleResponseDuration;
  equipmentType: EquipmentType;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxParticipants: ScheduleResponseMaxParticipants;
  isActive: boolean;
  startDate: string;
  endDate: ScheduleResponseEndDate;
  recurrencePattern: string;
  isPromoted: boolean;
  isPrivate: boolean;
  isEnrollmentBlocked: boolean;
  bannerUrl: ScheduleResponseBannerUrl;
  infoUrl: ScheduleResponseInfoUrl;
  additionalInformation: ScheduleResponseAdditionalInformation;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  customDropInPrice: ScheduleResponseCustomDropInPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  customMonthlyPrice: ScheduleResponseCustomMonthlyPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  customEquipmentSurcharge: ScheduleResponseCustomEquipmentSurcharge;
  isCoursePaidOnce: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  corporateSlotsCount: ScheduleResponseCorporateSlotsCount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  activeSubscribersCount?: ScheduleResponseActiveSubscribersCount;
  disableMakeups?: boolean;
  tags?: ScheduleResponseTags;
  secondCoachMemberId?: ScheduleResponseSecondCoachMemberId;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  availableSpots?: ScheduleResponseAvailableSpots;
  isFull?: boolean;
}

export type SchoolContextDtoSkillLevelName = null | string;

export type SchoolContextDtoParentId = null | string;

export interface SchoolContextDto {
  id: string;
  memberId: string;
  name: string;
  alias: string;
  roles: string[];
  enabledModules: string[];
  enabledFeatures: string[];
  skillLevelName?: SchoolContextDtoSkillLevelName;
  parentId?: SchoolContextDtoParentId;
  canManageTournaments?: boolean;
  canManageRacketStringing?: boolean;
}

export interface SchoolCreationAllowedResponse {
  isAllowed: boolean;
}

export type SchoolDomainResponseVerifiedAt = null | string;

export interface SchoolDomainResponse {
  id: string;
  domain: string;
  isVerified: boolean;
  isActive: boolean;
  createdAt: string;
  verifiedAt: SchoolDomainResponseVerifiedAt;
}

export interface SchoolHolidayImpactRequest {
  dates: string[];
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SchoolHolidayImpactResponseSessionCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SchoolHolidayImpactResponseEnrollmentCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SchoolHolidayImpactResponseStudentCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SchoolHolidayImpactResponseRefundedEnrollmentCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type SchoolHolidayImpactResponseRefundAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SchoolHolidayImpactResponseRestoredMakeUpCreditCount = number | string;

export interface SchoolHolidayImpactResponse {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sessionCount: SchoolHolidayImpactResponseSessionCount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  enrollmentCount: SchoolHolidayImpactResponseEnrollmentCount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  studentCount: SchoolHolidayImpactResponseStudentCount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  refundedEnrollmentCount: SchoolHolidayImpactResponseRefundedEnrollmentCount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  refundAmount: SchoolHolidayImpactResponseRefundAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  restoredMakeUpCreditCount: SchoolHolidayImpactResponseRestoredMakeUpCreditCount;
  sessions: SchoolHolidayImpactSessionDto[];
}

export type SchoolHolidayImpactSessionDtoTitle = null | string;

export type SchoolHolidayImpactSessionDtoLocationName = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SchoolHolidayImpactSessionDtoEnrollmentCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type SchoolHolidayImpactSessionDtoRefundAmount = number | string;

export interface SchoolHolidayImpactSessionDto {
  sessionId: string;
  startsAt: string;
  title: SchoolHolidayImpactSessionDtoTitle;
  locationName: SchoolHolidayImpactSessionDtoLocationName;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  enrollmentCount: SchoolHolidayImpactSessionDtoEnrollmentCount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  refundAmount: SchoolHolidayImpactSessionDtoRefundAmount;
}

export type SchoolHolidayResponseName = null | string;

export interface SchoolHolidayResponse {
  id: string;
  date: string;
  name: SchoolHolidayResponseName;
}

export type SchoolIntegrationsResponseSmtpHost = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SchoolIntegrationsResponseSmtpPort = number | string;

export type SchoolIntegrationsResponseSmtpUsername = null | string;

export type SchoolIntegrationsResponseSmtpPassword = null | string;

export type SchoolIntegrationsResponseSmtpFromAddress = null | string;

export type SchoolIntegrationsResponseSmtpFromName = null | string;

export type SchoolIntegrationsResponseSmtpReplyToAddress = null | string;

export type SchoolIntegrationsResponseGetResponseApiKey = null | string;

export type SchoolIntegrationsResponseGetResponseListId = null | string;

export type SchoolIntegrationsResponseGetResponseCustomFieldAmountId = null | string;

export type SchoolIntegrationsResponseGetResponseCustomFieldMonthId = null | string;

export type SchoolIntegrationsResponseGetResponseCustomFieldTriggerId = null | string;

export type SchoolIntegrationsResponseFakturowniaSubdomain = null | string;

export type SchoolIntegrationsResponseFakturowniaApiToken = null | string;

export type SchoolIntegrationsResponseFakturowniaDepartmentId = null | string;

export interface SchoolIntegrationsResponse {
  emailProvider: string;
  smtpHost: SchoolIntegrationsResponseSmtpHost;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  smtpPort: SchoolIntegrationsResponseSmtpPort;
  smtpUsername: SchoolIntegrationsResponseSmtpUsername;
  smtpPassword: SchoolIntegrationsResponseSmtpPassword;
  smtpEnableSsl: boolean;
  smtpFromAddress: SchoolIntegrationsResponseSmtpFromAddress;
  smtpFromName: SchoolIntegrationsResponseSmtpFromName;
  smtpReplyToAddress: SchoolIntegrationsResponseSmtpReplyToAddress;
  getResponseApiKey: SchoolIntegrationsResponseGetResponseApiKey;
  getResponseListId: SchoolIntegrationsResponseGetResponseListId;
  getResponseCustomFieldAmountId: SchoolIntegrationsResponseGetResponseCustomFieldAmountId;
  getResponseCustomFieldMonthId: SchoolIntegrationsResponseGetResponseCustomFieldMonthId;
  getResponseCustomFieldTriggerId: SchoolIntegrationsResponseGetResponseCustomFieldTriggerId;
  isInvoiceIntegrationEnabled: boolean;
  fakturowniaSubdomain: SchoolIntegrationsResponseFakturowniaSubdomain;
  fakturowniaApiToken: SchoolIntegrationsResponseFakturowniaApiToken;
  fakturowniaDepartmentId: SchoolIntegrationsResponseFakturowniaDepartmentId;
  fakturowniaSendToKsef?: boolean;
}

export type SchoolPaymentDetailsResponseSwiftBic = null | string;

export interface SchoolPaymentDetailsResponse {
  schoolId: string;
  recipientName: string;
  bankName: string;
  accountNumber: string;
  swiftBic: SchoolPaymentDetailsResponseSwiftBic;
}

export type SchoolResponseAddress = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SchoolResponseMakeUpCreditExpiryDays = number | string;

export type SchoolResponseLogoUrl = null | string;

export type SchoolResponseSlogan = null | string;

export type SchoolResponsePrimaryColor = null | string;

export type SchoolResponseSecondaryColor = null | string;

export type SchoolResponseEnabledFeatures = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SchoolResponseSubscriptionBillingDay = number | string;

export type SchoolResponseInstructionUrl = null | string;

export type SchoolResponseSupportEmail = null | string;

export type SchoolResponseSupportTopics = null | string;

export interface SchoolResponse {
  id: string;
  name: string;
  alias: string;
  address: SchoolResponseAddress;
  sportType: SportType;
  timezone: string;
  currency: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  makeUpCreditExpiryDays: SchoolResponseMakeUpCreditExpiryDays;
  allowedSessionDurations: string;
  logoUrl: SchoolResponseLogoUrl;
  slogan: SchoolResponseSlogan;
  primaryColor: SchoolResponsePrimaryColor;
  secondaryColor: SchoolResponseSecondaryColor;
  isActive: boolean;
  occupancyThresholds: string;
  resignationRule: ResignationRule;
  subscriptionDiscountTiers: string;
  showProgress: boolean;
  enabledFeatures?: SchoolResponseEnabledFeatures;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  subscriptionBillingDay?: SchoolResponseSubscriptionBillingDay;
  autoIssueSubscriberDropInVoucher?: boolean;
  instructionUrl?: SchoolResponseInstructionUrl;
  supportEmail?: SchoolResponseSupportEmail;
  supportTopics?: SchoolResponseSupportTopics;
}

export type SchoolRole = string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type SchoolStatisticsResponseOutstandingTotal = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SchoolStatisticsResponseOutstandingBillCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SchoolStatisticsResponseCancelledSessions = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SchoolStatisticsResponseCancelledEnrollments = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SchoolStatisticsResponseLateCancellations = number | string;

export interface SchoolStatisticsResponse {
  from: string;
  to: string;
  granularity: StatisticsGranularity;
  current: StatisticsKpis;
  previous: StatisticsKpis;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  outstandingTotal: SchoolStatisticsResponseOutstandingTotal;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  outstandingBillCount: SchoolStatisticsResponseOutstandingBillCount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  cancelledSessions: SchoolStatisticsResponseCancelledSessions;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  cancelledEnrollments: SchoolStatisticsResponseCancelledEnrollments;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  lateCancellations: SchoolStatisticsResponseLateCancellations;
  revenue: RevenuePoint[];
  billingCollection: BillingCollectionPoint[];
  studentFlow: StudentFlowPoint[];
  attendance: AttendancePoint[];
  occupancyHeatmap: OccupancyHeatmapCell[];
  groups: GroupStatisticsRow[];
  coaches: CoachStatisticsRow[];
  locations: LocationStatisticsRow[];
  enrollmentMix: NamedCount[];
  receivablesAging: AgingBucket[];
  topDebtors: DebtorRow[];
  makeUpCredits: MakeUpCreditStatistics;
  waitlist: WaitlistStatistics;
  mobileApp: MobileAppStatistics;
  gender: NamedCount[];
  ageGroups: NamedCount[];
  skillLevels: NamedCount[];
}

export type SendBatchNotificationRequestPayload = null | string;

export interface SendBatchNotificationRequest {
  memberIds: string[];
  title: string;
  body: string;
  payload?: SendBatchNotificationRequestPayload;
}

export interface SendCampWaitlistOffersRequest {
  participantIds: string[];
  expiresOn: string;
}

export type SendCustomNotificationRequestPayload = null | string;

export interface SendCustomNotificationRequest {
  title: string;
  body: string;
  payload?: SendCustomNotificationRequestPayload;
}

export interface SendSessionMessageRequest {
  subject: string;
  body: string;
}

export type SendSupportTicketRequestPhoneNumber = null | string;

export interface SendSupportTicketRequest {
  topic: string;
  message: string;
  email: string;
  phoneNumber: SendSupportTicketRequestPhoneNumber;
}

export interface SendTestNotificationRequest {
  email: string;
}

export type SessionMessageRecipientResponseMemberId = null | string;

export type SessionMessageRecipientResponseErrorMessage = null | string;

export type SessionMessageRecipientResponseSentAt = null | string;

export interface SessionMessageRecipientResponse {
  id: string;
  memberId: SessionMessageRecipientResponseMemberId;
  emailAddress: string;
  fullName: string;
  status: string;
  errorMessage: SessionMessageRecipientResponseErrorMessage;
  sentAt: SessionMessageRecipientResponseSentAt;
}

export type SessionMessageResponseSentAt = null | string;

export interface SessionMessageResponse {
  id: string;
  schoolId: string;
  subject: string;
  body: string;
  status: string;
  sentAt: SessionMessageResponseSentAt;
  createdAt: string;
  recipients: SessionMessageRecipientResponse[];
}

export type SessionNavigationInfoPrevSessionId = null | string;

export type SessionNavigationInfoPrevSessionStartsAt = null | string;

export type SessionNavigationInfoNextSessionId = null | string;

export type SessionNavigationInfoNextSessionStartsAt = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SessionNavigationInfoCurrentIndex = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SessionNavigationInfoTotalCount = number | string;

export interface SessionNavigationInfo {
  prevSessionId: SessionNavigationInfoPrevSessionId;
  prevSessionStartsAt: SessionNavigationInfoPrevSessionStartsAt;
  nextSessionId: SessionNavigationInfoNextSessionId;
  nextSessionStartsAt: SessionNavigationInfoNextSessionStartsAt;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  currentIndex: SessionNavigationInfoCurrentIndex;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  totalCount: SessionNavigationInfoTotalCount;
}

export type SessionResponseScheduleId = null | string;

export type SessionResponsePricingModelId = null | string;

export type SessionResponseCoachMemberId = null | string;

export type SessionResponseSkillLevelName = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SessionResponseMaxParticipants = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SessionResponseEnrolledCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type SessionResponseDropInPrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type SessionResponseEquipmentSurcharge = number | string;

export type SessionResponseTopic = null | string;

export type SessionResponseDescription = null | string;

export type SessionResponseBannerUrl = null | string;

export type SessionResponseInfoUrl = null | string;

export type SessionResponseAdditionalInformation = null | string;

export type SessionResponseSummaryNotes = null | string;

export type SessionResponseCancellationReason = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SessionResponseCorporateSlotsCount = number | string;

export type SessionResponseNavigation = null | SessionNavigationInfo;

export type SessionResponseSecondCoachMemberId = null | string;

export type SessionResponseSummaryUpdatedAt = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SessionResponseAvailableSpots = number | string;

export interface SessionResponse {
  id: string;
  schoolId: string;
  locationId: string;
  scheduleId: SessionResponseScheduleId;
  pricingModelId: SessionResponsePricingModelId;
  coachMemberId: SessionResponseCoachMemberId;
  type: SessionType;
  status: SessionStatus;
  skillLevelId: string;
  skillLevelName: SessionResponseSkillLevelName;
  equipmentType: EquipmentType;
  startsAt: string;
  endsAt: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxParticipants: SessionResponseMaxParticipants;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  enrolledCount: SessionResponseEnrolledCount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  dropInPrice: SessionResponseDropInPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  equipmentSurcharge: SessionResponseEquipmentSurcharge;
  title: string;
  topic: SessionResponseTopic;
  description: SessionResponseDescription;
  isPromoted: boolean;
  isPrivate: boolean;
  isEnrollmentBlocked: boolean;
  bannerUrl: SessionResponseBannerUrl;
  infoUrl: SessionResponseInfoUrl;
  additionalInformation: SessionResponseAdditionalInformation;
  summaryNotes: SessionResponseSummaryNotes;
  cancellationReason: SessionResponseCancellationReason;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  corporateSlotsCount: SessionResponseCorporateSlotsCount;
  disableMakeups: boolean;
  tags: string[];
  navigation?: SessionResponseNavigation;
  secondCoachMemberId?: SessionResponseSecondCoachMemberId;
  summaryUpdatedAt?: SessionResponseSummaryUpdatedAt;
  isGameDay?: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  availableSpots?: SessionResponseAvailableSpots;
  isFull?: boolean;
}

export type SessionStatus = typeof SessionStatus[keyof typeof SessionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SessionStatus = {
  Scheduled: 'Scheduled',
  Cancelled: 'Cancelled',
  Completed: 'Completed',
} as const;

export type SessionType = typeof SessionType[keyof typeof SessionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SessionType = {
  Regular: 'Regular',
  Event: 'Event',
} as const;

export type SetDateRangeUnavailabilityRequestReason = null | string;

export interface SetDateRangeUnavailabilityRequest {
  startDate: string;
  endDate: string;
  reason: SetDateRangeUnavailabilityRequestReason;
}

export interface SetEnrollmentBlockedRequest {
  isBlocked: boolean;
}

export interface SetGameDaysRequest {
  sessionIds: string[];
  isGameDay: boolean;
}

export interface SetRecurringUnavailabilityRequest {
  dayOfWeek: DayOfWeek;
  blockStart: string;
  blockEnd: string;
}

export interface SetSchoolActiveRequest {
  isActive: boolean;
}

export interface SetSessionGameDayRequest {
  isGameDay: boolean;
}

export type SetStudentSkillLevelRequestSkillLevelId = null | string;

export type SetStudentSkillLevelRequestNotes = null | string;

export interface SetStudentSkillLevelRequest {
  studentMemberId: string;
  skillLevelId: SetStudentSkillLevelRequestSkillLevelId;
  notes: SetStudentSkillLevelRequestNotes;
}

export interface SetTournamentCourtAvailabilityRequest {
  isActive: boolean;
}

export interface SetTournamentGroupManualOrderRequest {
  entryIds: string[];
}

export interface SetTournamentMatchLineupRequest {
  games: TournamentGameLineupInput[];
}

export interface SetUiPreferenceRequest {
  uiVersion: string;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SetupTournamentGroupsRequestGroupCount = number | string;

export interface SetupTournamentGroupsRequest {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  groupCount: SetupTournamentGroupsRequestGroupCount;
}

export type SkillCategory = typeof SkillCategory[keyof typeof SkillCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SkillCategory = {
  Child: 'Child',
  Beginner: 'Beginner',
  Intermediate: 'Intermediate',
  Advanced: 'Advanced',
} as const;

export type SkillLevelCategory = typeof SkillLevelCategory[keyof typeof SkillLevelCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SkillLevelCategory = {
  Adults: 'Adults',
  Youth: 'Youth',
  Children: 'Children',
} as const;

export type SlotSourceKind = typeof SlotSourceKind[keyof typeof SlotSourceKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SlotSourceKind = {
  Group: 'Group',
  Winner: 'Winner',
  Loser: 'Loser',
} as const;

export type SportType = typeof SportType[keyof typeof SportType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SportType = {
  Badminton: 'Badminton',
  Tennis: 'Tennis',
  Padel: 'Padel',
  TableTennis: 'TableTennis',
  Volleyball: 'Volleyball',
  Other: 'Other',
} as const;

export type StatisticsGranularity = typeof StatisticsGranularity[keyof typeof StatisticsGranularity];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StatisticsGranularity = {
  Day: 'Day',
  Week: 'Week',
  Month: 'Month',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type StatisticsKpisRevenue = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type StatisticsKpisNewStudents = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type StatisticsKpisActiveSubscribers = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type StatisticsKpisAttendanceRate = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type StatisticsKpisAverageOccupancy = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type StatisticsKpisSessionsHeld = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type StatisticsKpisEnrollments = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type StatisticsKpisResignations = number | string;

export interface StatisticsKpis {
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  revenue: StatisticsKpisRevenue;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  newStudents: StatisticsKpisNewStudents;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  activeSubscribers: StatisticsKpisActiveSubscribers;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  attendanceRate: StatisticsKpisAttendanceRate;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  averageOccupancy: StatisticsKpisAverageOccupancy;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sessionsHeld: StatisticsKpisSessionsHeld;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  enrollments: StatisticsKpisEnrollments;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  resignations: StatisticsKpisResignations;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type StudentBalanceResponseTotalPaid = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type StudentBalanceResponseTotalCharged = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type StudentBalanceResponseBalance = number | string;

export interface StudentBalanceResponse {
  studentMemberId: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalPaid: StudentBalanceResponseTotalPaid;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalCharged: StudentBalanceResponseTotalCharged;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  balance: StudentBalanceResponseBalance;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type StudentFlowPointNewStudents = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type StudentFlowPointResignations = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type StudentFlowPointActiveSubscribers = number | string;

export interface StudentFlowPoint {
  period: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  newStudents: StudentFlowPointNewStudents;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  resignations: StudentFlowPointResignations;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  activeSubscribers: StudentFlowPointActiveSubscribers;
}

export type StudentInvoiceDetailsResponseCompanyName = null | string;

export type StudentInvoiceDetailsResponseTaxId = null | string;

export type StudentInvoiceDetailsResponseStreet = null | string;

export type StudentInvoiceDetailsResponsePostalCode = null | string;

export type StudentInvoiceDetailsResponseCity = null | string;

export type StudentInvoiceDetailsResponseCountry = null | string;

export interface StudentInvoiceDetailsResponse {
  schoolMemberId: string;
  requestVatInvoice: boolean;
  companyName: StudentInvoiceDetailsResponseCompanyName;
  taxId: StudentInvoiceDetailsResponseTaxId;
  street: StudentInvoiceDetailsResponseStreet;
  postalCode: StudentInvoiceDetailsResponsePostalCode;
  city: StudentInvoiceDetailsResponseCity;
  country: StudentInvoiceDetailsResponseCountry;
}

export type StudentInvoiceResponseInvoiceNumber = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type StudentInvoiceResponseAmount = number | string;

export type StudentInvoiceResponseDescription = null | string;

export interface StudentInvoiceResponse {
  id: string;
  studentMemberId: string;
  studentName: string;
  invoiceNumber: StudentInvoiceResponseInvoiceNumber;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: StudentInvoiceResponseAmount;
  description: StudentInvoiceResponseDescription;
  issuedAt: string;
}

export type StudentNegativeBalanceDtoPhoneNumber = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type StudentNegativeBalanceDtoBalance = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type StudentNegativeBalanceDtoTotalCharged = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type StudentNegativeBalanceDtoTotalPaid = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type StudentNegativeBalanceDtoUnpaidBillsCount = number | string;

export type StudentNegativeBalanceDtoLastPaymentDate = null | string;

export type StudentNegativeBalanceDtoLastBillDate = null | string;

export interface StudentNegativeBalanceDto {
  studentMemberId: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: StudentNegativeBalanceDtoPhoneNumber;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  balance: StudentNegativeBalanceDtoBalance;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalCharged: StudentNegativeBalanceDtoTotalCharged;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalPaid: StudentNegativeBalanceDtoTotalPaid;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  unpaidBillsCount: StudentNegativeBalanceDtoUnpaidBillsCount;
  lastPaymentDate: StudentNegativeBalanceDtoLastPaymentDate;
  lastBillDate: StudentNegativeBalanceDtoLastBillDate;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type StudentNegativeBalancesResponseTotalCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type StudentNegativeBalancesResponseTotalDebt = number | string;

export interface StudentNegativeBalancesResponse {
  items: StudentNegativeBalanceDto[];
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  totalCount: StudentNegativeBalancesResponseTotalCount;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalDebt: StudentNegativeBalancesResponseTotalDebt;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type StudentPaymentTokenDtoExpirationMonth = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type StudentPaymentTokenDtoExpirationYear = null | number | string;

export interface StudentPaymentTokenDto {
  id: string;
  schoolId: string;
  studentMemberId: string;
  provider: string;
  maskedCardNumber: string;
  cardType: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  expirationMonth: StudentPaymentTokenDtoExpirationMonth;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  expirationYear: StudentPaymentTokenDtoExpirationYear;
  isActive: boolean;
  createdAt: string;
}

export interface SubmitMedicalSurveyRequest {
  healthDeclarationAccepted: boolean;
  regulationsAccepted: boolean;
  imageConsentAccepted: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type SubscriptionResponseAmountCharged = number | string;

export type SubscriptionResponsePaymentId = null | string;

export type SubscriptionResponseFirstSessionStartsAt = null | string;

export type SubscriptionResponseResignationEffectiveDate = null | string;

export type SubscriptionResponseScheduleName = null | string;

export type SubscriptionResponseStudentName = null | string;

export type SubscriptionResponseStartDate = null | string;

export interface SubscriptionResponse {
  id: string;
  schoolId: string;
  studentMemberId: string;
  scheduleId: string;
  billingMonth: string;
  status: SubscriptionStatus;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amountCharged: SubscriptionResponseAmountCharged;
  willNotRenew: boolean;
  createdAt: string;
  paymentId?: SubscriptionResponsePaymentId;
  firstSessionStartsAt?: SubscriptionResponseFirstSessionStartsAt;
  resignationEffectiveDate?: SubscriptionResponseResignationEffectiveDate;
  scheduleName?: SubscriptionResponseScheduleName;
  isCorporate?: boolean;
  autoPayEnabled?: boolean;
  studentName?: SubscriptionResponseStudentName;
  startDate?: SubscriptionResponseStartDate;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SubscriptionsListResponseTotalCount = number | string;

export interface SubscriptionsListResponse {
  items: AdminSubscriptionListItem[];
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  totalCount: SubscriptionsListResponseTotalCount;
}

export type SubscriptionStatus = typeof SubscriptionStatus[keyof typeof SubscriptionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionStatus = {
  Active: 'Active',
  WillNotRenew: 'WillNotRenew',
  Expired: 'Expired',
  Cancelled: 'Cancelled',
  PendingPayment: 'PendingPayment',
} as const;

export type SubscriptionSuspensionResponseReason = null | string;

export type SubscriptionSuspensionResponseCreatedByUserId = null | string;

export type SubscriptionSuspensionResponseScheduleName = null | string;

export interface SubscriptionSuspensionResponse {
  id: string;
  schoolId: string;
  studentMemberId: string;
  scheduleEnrollmentId: string;
  scheduleId: string;
  startDate: string;
  endDate: string;
  reason: SubscriptionSuspensionResponseReason;
  status: SuspensionStatus;
  reminderSent: boolean;
  createdByUserId: SubscriptionSuspensionResponseCreatedByUserId;
  createdAt: string;
  updatedAt: string;
  scheduleName?: SubscriptionSuspensionResponseScheduleName;
}

export type SummarizeSessionRequestTopic = null | string;

export type SummarizeSessionRequestTitle = null | string;

export type SummarizeSessionRequestClientUpdatedAt = null | string;

export interface SummarizeSessionRequest {
  notes: string;
  topic?: SummarizeSessionRequestTopic;
  title?: SummarizeSessionRequestTitle;
  clientUpdatedAt?: SummarizeSessionRequestClientUpdatedAt;
}

export type SuspensionStatus = typeof SuspensionStatus[keyof typeof SuspensionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuspensionStatus = {
  Active: 'Active',
  Cancelled: 'Cancelled',
  Completed: 'Completed',
} as const;

export interface ToggleAutoPayRequest {
  autoPayEnabled: boolean;
}

export type TournamentAmericanoByeMode = typeof TournamentAmericanoByeMode[keyof typeof TournamentAmericanoByeMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TournamentAmericanoByeMode = {
  None: 'None',
  Fixed: 'Fixed',
  Average: 'Average',
} as const;

export type TournamentAmericanoPlayMode = typeof TournamentAmericanoPlayMode[keyof typeof TournamentAmericanoPlayMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TournamentAmericanoPlayMode = {
  Rounds: 'Rounds',
  Continuous: 'Continuous',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentAmericanoSettingsPointsPerGame = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentAmericanoSettingsGameMinutes = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentAmericanoSettingsChangeoverMinutes = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentAmericanoSettingsGamesPerPlayer = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentAmericanoSettingsWinBonusPoints = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentAmericanoSettingsDrawBonusPoints = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentAmericanoSettingsByePoints = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentAmericanoSettingsMexicanoDrawnRounds = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentAmericanoSettingsMexicanoRepeatLimit = null | number | string;

export interface TournamentAmericanoSettings {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pointsPerGame?: TournamentAmericanoSettingsPointsPerGame;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  gameMinutes?: TournamentAmericanoSettingsGameMinutes;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  changeoverMinutes?: TournamentAmericanoSettingsChangeoverMinutes;
  playMode?: TournamentAmericanoPlayMode;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  gamesPerPlayer?: TournamentAmericanoSettingsGamesPerPlayer;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  winBonusPoints?: TournamentAmericanoSettingsWinBonusPoints;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  drawBonusPoints?: TournamentAmericanoSettingsDrawBonusPoints;
  byeMode?: TournamentAmericanoByeMode;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  byePoints?: TournamentAmericanoSettingsByePoints;
  simpleMode?: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  mexicanoDrawnRounds?: TournamentAmericanoSettingsMexicanoDrawnRounds;
  mexicanoCourtSplit?: TournamentMexicanoCourtSplit;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  mexicanoRepeatLimit?: TournamentAmericanoSettingsMexicanoRepeatLimit;
}

export type TournamentBoardResponseDescription = null | string;

export type TournamentBoardResponseOrganizerName = null | string;

export type TournamentBoardResponseVenueAddress = null | string;

export type TournamentBoardResponsePublicNotice = null | string;

export type TournamentBoardResponseRegulationsText = null | string;

export type TournamentBoardResponseSchoolLogoUrl = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentBoardResponseLiveVersion = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentBoardResponseRestMinutes = number | string;

export interface TournamentBoardResponse {
  tournamentId: string;
  name: string;
  description: TournamentBoardResponseDescription;
  organizerName: TournamentBoardResponseOrganizerName;
  startsAt: string;
  venueName: string;
  venueAddress: TournamentBoardResponseVenueAddress;
  status: TournamentStatus;
  publicNotice: TournamentBoardResponsePublicNotice;
  regulationsText: TournamentBoardResponseRegulationsText;
  schoolName: string;
  schoolLogoUrl: TournamentBoardResponseSchoolLogoUrl;
  timezone: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  liveVersion: TournamentBoardResponseLiveVersion;
  generatedAt: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  restMinutes: TournamentBoardResponseRestMinutes;
  autoCallNext: boolean;
  courts: BoardCourt[];
  timeBlocks: BoardTimeBlock[];
  players: BoardPlayer[];
  categories: BoardCategory[];
}

export type TournamentCategoryGender = typeof TournamentCategoryGender[keyof typeof TournamentCategoryGender];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TournamentCategoryGender = {
  Open: 'Open',
  Male: 'Male',
  Female: 'Female',
  Mixed: 'Mixed',
} as const;

export type TournamentCategoryResponseShortName = null | string;

export type TournamentCategoryResponseColor = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentCategoryResponseSortOrder = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentCategoryResponseBirthYearFrom = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentCategoryResponseQualifiersPerGroup = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentCategoryResponseEstimatedGameMinutes = number | string;

export type TournamentCategoryResponseTimeBlockId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentCategoryResponseEntryCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentCategoryResponseGroupCount = number | string;

export interface TournamentCategoryResponse {
  id: string;
  name: string;
  shortName: TournamentCategoryResponseShortName;
  gender: TournamentCategoryGender;
  color: TournamentCategoryResponseColor;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sortOrder: TournamentCategoryResponseSortOrder;
  format: TournamentFormat;
  entryType: TournamentEntryType;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  birthYearFrom: TournamentCategoryResponseBirthYearFrom;
  matchFormat: TournamentMatchFormat;
  standingsRules: TournamentStandingsRules;
  americanoSettings: TournamentAmericanoSettings;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  qualifiersPerGroup: TournamentCategoryResponseQualifiersPerGroup;
  thirdPlaceMatch: boolean;
  classificationMatches: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  estimatedGameMinutes: TournamentCategoryResponseEstimatedGameMinutes;
  timeBlockId: TournamentCategoryResponseTimeBlockId;
  courtIds: string[];
  status: TournamentCategoryStatus;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  entryCount: TournamentCategoryResponseEntryCount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  groupCount: TournamentCategoryResponseGroupCount;
  hasDraw: boolean;
}

export type TournamentCategoryStatus = typeof TournamentCategoryStatus[keyof typeof TournamentCategoryStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TournamentCategoryStatus = {
  Setup: 'Setup',
  GroupStage: 'GroupStage',
  Knockout: 'Knockout',
  Finished: 'Finished',
} as const;

export type TournamentCourtInputId = null | string;

export interface TournamentCourtInput {
  id: TournamentCourtInputId;
  name: string;
  isActive: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentCourtResponseNumber = number | string;

export interface TournamentCourtResponse {
  id: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  number: TournamentCourtResponseNumber;
  name: string;
  isActive: boolean;
}

export type TournamentEntryPlayerInputPlayerId = null | string;

export type TournamentEntryPlayerInputMemberId = null | string;

export type TournamentEntryPlayerInputFirstName = null | string;

export type TournamentEntryPlayerInputLastName = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentEntryPlayerInputBirthYear = null | number | string;

export type TournamentEntryPlayerInputGender = null | Gender;

export type TournamentEntryPlayerInputClubName = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentEntryPlayerInputRacketNumber = number | string;

export interface TournamentEntryPlayerInput {
  playerId: TournamentEntryPlayerInputPlayerId;
  memberId: TournamentEntryPlayerInputMemberId;
  firstName: TournamentEntryPlayerInputFirstName;
  lastName: TournamentEntryPlayerInputLastName;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  birthYear: TournamentEntryPlayerInputBirthYear;
  gender: TournamentEntryPlayerInputGender;
  clubName: TournamentEntryPlayerInputClubName;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  racketNumber: TournamentEntryPlayerInputRacketNumber;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentEntryPlayerResponseBirthYear = null | number | string;

export type TournamentEntryPlayerResponseClubName = null | string;

export type TournamentEntryPlayerResponseMemberId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentEntryPlayerResponseRacketNumber = number | string;

export interface TournamentEntryPlayerResponse {
  playerId: string;
  firstName: string;
  lastName: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  birthYear: TournamentEntryPlayerResponseBirthYear;
  gender: Gender;
  clubName: TournamentEntryPlayerResponseClubName;
  memberId: TournamentEntryPlayerResponseMemberId;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  racketNumber: TournamentEntryPlayerResponseRacketNumber;
  isEligible: boolean;
}

export type TournamentEntryResponseClubName = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentEntryResponseSeed = null | number | string;

export type TournamentEntryResponseGroupId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentEntryResponseGroupSlot = null | number | string;

export interface TournamentEntryResponse {
  id: string;
  categoryId: string;
  displayName: string;
  clubName: TournamentEntryResponseClubName;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  seed: TournamentEntryResponseSeed;
  groupId: TournamentEntryResponseGroupId;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  groupSlot: TournamentEntryResponseGroupSlot;
  status: TournamentEntryStatus;
  players: TournamentEntryPlayerResponse[];
}

export type TournamentEntryStatus = typeof TournamentEntryStatus[keyof typeof TournamentEntryStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TournamentEntryStatus = {
  Active: 'Active',
  Withdrawn: 'Withdrawn',
} as const;

export type TournamentEntryType = typeof TournamentEntryType[keyof typeof TournamentEntryType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TournamentEntryType = {
  Single: 'Single',
  Pair: 'Pair',
  Team: 'Team',
} as const;

export type TournamentFormat = typeof TournamentFormat[keyof typeof TournamentFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TournamentFormat = {
  GroupKnockout: 'GroupKnockout',
  RoundRobin: 'RoundRobin',
  Knockout: 'Knockout',
  Americano: 'Americano',
  PairAmericano: 'PairAmericano',
  Mexicano: 'Mexicano',
} as const;

export type TournamentGameKind = typeof TournamentGameKind[keyof typeof TournamentGameKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TournamentGameKind = {
  Singles: 'Singles',
  Doubles: 'Doubles',
} as const;

export type TournamentGameLineupInputHomePlayer1Id = null | string;

export type TournamentGameLineupInputHomePlayer2Id = null | string;

export type TournamentGameLineupInputAwayPlayer1Id = null | string;

export type TournamentGameLineupInputAwayPlayer2Id = null | string;

export interface TournamentGameLineupInput {
  gameId: string;
  homePlayer1Id: TournamentGameLineupInputHomePlayer1Id;
  homePlayer2Id: TournamentGameLineupInputHomePlayer2Id;
  awayPlayer1Id: TournamentGameLineupInputAwayPlayer1Id;
  awayPlayer2Id: TournamentGameLineupInputAwayPlayer2Id;
}

export type TournamentGameStatus = typeof TournamentGameStatus[keyof typeof TournamentGameStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TournamentGameStatus = {
  WaitingLineup: 'WaitingLineup',
  WaitingDependency: 'WaitingDependency',
  Ready: 'Ready',
  Called: 'Called',
  InProgress: 'InProgress',
  Finished: 'Finished',
  Walkover: 'Walkover',
  Retired: 'Retired',
  NotRequired: 'NotRequired',
} as const;

export type TournamentGroupEntryAssignmentGroupId = null | string;

export interface TournamentGroupEntryAssignment {
  entryId: string;
  groupId: TournamentGroupEntryAssignmentGroupId;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentMatchFormatSetsToWin = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentMatchFormatPointsPerSet = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentMatchFormatMaxPoints = number | string;

export interface TournamentMatchFormat {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  setsToWin?: TournamentMatchFormatSetsToWin;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pointsPerSet?: TournamentMatchFormatPointsPerSet;
  settingEnabled?: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxPoints?: TournamentMatchFormatMaxPoints;
  rubbers?: TournamentRubberTemplate[];
  playAllRubbers?: boolean;
}

export type TournamentMatchStage = typeof TournamentMatchStage[keyof typeof TournamentMatchStage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TournamentMatchStage = {
  Group: 'Group',
  Knockout: 'Knockout',
  Classification: 'Classification',
  AmericanoRound: 'AmericanoRound',
} as const;

export type TournamentMatchStatus = typeof TournamentMatchStatus[keyof typeof TournamentMatchStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TournamentMatchStatus = {
  Pending: 'Pending',
  Scheduled: 'Scheduled',
  InProgress: 'InProgress',
  Finished: 'Finished',
  Walkover: 'Walkover',
  Cancelled: 'Cancelled',
} as const;

export type TournamentMexicanoCourtSplit = typeof TournamentMexicanoCourtSplit[keyof typeof TournamentMexicanoCourtSplit];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TournamentMexicanoCourtSplit = {
  OneThreeVsTwoFour: 'OneThreeVsTwoFour',
  OneFourVsTwoThree: 'OneFourVsTwoThree',
  OneTwoVsThreeFour: 'OneTwoVsThreeFour',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentMonthlyRankingResponseYear = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentMonthlyRankingResponseMonth = number | string;

export type TournamentMonthlyRankingResponseGroupName = null | string;

export interface TournamentMonthlyRankingResponse {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  year: TournamentMonthlyRankingResponseYear;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  month: TournamentMonthlyRankingResponseMonth;
  groupName: TournamentMonthlyRankingResponseGroupName;
  tournaments: TournamentMonthlyRankingTournament[];
  rows: TournamentMonthlyRankingRow[];
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentMonthlyRankingRowPosition = number | string;

export type TournamentMonthlyRankingRowMemberId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentMonthlyRankingRowTournamentsPlayed = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentMonthlyRankingRowBestPosition = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentMonthlyRankingRowPlayed = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentMonthlyRankingRowWon = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentMonthlyRankingRowDrawn = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentMonthlyRankingRowLost = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentMonthlyRankingRowPointsWon = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentMonthlyRankingRowPointsLost = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentMonthlyRankingRowScore = number | string;

export interface TournamentMonthlyRankingRow {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  position: TournamentMonthlyRankingRowPosition;
  memberId: TournamentMonthlyRankingRowMemberId;
  name: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  tournamentsPlayed: TournamentMonthlyRankingRowTournamentsPlayed;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  bestPosition: TournamentMonthlyRankingRowBestPosition;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  played: TournamentMonthlyRankingRowPlayed;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  won: TournamentMonthlyRankingRowWon;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  drawn: TournamentMonthlyRankingRowDrawn;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  lost: TournamentMonthlyRankingRowLost;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pointsWon: TournamentMonthlyRankingRowPointsWon;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pointsLost: TournamentMonthlyRankingRowPointsLost;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  score: TournamentMonthlyRankingRowScore;
}

export interface TournamentMonthlyRankingTournament {
  id: string;
  name: string;
  startsAt: string;
  status: TournamentStatus;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentPlayerResponseBirthYear = null | number | string;

export type TournamentPlayerResponseClubName = null | string;

export type TournamentPlayerResponseMemberId = null | string;

export interface TournamentPlayerResponse {
  id: string;
  firstName: string;
  lastName: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  birthYear: TournamentPlayerResponseBirthYear;
  gender: Gender;
  clubName: TournamentPlayerResponseClubName;
  memberId: TournamentPlayerResponseMemberId;
  categoryIds: string[];
}

export type TournamentPublicNameMode = typeof TournamentPublicNameMode[keyof typeof TournamentPublicNameMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TournamentPublicNameMode = {
  FirstNameInitial: 'FirstNameInitial',
  Full: 'Full',
} as const;

export type TournamentResponseDescription = null | string;

export type TournamentResponseOrganizerName = null | string;

export type TournamentResponseLocationId = null | string;

export type TournamentResponseVenueAddress = null | string;

export type TournamentResponsePublicNotice = null | string;

export type TournamentResponseRegulationsText = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentResponseRestMinutes = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentResponseLiveVersion = number | string;

export type TournamentResponseSessionId = null | string;

export interface TournamentResponse {
  id: string;
  name: string;
  description: TournamentResponseDescription;
  organizerName: TournamentResponseOrganizerName;
  startsAt: string;
  locationId: TournamentResponseLocationId;
  venueName: string;
  venueAddress: TournamentResponseVenueAddress;
  status: TournamentStatus;
  isPublic: boolean;
  publicNameMode: TournamentPublicNameMode;
  publicNotice: TournamentResponsePublicNotice;
  regulationsText: TournamentResponseRegulationsText;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  restMinutes: TournamentResponseRestMinutes;
  autoCallNext: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  liveVersion: TournamentResponseLiveVersion;
  canAdminister: boolean;
  sessionId: TournamentResponseSessionId;
  courts: TournamentCourtResponse[];
  timeBlocks: TournamentTimeBlockResponse[];
  categories: TournamentCategoryResponse[];
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentRubberTemplateOrder = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentRubberTemplateRacket = null | number | string;

export interface TournamentRubberTemplate {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  order?: TournamentRubberTemplateOrder;
  kind?: TournamentGameKind;
  label?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  racket?: TournamentRubberTemplateRacket;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentSetScoreHome = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentSetScoreAway = number | string;

export interface TournamentSetScore {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  home?: TournamentSetScoreHome;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  away?: TournamentSetScoreAway;
}

export type TournamentSide = typeof TournamentSide[keyof typeof TournamentSide];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TournamentSide = {
  Home: 'Home',
  Away: 'Away',
} as const;

export interface TournamentSideRequest {
  side: TournamentSide;
}

export type TournamentStaffResponseFirstName = null | string;

export type TournamentStaffResponseLastName = null | string;

export type TournamentStaffResponsePhotoUrl = null | string;

export interface TournamentStaffResponse {
  id: string;
  memberId: string;
  firstName: TournamentStaffResponseFirstName;
  lastName: TournamentStaffResponseLastName;
  email: string;
  photoUrl: TournamentStaffResponsePhotoUrl;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentStandingsRulesPointsForWin = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentStandingsRulesPointsForLoss = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentStandingsRulesPointsForWalkoverLoss = number | string;

export interface TournamentStandingsRules {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pointsForWin?: TournamentStandingsRulesPointsForWin;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pointsForLoss?: TournamentStandingsRulesPointsForLoss;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pointsForWalkoverLoss?: TournamentStandingsRulesPointsForWalkoverLoss;
  pointsPerRubberWon?: boolean;
}

export type TournamentStatus = typeof TournamentStatus[keyof typeof TournamentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TournamentStatus = {
  Draft: 'Draft',
  Published: 'Published',
  InProgress: 'InProgress',
  Finished: 'Finished',
  Cancelled: 'Cancelled',
} as const;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentSummaryResponseCategoryCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentSummaryResponseEntryCount = number | string;

export type TournamentSummaryResponseSessionId = null | string;

export interface TournamentSummaryResponse {
  id: string;
  name: string;
  startsAt: string;
  venueName: string;
  status: TournamentStatus;
  isPublic: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  categoryCount: TournamentSummaryResponseCategoryCount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  entryCount: TournamentSummaryResponseEntryCount;
  sessionId: TournamentSummaryResponseSessionId;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type TournamentTimeBlockResponseSortOrder = number | string;

export interface TournamentTimeBlockResponse {
  id: string;
  name: string;
  startsAt: string;
  endsAt: string;
  courtIds: string[];
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sortOrder: TournamentTimeBlockResponseSortOrder;
}

export interface TransferSessionRequest {
  targetSessionId: string;
}

export interface TransferStudentGroupNextMonthRequest {
  studentMemberId: string;
  sourceScheduleId: string;
  targetScheduleId: string;
  allowOverbooking?: boolean;
}

export interface TransferStudentGroupRequest {
  targetScheduleId: string;
  allowOverbooking?: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type UpdateBillRequestAmount = number | string;

export type UpdateBillRequestDescription = null | string;

export type UpdateBillRequestDueDate = null | string;

export interface UpdateBillRequest {
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount: UpdateBillRequestAmount;
  description?: UpdateBillRequestDescription;
  dueDate?: UpdateBillRequestDueDate;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type UpdateCampParticipantAddonRequestPrice = null | number | string;

export type UpdateCampParticipantAddonRequestApprovalStatus = null | CampAddonApprovalStatus;

export interface UpdateCampParticipantAddonRequest {
  addonId: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  price: UpdateCampParticipantAddonRequestPrice;
  approvalStatus: UpdateCampParticipantAddonRequestApprovalStatus;
}

export type UpdateCampParticipantRequestDiet = null | string;

export type UpdateCampParticipantRequestRoomMatePreference = null | string;

export type UpdateCampParticipantRequestNotes = null | string;

export type UpdateCampParticipantRequestBalanceDueDateOverride = null | string;

export interface UpdateCampParticipantRequest {
  priceOptionId: string;
  addons: UpdateCampParticipantAddonRequest[];
  medicalClearanceDeclared: boolean;
  diet: UpdateCampParticipantRequestDiet;
  roomMatePreference: UpdateCampParticipantRequestRoomMatePreference;
  notes: UpdateCampParticipantRequestNotes;
  balanceDueDateOverride: UpdateCampParticipantRequestBalanceDueDateOverride;
}

export interface UpdateCampPricingRequest {
  priceOptions: UpsertCampPriceOptionRequest[];
  addons: UpsertCampAddonRequest[];
  refundRules: UpsertCampRefundRuleRequest[];
}

export type UpdateCampRequestSummary = null | string;

export type UpdateCampRequestDescription = null | string;

export type UpdateCampRequestBannerUrl = null | string;

export type UpdateCampRequestWebsiteUrl = null | string;

export type UpdateCampRequestArrivalInfo = null | string;

export type UpdateCampRequestDepartureInfo = null | string;

export type UpdateCampRequestLocationId = null | string;

export type UpdateCampRequestVenueAddress = null | string;

export type UpdateCampRequestContactName = null | string;

export type UpdateCampRequestContactEmail = null | string;

export type UpdateCampRequestContactPhone = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateCampRequestCapacity = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateCampRequestMinAge = null | number | string;

export type UpdateCampRequestRegistrationOpensAt = null | string;

export type UpdateCampRequestRegistrationClosesAt = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type UpdateCampRequestDepositAmount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateCampRequestDepositDueDays = number | string;

export type UpdateCampRequestBalanceDueDate = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type UpdateCampRequestLateFeePercent = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateCampRequestLateFeeGraceDays = number | string;

export type UpdateCampRequestBlikPhoneNumber = null | string;

export interface UpdateCampRequest {
  name: string;
  slug: string;
  summary: UpdateCampRequestSummary;
  description: UpdateCampRequestDescription;
  bannerUrl: UpdateCampRequestBannerUrl;
  websiteUrl: UpdateCampRequestWebsiteUrl;
  startsAt: string;
  endsAt: string;
  arrivalInfo: UpdateCampRequestArrivalInfo;
  departureInfo: UpdateCampRequestDepartureInfo;
  locationId: UpdateCampRequestLocationId;
  venueName: string;
  venueAddress: UpdateCampRequestVenueAddress;
  contactName: UpdateCampRequestContactName;
  contactEmail: UpdateCampRequestContactEmail;
  contactPhone: UpdateCampRequestContactPhone;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  capacity: UpdateCampRequestCapacity;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  minAge: UpdateCampRequestMinAge;
  minorsRequireGuardian: boolean;
  requiresMedicalClearance: boolean;
  registrationOpensAt: UpdateCampRequestRegistrationOpensAt;
  registrationClosesAt: UpdateCampRequestRegistrationClosesAt;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  depositAmount: UpdateCampRequestDepositAmount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  depositDueDays: UpdateCampRequestDepositDueDays;
  depositRefundable: boolean;
  balanceDueDate: UpdateCampRequestBalanceDueDate;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  lateFeePercent: UpdateCampRequestLateFeePercent;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  lateFeeGraceDays: UpdateCampRequestLateFeeGraceDays;
  autoRemoveUnpaid: boolean;
  allowOnlinePayment: boolean;
  allowBankTransfer: boolean;
  allowBlik: boolean;
  blikPhoneNumber: UpdateCampRequestBlikPhoneNumber;
}

export interface UpdateCampTermsDraftRequest {
  content: string;
}

export interface UpdateCoachIndividualClassesRequest {
  canOfferIndividualClasses: boolean;
}

export interface UpdateCoachRacketStringingAccessRequest {
  canManageRacketStringing: boolean;
}

export interface UpdateCoachTournamentAccessRequest {
  canManageTournaments: boolean;
}

export interface UpdateEmailTemplateRequest {
  name: string;
  htmlContent: string;
  isDefault: boolean;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateGameDayRuleRequestSessionOrdinal = number | string;

export interface UpdateGameDayRuleRequest {
  oddMonthDays: DayOfWeek[];
  evenMonthDays: DayOfWeek[];
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sessionOrdinal: UpdateGameDayRuleRequestSessionOrdinal;
}

export type UpdateIndividualClassSettingsRequestIndividualPriceListId = null | string;

export type UpdateIndividualClassSettingsRequestBlikPhoneNumber = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateIndividualClassSettingsRequestFreeCancellationHours = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateIndividualClassSettingsRequestApprovalTimeoutHours = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateIndividualClassSettingsRequestBookingMinLeadHours = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateIndividualClassSettingsRequestBookingHorizonDays = number | string;

export interface UpdateIndividualClassSettingsRequest {
  individualPriceListId: UpdateIndividualClassSettingsRequestIndividualPriceListId;
  blikPhoneNumber: UpdateIndividualClassSettingsRequestBlikPhoneNumber;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  freeCancellationHours: UpdateIndividualClassSettingsRequestFreeCancellationHours;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  approvalTimeoutHours: UpdateIndividualClassSettingsRequestApprovalTimeoutHours;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  bookingMinLeadHours: UpdateIndividualClassSettingsRequestBookingMinLeadHours;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  bookingHorizonDays: UpdateIndividualClassSettingsRequestBookingHorizonDays;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateIndividualSlotRequestDuration = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateIndividualSlotRequestMaxPartySize = number | string;

export type UpdateIndividualSlotRequestCourtBookingMode = null | CourtBookingMode;

export type UpdateIndividualSlotRequestCourtBookingUrl = null | string;

export type UpdateIndividualSlotRequestAdditionalInformation = null | string;

export interface UpdateIndividualSlotRequest {
  locationId: string;
  startsAt: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  duration: UpdateIndividualSlotRequestDuration;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxPartySize: UpdateIndividualSlotRequestMaxPartySize;
  courtBookingMode: UpdateIndividualSlotRequestCourtBookingMode;
  courtBookingUrl: UpdateIndividualSlotRequestCourtBookingUrl;
  allowOnlinePayment: boolean;
  allowOnSitePayment: boolean;
  additionalInformation: UpdateIndividualSlotRequestAdditionalInformation;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateLocationRequestCourtCount = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateLocationRequestMaxParticipants = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type UpdateLocationRequestLatitude = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
 */
export type UpdateLocationRequestLongitude = null | number | string;

export type UpdateLocationRequestCourtBookingUrl = null | string;

export type UpdateLocationRequestDescription = null | string;

export interface UpdateLocationRequest {
  name: string;
  alias: string;
  address: string;
  district: string;
  postalCode: string;
  city: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  courtCount: UpdateLocationRequestCourtCount;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxParticipants: UpdateLocationRequestMaxParticipants;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  latitude?: UpdateLocationRequestLatitude;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  longitude?: UpdateLocationRequestLongitude;
  isIndividualOnly?: boolean;
  defaultCourtBookingMode?: CourtBookingMode;
  courtBookingUrl?: UpdateLocationRequestCourtBookingUrl;
  description?: UpdateLocationRequestDescription;
}

export type UpdateMailingCampaignRequestEmailTemplateId = null | string;

export type UpdateMailingCampaignRequestTargetId = null | string;

export type UpdateMailingCampaignRequestScheduledFor = null | string;

export interface UpdateMailingCampaignRequest {
  subject: string;
  body: string;
  emailTemplateId: UpdateMailingCampaignRequestEmailTemplateId;
  targetType: string;
  targetId: UpdateMailingCampaignRequestTargetId;
  status: string;
  scheduledFor: UpdateMailingCampaignRequestScheduledFor;
}

export interface UpdateMailingWorkflowRequest {
  name: string;
  triggerType: string;
  isEnabled: boolean;
  workflowDataJson: string;
}

export interface UpdateMakeUpCreditExpiryRequest {
  expiresAt: string;
}

export type UpdateMediaRequestTitle = null | string;

export type UpdateMediaRequestAltText = null | string;

export type UpdateMediaRequestDescription = null | string;

export type UpdateMediaRequestVirtualFolder = null | string;

export interface UpdateMediaRequest {
  title: UpdateMediaRequestTitle;
  altText: UpdateMediaRequestAltText;
  description: UpdateMediaRequestDescription;
  virtualFolder: UpdateMediaRequestVirtualFolder;
}

export type UpdateMemberRequestEmail = null | string;

export type UpdateMemberRequestFirstName = null | string;

export type UpdateMemberRequestLastName = null | string;

export type UpdateMemberRequestRoles = null | SchoolRole;

export type UpdateMemberRequestSkillLevelId = null | string;

export type UpdateMemberRequestDateOfBirth = null | string;

export type UpdateMemberRequestBio = null | string;

export type UpdateMemberRequestPhotoUrl = null | string;

export type UpdateMemberRequestIsActive = null | boolean;

export type UpdateMemberRequestNotes = null | string;

export type UpdateMemberRequestGender = null | Gender;

export type UpdateMemberRequestPhoneNumber = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateMemberRequestPaymentDueDay = null | number | string;

export type UpdateMemberRequestIsBetaTester = null | boolean;

export interface UpdateMemberRequest {
  email: UpdateMemberRequestEmail;
  firstName: UpdateMemberRequestFirstName;
  lastName: UpdateMemberRequestLastName;
  roles: UpdateMemberRequestRoles;
  skillLevelId: UpdateMemberRequestSkillLevelId;
  dateOfBirth: UpdateMemberRequestDateOfBirth;
  bio: UpdateMemberRequestBio;
  photoUrl: UpdateMemberRequestPhotoUrl;
  isActive: UpdateMemberRequestIsActive;
  notes: UpdateMemberRequestNotes;
  gender: UpdateMemberRequestGender;
  phoneNumber: UpdateMemberRequestPhoneNumber;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  paymentDueDay?: UpdateMemberRequestPaymentDueDay;
  isBetaTester?: UpdateMemberRequestIsBetaTester;
}

export type UpdateMemberSkillLevelRequestSkillLevelId = null | string;

export interface UpdateMemberSkillLevelRequest {
  skillLevelId: UpdateMemberSkillLevelRequestSkillLevelId;
}

export interface UpdateNotificationTemplateRequest {
  isEnabled: boolean;
  sendPush: boolean;
  sendEmail: boolean;
  titleTemplate: string;
  bodyTemplate: string;
}

export type UpdatePriceListItemRequestValidFrom = null | string;

export type UpdatePriceListItemRequestValidTo = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type UpdatePriceListItemRequestDropInPrice = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type UpdatePriceListItemRequestMonthlyBasePrice = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type UpdatePriceListItemRequestEquipmentSurcharge = null | number | string;

export type UpdatePriceListItemRequestGrandfatheringUntil = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdatePriceListItemRequestPartySizeFrom = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdatePriceListItemRequestPartySizeTo = null | number | string;

export interface UpdatePriceListItemRequest {
  validFrom: UpdatePriceListItemRequestValidFrom;
  validTo: UpdatePriceListItemRequestValidTo;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  dropInPrice: UpdatePriceListItemRequestDropInPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  monthlyBasePrice: UpdatePriceListItemRequestMonthlyBasePrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  equipmentSurcharge: UpdatePriceListItemRequestEquipmentSurcharge;
  grandfatheringUntil?: UpdatePriceListItemRequestGrandfatheringUntil;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  partySizeFrom?: UpdatePriceListItemRequestPartySizeFrom;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  partySizeTo?: UpdatePriceListItemRequestPartySizeTo;
}

export type UpdatePriceListRequestEquipmentName = null | string;

export interface UpdatePriceListRequest {
  name: string;
  isActive: boolean;
  equipmentName?: UpdatePriceListRequestEquipmentName;
}

export type UpdateProfileRequestPhoneNumber = null | string;

export type UpdateProfileRequestGender = null | Gender;

export type UpdateProfileRequestDateOfBirth = null | string;

export type UpdateProfileRequestReceiveEmails = null | boolean;

export type UpdateProfileRequestReceivePush = null | boolean;

export type UpdateProfileRequestIsBetaTester = null | boolean;

export interface UpdateProfileRequest {
  firstName: string;
  lastName: string;
  phoneNumber: UpdateProfileRequestPhoneNumber;
  gender: UpdateProfileRequestGender;
  dateOfBirth: UpdateProfileRequestDateOfBirth;
  receiveEmails: UpdateProfileRequestReceiveEmails;
  receivePush: UpdateProfileRequestReceivePush;
  isBetaTester?: UpdateProfileRequestIsBetaTester;
}

export type UpdatePromoRequestTargetUrl = null | string;

export type UpdatePromoRequestPublishEndDate = null | string;

export interface UpdatePromoRequest {
  title: string;
  imageUrl: string;
  targetUrl: UpdatePromoRequestTargetUrl;
  publishStartDate: string;
  publishEndDate: UpdatePromoRequestPublishEndDate;
  isActive: boolean;
}

export type UpdateRacketStringingOrderRequestStringerName = null | string;

export type UpdateRacketStringingOrderRequestStaffNotes = null | string;

export interface UpdateRacketStringingOrderRequest {
  status: RacketStringingStatus;
  stringerName: UpdateRacketStringingOrderRequestStringerName;
  isPaid: boolean;
  staffNotes: UpdateRacketStringingOrderRequestStaffNotes;
}

export type UpdateRacketStringingSettingsRequestInstructions = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type UpdateRacketStringingSettingsRequestPrice = null | number | string;

export interface UpdateRacketStringingSettingsRequest {
  instructions: UpdateRacketStringingSettingsRequestInstructions;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  price: UpdateRacketStringingSettingsRequestPrice;
  defaultTension: string;
  defaultStringType: string;
}

export type UpdateRegulationRequestIntroMessage = null | string;

export interface UpdateRegulationRequest {
  title: string;
  content: string;
  introMessage: UpdateRegulationRequestIntroMessage;
  publishedAt: string;
  effectiveAt: string;
  language: string;
  type?: RegulationType;
}

export type UpdateScheduleRequestName = null | string;

export type UpdateScheduleRequestCoachMemberId = null | string;

export type UpdateScheduleRequestPriceListId = null | string;

export type UpdateScheduleRequestPricingModelId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateScheduleRequestDuration = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateScheduleRequestMaxParticipants = number | string;

export type UpdateScheduleRequestEndDate = null | string;

export type UpdateScheduleRequestBannerUrl = null | string;

export type UpdateScheduleRequestInfoUrl = null | string;

export type UpdateScheduleRequestAdditionalInformation = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type UpdateScheduleRequestCustomDropInPrice = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type UpdateScheduleRequestCustomMonthlyPrice = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type UpdateScheduleRequestCustomEquipmentSurcharge = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateScheduleRequestCorporateSlotsCount = number | string;

export type UpdateScheduleRequestTags = null | string[];

export type UpdateScheduleRequestSecondCoachMemberId = null | string;

export interface UpdateScheduleRequest {
  name: UpdateScheduleRequestName;
  locationId: string;
  coachMemberId: UpdateScheduleRequestCoachMemberId;
  priceListId: UpdateScheduleRequestPriceListId;
  pricingModelId: UpdateScheduleRequestPricingModelId;
  skillLevelId: string;
  dayOfWeek: DayOfWeek;
  startTime: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  duration: UpdateScheduleRequestDuration;
  equipmentType: EquipmentType;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxParticipants: UpdateScheduleRequestMaxParticipants;
  startDate: string;
  endDate?: UpdateScheduleRequestEndDate;
  recurrencePattern?: string;
  isPromoted?: boolean;
  isPrivate?: boolean;
  bannerUrl?: UpdateScheduleRequestBannerUrl;
  infoUrl?: UpdateScheduleRequestInfoUrl;
  additionalInformation?: UpdateScheduleRequestAdditionalInformation;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  customDropInPrice?: UpdateScheduleRequestCustomDropInPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  customMonthlyPrice?: UpdateScheduleRequestCustomMonthlyPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  customEquipmentSurcharge?: UpdateScheduleRequestCustomEquipmentSurcharge;
  isCoursePaidOnce?: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  corporateSlotsCount?: UpdateScheduleRequestCorporateSlotsCount;
  disableMakeups?: boolean;
  tags?: UpdateScheduleRequestTags;
  terminateStudentSubscriptions?: boolean;
  deleteFutureSessionsAfterEndDate?: boolean;
  secondCoachMemberId?: UpdateScheduleRequestSecondCoachMemberId;
}

export type UpdateSchoolBrandingRequestLogoUrl = null | string;

export type UpdateSchoolBrandingRequestSlogan = null | string;

export type UpdateSchoolBrandingRequestPrimaryColor = null | string;

export type UpdateSchoolBrandingRequestSecondaryColor = null | string;

export interface UpdateSchoolBrandingRequest {
  logoUrl: UpdateSchoolBrandingRequestLogoUrl;
  slogan: UpdateSchoolBrandingRequestSlogan;
  primaryColor: UpdateSchoolBrandingRequestPrimaryColor;
  secondaryColor: UpdateSchoolBrandingRequestSecondaryColor;
}

export interface UpdateSchoolFeaturesRequest {
  features: string[];
}

export type UpdateSchoolHolidayRequestName = null | string;

export interface UpdateSchoolHolidayRequest {
  name: UpdateSchoolHolidayRequestName;
}

export type UpdateSchoolIntegrationsRequestSmtpHost = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateSchoolIntegrationsRequestSmtpPort = number | string;

export type UpdateSchoolIntegrationsRequestSmtpUsername = null | string;

export type UpdateSchoolIntegrationsRequestSmtpPassword = null | string;

export type UpdateSchoolIntegrationsRequestSmtpFromAddress = null | string;

export type UpdateSchoolIntegrationsRequestSmtpFromName = null | string;

export type UpdateSchoolIntegrationsRequestSmtpReplyToAddress = null | string;

export type UpdateSchoolIntegrationsRequestGetResponseApiKey = null | string;

export type UpdateSchoolIntegrationsRequestGetResponseListId = null | string;

export type UpdateSchoolIntegrationsRequestGetResponseCustomFieldAmountId = null | string;

export type UpdateSchoolIntegrationsRequestGetResponseCustomFieldMonthId = null | string;

export type UpdateSchoolIntegrationsRequestGetResponseCustomFieldTriggerId = null | string;

export type UpdateSchoolIntegrationsRequestFakturowniaSubdomain = null | string;

export type UpdateSchoolIntegrationsRequestFakturowniaApiToken = null | string;

export type UpdateSchoolIntegrationsRequestFakturowniaDepartmentId = null | string;

export interface UpdateSchoolIntegrationsRequest {
  emailProvider: string;
  smtpHost: UpdateSchoolIntegrationsRequestSmtpHost;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  smtpPort: UpdateSchoolIntegrationsRequestSmtpPort;
  smtpUsername: UpdateSchoolIntegrationsRequestSmtpUsername;
  smtpPassword: UpdateSchoolIntegrationsRequestSmtpPassword;
  smtpEnableSsl: boolean;
  smtpFromAddress: UpdateSchoolIntegrationsRequestSmtpFromAddress;
  smtpFromName: UpdateSchoolIntegrationsRequestSmtpFromName;
  smtpReplyToAddress: UpdateSchoolIntegrationsRequestSmtpReplyToAddress;
  getResponseApiKey: UpdateSchoolIntegrationsRequestGetResponseApiKey;
  getResponseListId: UpdateSchoolIntegrationsRequestGetResponseListId;
  getResponseCustomFieldAmountId: UpdateSchoolIntegrationsRequestGetResponseCustomFieldAmountId;
  getResponseCustomFieldMonthId: UpdateSchoolIntegrationsRequestGetResponseCustomFieldMonthId;
  getResponseCustomFieldTriggerId: UpdateSchoolIntegrationsRequestGetResponseCustomFieldTriggerId;
  isInvoiceIntegrationEnabled: boolean;
  fakturowniaSubdomain: UpdateSchoolIntegrationsRequestFakturowniaSubdomain;
  fakturowniaApiToken: UpdateSchoolIntegrationsRequestFakturowniaApiToken;
  fakturowniaDepartmentId: UpdateSchoolIntegrationsRequestFakturowniaDepartmentId;
  fakturowniaSendToKsef?: boolean;
}

export type UpdateSchoolPaymentDetailsRequestSwiftBic = null | string;

export interface UpdateSchoolPaymentDetailsRequest {
  recipientName: string;
  bankName: string;
  accountNumber: string;
  swiftBic: UpdateSchoolPaymentDetailsRequestSwiftBic;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateSchoolRequestMakeUpCreditExpiryDays = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateSchoolRequestSubscriptionBillingDay = number | string;

export type UpdateSchoolRequestInstructionUrl = null | string;

export type UpdateSchoolRequestSupportEmail = null | string;

export type UpdateSchoolRequestSupportTopics = null | string;

export interface UpdateSchoolRequest {
  name: string;
  timezone: string;
  currency: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  makeUpCreditExpiryDays: UpdateSchoolRequestMakeUpCreditExpiryDays;
  allowedSessionDurations: string;
  sportType: SportType;
  alias: string;
  occupancyThresholds: string;
  resignationRule: ResignationRule;
  subscriptionDiscountTiers: string;
  showProgress: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  subscriptionBillingDay?: UpdateSchoolRequestSubscriptionBillingDay;
  autoIssueSubscriberDropInVoucher?: boolean;
  instructionUrl?: UpdateSchoolRequestInstructionUrl;
  supportEmail?: UpdateSchoolRequestSupportEmail;
  supportTopics?: UpdateSchoolRequestSupportTopics;
}

export type UpdateSessionCoachRequestCoachMemberId = null | string;

export interface UpdateSessionCoachRequest {
  coachMemberId: UpdateSessionCoachRequestCoachMemberId;
}

export type UpdateSessionNotesRequestClientUpdatedAt = null | string;

export interface UpdateSessionNotesRequest {
  notes: string;
  clientUpdatedAt?: UpdateSessionNotesRequestClientUpdatedAt;
}

export type UpdateSessionRequestCoachMemberId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateSessionRequestMaxParticipants = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type UpdateSessionRequestDropInPrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type UpdateSessionRequestEquipmentSurcharge = number | string;

export type UpdateSessionRequestTitle = null | string;

export type UpdateSessionRequestDescription = null | string;

export type UpdateSessionRequestBannerUrl = null | string;

export type UpdateSessionRequestInfoUrl = null | string;

export type UpdateSessionRequestAdditionalInformation = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateSessionRequestCorporateSlotsCount = number | string;

export type UpdateSessionRequestTags = null | string[];

export type UpdateSessionRequestTopic = null | string;

export type UpdateSessionRequestSecondCoachMemberId = null | string;

export interface UpdateSessionRequest {
  locationId: string;
  coachMemberId: UpdateSessionRequestCoachMemberId;
  skillLevelId: string;
  equipmentType: EquipmentType;
  startsAt: string;
  endsAt: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxParticipants: UpdateSessionRequestMaxParticipants;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  dropInPrice: UpdateSessionRequestDropInPrice;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  equipmentSurcharge: UpdateSessionRequestEquipmentSurcharge;
  title: UpdateSessionRequestTitle;
  description: UpdateSessionRequestDescription;
  isPromoted?: boolean;
  bannerUrl?: UpdateSessionRequestBannerUrl;
  infoUrl?: UpdateSessionRequestInfoUrl;
  additionalInformation?: UpdateSessionRequestAdditionalInformation;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  corporateSlotsCount?: UpdateSessionRequestCorporateSlotsCount;
  disableMakeups?: boolean;
  tags?: UpdateSessionRequestTags;
  topic?: UpdateSessionRequestTopic;
  secondCoachMemberId?: UpdateSessionRequestSecondCoachMemberId;
}

export interface UpdateSessionTitleRequest {
  title: string;
}

export type UpdateSessionTopicRequestClientUpdatedAt = null | string;

export interface UpdateSessionTopicRequest {
  topic: string;
  clientUpdatedAt?: UpdateSessionTopicRequestClientUpdatedAt;
}

export interface UpdateSkillLevelRequest {
  namePl: string;
  nameEn: string;
  color: string;
  category?: SkillLevelCategory;
}

export type UpdateStudentInvoiceDetailsRequestCompanyName = null | string;

export type UpdateStudentInvoiceDetailsRequestTaxId = null | string;

export type UpdateStudentInvoiceDetailsRequestStreet = null | string;

export type UpdateStudentInvoiceDetailsRequestPostalCode = null | string;

export type UpdateStudentInvoiceDetailsRequestCity = null | string;

export type UpdateStudentInvoiceDetailsRequestCountry = null | string;

export interface UpdateStudentInvoiceDetailsRequest {
  requestVatInvoice: boolean;
  companyName: UpdateStudentInvoiceDetailsRequestCompanyName;
  taxId: UpdateStudentInvoiceDetailsRequestTaxId;
  street: UpdateStudentInvoiceDetailsRequestStreet;
  postalCode: UpdateStudentInvoiceDetailsRequestPostalCode;
  city: UpdateStudentInvoiceDetailsRequestCity;
  country: UpdateStudentInvoiceDetailsRequestCountry;
}

export type UpdateSubscriptionEndDateRequestEndDate = null | string;

export interface UpdateSubscriptionEndDateRequest {
  studentMemberId: string;
  scheduleId: string;
  endDate?: UpdateSubscriptionEndDateRequestEndDate;
}

export type UpdateSubscriptionSuspensionRequestReason = null | string;

export interface UpdateSubscriptionSuspensionRequest {
  startDate: string;
  endDate: string;
  reason?: UpdateSubscriptionSuspensionRequestReason;
}

export interface UpdateTournamentCourtsRequest {
  courts: TournamentCourtInput[];
}

export interface UpdateTournamentGameScoreRequest {
  sets: TournamentSetScore[];
  finish: boolean;
}

export type UpdateTournamentRequestDescription = null | string;

export type UpdateTournamentRequestOrganizerName = null | string;

export type UpdateTournamentRequestLocationId = null | string;

export type UpdateTournamentRequestVenueAddress = null | string;

export type UpdateTournamentRequestPublicNotice = null | string;

export type UpdateTournamentRequestRegulationsText = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpdateTournamentRequestRestMinutes = number | string;

export interface UpdateTournamentRequest {
  name: string;
  description: UpdateTournamentRequestDescription;
  organizerName: UpdateTournamentRequestOrganizerName;
  startsAt: string;
  locationId: UpdateTournamentRequestLocationId;
  venueName: string;
  venueAddress: UpdateTournamentRequestVenueAddress;
  isPublic: boolean;
  publicNameMode: TournamentPublicNameMode;
  publicNotice: UpdateTournamentRequestPublicNotice;
  regulationsText: UpdateTournamentRequestRegulationsText;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  restMinutes: UpdateTournamentRequestRestMinutes;
  autoCallNext: boolean;
}

export interface UpdateWaitlistExpiryRequest {
  expiresAt: string;
}

export type UpsertCampAddonRequestId = null | string;

export type UpsertCampAddonRequestDescription = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type UpsertCampAddonRequestPrice = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpsertCampAddonRequestCapacity = null | number | string;

export interface UpsertCampAddonRequest {
  id: UpsertCampAddonRequestId;
  name: string;
  description: UpsertCampAddonRequestDescription;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  price: UpsertCampAddonRequestPrice;
  unit: CampAddonUnit;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  capacity: UpsertCampAddonRequestCapacity;
  requiresApproval: boolean;
  priceOnRequest: boolean;
}

export type UpsertCampPriceOptionRequestId = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpsertCampPriceOptionRequestMinAge = null | number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpsertCampPriceOptionRequestMaxAge = null | number | string;

export interface UpsertCampPriceOptionRequest {
  id: UpsertCampPriceOptionRequestId;
  name: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  minAge: UpsertCampPriceOptionRequestMinAge;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxAge: UpsertCampPriceOptionRequestMaxAge;
  tiers: UpsertCampPriceTierRequest[];
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type UpsertCampPriceTierRequestPrice = number | string;

export type UpsertCampPriceTierRequestValidUntil = null | string;

export interface UpsertCampPriceTierRequest {
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  price: UpsertCampPriceTierRequestPrice;
  validUntil: UpsertCampPriceTierRequestValidUntil;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpsertCampRefundRuleRequestMinDaysBeforeStart = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
 */
export type UpsertCampRefundRuleRequestRefundPercent = number | string;

export interface UpsertCampRefundRuleRequest {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  minDaysBeforeStart: UpsertCampRefundRuleRequestMinDaysBeforeStart;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  refundPercent: UpsertCampRefundRuleRequestRefundPercent;
  basis: CampRefundBasis;
  deductDeposit: boolean;
}

export type UpsertPaymentGatewayConfigRequestExtraKey = null | string;

export interface UpsertPaymentGatewayConfigRequest {
  providerName: string;
  posId: string;
  clientId: string;
  clientSecret: string;
  extraKey: UpsertPaymentGatewayConfigRequestExtraKey;
  isSandbox: boolean;
}

export interface UpsertRacketStringerRequest {
  fullName: string;
  isActive?: boolean;
}

export type UpsertTournamentCategoryRequestShortName = null | string;

export type UpsertTournamentCategoryRequestColor = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpsertTournamentCategoryRequestBirthYearFrom = null | number | string;

export type UpsertTournamentCategoryRequestAmericanoSettings = null | TournamentAmericanoSettings;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpsertTournamentCategoryRequestQualifiersPerGroup = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpsertTournamentCategoryRequestEstimatedGameMinutes = number | string;

export type UpsertTournamentCategoryRequestTimeBlockId = null | string;

export type UpsertTournamentCategoryRequestCourtIds = null | string[];

export interface UpsertTournamentCategoryRequest {
  name: string;
  shortName: UpsertTournamentCategoryRequestShortName;
  gender: TournamentCategoryGender;
  color: UpsertTournamentCategoryRequestColor;
  format: TournamentFormat;
  entryType: TournamentEntryType;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  birthYearFrom: UpsertTournamentCategoryRequestBirthYearFrom;
  matchFormat: TournamentMatchFormat;
  standingsRules: TournamentStandingsRules;
  americanoSettings: UpsertTournamentCategoryRequestAmericanoSettings;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  qualifiersPerGroup: UpsertTournamentCategoryRequestQualifiersPerGroup;
  thirdPlaceMatch: boolean;
  classificationMatches: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  estimatedGameMinutes: UpsertTournamentCategoryRequestEstimatedGameMinutes;
  timeBlockId: UpsertTournamentCategoryRequestTimeBlockId;
  courtIds?: UpsertTournamentCategoryRequestCourtIds;
}

export type UpsertTournamentEntryRequestDisplayName = null | string;

export type UpsertTournamentEntryRequestClubName = null | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type UpsertTournamentEntryRequestSeed = null | number | string;

export type UpsertTournamentEntryRequestStatus = null | TournamentEntryStatus;

export interface UpsertTournamentEntryRequest {
  displayName: UpsertTournamentEntryRequestDisplayName;
  clubName: UpsertTournamentEntryRequestClubName;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  seed: UpsertTournamentEntryRequestSeed;
  status: UpsertTournamentEntryRequestStatus;
  players: TournamentEntryPlayerInput[];
}

export interface UpsertTournamentTimeBlockRequest {
  name: string;
  startsAt: string;
  endsAt: string;
  courtIds: string[];
}

export type UserContextResponseActiveSubscriptions = null | SubscriptionResponse[];

export type UserContextResponseAvailableCredits = null | MakeUpCreditResponse[];

export interface UserContextResponse {
  user: UserDto;
  activeSchool: SchoolContextDto;
  mySchools: MySchoolMembershipDto[];
  activeSubscriptions?: UserContextResponseActiveSubscriptions;
  availableCredits?: UserContextResponseAvailableCredits;
}

export type UserDtoFirstName = null | string;

export type UserDtoLastName = null | string;

export interface UserDto {
  id: string;
  email: string;
  firstName: UserDtoFirstName;
  lastName: UserDtoLastName;
}

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type WaitlistStatisticsCreated = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type WaitlistStatisticsPromoted = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type WaitlistStatisticsCancelled = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type WaitlistStatisticsExpired = number | string;

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type WaitlistStatisticsPending = number | string;

export interface WaitlistStatistics {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  created: WaitlistStatisticsCreated;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  promoted: WaitlistStatisticsPromoted;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  cancelled: WaitlistStatisticsCancelled;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  expired: WaitlistStatisticsExpired;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pending: WaitlistStatisticsPending;
}

export type WaitlistStatus = typeof WaitlistStatus[keyof typeof WaitlistStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WaitlistStatus = {
  Pending: 'Pending',
  Promoted: 'Promoted',
  Cancelled: 'Cancelled',
  Expired: 'Expired',
} as const;

export type ImpersonateUserParams = {
targetUserId: string;
};

export type GetAllCoachesCashSettlementsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
year?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
month?: number | string;
dateFrom?: string;
dateTo?: string;
};

export type GetCoachSessionsReportParams = {
from?: string;
to?: string;
coachMemberId?: string;
includeScheduled?: boolean;
};

export type ExportCoachSessionsReportExcelParams = {
from?: string;
to?: string;
coachMemberId?: string;
includeScheduled?: boolean;
};

export type GetCoachMemberSessionsReportParams = {
from?: string;
to?: string;
includeScheduled?: boolean;
};

export type ListMemberNotificationsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number | string;
};

export type ReplaceAttachmentFileBody = {
  file: IFormFile;
};

export type GetSchoolStatisticsParams = {
from: string;
to: string;
};

export type GenerateLogoUploadUrlParams = {
contentType: string;
};

export type ListSchoolMembersParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number | string;
sortBy?: string;
sortDesc?: boolean;
search?: string;
skillLevelId?: string;
role?: SchoolRole;
joinedFrom?: string;
joinedTo?: string;
loginStatus?: MemberLoginStatus;
};

export type ExportSchoolMembersExcelParams = {
sortBy?: string;
sortDesc?: boolean;
search?: string;
skillLevelId?: string;
role?: SchoolRole;
joinedFrom?: string;
joinedTo?: string;
loginStatus?: MemberLoginStatus;
};

export type ExportSchoolMembersCsvParams = {
sortBy?: string;
sortDesc?: boolean;
search?: string;
skillLevelId?: string;
role?: SchoolRole;
joinedFrom?: string;
joinedTo?: string;
loginStatus?: MemberLoginStatus;
getResponseFormat?: boolean;
};

export type ListSchoolMembersLiteParams = {
role?: SchoolRole;
};

export type RemoveSchoolMemberParams = {
hardDelete?: boolean;
};

export type ImportStudentsFromCsvBodyAllOf = {
  file?: IFormFile;
};

export type ImportStudentsFromCsvBodyAllOfTwo = {
  billingMonth?: string;
};

export type ImportStudentsFromCsvBody = ImportStudentsFromCsvBodyAllOf & ImportStudentsFromCsvBodyAllOfTwo & Required<Pick<ImportStudentsFromCsvBodyAllOf & ImportStudentsFromCsvBodyAllOfTwo, 'file' | 'billingMonth'>>;

export type ListLocationsParams = {
kind?: ClassKind;
};

export type ListSchoolHolidaysParams = {
from?: string;
to?: string;
};

export type ListGameDaysParams = {
from: string;
to: string;
};

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type SetGameDays200 = number | string;

export type ListSchedulesParams = {
locationId?: string;
coachMemberId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
dayOfWeek?: number | string;
skillLevelId?: string;
showOnlyPrivate?: boolean;
showArchived?: boolean;
query?: string;
forStudent?: boolean;
};

export type GetScheduleParams = {
forStudent?: boolean;
};

export type ListSessionsParams = {
skillLevelId?: string[];
locationId?: string[];
coachMemberId?: string[];
sessionId?: string[];
dayOfWeek?: ListSessionsDayOfWeekItem[];
from?: string;
to?: string;
query?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number | string;
status?: SessionStatus;
sortDescending?: boolean;
scheduleId?: string;
tag?: string[];
forStudent?: boolean;
includeCancelled?: boolean;
};

/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
export type ListSessionsDayOfWeekItem = number | string;

export type GetSessionParams = {
forStudent?: boolean;
};

export type CancelSessionBody = null | CancelSessionRequest;

export type GetPublicSchedulesParams = {
apiKey?: string;
};

export type GetPublicCoachesParams = {
apiKey?: string;
};

export type CalculateEnrollmentPriceParams = {
sessionId: string;
studentMemberId?: string;
type: EnrollmentType;
makeUpCreditId?: string;
discountCouponId?: string;
useGiftVouchers: boolean;
};

export type ListAllEnrollmentsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number | string;
};

export type ApproveEnrollmentParams = {
allowOverbooking?: boolean;
};

export type ListStudentEnrollmentsParams = {
UpcomingOnly?: boolean;
LocationId?: string;
Type?: EnrollmentType;
Status?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
Page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
PageSize?: number | string;
Scope?: string;
SortDirection?: string;
};

export type ListMyEnrollmentsParams = {
upcomingOnly?: boolean;
};

export type CancelEnrollmentParams = {
issueFollowUp?: boolean;
refundFollowUp?: boolean;
hardDelete?: boolean;
decline?: boolean;
};

export type DeleteAttendanceParams = {
markedAt?: string;
};

export type QueryWaitlistsParams = {
sessionId?: string;
scheduleId?: string;
studentMemberId?: string;
status?: WaitlistStatus;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number | string;
};

export type ListMyWaitlistsParams = {
status?: WaitlistStatus;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number | string;
};

export type PromoteWaitlistEntryParams = {
allowOverbooking?: boolean;
};

export type ListPaymentsParams = {
StudentMemberId?: string;
From?: string;
To?: string;
Query?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
Page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
PageSize?: number | string;
ShowCancelled?: boolean;
Status?: PaymentStatus[];
EnrollmentType?: string;
};

export type InitializeOnlinePaymentParams = {
returnUrl: string;
enableAutoPay: boolean;
};

export type ListAdminSubscriptionsParams = {
StudentMemberId?: string;
ScheduleId?: string;
Status?: SubscriptionStatus[];
Query?: string;
OnlyNegativeBalance?: boolean;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
Page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
PageSize?: number | string;
SortBy?: string;
SortDesc?: boolean;
MissingBillMonth?: string;
};

export type ListBillsParams = {
StudentMemberId?: string;
From?: string;
To?: string;
Query?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
Page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
PageSize?: number | string;
Status?: BillStatus[];
EnrollmentType?: string;
};

export type ExportBillsExcelParams = {
StudentMemberId?: string;
From?: string;
To?: string;
Query?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
Page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
PageSize?: number | string;
Status?: BillStatus[];
EnrollmentType?: string;
};

export type GetAdminBillingMetricsParams = {
StudentMemberId?: string;
From?: string;
To?: string;
Query?: string;
BillStatus?: BillStatus[];
PaymentStatus?: PaymentStatus[];
EnrollmentType?: string;
};

export type ListStudentNegativeBalancesParams = {
Query?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
Page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
PageSize?: number | string;
SortBy?: string;
SortDesc?: boolean;
};

export type ExportNegativeBalancesExcelParams = {
Query?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
Page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
PageSize?: number | string;
SortBy?: string;
SortDesc?: boolean;
};

export type ListStudentBillsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number | string;
};

export type InitializeBillOnlinePaymentParams = {
returnUrl: string;
enableAutoPay: boolean;
};

export type ListUsableStudentCreditsParams = {
sessionId?: string;
};

export type ListActiveCreditsAdminParams = {
search?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number | string;
};

export type DeleteBillParams = {
generateDropInBills?: boolean;
unenroll?: boolean;
};

export type ListCouponsParams = {
status?: DiscountCouponStatus;
studentMemberId?: string;
couponType?: CouponType;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number | string;
};

export type ResolvePriceListItemParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
duration: number | string;
startDate?: string;
};

export type GetCoachCashSettlementParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
year?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
month?: number | string;
dateFrom?: string;
dateTo?: string;
};

export type ListNotificationsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number | string;
};

export type UploadAttachmentParams = {
folder?: string;
};

export type UploadAttachmentBody = {
  file: IFormFile;
};

export type ListAttachmentsParams = {
folder?: string;
};

export type ListActiveRegulationsParams = {
lang?: string;
type?: RegulationType;
};

export type GetCurrentRegulationParams = {
type: RegulationType;
lang?: string;
};

export type ListIndividualClassCoachesParams = {
onlyEnabled?: boolean;
};

export type ListFreeIndividualSlotsParams = {
from?: string;
to?: string;
coachMemberId?: string;
locationId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
duration?: number | string;
};

export type GetIndividualSlotPriceParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
partySize: number | string;
bookingType: IndividualBookingType;
};

export type ListCoachIndividualSlotsParams = {
from?: string;
to?: string;
coachMemberId?: string;
locationId?: string;
};

export type ListIndividualSchedulesParams = {
coachMemberId?: string;
};

export type ListIndividualBookingRequestsParams = {
coachMemberId?: string;
};

export type ListIndividualOnSiteBillsParams = {
coachMemberId?: string;
};

export type PreviewMailingRecipientsParams = {
targetType: string;
targetId?: string;
};

export type PreviewGroupMessageRecipientsParams = {
targetType: string;
targetId?: string;
};

export type GetTournamentMonthlyRankingParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
year?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
month?: number | string;
};

export type ListTournamentPlayersParams = {
search?: string;
};

export type ListCampParticipantsParams = {
status?: CampParticipantStatus;
priceOptionId?: string;
addonId?: string;
search?: string;
};

export type ExportCampParticipantsParams = {
status?: CampParticipantStatus;
priceOptionId?: string;
addonId?: string;
search?: string;
format?: CampParticipantExportFormat;
};

export type PayCampParticipantOnlineParams = {
returnUrl: string;
};

export type ListRacketStringingOrdersParams = {
status?: RacketStringingStatus;
closed?: boolean;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number | string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number | string;
};

export type ListRacketStringersParams = {
includeInactive?: boolean;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getConnectUserinfo = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/connect/userinfo`, method: 'GET', signal
    },
      options);
    }
  



export const getGetConnectUserinfoQueryKey = () => {
    return [
    `/connect/userinfo`
    ] as const;
    }

    
export const getGetConnectUserinfoQueryOptions = <TData = Awaited<ReturnType<typeof getConnectUserinfo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectUserinfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectUserinfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectUserinfo>>> = ({ signal }) => getConnectUserinfo(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectUserinfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConnectUserinfoQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectUserinfo>>>
export type GetConnectUserinfoQueryError = unknown


export function useGetConnectUserinfo<TData = Awaited<ReturnType<typeof getConnectUserinfo>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectUserinfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnectUserinfo>>,
          TError,
          Awaited<ReturnType<typeof getConnectUserinfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConnectUserinfo<TData = Awaited<ReturnType<typeof getConnectUserinfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectUserinfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnectUserinfo>>,
          TError,
          Awaited<ReturnType<typeof getConnectUserinfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConnectUserinfo<TData = Awaited<ReturnType<typeof getConnectUserinfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectUserinfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConnectUserinfo<TData = Awaited<ReturnType<typeof getConnectUserinfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectUserinfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConnectUserinfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getUserContext = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<UserContextResponse>(
      {url: `/api/v1/schools/${schoolId}/me`, method: 'GET', signal
    },
      options);
    }
  



export const getGetUserContextQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/me`
    ] as const;
    }

    
export const getGetUserContextQueryOptions = <TData = Awaited<ReturnType<typeof getUserContext>>, TError = void>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserContextQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserContext>>> = ({ signal }) => getUserContext(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserContext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserContextQueryResult = NonNullable<Awaited<ReturnType<typeof getUserContext>>>
export type GetUserContextQueryError = void


export function useGetUserContext<TData = Awaited<ReturnType<typeof getUserContext>>, TError = void>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserContext>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserContext>>,
          TError,
          Awaited<ReturnType<typeof getUserContext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserContext<TData = Awaited<ReturnType<typeof getUserContext>>, TError = void>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserContext>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserContext>>,
          TError,
          Awaited<ReturnType<typeof getUserContext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserContext<TData = Awaited<ReturnType<typeof getUserContext>>, TError = void>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserContext<TData = Awaited<ReturnType<typeof getUserContext>>, TError = void>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserContextQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const impersonateUser = (
    schoolId: string,
    params: ImpersonateUserParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/auth/impersonate`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getImpersonateUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof impersonateUser>>, TError,{schoolId: string;params: ImpersonateUserParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof impersonateUser>>, TError,{schoolId: string;params: ImpersonateUserParams}, TContext> => {

const mutationKey = ['impersonateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof impersonateUser>>, {schoolId: string;params: ImpersonateUserParams}> = (props) => {
          const {schoolId,params} = props ?? {};

          return  impersonateUser(schoolId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImpersonateUserMutationResult = NonNullable<Awaited<ReturnType<typeof impersonateUser>>>
    
    export type ImpersonateUserMutationError = unknown

    export const useImpersonateUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof impersonateUser>>, TError,{schoolId: string;params: ImpersonateUserParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof impersonateUser>>,
        TError,
        {schoolId: string;params: ImpersonateUserParams},
        TContext
      > => {

      const mutationOptions = getImpersonateUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Clear registration, subscription, billing, and notification tables for testing (API key required)
 */
export const testingClearData = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/testing/clear-data`, method: 'POST', signal
    },
      options);
    }
  


export const getTestingClearDataMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingClearData>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof testingClearData>>, TError,void, TContext> => {

const mutationKey = ['testingClearData'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingClearData>>, void> = () => {
          

          return  testingClearData(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TestingClearDataMutationResult = NonNullable<Awaited<ReturnType<typeof testingClearData>>>
    
    export type TestingClearDataMutationError = unknown

    /**
 * @summary Clear registration, subscription, billing, and notification tables for testing (API key required)
 */
export const useTestingClearData = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingClearData>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingClearData>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getTestingClearDataMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setStudentSkillLevel = (
    schoolId: string,
    coachMemberId: string,
    setStudentSkillLevelRequest: SetStudentSkillLevelRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coaches/${coachMemberId}/skill-level`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setStudentSkillLevelRequest, signal
    },
      options);
    }
  


export const getSetStudentSkillLevelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setStudentSkillLevel>>, TError,{schoolId: string;coachMemberId: string;data: SetStudentSkillLevelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setStudentSkillLevel>>, TError,{schoolId: string;coachMemberId: string;data: SetStudentSkillLevelRequest}, TContext> => {

const mutationKey = ['setStudentSkillLevel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setStudentSkillLevel>>, {schoolId: string;coachMemberId: string;data: SetStudentSkillLevelRequest}> = (props) => {
          const {schoolId,coachMemberId,data} = props ?? {};

          return  setStudentSkillLevel(schoolId,coachMemberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetStudentSkillLevelMutationResult = NonNullable<Awaited<ReturnType<typeof setStudentSkillLevel>>>
    export type SetStudentSkillLevelMutationBody = SetStudentSkillLevelRequest
    export type SetStudentSkillLevelMutationError = unknown

    export const useSetStudentSkillLevel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setStudentSkillLevel>>, TError,{schoolId: string;coachMemberId: string;data: SetStudentSkillLevelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setStudentSkillLevel>>,
        TError,
        {schoolId: string;coachMemberId: string;data: SetStudentSkillLevelRequest},
        TContext
      > => {

      const mutationOptions = getSetStudentSkillLevelMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAllCoachesCashSettlements = (
    schoolId: string,
    params?: GetAllCoachesCashSettlementsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoachCashSettlementSummary[]>(
      {url: `/api/v1/schools/${schoolId}/coaches/cash-settlements`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAllCoachesCashSettlementsQueryKey = (schoolId?: string,
    params?: GetAllCoachesCashSettlementsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/coaches/cash-settlements`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllCoachesCashSettlementsQueryOptions = <TData = Awaited<ReturnType<typeof getAllCoachesCashSettlements>>, TError = unknown>(schoolId: string,
    params?: GetAllCoachesCashSettlementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCoachesCashSettlements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllCoachesCashSettlementsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCoachesCashSettlements>>> = ({ signal }) => getAllCoachesCashSettlements(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllCoachesCashSettlements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllCoachesCashSettlementsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCoachesCashSettlements>>>
export type GetAllCoachesCashSettlementsQueryError = unknown


export function useGetAllCoachesCashSettlements<TData = Awaited<ReturnType<typeof getAllCoachesCashSettlements>>, TError = unknown>(
 schoolId: string,
    params: undefined |  GetAllCoachesCashSettlementsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCoachesCashSettlements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCoachesCashSettlements>>,
          TError,
          Awaited<ReturnType<typeof getAllCoachesCashSettlements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllCoachesCashSettlements<TData = Awaited<ReturnType<typeof getAllCoachesCashSettlements>>, TError = unknown>(
 schoolId: string,
    params?: GetAllCoachesCashSettlementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCoachesCashSettlements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCoachesCashSettlements>>,
          TError,
          Awaited<ReturnType<typeof getAllCoachesCashSettlements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllCoachesCashSettlements<TData = Awaited<ReturnType<typeof getAllCoachesCashSettlements>>, TError = unknown>(
 schoolId: string,
    params?: GetAllCoachesCashSettlementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCoachesCashSettlements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAllCoachesCashSettlements<TData = Awaited<ReturnType<typeof getAllCoachesCashSettlements>>, TError = unknown>(
 schoolId: string,
    params?: GetAllCoachesCashSettlementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCoachesCashSettlements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllCoachesCashSettlementsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getCoachSessionsReport = (
    schoolId: string,
    params?: GetCoachSessionsReportParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoachSessionsReportResponse>(
      {url: `/api/v1/schools/${schoolId}/coaches/reports/sessions`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCoachSessionsReportQueryKey = (schoolId?: string,
    params?: GetCoachSessionsReportParams,) => {
    return [
    `/api/v1/schools/${schoolId}/coaches/reports/sessions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCoachSessionsReportQueryOptions = <TData = Awaited<ReturnType<typeof getCoachSessionsReport>>, TError = unknown>(schoolId: string,
    params?: GetCoachSessionsReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachSessionsReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoachSessionsReportQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoachSessionsReport>>> = ({ signal }) => getCoachSessionsReport(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoachSessionsReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCoachSessionsReportQueryResult = NonNullable<Awaited<ReturnType<typeof getCoachSessionsReport>>>
export type GetCoachSessionsReportQueryError = unknown


export function useGetCoachSessionsReport<TData = Awaited<ReturnType<typeof getCoachSessionsReport>>, TError = unknown>(
 schoolId: string,
    params: undefined |  GetCoachSessionsReportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachSessionsReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoachSessionsReport>>,
          TError,
          Awaited<ReturnType<typeof getCoachSessionsReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCoachSessionsReport<TData = Awaited<ReturnType<typeof getCoachSessionsReport>>, TError = unknown>(
 schoolId: string,
    params?: GetCoachSessionsReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachSessionsReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoachSessionsReport>>,
          TError,
          Awaited<ReturnType<typeof getCoachSessionsReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCoachSessionsReport<TData = Awaited<ReturnType<typeof getCoachSessionsReport>>, TError = unknown>(
 schoolId: string,
    params?: GetCoachSessionsReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachSessionsReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCoachSessionsReport<TData = Awaited<ReturnType<typeof getCoachSessionsReport>>, TError = unknown>(
 schoolId: string,
    params?: GetCoachSessionsReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachSessionsReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCoachSessionsReportQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const exportCoachSessionsReportExcel = (
    schoolId: string,
    params?: ExportCoachSessionsReportExcelParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coaches/reports/sessions/export-excel`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getExportCoachSessionsReportExcelQueryKey = (schoolId?: string,
    params?: ExportCoachSessionsReportExcelParams,) => {
    return [
    `/api/v1/schools/${schoolId}/coaches/reports/sessions/export-excel`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getExportCoachSessionsReportExcelQueryOptions = <TData = Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>, TError = unknown>(schoolId: string,
    params?: ExportCoachSessionsReportExcelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportCoachSessionsReportExcelQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>> = ({ signal }) => exportCoachSessionsReportExcel(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportCoachSessionsReportExcelQueryResult = NonNullable<Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>>
export type ExportCoachSessionsReportExcelQueryError = unknown


export function useExportCoachSessionsReportExcel<TData = Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ExportCoachSessionsReportExcelParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>,
          TError,
          Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportCoachSessionsReportExcel<TData = Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>, TError = unknown>(
 schoolId: string,
    params?: ExportCoachSessionsReportExcelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>,
          TError,
          Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportCoachSessionsReportExcel<TData = Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>, TError = unknown>(
 schoolId: string,
    params?: ExportCoachSessionsReportExcelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExportCoachSessionsReportExcel<TData = Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>, TError = unknown>(
 schoolId: string,
    params?: ExportCoachSessionsReportExcelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCoachSessionsReportExcel>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportCoachSessionsReportExcelQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getCoachMemberSessionsReport = (
    schoolId: string,
    coachMemberId: string,
    params?: GetCoachMemberSessionsReportParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoachSessionsReportResponse>(
      {url: `/api/v1/schools/${schoolId}/coaches/${coachMemberId}/reports/sessions`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCoachMemberSessionsReportQueryKey = (schoolId?: string,
    coachMemberId?: string,
    params?: GetCoachMemberSessionsReportParams,) => {
    return [
    `/api/v1/schools/${schoolId}/coaches/${coachMemberId}/reports/sessions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCoachMemberSessionsReportQueryOptions = <TData = Awaited<ReturnType<typeof getCoachMemberSessionsReport>>, TError = unknown>(schoolId: string,
    coachMemberId: string,
    params?: GetCoachMemberSessionsReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachMemberSessionsReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoachMemberSessionsReportQueryKey(schoolId,coachMemberId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoachMemberSessionsReport>>> = ({ signal }) => getCoachMemberSessionsReport(schoolId,coachMemberId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && coachMemberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoachMemberSessionsReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCoachMemberSessionsReportQueryResult = NonNullable<Awaited<ReturnType<typeof getCoachMemberSessionsReport>>>
export type GetCoachMemberSessionsReportQueryError = unknown


export function useGetCoachMemberSessionsReport<TData = Awaited<ReturnType<typeof getCoachMemberSessionsReport>>, TError = unknown>(
 schoolId: string,
    coachMemberId: string,
    params: undefined |  GetCoachMemberSessionsReportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachMemberSessionsReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoachMemberSessionsReport>>,
          TError,
          Awaited<ReturnType<typeof getCoachMemberSessionsReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCoachMemberSessionsReport<TData = Awaited<ReturnType<typeof getCoachMemberSessionsReport>>, TError = unknown>(
 schoolId: string,
    coachMemberId: string,
    params?: GetCoachMemberSessionsReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachMemberSessionsReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoachMemberSessionsReport>>,
          TError,
          Awaited<ReturnType<typeof getCoachMemberSessionsReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCoachMemberSessionsReport<TData = Awaited<ReturnType<typeof getCoachMemberSessionsReport>>, TError = unknown>(
 schoolId: string,
    coachMemberId: string,
    params?: GetCoachMemberSessionsReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachMemberSessionsReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCoachMemberSessionsReport<TData = Awaited<ReturnType<typeof getCoachMemberSessionsReport>>, TError = unknown>(
 schoolId: string,
    coachMemberId: string,
    params?: GetCoachMemberSessionsReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachMemberSessionsReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCoachMemberSessionsReportQueryOptions(schoolId,coachMemberId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listNotificationTemplates = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NotificationTemplateResponse[]>(
      {url: `/api/v1/schools/${schoolId}/notifications/templates`, method: 'GET', signal
    },
      options);
    }
  



export const getListNotificationTemplatesQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/notifications/templates`
    ] as const;
    }

    
export const getListNotificationTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listNotificationTemplates>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationTemplatesQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotificationTemplates>>> = ({ signal }) => listNotificationTemplates(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotificationTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNotificationTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listNotificationTemplates>>>
export type ListNotificationTemplatesQueryError = unknown


export function useListNotificationTemplates<TData = Awaited<ReturnType<typeof listNotificationTemplates>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotificationTemplates>>,
          TError,
          Awaited<ReturnType<typeof listNotificationTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotificationTemplates<TData = Awaited<ReturnType<typeof listNotificationTemplates>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotificationTemplates>>,
          TError,
          Awaited<ReturnType<typeof listNotificationTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotificationTemplates<TData = Awaited<ReturnType<typeof listNotificationTemplates>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListNotificationTemplates<TData = Awaited<ReturnType<typeof listNotificationTemplates>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNotificationTemplatesQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateNotificationTemplate = (
    schoolId: string,
    type: string,
    updateNotificationTemplateRequest: UpdateNotificationTemplateRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<NotificationTemplateResponse>(
      {url: `/api/v1/schools/${schoolId}/notifications/templates/${type}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateNotificationTemplateRequest
    },
      options);
    }
  


export const getUpdateNotificationTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationTemplate>>, TError,{schoolId: string;type: string;data: UpdateNotificationTemplateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNotificationTemplate>>, TError,{schoolId: string;type: string;data: UpdateNotificationTemplateRequest}, TContext> => {

const mutationKey = ['updateNotificationTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNotificationTemplate>>, {schoolId: string;type: string;data: UpdateNotificationTemplateRequest}> = (props) => {
          const {schoolId,type,data} = props ?? {};

          return  updateNotificationTemplate(schoolId,type,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateNotificationTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateNotificationTemplate>>>
    export type UpdateNotificationTemplateMutationBody = UpdateNotificationTemplateRequest
    export type UpdateNotificationTemplateMutationError = unknown

    export const useUpdateNotificationTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationTemplate>>, TError,{schoolId: string;type: string;data: UpdateNotificationTemplateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateNotificationTemplate>>,
        TError,
        {schoolId: string;type: string;data: UpdateNotificationTemplateRequest},
        TContext
      > => {

      const mutationOptions = getUpdateNotificationTemplateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const sendTestNotification = (
    schoolId: string,
    type: string,
    sendTestNotificationRequest: SendTestNotificationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/notifications/templates/${type}/test`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendTestNotificationRequest, signal
    },
      options);
    }
  


export const getSendTestNotificationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendTestNotification>>, TError,{schoolId: string;type: string;data: SendTestNotificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendTestNotification>>, TError,{schoolId: string;type: string;data: SendTestNotificationRequest}, TContext> => {

const mutationKey = ['sendTestNotification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendTestNotification>>, {schoolId: string;type: string;data: SendTestNotificationRequest}> = (props) => {
          const {schoolId,type,data} = props ?? {};

          return  sendTestNotification(schoolId,type,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendTestNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof sendTestNotification>>>
    export type SendTestNotificationMutationBody = SendTestNotificationRequest
    export type SendTestNotificationMutationError = unknown

    export const useSendTestNotification = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendTestNotification>>, TError,{schoolId: string;type: string;data: SendTestNotificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendTestNotification>>,
        TError,
        {schoolId: string;type: string;data: SendTestNotificationRequest},
        TContext
      > => {

      const mutationOptions = getSendTestNotificationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const sendTestPushNotification = (
    schoolId: string,
    type: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/notifications/templates/${type}/test-push`, method: 'POST', signal
    },
      options);
    }
  


export const getSendTestPushNotificationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendTestPushNotification>>, TError,{schoolId: string;type: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendTestPushNotification>>, TError,{schoolId: string;type: string}, TContext> => {

const mutationKey = ['sendTestPushNotification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendTestPushNotification>>, {schoolId: string;type: string}> = (props) => {
          const {schoolId,type} = props ?? {};

          return  sendTestPushNotification(schoolId,type,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendTestPushNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof sendTestPushNotification>>>
    
    export type SendTestPushNotificationMutationError = unknown

    export const useSendTestPushNotification = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendTestPushNotification>>, TError,{schoolId: string;type: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendTestPushNotification>>,
        TError,
        {schoolId: string;type: string},
        TContext
      > => {

      const mutationOptions = getSendTestPushNotificationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listMemberNotifications = (
    schoolId: string,
    memberId: string,
    params?: ListMemberNotificationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NotificationResponse[]>(
      {url: `/api/v1/schools/${schoolId}/members/${memberId}/notifications`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListMemberNotificationsQueryKey = (schoolId?: string,
    memberId?: string,
    params?: ListMemberNotificationsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/members/${memberId}/notifications`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListMemberNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listMemberNotifications>>, TError = unknown>(schoolId: string,
    memberId: string,
    params?: ListMemberNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMemberNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMemberNotificationsQueryKey(schoolId,memberId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMemberNotifications>>> = ({ signal }) => listMemberNotifications(schoolId,memberId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && memberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMemberNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMemberNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listMemberNotifications>>>
export type ListMemberNotificationsQueryError = unknown


export function useListMemberNotifications<TData = Awaited<ReturnType<typeof listMemberNotifications>>, TError = unknown>(
 schoolId: string,
    memberId: string,
    params: undefined |  ListMemberNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMemberNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMemberNotifications>>,
          TError,
          Awaited<ReturnType<typeof listMemberNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMemberNotifications<TData = Awaited<ReturnType<typeof listMemberNotifications>>, TError = unknown>(
 schoolId: string,
    memberId: string,
    params?: ListMemberNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMemberNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMemberNotifications>>,
          TError,
          Awaited<ReturnType<typeof listMemberNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMemberNotifications<TData = Awaited<ReturnType<typeof listMemberNotifications>>, TError = unknown>(
 schoolId: string,
    memberId: string,
    params?: ListMemberNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMemberNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListMemberNotifications<TData = Awaited<ReturnType<typeof listMemberNotifications>>, TError = unknown>(
 schoolId: string,
    memberId: string,
    params?: ListMemberNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMemberNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMemberNotificationsQueryOptions(schoolId,memberId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const sendCustomNotificationToMember = (
    schoolId: string,
    memberId: string,
    sendCustomNotificationRequest: SendCustomNotificationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/members/${memberId}/notifications`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendCustomNotificationRequest, signal
    },
      options);
    }
  


export const getSendCustomNotificationToMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCustomNotificationToMember>>, TError,{schoolId: string;memberId: string;data: SendCustomNotificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendCustomNotificationToMember>>, TError,{schoolId: string;memberId: string;data: SendCustomNotificationRequest}, TContext> => {

const mutationKey = ['sendCustomNotificationToMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendCustomNotificationToMember>>, {schoolId: string;memberId: string;data: SendCustomNotificationRequest}> = (props) => {
          const {schoolId,memberId,data} = props ?? {};

          return  sendCustomNotificationToMember(schoolId,memberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendCustomNotificationToMemberMutationResult = NonNullable<Awaited<ReturnType<typeof sendCustomNotificationToMember>>>
    export type SendCustomNotificationToMemberMutationBody = SendCustomNotificationRequest
    export type SendCustomNotificationToMemberMutationError = unknown

    export const useSendCustomNotificationToMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCustomNotificationToMember>>, TError,{schoolId: string;memberId: string;data: SendCustomNotificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendCustomNotificationToMember>>,
        TError,
        {schoolId: string;memberId: string;data: SendCustomNotificationRequest},
        TContext
      > => {

      const mutationOptions = getSendCustomNotificationToMemberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const sendCustomNotificationToMembers = (
    schoolId: string,
    sendBatchNotificationRequest: SendBatchNotificationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/notifications/send-custom`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendBatchNotificationRequest, signal
    },
      options);
    }
  


export const getSendCustomNotificationToMembersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCustomNotificationToMembers>>, TError,{schoolId: string;data: SendBatchNotificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendCustomNotificationToMembers>>, TError,{schoolId: string;data: SendBatchNotificationRequest}, TContext> => {

const mutationKey = ['sendCustomNotificationToMembers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendCustomNotificationToMembers>>, {schoolId: string;data: SendBatchNotificationRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  sendCustomNotificationToMembers(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendCustomNotificationToMembersMutationResult = NonNullable<Awaited<ReturnType<typeof sendCustomNotificationToMembers>>>
    export type SendCustomNotificationToMembersMutationBody = SendBatchNotificationRequest
    export type SendCustomNotificationToMembersMutationError = unknown

    export const useSendCustomNotificationToMembers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCustomNotificationToMembers>>, TError,{schoolId: string;data: SendBatchNotificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendCustomNotificationToMembers>>,
        TError,
        {schoolId: string;data: SendBatchNotificationRequest},
        TContext
      > => {

      const mutationOptions = getSendCustomNotificationToMembersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const downloadAttachmentFile = (
    schoolId: string,
    attachmentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/attachments/${attachmentId}/file`, method: 'GET', signal
    },
      options);
    }
  



export const getDownloadAttachmentFileQueryKey = (schoolId?: string,
    attachmentId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/attachments/${attachmentId}/file`
    ] as const;
    }

    
export const getDownloadAttachmentFileQueryOptions = <TData = Awaited<ReturnType<typeof downloadAttachmentFile>>, TError = unknown>(schoolId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAttachmentFile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadAttachmentFileQueryKey(schoolId,attachmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadAttachmentFile>>> = ({ signal }) => downloadAttachmentFile(schoolId,attachmentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && attachmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadAttachmentFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadAttachmentFileQueryResult = NonNullable<Awaited<ReturnType<typeof downloadAttachmentFile>>>
export type DownloadAttachmentFileQueryError = unknown


export function useDownloadAttachmentFile<TData = Awaited<ReturnType<typeof downloadAttachmentFile>>, TError = unknown>(
 schoolId: string,
    attachmentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAttachmentFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadAttachmentFile>>,
          TError,
          Awaited<ReturnType<typeof downloadAttachmentFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadAttachmentFile<TData = Awaited<ReturnType<typeof downloadAttachmentFile>>, TError = unknown>(
 schoolId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAttachmentFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadAttachmentFile>>,
          TError,
          Awaited<ReturnType<typeof downloadAttachmentFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadAttachmentFile<TData = Awaited<ReturnType<typeof downloadAttachmentFile>>, TError = unknown>(
 schoolId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAttachmentFile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDownloadAttachmentFile<TData = Awaited<ReturnType<typeof downloadAttachmentFile>>, TError = unknown>(
 schoolId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAttachmentFile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadAttachmentFileQueryOptions(schoolId,attachmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const replaceAttachmentFile = (
    schoolId: string,
    attachmentId: string,
    replaceAttachmentFileBody: ReplaceAttachmentFileBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      const formData = new FormData();
formData.append(`file`, replaceAttachmentFileBody.file)

      return customInstance<AttachmentResponse>(
      {url: `/api/v1/schools/${schoolId}/attachments/${attachmentId}/file`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getReplaceAttachmentFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceAttachmentFile>>, TError,{schoolId: string;attachmentId: string;data: ReplaceAttachmentFileBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceAttachmentFile>>, TError,{schoolId: string;attachmentId: string;data: ReplaceAttachmentFileBody}, TContext> => {

const mutationKey = ['replaceAttachmentFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceAttachmentFile>>, {schoolId: string;attachmentId: string;data: ReplaceAttachmentFileBody}> = (props) => {
          const {schoolId,attachmentId,data} = props ?? {};

          return  replaceAttachmentFile(schoolId,attachmentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReplaceAttachmentFileMutationResult = NonNullable<Awaited<ReturnType<typeof replaceAttachmentFile>>>
    export type ReplaceAttachmentFileMutationBody = ReplaceAttachmentFileBody
    export type ReplaceAttachmentFileMutationError = unknown

    export const useReplaceAttachmentFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceAttachmentFile>>, TError,{schoolId: string;attachmentId: string;data: ReplaceAttachmentFileBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceAttachmentFile>>,
        TError,
        {schoolId: string;attachmentId: string;data: ReplaceAttachmentFileBody},
        TContext
      > => {

      const mutationOptions = getReplaceAttachmentFileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getPublicTournamentLive = (
    schoolId: string,
    tournamentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TournamentBoardResponse>(
      {url: `/api/v1/public/schools/${schoolId}/tournaments/${tournamentId}/live`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPublicTournamentLiveQueryKey = (schoolId?: string,
    tournamentId?: string,) => {
    return [
    `/api/v1/public/schools/${schoolId}/tournaments/${tournamentId}/live`
    ] as const;
    }

    
export const getGetPublicTournamentLiveQueryOptions = <TData = Awaited<ReturnType<typeof getPublicTournamentLive>>, TError = void>(schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTournamentLive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicTournamentLiveQueryKey(schoolId,tournamentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicTournamentLive>>> = ({ signal }) => getPublicTournamentLive(schoolId,tournamentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && tournamentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicTournamentLive>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicTournamentLiveQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicTournamentLive>>>
export type GetPublicTournamentLiveQueryError = void


export function useGetPublicTournamentLive<TData = Awaited<ReturnType<typeof getPublicTournamentLive>>, TError = void>(
 schoolId: string,
    tournamentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTournamentLive>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicTournamentLive>>,
          TError,
          Awaited<ReturnType<typeof getPublicTournamentLive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicTournamentLive<TData = Awaited<ReturnType<typeof getPublicTournamentLive>>, TError = void>(
 schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTournamentLive>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicTournamentLive>>,
          TError,
          Awaited<ReturnType<typeof getPublicTournamentLive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicTournamentLive<TData = Awaited<ReturnType<typeof getPublicTournamentLive>>, TError = void>(
 schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTournamentLive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicTournamentLive<TData = Awaited<ReturnType<typeof getPublicTournamentLive>>, TError = void>(
 schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTournamentLive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicTournamentLiveQueryOptions(schoolId,tournamentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getPublicTournamentQr = (
    schoolId: string,
    tournamentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/public/schools/${schoolId}/tournaments/${tournamentId}/qr`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPublicTournamentQrQueryKey = (schoolId?: string,
    tournamentId?: string,) => {
    return [
    `/api/v1/public/schools/${schoolId}/tournaments/${tournamentId}/qr`
    ] as const;
    }

    
export const getGetPublicTournamentQrQueryOptions = <TData = Awaited<ReturnType<typeof getPublicTournamentQr>>, TError = unknown>(schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTournamentQr>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicTournamentQrQueryKey(schoolId,tournamentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicTournamentQr>>> = ({ signal }) => getPublicTournamentQr(schoolId,tournamentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && tournamentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicTournamentQr>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicTournamentQrQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicTournamentQr>>>
export type GetPublicTournamentQrQueryError = unknown


export function useGetPublicTournamentQr<TData = Awaited<ReturnType<typeof getPublicTournamentQr>>, TError = unknown>(
 schoolId: string,
    tournamentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTournamentQr>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicTournamentQr>>,
          TError,
          Awaited<ReturnType<typeof getPublicTournamentQr>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicTournamentQr<TData = Awaited<ReturnType<typeof getPublicTournamentQr>>, TError = unknown>(
 schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTournamentQr>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicTournamentQr>>,
          TError,
          Awaited<ReturnType<typeof getPublicTournamentQr>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicTournamentQr<TData = Awaited<ReturnType<typeof getPublicTournamentQr>>, TError = unknown>(
 schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTournamentQr>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicTournamentQr<TData = Awaited<ReturnType<typeof getPublicTournamentQr>>, TError = unknown>(
 schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTournamentQr>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicTournamentQrQueryOptions(schoolId,tournamentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getSchoolStatistics = (
    schoolId: string,
    params: GetSchoolStatisticsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SchoolStatisticsResponse>(
      {url: `/api/v1/schools/${schoolId}/statistics`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetSchoolStatisticsQueryKey = (schoolId?: string,
    params?: GetSchoolStatisticsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/statistics`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSchoolStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getSchoolStatistics>>, TError = unknown>(schoolId: string,
    params: GetSchoolStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSchoolStatisticsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchoolStatistics>>> = ({ signal }) => getSchoolStatistics(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchoolStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSchoolStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getSchoolStatistics>>>
export type GetSchoolStatisticsQueryError = unknown


export function useGetSchoolStatistics<TData = Awaited<ReturnType<typeof getSchoolStatistics>>, TError = unknown>(
 schoolId: string,
    params: GetSchoolStatisticsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchoolStatistics>>,
          TError,
          Awaited<ReturnType<typeof getSchoolStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchoolStatistics<TData = Awaited<ReturnType<typeof getSchoolStatistics>>, TError = unknown>(
 schoolId: string,
    params: GetSchoolStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchoolStatistics>>,
          TError,
          Awaited<ReturnType<typeof getSchoolStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchoolStatistics<TData = Awaited<ReturnType<typeof getSchoolStatistics>>, TError = unknown>(
 schoolId: string,
    params: GetSchoolStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSchoolStatistics<TData = Awaited<ReturnType<typeof getSchoolStatistics>>, TError = unknown>(
 schoolId: string,
    params: GetSchoolStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSchoolStatisticsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary List all schools with member statistics (master-admin only)
 */
export const adminListSchools = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/admin/schools`, method: 'GET', signal
    },
      options);
    }
  



export const getAdminListSchoolsQueryKey = () => {
    return [
    `/api/v1/admin/schools`
    ] as const;
    }

    
export const getAdminListSchoolsQueryOptions = <TData = Awaited<ReturnType<typeof adminListSchools>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListSchools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListSchoolsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListSchools>>> = ({ signal }) => adminListSchools(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListSchools>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListSchoolsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListSchools>>>
export type AdminListSchoolsQueryError = unknown


export function useAdminListSchools<TData = Awaited<ReturnType<typeof adminListSchools>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListSchools>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListSchools>>,
          TError,
          Awaited<ReturnType<typeof adminListSchools>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListSchools<TData = Awaited<ReturnType<typeof adminListSchools>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListSchools>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListSchools>>,
          TError,
          Awaited<ReturnType<typeof adminListSchools>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListSchools<TData = Awaited<ReturnType<typeof adminListSchools>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListSchools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all schools with member statistics (master-admin only)
 */

export function useAdminListSchools<TData = Awaited<ReturnType<typeof adminListSchools>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListSchools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListSchoolsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get a school with member statistics (master-admin only)
 */
export const adminGetSchool = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/admin/schools/${schoolId}`, method: 'GET', signal
    },
      options);
    }
  



export const getAdminGetSchoolQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/admin/schools/${schoolId}`
    ] as const;
    }

    
export const getAdminGetSchoolQueryOptions = <TData = Awaited<ReturnType<typeof adminGetSchool>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetSchool>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetSchoolQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetSchool>>> = ({ signal }) => adminGetSchool(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetSchool>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetSchoolQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetSchool>>>
export type AdminGetSchoolQueryError = unknown


export function useAdminGetSchool<TData = Awaited<ReturnType<typeof adminGetSchool>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetSchool>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetSchool>>,
          TError,
          Awaited<ReturnType<typeof adminGetSchool>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetSchool<TData = Awaited<ReturnType<typeof adminGetSchool>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetSchool>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetSchool>>,
          TError,
          Awaited<ReturnType<typeof adminGetSchool>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetSchool<TData = Awaited<ReturnType<typeof adminGetSchool>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetSchool>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a school with member statistics (master-admin only)
 */

export function useAdminGetSchool<TData = Awaited<ReturnType<typeof adminGetSchool>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetSchool>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetSchoolQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Provision a new school with admin user (master-admin only)
 */
export const adminProvisionSchool = (
    provisionSchoolRequest: ProvisionSchoolRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/admin/schools/provision`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: provisionSchoolRequest, signal
    },
      options);
    }
  


export const getAdminProvisionSchoolMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProvisionSchool>>, TError,{data: ProvisionSchoolRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminProvisionSchool>>, TError,{data: ProvisionSchoolRequest}, TContext> => {

const mutationKey = ['adminProvisionSchool'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminProvisionSchool>>, {data: ProvisionSchoolRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminProvisionSchool(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminProvisionSchoolMutationResult = NonNullable<Awaited<ReturnType<typeof adminProvisionSchool>>>
    export type AdminProvisionSchoolMutationBody = ProvisionSchoolRequest
    export type AdminProvisionSchoolMutationError = unknown

    /**
 * @summary Provision a new school with admin user (master-admin only)
 */
export const useAdminProvisionSchool = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProvisionSchool>>, TError,{data: ProvisionSchoolRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminProvisionSchool>>,
        TError,
        {data: ProvisionSchoolRequest},
        TContext
      > => {

      const mutationOptions = getAdminProvisionSchoolMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Activate or deactivate a school (master-admin only)
 */
export const adminSetSchoolActive = (
    schoolId: string,
    setSchoolActiveRequest: SetSchoolActiveRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/admin/schools/${schoolId}/active`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: setSchoolActiveRequest
    },
      options);
    }
  


export const getAdminSetSchoolActiveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetSchoolActive>>, TError,{schoolId: string;data: SetSchoolActiveRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSetSchoolActive>>, TError,{schoolId: string;data: SetSchoolActiveRequest}, TContext> => {

const mutationKey = ['adminSetSchoolActive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSetSchoolActive>>, {schoolId: string;data: SetSchoolActiveRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  adminSetSchoolActive(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminSetSchoolActiveMutationResult = NonNullable<Awaited<ReturnType<typeof adminSetSchoolActive>>>
    export type AdminSetSchoolActiveMutationBody = SetSchoolActiveRequest
    export type AdminSetSchoolActiveMutationError = unknown

    /**
 * @summary Activate or deactivate a school (master-admin only)
 */
export const useAdminSetSchoolActive = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetSchoolActive>>, TError,{schoolId: string;data: SetSchoolActiveRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminSetSchoolActive>>,
        TError,
        {schoolId: string;data: SetSchoolActiveRequest},
        TContext
      > => {

      const mutationOptions = getAdminSetSchoolActiveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update enabled features for a school (master-admin only)
 */
export const adminUpdateSchoolFeatures = (
    schoolId: string,
    updateSchoolFeaturesRequest: UpdateSchoolFeaturesRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/admin/schools/${schoolId}/features`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSchoolFeaturesRequest
    },
      options);
    }
  


export const getAdminUpdateSchoolFeaturesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateSchoolFeatures>>, TError,{schoolId: string;data: UpdateSchoolFeaturesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateSchoolFeatures>>, TError,{schoolId: string;data: UpdateSchoolFeaturesRequest}, TContext> => {

const mutationKey = ['adminUpdateSchoolFeatures'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateSchoolFeatures>>, {schoolId: string;data: UpdateSchoolFeaturesRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  adminUpdateSchoolFeatures(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateSchoolFeaturesMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateSchoolFeatures>>>
    export type AdminUpdateSchoolFeaturesMutationBody = UpdateSchoolFeaturesRequest
    export type AdminUpdateSchoolFeaturesMutationError = unknown

    /**
 * @summary Update enabled features for a school (master-admin only)
 */
export const useAdminUpdateSchoolFeatures = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateSchoolFeatures>>, TError,{schoolId: string;data: UpdateSchoolFeaturesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminUpdateSchoolFeatures>>,
        TError,
        {schoolId: string;data: UpdateSchoolFeaturesRequest},
        TContext
      > => {

      const mutationOptions = getAdminUpdateSchoolFeaturesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get platform-wide statistics (master-admin only)
 */
export const adminGetPlatformStats = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/admin/stats`, method: 'GET', signal
    },
      options);
    }
  



export const getAdminGetPlatformStatsQueryKey = () => {
    return [
    `/api/v1/admin/stats`
    ] as const;
    }

    
export const getAdminGetPlatformStatsQueryOptions = <TData = Awaited<ReturnType<typeof adminGetPlatformStats>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetPlatformStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetPlatformStatsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetPlatformStats>>> = ({ signal }) => adminGetPlatformStats(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetPlatformStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetPlatformStatsQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetPlatformStats>>>
export type AdminGetPlatformStatsQueryError = unknown


export function useAdminGetPlatformStats<TData = Awaited<ReturnType<typeof adminGetPlatformStats>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetPlatformStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetPlatformStats>>,
          TError,
          Awaited<ReturnType<typeof adminGetPlatformStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetPlatformStats<TData = Awaited<ReturnType<typeof adminGetPlatformStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetPlatformStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetPlatformStats>>,
          TError,
          Awaited<ReturnType<typeof adminGetPlatformStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetPlatformStats<TData = Awaited<ReturnType<typeof adminGetPlatformStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetPlatformStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get platform-wide statistics (master-admin only)
 */

export function useAdminGetPlatformStats<TData = Awaited<ReturnType<typeof adminGetPlatformStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetPlatformStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetPlatformStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const provisionSchool = (
    provisionSchoolRequest: ProvisionSchoolRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/provision`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: provisionSchoolRequest, signal
    },
      options);
    }
  


export const getProvisionSchoolMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof provisionSchool>>, TError,{data: ProvisionSchoolRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof provisionSchool>>, TError,{data: ProvisionSchoolRequest}, TContext> => {

const mutationKey = ['provisionSchool'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof provisionSchool>>, {data: ProvisionSchoolRequest}> = (props) => {
          const {data} = props ?? {};

          return  provisionSchool(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProvisionSchoolMutationResult = NonNullable<Awaited<ReturnType<typeof provisionSchool>>>
    export type ProvisionSchoolMutationBody = ProvisionSchoolRequest
    export type ProvisionSchoolMutationError = unknown

    export const useProvisionSchool = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof provisionSchool>>, TError,{data: ProvisionSchoolRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof provisionSchool>>,
        TError,
        {data: ProvisionSchoolRequest},
        TContext
      > => {

      const mutationOptions = getProvisionSchoolMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createSchool = (
    createSchoolRequest: CreateSchoolRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSchoolRequest, signal
    },
      options);
    }
  


export const getCreateSchoolMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchool>>, TError,{data: CreateSchoolRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSchool>>, TError,{data: CreateSchoolRequest}, TContext> => {

const mutationKey = ['createSchool'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSchool>>, {data: CreateSchoolRequest}> = (props) => {
          const {data} = props ?? {};

          return  createSchool(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSchoolMutationResult = NonNullable<Awaited<ReturnType<typeof createSchool>>>
    export type CreateSchoolMutationBody = CreateSchoolRequest
    export type CreateSchoolMutationError = unknown

    export const useCreateSchool = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchool>>, TError,{data: CreateSchoolRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSchool>>,
        TError,
        {data: CreateSchoolRequest},
        TContext
      > => {

      const mutationOptions = getCreateSchoolMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getSchoolCreationAllowed = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SchoolCreationAllowedResponse>(
      {url: `/api/v1/schools/creation-allowed`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSchoolCreationAllowedQueryKey = () => {
    return [
    `/api/v1/schools/creation-allowed`
    ] as const;
    }

    
export const getGetSchoolCreationAllowedQueryOptions = <TData = Awaited<ReturnType<typeof getSchoolCreationAllowed>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolCreationAllowed>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSchoolCreationAllowedQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchoolCreationAllowed>>> = ({ signal }) => getSchoolCreationAllowed(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchoolCreationAllowed>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSchoolCreationAllowedQueryResult = NonNullable<Awaited<ReturnType<typeof getSchoolCreationAllowed>>>
export type GetSchoolCreationAllowedQueryError = unknown


export function useGetSchoolCreationAllowed<TData = Awaited<ReturnType<typeof getSchoolCreationAllowed>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolCreationAllowed>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchoolCreationAllowed>>,
          TError,
          Awaited<ReturnType<typeof getSchoolCreationAllowed>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchoolCreationAllowed<TData = Awaited<ReturnType<typeof getSchoolCreationAllowed>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolCreationAllowed>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchoolCreationAllowed>>,
          TError,
          Awaited<ReturnType<typeof getSchoolCreationAllowed>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchoolCreationAllowed<TData = Awaited<ReturnType<typeof getSchoolCreationAllowed>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolCreationAllowed>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSchoolCreationAllowed<TData = Awaited<ReturnType<typeof getSchoolCreationAllowed>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolCreationAllowed>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSchoolCreationAllowedQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listMySchools = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SchoolResponse[]>(
      {url: `/api/v1/schools/me`, method: 'GET', signal
    },
      options);
    }
  



export const getListMySchoolsQueryKey = () => {
    return [
    `/api/v1/schools/me`
    ] as const;
    }

    
export const getListMySchoolsQueryOptions = <TData = Awaited<ReturnType<typeof listMySchools>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMySchools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMySchoolsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMySchools>>> = ({ signal }) => listMySchools(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMySchools>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMySchoolsQueryResult = NonNullable<Awaited<ReturnType<typeof listMySchools>>>
export type ListMySchoolsQueryError = unknown


export function useListMySchools<TData = Awaited<ReturnType<typeof listMySchools>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMySchools>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMySchools>>,
          TError,
          Awaited<ReturnType<typeof listMySchools>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMySchools<TData = Awaited<ReturnType<typeof listMySchools>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMySchools>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMySchools>>,
          TError,
          Awaited<ReturnType<typeof listMySchools>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMySchools<TData = Awaited<ReturnType<typeof listMySchools>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMySchools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListMySchools<TData = Awaited<ReturnType<typeof listMySchools>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMySchools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMySchoolsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getSchool = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSchoolQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}`
    ] as const;
    }

    
export const getGetSchoolQueryOptions = <TData = Awaited<ReturnType<typeof getSchool>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchool>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSchoolQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchool>>> = ({ signal }) => getSchool(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchool>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSchoolQueryResult = NonNullable<Awaited<ReturnType<typeof getSchool>>>
export type GetSchoolQueryError = unknown


export function useGetSchool<TData = Awaited<ReturnType<typeof getSchool>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchool>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchool>>,
          TError,
          Awaited<ReturnType<typeof getSchool>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchool<TData = Awaited<ReturnType<typeof getSchool>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchool>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchool>>,
          TError,
          Awaited<ReturnType<typeof getSchool>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchool<TData = Awaited<ReturnType<typeof getSchool>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchool>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSchool<TData = Awaited<ReturnType<typeof getSchool>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchool>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSchoolQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateSchool = (
    schoolId: string,
    updateSchoolRequest: UpdateSchoolRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSchoolRequest
    },
      options);
    }
  


export const getUpdateSchoolMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchool>>, TError,{schoolId: string;data: UpdateSchoolRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSchool>>, TError,{schoolId: string;data: UpdateSchoolRequest}, TContext> => {

const mutationKey = ['updateSchool'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSchool>>, {schoolId: string;data: UpdateSchoolRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  updateSchool(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSchoolMutationResult = NonNullable<Awaited<ReturnType<typeof updateSchool>>>
    export type UpdateSchoolMutationBody = UpdateSchoolRequest
    export type UpdateSchoolMutationError = unknown

    export const useUpdateSchool = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchool>>, TError,{schoolId: string;data: UpdateSchoolRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSchool>>,
        TError,
        {schoolId: string;data: UpdateSchoolRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSchoolMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getEnabledFeatures = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/features`, method: 'GET', signal
    },
      options);
    }
  



export const getGetEnabledFeaturesQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/features`
    ] as const;
    }

    
export const getGetEnabledFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof getEnabledFeatures>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnabledFeatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnabledFeaturesQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnabledFeatures>>> = ({ signal }) => getEnabledFeatures(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEnabledFeatures>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEnabledFeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof getEnabledFeatures>>>
export type GetEnabledFeaturesQueryError = unknown


export function useGetEnabledFeatures<TData = Awaited<ReturnType<typeof getEnabledFeatures>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnabledFeatures>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnabledFeatures>>,
          TError,
          Awaited<ReturnType<typeof getEnabledFeatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnabledFeatures<TData = Awaited<ReturnType<typeof getEnabledFeatures>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnabledFeatures>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnabledFeatures>>,
          TError,
          Awaited<ReturnType<typeof getEnabledFeatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnabledFeatures<TData = Awaited<ReturnType<typeof getEnabledFeatures>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnabledFeatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEnabledFeatures<TData = Awaited<ReturnType<typeof getEnabledFeatures>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnabledFeatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEnabledFeaturesQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const sendSupportTicket = (
    schoolId: string,
    sendSupportTicketRequest: SendSupportTicketRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/support/contact`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendSupportTicketRequest, signal
    },
      options);
    }
  


export const getSendSupportTicketMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSupportTicket>>, TError,{schoolId: string;data: SendSupportTicketRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendSupportTicket>>, TError,{schoolId: string;data: SendSupportTicketRequest}, TContext> => {

const mutationKey = ['sendSupportTicket'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendSupportTicket>>, {schoolId: string;data: SendSupportTicketRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  sendSupportTicket(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendSupportTicketMutationResult = NonNullable<Awaited<ReturnType<typeof sendSupportTicket>>>
    export type SendSupportTicketMutationBody = SendSupportTicketRequest
    export type SendSupportTicketMutationError = unknown

    export const useSendSupportTicket = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSupportTicket>>, TError,{schoolId: string;data: SendSupportTicketRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendSupportTicket>>,
        TError,
        {schoolId: string;data: SendSupportTicketRequest},
        TContext
      > => {

      const mutationOptions = getSendSupportTicketMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getSchoolBranding = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/branding`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSchoolBrandingQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/branding`
    ] as const;
    }

    
export const getGetSchoolBrandingQueryOptions = <TData = Awaited<ReturnType<typeof getSchoolBranding>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolBranding>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSchoolBrandingQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchoolBranding>>> = ({ signal }) => getSchoolBranding(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchoolBranding>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSchoolBrandingQueryResult = NonNullable<Awaited<ReturnType<typeof getSchoolBranding>>>
export type GetSchoolBrandingQueryError = unknown


export function useGetSchoolBranding<TData = Awaited<ReturnType<typeof getSchoolBranding>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolBranding>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchoolBranding>>,
          TError,
          Awaited<ReturnType<typeof getSchoolBranding>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchoolBranding<TData = Awaited<ReturnType<typeof getSchoolBranding>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolBranding>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchoolBranding>>,
          TError,
          Awaited<ReturnType<typeof getSchoolBranding>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchoolBranding<TData = Awaited<ReturnType<typeof getSchoolBranding>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolBranding>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSchoolBranding<TData = Awaited<ReturnType<typeof getSchoolBranding>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolBranding>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSchoolBrandingQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateSchoolBranding = (
    schoolId: string,
    updateSchoolBrandingRequest: UpdateSchoolBrandingRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/branding`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSchoolBrandingRequest
    },
      options);
    }
  


export const getUpdateSchoolBrandingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolBranding>>, TError,{schoolId: string;data: UpdateSchoolBrandingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSchoolBranding>>, TError,{schoolId: string;data: UpdateSchoolBrandingRequest}, TContext> => {

const mutationKey = ['updateSchoolBranding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSchoolBranding>>, {schoolId: string;data: UpdateSchoolBrandingRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  updateSchoolBranding(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSchoolBrandingMutationResult = NonNullable<Awaited<ReturnType<typeof updateSchoolBranding>>>
    export type UpdateSchoolBrandingMutationBody = UpdateSchoolBrandingRequest
    export type UpdateSchoolBrandingMutationError = unknown

    export const useUpdateSchoolBranding = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolBranding>>, TError,{schoolId: string;data: UpdateSchoolBrandingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSchoolBranding>>,
        TError,
        {schoolId: string;data: UpdateSchoolBrandingRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSchoolBrandingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const generateLogoUploadUrl = (
    schoolId: string,
    params: GenerateLogoUploadUrlParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/branding/logo-upload-url`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getGenerateLogoUploadUrlMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateLogoUploadUrl>>, TError,{schoolId: string;params: GenerateLogoUploadUrlParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generateLogoUploadUrl>>, TError,{schoolId: string;params: GenerateLogoUploadUrlParams}, TContext> => {

const mutationKey = ['generateLogoUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateLogoUploadUrl>>, {schoolId: string;params: GenerateLogoUploadUrlParams}> = (props) => {
          const {schoolId,params} = props ?? {};

          return  generateLogoUploadUrl(schoolId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateLogoUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof generateLogoUploadUrl>>>
    
    export type GenerateLogoUploadUrlMutationError = unknown

    export const useGenerateLogoUploadUrl = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateLogoUploadUrl>>, TError,{schoolId: string;params: GenerateLogoUploadUrlParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateLogoUploadUrl>>,
        TError,
        {schoolId: string;params: GenerateLogoUploadUrlParams},
        TContext
      > => {

      const mutationOptions = getGenerateLogoUploadUrlMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getSchoolPaymentDetails = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SchoolPaymentDetailsResponse>(
      {url: `/api/v1/schools/${schoolId}/payment-details`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSchoolPaymentDetailsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/payment-details`
    ] as const;
    }

    
export const getGetSchoolPaymentDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getSchoolPaymentDetails>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolPaymentDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSchoolPaymentDetailsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchoolPaymentDetails>>> = ({ signal }) => getSchoolPaymentDetails(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchoolPaymentDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSchoolPaymentDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getSchoolPaymentDetails>>>
export type GetSchoolPaymentDetailsQueryError = unknown


export function useGetSchoolPaymentDetails<TData = Awaited<ReturnType<typeof getSchoolPaymentDetails>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolPaymentDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchoolPaymentDetails>>,
          TError,
          Awaited<ReturnType<typeof getSchoolPaymentDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchoolPaymentDetails<TData = Awaited<ReturnType<typeof getSchoolPaymentDetails>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolPaymentDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchoolPaymentDetails>>,
          TError,
          Awaited<ReturnType<typeof getSchoolPaymentDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchoolPaymentDetails<TData = Awaited<ReturnType<typeof getSchoolPaymentDetails>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolPaymentDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSchoolPaymentDetails<TData = Awaited<ReturnType<typeof getSchoolPaymentDetails>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolPaymentDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSchoolPaymentDetailsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const upsertSchoolPaymentDetails = (
    schoolId: string,
    updateSchoolPaymentDetailsRequest: UpdateSchoolPaymentDetailsRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SchoolPaymentDetailsResponse>(
      {url: `/api/v1/schools/${schoolId}/payment-details`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSchoolPaymentDetailsRequest
    },
      options);
    }
  


export const getUpsertSchoolPaymentDetailsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertSchoolPaymentDetails>>, TError,{schoolId: string;data: UpdateSchoolPaymentDetailsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertSchoolPaymentDetails>>, TError,{schoolId: string;data: UpdateSchoolPaymentDetailsRequest}, TContext> => {

const mutationKey = ['upsertSchoolPaymentDetails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertSchoolPaymentDetails>>, {schoolId: string;data: UpdateSchoolPaymentDetailsRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  upsertSchoolPaymentDetails(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertSchoolPaymentDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof upsertSchoolPaymentDetails>>>
    export type UpsertSchoolPaymentDetailsMutationBody = UpdateSchoolPaymentDetailsRequest
    export type UpsertSchoolPaymentDetailsMutationError = unknown

    export const useUpsertSchoolPaymentDetails = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertSchoolPaymentDetails>>, TError,{schoolId: string;data: UpdateSchoolPaymentDetailsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertSchoolPaymentDetails>>,
        TError,
        {schoolId: string;data: UpdateSchoolPaymentDetailsRequest},
        TContext
      > => {

      const mutationOptions = getUpsertSchoolPaymentDetailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listSchoolDomains = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SchoolDomainResponse[]>(
      {url: `/api/v1/schools/${schoolId}/domains`, method: 'GET', signal
    },
      options);
    }
  



export const getListSchoolDomainsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/domains`
    ] as const;
    }

    
export const getListSchoolDomainsQueryOptions = <TData = Awaited<ReturnType<typeof listSchoolDomains>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSchoolDomainsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchoolDomains>>> = ({ signal }) => listSchoolDomains(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSchoolDomains>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSchoolDomainsQueryResult = NonNullable<Awaited<ReturnType<typeof listSchoolDomains>>>
export type ListSchoolDomainsQueryError = unknown


export function useListSchoolDomains<TData = Awaited<ReturnType<typeof listSchoolDomains>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolDomains>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSchoolDomains>>,
          TError,
          Awaited<ReturnType<typeof listSchoolDomains>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSchoolDomains<TData = Awaited<ReturnType<typeof listSchoolDomains>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolDomains>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSchoolDomains>>,
          TError,
          Awaited<ReturnType<typeof listSchoolDomains>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSchoolDomains<TData = Awaited<ReturnType<typeof listSchoolDomains>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSchoolDomains<TData = Awaited<ReturnType<typeof listSchoolDomains>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSchoolDomainsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const registerSchoolDomain = (
    schoolId: string,
    registerDomainRequest: RegisterDomainRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SchoolDomainResponse>(
      {url: `/api/v1/schools/${schoolId}/domains`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerDomainRequest, signal
    },
      options);
    }
  


export const getRegisterSchoolDomainMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerSchoolDomain>>, TError,{schoolId: string;data: RegisterDomainRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof registerSchoolDomain>>, TError,{schoolId: string;data: RegisterDomainRequest}, TContext> => {

const mutationKey = ['registerSchoolDomain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerSchoolDomain>>, {schoolId: string;data: RegisterDomainRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  registerSchoolDomain(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegisterSchoolDomainMutationResult = NonNullable<Awaited<ReturnType<typeof registerSchoolDomain>>>
    export type RegisterSchoolDomainMutationBody = RegisterDomainRequest
    export type RegisterSchoolDomainMutationError = unknown

    export const useRegisterSchoolDomain = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerSchoolDomain>>, TError,{schoolId: string;data: RegisterDomainRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registerSchoolDomain>>,
        TError,
        {schoolId: string;data: RegisterDomainRequest},
        TContext
      > => {

      const mutationOptions = getRegisterSchoolDomainMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const verifySchoolDomain = (
    schoolId: string,
    domainId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SchoolDomainResponse>(
      {url: `/api/v1/schools/${schoolId}/domains/${domainId}/verify`, method: 'POST', signal
    },
      options);
    }
  


export const getVerifySchoolDomainMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifySchoolDomain>>, TError,{schoolId: string;domainId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifySchoolDomain>>, TError,{schoolId: string;domainId: string}, TContext> => {

const mutationKey = ['verifySchoolDomain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifySchoolDomain>>, {schoolId: string;domainId: string}> = (props) => {
          const {schoolId,domainId} = props ?? {};

          return  verifySchoolDomain(schoolId,domainId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifySchoolDomainMutationResult = NonNullable<Awaited<ReturnType<typeof verifySchoolDomain>>>
    
    export type VerifySchoolDomainMutationError = unknown

    export const useVerifySchoolDomain = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifySchoolDomain>>, TError,{schoolId: string;domainId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifySchoolDomain>>,
        TError,
        {schoolId: string;domainId: string},
        TContext
      > => {

      const mutationOptions = getVerifySchoolDomainMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteSchoolDomain = (
    schoolId: string,
    domainId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/domains/${domainId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteSchoolDomainMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolDomain>>, TError,{schoolId: string;domainId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolDomain>>, TError,{schoolId: string;domainId: string}, TContext> => {

const mutationKey = ['deleteSchoolDomain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSchoolDomain>>, {schoolId: string;domainId: string}> = (props) => {
          const {schoolId,domainId} = props ?? {};

          return  deleteSchoolDomain(schoolId,domainId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSchoolDomainMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSchoolDomain>>>
    
    export type DeleteSchoolDomainMutationError = unknown

    export const useDeleteSchoolDomain = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolDomain>>, TError,{schoolId: string;domainId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSchoolDomain>>,
        TError,
        {schoolId: string;domainId: string},
        TContext
      > => {

      const mutationOptions = getDeleteSchoolDomainMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listSkillLevels = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/skill-levels`, method: 'GET', signal
    },
      options);
    }
  



export const getListSkillLevelsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/skill-levels`
    ] as const;
    }

    
export const getListSkillLevelsQueryOptions = <TData = Awaited<ReturnType<typeof listSkillLevels>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillLevels>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSkillLevelsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSkillLevels>>> = ({ signal }) => listSkillLevels(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSkillLevels>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSkillLevelsQueryResult = NonNullable<Awaited<ReturnType<typeof listSkillLevels>>>
export type ListSkillLevelsQueryError = unknown


export function useListSkillLevels<TData = Awaited<ReturnType<typeof listSkillLevels>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillLevels>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSkillLevels>>,
          TError,
          Awaited<ReturnType<typeof listSkillLevels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSkillLevels<TData = Awaited<ReturnType<typeof listSkillLevels>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillLevels>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSkillLevels>>,
          TError,
          Awaited<ReturnType<typeof listSkillLevels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSkillLevels<TData = Awaited<ReturnType<typeof listSkillLevels>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillLevels>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSkillLevels<TData = Awaited<ReturnType<typeof listSkillLevels>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillLevels>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSkillLevelsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createSkillLevel = (
    schoolId: string,
    createSkillLevelRequest: CreateSkillLevelRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/skill-levels`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSkillLevelRequest, signal
    },
      options);
    }
  


export const getCreateSkillLevelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSkillLevel>>, TError,{schoolId: string;data: CreateSkillLevelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSkillLevel>>, TError,{schoolId: string;data: CreateSkillLevelRequest}, TContext> => {

const mutationKey = ['createSkillLevel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSkillLevel>>, {schoolId: string;data: CreateSkillLevelRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createSkillLevel(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSkillLevelMutationResult = NonNullable<Awaited<ReturnType<typeof createSkillLevel>>>
    export type CreateSkillLevelMutationBody = CreateSkillLevelRequest
    export type CreateSkillLevelMutationError = unknown

    export const useCreateSkillLevel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSkillLevel>>, TError,{schoolId: string;data: CreateSkillLevelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSkillLevel>>,
        TError,
        {schoolId: string;data: CreateSkillLevelRequest},
        TContext
      > => {

      const mutationOptions = getCreateSkillLevelMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const reorderSkillLevels = (
    schoolId: string,
    reorderSkillLevelsRequest: ReorderSkillLevelsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/skill-levels/reorder`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reorderSkillLevelsRequest, signal
    },
      options);
    }
  


export const getReorderSkillLevelsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderSkillLevels>>, TError,{schoolId: string;data: ReorderSkillLevelsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderSkillLevels>>, TError,{schoolId: string;data: ReorderSkillLevelsRequest}, TContext> => {

const mutationKey = ['reorderSkillLevels'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderSkillLevels>>, {schoolId: string;data: ReorderSkillLevelsRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  reorderSkillLevels(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReorderSkillLevelsMutationResult = NonNullable<Awaited<ReturnType<typeof reorderSkillLevels>>>
    export type ReorderSkillLevelsMutationBody = ReorderSkillLevelsRequest
    export type ReorderSkillLevelsMutationError = unknown

    export const useReorderSkillLevels = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderSkillLevels>>, TError,{schoolId: string;data: ReorderSkillLevelsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reorderSkillLevels>>,
        TError,
        {schoolId: string;data: ReorderSkillLevelsRequest},
        TContext
      > => {

      const mutationOptions = getReorderSkillLevelsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateSkillLevel = (
    schoolId: string,
    id: string,
    updateSkillLevelRequest: UpdateSkillLevelRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/skill-levels/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSkillLevelRequest
    },
      options);
    }
  


export const getUpdateSkillLevelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSkillLevel>>, TError,{schoolId: string;id: string;data: UpdateSkillLevelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSkillLevel>>, TError,{schoolId: string;id: string;data: UpdateSkillLevelRequest}, TContext> => {

const mutationKey = ['updateSkillLevel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSkillLevel>>, {schoolId: string;id: string;data: UpdateSkillLevelRequest}> = (props) => {
          const {schoolId,id,data} = props ?? {};

          return  updateSkillLevel(schoolId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSkillLevelMutationResult = NonNullable<Awaited<ReturnType<typeof updateSkillLevel>>>
    export type UpdateSkillLevelMutationBody = UpdateSkillLevelRequest
    export type UpdateSkillLevelMutationError = unknown

    export const useUpdateSkillLevel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSkillLevel>>, TError,{schoolId: string;id: string;data: UpdateSkillLevelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSkillLevel>>,
        TError,
        {schoolId: string;id: string;data: UpdateSkillLevelRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSkillLevelMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteSkillLevel = (
    schoolId: string,
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/skill-levels/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteSkillLevelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSkillLevel>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSkillLevel>>, TError,{schoolId: string;id: string}, TContext> => {

const mutationKey = ['deleteSkillLevel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSkillLevel>>, {schoolId: string;id: string}> = (props) => {
          const {schoolId,id} = props ?? {};

          return  deleteSkillLevel(schoolId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSkillLevelMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSkillLevel>>>
    
    export type DeleteSkillLevelMutationError = unknown

    export const useDeleteSkillLevel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSkillLevel>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSkillLevel>>,
        TError,
        {schoolId: string;id: string},
        TContext
      > => {

      const mutationOptions = getDeleteSkillLevelMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listSchoolMembers = (
    schoolId: string,
    params?: ListSchoolMembersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MembersListResponse>(
      {url: `/api/v1/schools/${schoolId}/members`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListSchoolMembersQueryKey = (schoolId?: string,
    params?: ListSchoolMembersParams,) => {
    return [
    `/api/v1/schools/${schoolId}/members`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListSchoolMembersQueryOptions = <TData = Awaited<ReturnType<typeof listSchoolMembers>>, TError = unknown>(schoolId: string,
    params?: ListSchoolMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSchoolMembersQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchoolMembers>>> = ({ signal }) => listSchoolMembers(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSchoolMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSchoolMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listSchoolMembers>>>
export type ListSchoolMembersQueryError = unknown


export function useListSchoolMembers<TData = Awaited<ReturnType<typeof listSchoolMembers>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListSchoolMembersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSchoolMembers>>,
          TError,
          Awaited<ReturnType<typeof listSchoolMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSchoolMembers<TData = Awaited<ReturnType<typeof listSchoolMembers>>, TError = unknown>(
 schoolId: string,
    params?: ListSchoolMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSchoolMembers>>,
          TError,
          Awaited<ReturnType<typeof listSchoolMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSchoolMembers<TData = Awaited<ReturnType<typeof listSchoolMembers>>, TError = unknown>(
 schoolId: string,
    params?: ListSchoolMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSchoolMembers<TData = Awaited<ReturnType<typeof listSchoolMembers>>, TError = unknown>(
 schoolId: string,
    params?: ListSchoolMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSchoolMembersQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const exportSchoolMembersExcel = (
    schoolId: string,
    params?: ExportSchoolMembersExcelParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/members/export-excel`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getExportSchoolMembersExcelQueryKey = (schoolId?: string,
    params?: ExportSchoolMembersExcelParams,) => {
    return [
    `/api/v1/schools/${schoolId}/members/export-excel`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getExportSchoolMembersExcelQueryOptions = <TData = Awaited<ReturnType<typeof exportSchoolMembersExcel>>, TError = unknown>(schoolId: string,
    params?: ExportSchoolMembersExcelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSchoolMembersExcel>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportSchoolMembersExcelQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportSchoolMembersExcel>>> = ({ signal }) => exportSchoolMembersExcel(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportSchoolMembersExcel>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportSchoolMembersExcelQueryResult = NonNullable<Awaited<ReturnType<typeof exportSchoolMembersExcel>>>
export type ExportSchoolMembersExcelQueryError = unknown


export function useExportSchoolMembersExcel<TData = Awaited<ReturnType<typeof exportSchoolMembersExcel>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ExportSchoolMembersExcelParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSchoolMembersExcel>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportSchoolMembersExcel>>,
          TError,
          Awaited<ReturnType<typeof exportSchoolMembersExcel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportSchoolMembersExcel<TData = Awaited<ReturnType<typeof exportSchoolMembersExcel>>, TError = unknown>(
 schoolId: string,
    params?: ExportSchoolMembersExcelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSchoolMembersExcel>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportSchoolMembersExcel>>,
          TError,
          Awaited<ReturnType<typeof exportSchoolMembersExcel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportSchoolMembersExcel<TData = Awaited<ReturnType<typeof exportSchoolMembersExcel>>, TError = unknown>(
 schoolId: string,
    params?: ExportSchoolMembersExcelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSchoolMembersExcel>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExportSchoolMembersExcel<TData = Awaited<ReturnType<typeof exportSchoolMembersExcel>>, TError = unknown>(
 schoolId: string,
    params?: ExportSchoolMembersExcelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSchoolMembersExcel>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportSchoolMembersExcelQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const exportSchoolMembersCsv = (
    schoolId: string,
    params?: ExportSchoolMembersCsvParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/members/export-csv`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getExportSchoolMembersCsvQueryKey = (schoolId?: string,
    params?: ExportSchoolMembersCsvParams,) => {
    return [
    `/api/v1/schools/${schoolId}/members/export-csv`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getExportSchoolMembersCsvQueryOptions = <TData = Awaited<ReturnType<typeof exportSchoolMembersCsv>>, TError = unknown>(schoolId: string,
    params?: ExportSchoolMembersCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSchoolMembersCsv>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportSchoolMembersCsvQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportSchoolMembersCsv>>> = ({ signal }) => exportSchoolMembersCsv(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportSchoolMembersCsv>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportSchoolMembersCsvQueryResult = NonNullable<Awaited<ReturnType<typeof exportSchoolMembersCsv>>>
export type ExportSchoolMembersCsvQueryError = unknown


export function useExportSchoolMembersCsv<TData = Awaited<ReturnType<typeof exportSchoolMembersCsv>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ExportSchoolMembersCsvParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSchoolMembersCsv>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportSchoolMembersCsv>>,
          TError,
          Awaited<ReturnType<typeof exportSchoolMembersCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportSchoolMembersCsv<TData = Awaited<ReturnType<typeof exportSchoolMembersCsv>>, TError = unknown>(
 schoolId: string,
    params?: ExportSchoolMembersCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSchoolMembersCsv>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportSchoolMembersCsv>>,
          TError,
          Awaited<ReturnType<typeof exportSchoolMembersCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportSchoolMembersCsv<TData = Awaited<ReturnType<typeof exportSchoolMembersCsv>>, TError = unknown>(
 schoolId: string,
    params?: ExportSchoolMembersCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSchoolMembersCsv>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExportSchoolMembersCsv<TData = Awaited<ReturnType<typeof exportSchoolMembersCsv>>, TError = unknown>(
 schoolId: string,
    params?: ExportSchoolMembersCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSchoolMembersCsv>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportSchoolMembersCsvQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listSchoolMembersLite = (
    schoolId: string,
    params?: ListSchoolMembersLiteParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MemberLiteResponse[]>(
      {url: `/api/v1/schools/${schoolId}/members/lite`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListSchoolMembersLiteQueryKey = (schoolId?: string,
    params?: ListSchoolMembersLiteParams,) => {
    return [
    `/api/v1/schools/${schoolId}/members/lite`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListSchoolMembersLiteQueryOptions = <TData = Awaited<ReturnType<typeof listSchoolMembersLite>>, TError = unknown>(schoolId: string,
    params?: ListSchoolMembersLiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolMembersLite>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSchoolMembersLiteQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchoolMembersLite>>> = ({ signal }) => listSchoolMembersLite(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSchoolMembersLite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSchoolMembersLiteQueryResult = NonNullable<Awaited<ReturnType<typeof listSchoolMembersLite>>>
export type ListSchoolMembersLiteQueryError = unknown


export function useListSchoolMembersLite<TData = Awaited<ReturnType<typeof listSchoolMembersLite>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListSchoolMembersLiteParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolMembersLite>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSchoolMembersLite>>,
          TError,
          Awaited<ReturnType<typeof listSchoolMembersLite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSchoolMembersLite<TData = Awaited<ReturnType<typeof listSchoolMembersLite>>, TError = unknown>(
 schoolId: string,
    params?: ListSchoolMembersLiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolMembersLite>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSchoolMembersLite>>,
          TError,
          Awaited<ReturnType<typeof listSchoolMembersLite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSchoolMembersLite<TData = Awaited<ReturnType<typeof listSchoolMembersLite>>, TError = unknown>(
 schoolId: string,
    params?: ListSchoolMembersLiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolMembersLite>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSchoolMembersLite<TData = Awaited<ReturnType<typeof listSchoolMembersLite>>, TError = unknown>(
 schoolId: string,
    params?: ListSchoolMembersLiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolMembersLite>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSchoolMembersLiteQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listCoachesPublic = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoachPublicResponse[]>(
      {url: `/api/v1/schools/${schoolId}/coaches/public`, method: 'GET', signal
    },
      options);
    }
  



export const getListCoachesPublicQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/coaches/public`
    ] as const;
    }

    
export const getListCoachesPublicQueryOptions = <TData = Awaited<ReturnType<typeof listCoachesPublic>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoachesPublic>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCoachesPublicQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCoachesPublic>>> = ({ signal }) => listCoachesPublic(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCoachesPublic>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCoachesPublicQueryResult = NonNullable<Awaited<ReturnType<typeof listCoachesPublic>>>
export type ListCoachesPublicQueryError = unknown


export function useListCoachesPublic<TData = Awaited<ReturnType<typeof listCoachesPublic>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoachesPublic>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCoachesPublic>>,
          TError,
          Awaited<ReturnType<typeof listCoachesPublic>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCoachesPublic<TData = Awaited<ReturnType<typeof listCoachesPublic>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoachesPublic>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCoachesPublic>>,
          TError,
          Awaited<ReturnType<typeof listCoachesPublic>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCoachesPublic<TData = Awaited<ReturnType<typeof listCoachesPublic>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoachesPublic>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCoachesPublic<TData = Awaited<ReturnType<typeof listCoachesPublic>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoachesPublic>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCoachesPublicQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const inviteSchoolMemberByEmail = (
    schoolId: string,
    inviteUserByEmailRequest: InviteUserByEmailRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/members/invite-by-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteUserByEmailRequest, signal
    },
      options);
    }
  


export const getInviteSchoolMemberByEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteSchoolMemberByEmail>>, TError,{schoolId: string;data: InviteUserByEmailRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteSchoolMemberByEmail>>, TError,{schoolId: string;data: InviteUserByEmailRequest}, TContext> => {

const mutationKey = ['inviteSchoolMemberByEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteSchoolMemberByEmail>>, {schoolId: string;data: InviteUserByEmailRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  inviteSchoolMemberByEmail(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InviteSchoolMemberByEmailMutationResult = NonNullable<Awaited<ReturnType<typeof inviteSchoolMemberByEmail>>>
    export type InviteSchoolMemberByEmailMutationBody = InviteUserByEmailRequest
    export type InviteSchoolMemberByEmailMutationError = unknown

    export const useInviteSchoolMemberByEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteSchoolMemberByEmail>>, TError,{schoolId: string;data: InviteUserByEmailRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteSchoolMemberByEmail>>,
        TError,
        {schoolId: string;data: InviteUserByEmailRequest},
        TContext
      > => {

      const mutationOptions = getInviteSchoolMemberByEmailMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const inviteExistingSchoolMember = (
    schoolId: string,
    memberId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/members/${memberId}/invite`, method: 'POST', signal
    },
      options);
    }
  


export const getInviteExistingSchoolMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteExistingSchoolMember>>, TError,{schoolId: string;memberId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteExistingSchoolMember>>, TError,{schoolId: string;memberId: string}, TContext> => {

const mutationKey = ['inviteExistingSchoolMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteExistingSchoolMember>>, {schoolId: string;memberId: string}> = (props) => {
          const {schoolId,memberId} = props ?? {};

          return  inviteExistingSchoolMember(schoolId,memberId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InviteExistingSchoolMemberMutationResult = NonNullable<Awaited<ReturnType<typeof inviteExistingSchoolMember>>>
    
    export type InviteExistingSchoolMemberMutationError = unknown

    export const useInviteExistingSchoolMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteExistingSchoolMember>>, TError,{schoolId: string;memberId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteExistingSchoolMember>>,
        TError,
        {schoolId: string;memberId: string},
        TContext
      > => {

      const mutationOptions = getInviteExistingSchoolMemberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateSchoolMember = (
    schoolId: string,
    memberId: string,
    updateMemberRequest: UpdateMemberRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/members/${memberId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMemberRequest
    },
      options);
    }
  


export const getUpdateSchoolMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolMember>>, TError,{schoolId: string;memberId: string;data: UpdateMemberRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSchoolMember>>, TError,{schoolId: string;memberId: string;data: UpdateMemberRequest}, TContext> => {

const mutationKey = ['updateSchoolMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSchoolMember>>, {schoolId: string;memberId: string;data: UpdateMemberRequest}> = (props) => {
          const {schoolId,memberId,data} = props ?? {};

          return  updateSchoolMember(schoolId,memberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSchoolMemberMutationResult = NonNullable<Awaited<ReturnType<typeof updateSchoolMember>>>
    export type UpdateSchoolMemberMutationBody = UpdateMemberRequest
    export type UpdateSchoolMemberMutationError = unknown

    export const useUpdateSchoolMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolMember>>, TError,{schoolId: string;memberId: string;data: UpdateMemberRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSchoolMember>>,
        TError,
        {schoolId: string;memberId: string;data: UpdateMemberRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSchoolMemberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const removeSchoolMember = (
    schoolId: string,
    memberId: string,
    params?: RemoveSchoolMemberParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/members/${memberId}`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getRemoveSchoolMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeSchoolMember>>, TError,{schoolId: string;memberId: string;params?: RemoveSchoolMemberParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeSchoolMember>>, TError,{schoolId: string;memberId: string;params?: RemoveSchoolMemberParams}, TContext> => {

const mutationKey = ['removeSchoolMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeSchoolMember>>, {schoolId: string;memberId: string;params?: RemoveSchoolMemberParams}> = (props) => {
          const {schoolId,memberId,params} = props ?? {};

          return  removeSchoolMember(schoolId,memberId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveSchoolMemberMutationResult = NonNullable<Awaited<ReturnType<typeof removeSchoolMember>>>
    
    export type RemoveSchoolMemberMutationError = unknown

    export const useRemoveSchoolMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeSchoolMember>>, TError,{schoolId: string;memberId: string;params?: RemoveSchoolMemberParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeSchoolMember>>,
        TError,
        {schoolId: string;memberId: string;params?: RemoveSchoolMemberParams},
        TContext
      > => {

      const mutationOptions = getRemoveSchoolMemberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateMemberSkillLevel = (
    schoolId: string,
    memberId: string,
    updateMemberSkillLevelRequest: UpdateMemberSkillLevelRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/members/${memberId}/skill-level`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMemberSkillLevelRequest
    },
      options);
    }
  


export const getUpdateMemberSkillLevelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMemberSkillLevel>>, TError,{schoolId: string;memberId: string;data: UpdateMemberSkillLevelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMemberSkillLevel>>, TError,{schoolId: string;memberId: string;data: UpdateMemberSkillLevelRequest}, TContext> => {

const mutationKey = ['updateMemberSkillLevel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMemberSkillLevel>>, {schoolId: string;memberId: string;data: UpdateMemberSkillLevelRequest}> = (props) => {
          const {schoolId,memberId,data} = props ?? {};

          return  updateMemberSkillLevel(schoolId,memberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMemberSkillLevelMutationResult = NonNullable<Awaited<ReturnType<typeof updateMemberSkillLevel>>>
    export type UpdateMemberSkillLevelMutationBody = UpdateMemberSkillLevelRequest
    export type UpdateMemberSkillLevelMutationError = unknown

    export const useUpdateMemberSkillLevel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMemberSkillLevel>>, TError,{schoolId: string;memberId: string;data: UpdateMemberSkillLevelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMemberSkillLevel>>,
        TError,
        {schoolId: string;memberId: string;data: UpdateMemberSkillLevelRequest},
        TContext
      > => {

      const mutationOptions = getUpdateMemberSkillLevelMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const mergeSchoolMember = (
    schoolId: string,
    memberId: string,
    mergeMembersRequest: MergeMembersRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/members/${memberId}/merge`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mergeMembersRequest, signal
    },
      options);
    }
  


export const getMergeSchoolMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeSchoolMember>>, TError,{schoolId: string;memberId: string;data: MergeMembersRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof mergeSchoolMember>>, TError,{schoolId: string;memberId: string;data: MergeMembersRequest}, TContext> => {

const mutationKey = ['mergeSchoolMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mergeSchoolMember>>, {schoolId: string;memberId: string;data: MergeMembersRequest}> = (props) => {
          const {schoolId,memberId,data} = props ?? {};

          return  mergeSchoolMember(schoolId,memberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MergeSchoolMemberMutationResult = NonNullable<Awaited<ReturnType<typeof mergeSchoolMember>>>
    export type MergeSchoolMemberMutationBody = MergeMembersRequest
    export type MergeSchoolMemberMutationError = unknown

    export const useMergeSchoolMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeSchoolMember>>, TError,{schoolId: string;memberId: string;data: MergeMembersRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mergeSchoolMember>>,
        TError,
        {schoolId: string;memberId: string;data: MergeMembersRequest},
        TContext
      > => {

      const mutationOptions = getMergeSchoolMemberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const moveSchoolMemberToFamily = (
    schoolId: string,
    memberId: string,
    moveToFamilyRequest: MoveToFamilyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MemberResponse>(
      {url: `/api/v1/schools/${schoolId}/members/${memberId}/move-to-family`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moveToFamilyRequest, signal
    },
      options);
    }
  


export const getMoveSchoolMemberToFamilyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveSchoolMemberToFamily>>, TError,{schoolId: string;memberId: string;data: MoveToFamilyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof moveSchoolMemberToFamily>>, TError,{schoolId: string;memberId: string;data: MoveToFamilyRequest}, TContext> => {

const mutationKey = ['moveSchoolMemberToFamily'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveSchoolMemberToFamily>>, {schoolId: string;memberId: string;data: MoveToFamilyRequest}> = (props) => {
          const {schoolId,memberId,data} = props ?? {};

          return  moveSchoolMemberToFamily(schoolId,memberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MoveSchoolMemberToFamilyMutationResult = NonNullable<Awaited<ReturnType<typeof moveSchoolMemberToFamily>>>
    export type MoveSchoolMemberToFamilyMutationBody = MoveToFamilyRequest
    export type MoveSchoolMemberToFamilyMutationError = unknown

    export const useMoveSchoolMemberToFamily = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveSchoolMemberToFamily>>, TError,{schoolId: string;memberId: string;data: MoveToFamilyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof moveSchoolMemberToFamily>>,
        TError,
        {schoolId: string;memberId: string;data: MoveToFamilyRequest},
        TContext
      > => {

      const mutationOptions = getMoveSchoolMemberToFamilyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const detachSchoolMemberFromFamily = (
    schoolId: string,
    memberId: string,
    detachFromFamilyRequest: DetachFromFamilyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MemberResponse>(
      {url: `/api/v1/schools/${schoolId}/members/${memberId}/detach-from-family`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: detachFromFamilyRequest, signal
    },
      options);
    }
  


export const getDetachSchoolMemberFromFamilyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof detachSchoolMemberFromFamily>>, TError,{schoolId: string;memberId: string;data: DetachFromFamilyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof detachSchoolMemberFromFamily>>, TError,{schoolId: string;memberId: string;data: DetachFromFamilyRequest}, TContext> => {

const mutationKey = ['detachSchoolMemberFromFamily'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof detachSchoolMemberFromFamily>>, {schoolId: string;memberId: string;data: DetachFromFamilyRequest}> = (props) => {
          const {schoolId,memberId,data} = props ?? {};

          return  detachSchoolMemberFromFamily(schoolId,memberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DetachSchoolMemberFromFamilyMutationResult = NonNullable<Awaited<ReturnType<typeof detachSchoolMemberFromFamily>>>
    export type DetachSchoolMemberFromFamilyMutationBody = DetachFromFamilyRequest
    export type DetachSchoolMemberFromFamilyMutationError = unknown

    export const useDetachSchoolMemberFromFamily = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof detachSchoolMemberFromFamily>>, TError,{schoolId: string;memberId: string;data: DetachFromFamilyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof detachSchoolMemberFromFamily>>,
        TError,
        {schoolId: string;memberId: string;data: DetachFromFamilyRequest},
        TContext
      > => {

      const mutationOptions = getDetachSchoolMemberFromFamilyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getDetachFromFamilyPreview = (
    schoolId: string,
    memberId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DetachFromFamilyPreviewResponse>(
      {url: `/api/v1/schools/${schoolId}/members/${memberId}/detach-from-family/preview`, method: 'GET', signal
    },
      options);
    }
  



export const getGetDetachFromFamilyPreviewQueryKey = (schoolId?: string,
    memberId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/members/${memberId}/detach-from-family/preview`
    ] as const;
    }

    
export const getGetDetachFromFamilyPreviewQueryOptions = <TData = Awaited<ReturnType<typeof getDetachFromFamilyPreview>>, TError = unknown>(schoolId: string,
    memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDetachFromFamilyPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDetachFromFamilyPreviewQueryKey(schoolId,memberId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDetachFromFamilyPreview>>> = ({ signal }) => getDetachFromFamilyPreview(schoolId,memberId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && memberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDetachFromFamilyPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDetachFromFamilyPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getDetachFromFamilyPreview>>>
export type GetDetachFromFamilyPreviewQueryError = unknown


export function useGetDetachFromFamilyPreview<TData = Awaited<ReturnType<typeof getDetachFromFamilyPreview>>, TError = unknown>(
 schoolId: string,
    memberId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDetachFromFamilyPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDetachFromFamilyPreview>>,
          TError,
          Awaited<ReturnType<typeof getDetachFromFamilyPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDetachFromFamilyPreview<TData = Awaited<ReturnType<typeof getDetachFromFamilyPreview>>, TError = unknown>(
 schoolId: string,
    memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDetachFromFamilyPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDetachFromFamilyPreview>>,
          TError,
          Awaited<ReturnType<typeof getDetachFromFamilyPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDetachFromFamilyPreview<TData = Awaited<ReturnType<typeof getDetachFromFamilyPreview>>, TError = unknown>(
 schoolId: string,
    memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDetachFromFamilyPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDetachFromFamilyPreview<TData = Awaited<ReturnType<typeof getDetachFromFamilyPreview>>, TError = unknown>(
 schoolId: string,
    memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDetachFromFamilyPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDetachFromFamilyPreviewQueryOptions(schoolId,memberId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const selfJoinSchool = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/members/join`, method: 'POST', signal
    },
      options);
    }
  


export const getSelfJoinSchoolMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selfJoinSchool>>, TError,{schoolId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof selfJoinSchool>>, TError,{schoolId: string}, TContext> => {

const mutationKey = ['selfJoinSchool'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof selfJoinSchool>>, {schoolId: string}> = (props) => {
          const {schoolId} = props ?? {};

          return  selfJoinSchool(schoolId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SelfJoinSchoolMutationResult = NonNullable<Awaited<ReturnType<typeof selfJoinSchool>>>
    
    export type SelfJoinSchoolMutationError = unknown

    export const useSelfJoinSchool = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selfJoinSchool>>, TError,{schoolId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof selfJoinSchool>>,
        TError,
        {schoolId: string},
        TContext
      > => {

      const mutationOptions = getSelfJoinSchoolMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getProfile = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MemberResponse>(
      {url: `/api/v1/schools/${schoolId}/profile`, method: 'GET', signal
    },
      options);
    }
  



export const getGetProfileQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/profile`
    ] as const;
    }

    
export const getGetProfileQueryOptions = <TData = Awaited<ReturnType<typeof getProfile>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) => getProfile(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>
export type GetProfileQueryError = unknown


export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateProfile = (
    schoolId: string,
    updateProfileRequest: UpdateProfileRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MemberResponse>(
      {url: `/api/v1/schools/${schoolId}/profile`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateProfileRequest
    },
      options);
    }
  


export const getUpdateProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{schoolId: string;data: UpdateProfileRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{schoolId: string;data: UpdateProfileRequest}, TContext> => {

const mutationKey = ['updateProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfile>>, {schoolId: string;data: UpdateProfileRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  updateProfile(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfile>>>
    export type UpdateProfileMutationBody = UpdateProfileRequest
    export type UpdateProfileMutationError = unknown

    export const useUpdateProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{schoolId: string;data: UpdateProfileRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProfile>>,
        TError,
        {schoolId: string;data: UpdateProfileRequest},
        TContext
      > => {

      const mutationOptions = getUpdateProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setUiPreference = (
    schoolId: string,
    setUiPreferenceRequest: SetUiPreferenceRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MemberResponse>(
      {url: `/api/v1/schools/${schoolId}/profile/ui-preference`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setUiPreferenceRequest
    },
      options);
    }
  


export const getSetUiPreferenceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUiPreference>>, TError,{schoolId: string;data: SetUiPreferenceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setUiPreference>>, TError,{schoolId: string;data: SetUiPreferenceRequest}, TContext> => {

const mutationKey = ['setUiPreference'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setUiPreference>>, {schoolId: string;data: SetUiPreferenceRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  setUiPreference(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetUiPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof setUiPreference>>>
    export type SetUiPreferenceMutationBody = SetUiPreferenceRequest
    export type SetUiPreferenceMutationError = unknown

    export const useSetUiPreference = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUiPreference>>, TError,{schoolId: string;data: SetUiPreferenceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setUiPreference>>,
        TError,
        {schoolId: string;data: SetUiPreferenceRequest},
        TContext
      > => {

      const mutationOptions = getSetUiPreferenceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAccountDeletionStatus = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AccountDeletionStatusResponse>(
      {url: `/api/v1/schools/${schoolId}/profile/deletion-status`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAccountDeletionStatusQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/profile/deletion-status`
    ] as const;
    }

    
export const getGetAccountDeletionStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAccountDeletionStatus>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountDeletionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountDeletionStatusQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountDeletionStatus>>> = ({ signal }) => getAccountDeletionStatus(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountDeletionStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccountDeletionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountDeletionStatus>>>
export type GetAccountDeletionStatusQueryError = unknown


export function useGetAccountDeletionStatus<TData = Awaited<ReturnType<typeof getAccountDeletionStatus>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountDeletionStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountDeletionStatus>>,
          TError,
          Awaited<ReturnType<typeof getAccountDeletionStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccountDeletionStatus<TData = Awaited<ReturnType<typeof getAccountDeletionStatus>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountDeletionStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountDeletionStatus>>,
          TError,
          Awaited<ReturnType<typeof getAccountDeletionStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccountDeletionStatus<TData = Awaited<ReturnType<typeof getAccountDeletionStatus>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountDeletionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAccountDeletionStatus<TData = Awaited<ReturnType<typeof getAccountDeletionStatus>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountDeletionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccountDeletionStatusQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const deleteAccount = (
    schoolId: string,
    deleteAccountRequest: DeleteAccountRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/profile/delete-account`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: deleteAccountRequest, signal
    },
      options);
    }
  


export const getDeleteAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{schoolId: string;data: DeleteAccountRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{schoolId: string;data: DeleteAccountRequest}, TContext> => {

const mutationKey = ['deleteAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccount>>, {schoolId: string;data: DeleteAccountRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  deleteAccount(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccount>>>
    export type DeleteAccountMutationBody = DeleteAccountRequest
    export type DeleteAccountMutationError = unknown

    export const useDeleteAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{schoolId: string;data: DeleteAccountRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccount>>,
        TError,
        {schoolId: string;data: DeleteAccountRequest},
        TContext
      > => {

      const mutationOptions = getDeleteAccountMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const submitMedicalSurvey = (
    schoolId: string,
    memberId: string,
    submitMedicalSurveyRequest: SubmitMedicalSurveyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MemberResponse>(
      {url: `/api/v1/schools/${schoolId}/members/${memberId}/medical-survey`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitMedicalSurveyRequest, signal
    },
      options);
    }
  


export const getSubmitMedicalSurveyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitMedicalSurvey>>, TError,{schoolId: string;memberId: string;data: SubmitMedicalSurveyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof submitMedicalSurvey>>, TError,{schoolId: string;memberId: string;data: SubmitMedicalSurveyRequest}, TContext> => {

const mutationKey = ['submitMedicalSurvey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitMedicalSurvey>>, {schoolId: string;memberId: string;data: SubmitMedicalSurveyRequest}> = (props) => {
          const {schoolId,memberId,data} = props ?? {};

          return  submitMedicalSurvey(schoolId,memberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitMedicalSurveyMutationResult = NonNullable<Awaited<ReturnType<typeof submitMedicalSurvey>>>
    export type SubmitMedicalSurveyMutationBody = SubmitMedicalSurveyRequest
    export type SubmitMedicalSurveyMutationError = unknown

    export const useSubmitMedicalSurvey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitMedicalSurvey>>, TError,{schoolId: string;memberId: string;data: SubmitMedicalSurveyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitMedicalSurvey>>,
        TError,
        {schoolId: string;memberId: string;data: SubmitMedicalSurveyRequest},
        TContext
      > => {

      const mutationOptions = getSubmitMedicalSurveyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getMyInvoiceDetails = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<StudentInvoiceDetailsResponse>(
      {url: `/api/v1/schools/${schoolId}/students/me/invoice-details`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMyInvoiceDetailsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/students/me/invoice-details`
    ] as const;
    }

    
export const getGetMyInvoiceDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getMyInvoiceDetails>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyInvoiceDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyInvoiceDetailsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyInvoiceDetails>>> = ({ signal }) => getMyInvoiceDetails(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyInvoiceDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyInvoiceDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyInvoiceDetails>>>
export type GetMyInvoiceDetailsQueryError = unknown


export function useGetMyInvoiceDetails<TData = Awaited<ReturnType<typeof getMyInvoiceDetails>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyInvoiceDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyInvoiceDetails>>,
          TError,
          Awaited<ReturnType<typeof getMyInvoiceDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyInvoiceDetails<TData = Awaited<ReturnType<typeof getMyInvoiceDetails>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyInvoiceDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyInvoiceDetails>>,
          TError,
          Awaited<ReturnType<typeof getMyInvoiceDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyInvoiceDetails<TData = Awaited<ReturnType<typeof getMyInvoiceDetails>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyInvoiceDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyInvoiceDetails<TData = Awaited<ReturnType<typeof getMyInvoiceDetails>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyInvoiceDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyInvoiceDetailsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateMyInvoiceDetails = (
    schoolId: string,
    updateStudentInvoiceDetailsRequest: UpdateStudentInvoiceDetailsRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<StudentInvoiceDetailsResponse>(
      {url: `/api/v1/schools/${schoolId}/students/me/invoice-details`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateStudentInvoiceDetailsRequest
    },
      options);
    }
  


export const getUpdateMyInvoiceDetailsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyInvoiceDetails>>, TError,{schoolId: string;data: UpdateStudentInvoiceDetailsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMyInvoiceDetails>>, TError,{schoolId: string;data: UpdateStudentInvoiceDetailsRequest}, TContext> => {

const mutationKey = ['updateMyInvoiceDetails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMyInvoiceDetails>>, {schoolId: string;data: UpdateStudentInvoiceDetailsRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  updateMyInvoiceDetails(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMyInvoiceDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyInvoiceDetails>>>
    export type UpdateMyInvoiceDetailsMutationBody = UpdateStudentInvoiceDetailsRequest
    export type UpdateMyInvoiceDetailsMutationError = unknown

    export const useUpdateMyInvoiceDetails = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyInvoiceDetails>>, TError,{schoolId: string;data: UpdateStudentInvoiceDetailsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMyInvoiceDetails>>,
        TError,
        {schoolId: string;data: UpdateStudentInvoiceDetailsRequest},
        TContext
      > => {

      const mutationOptions = getUpdateMyInvoiceDetailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getStudentInvoiceDetailsByMemberId = (
    schoolId: string,
    memberId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<StudentInvoiceDetailsResponse>(
      {url: `/api/v1/schools/${schoolId}/students/${memberId}/invoice-details`, method: 'GET', signal
    },
      options);
    }
  



export const getGetStudentInvoiceDetailsByMemberIdQueryKey = (schoolId?: string,
    memberId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/students/${memberId}/invoice-details`
    ] as const;
    }

    
export const getGetStudentInvoiceDetailsByMemberIdQueryOptions = <TData = Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>, TError = unknown>(schoolId: string,
    memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStudentInvoiceDetailsByMemberIdQueryKey(schoolId,memberId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>> = ({ signal }) => getStudentInvoiceDetailsByMemberId(schoolId,memberId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && memberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStudentInvoiceDetailsByMemberIdQueryResult = NonNullable<Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>>
export type GetStudentInvoiceDetailsByMemberIdQueryError = unknown


export function useGetStudentInvoiceDetailsByMemberId<TData = Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>, TError = unknown>(
 schoolId: string,
    memberId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>,
          TError,
          Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStudentInvoiceDetailsByMemberId<TData = Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>, TError = unknown>(
 schoolId: string,
    memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>,
          TError,
          Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStudentInvoiceDetailsByMemberId<TData = Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>, TError = unknown>(
 schoolId: string,
    memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetStudentInvoiceDetailsByMemberId<TData = Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>, TError = unknown>(
 schoolId: string,
    memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentInvoiceDetailsByMemberId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStudentInvoiceDetailsByMemberIdQueryOptions(schoolId,memberId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const resolveNipDetails = (
    schoolId: string,
    nip: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NipSearchResult>(
      {url: `/api/v1/schools/${schoolId}/students/me/invoice-details/nip/${nip}`, method: 'GET', signal
    },
      options);
    }
  



export const getResolveNipDetailsQueryKey = (schoolId?: string,
    nip?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/students/me/invoice-details/nip/${nip}`
    ] as const;
    }

    
export const getResolveNipDetailsQueryOptions = <TData = Awaited<ReturnType<typeof resolveNipDetails>>, TError = unknown>(schoolId: string,
    nip: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveNipDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getResolveNipDetailsQueryKey(schoolId,nip);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof resolveNipDetails>>> = ({ signal }) => resolveNipDetails(schoolId,nip, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && nip), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resolveNipDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ResolveNipDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof resolveNipDetails>>>
export type ResolveNipDetailsQueryError = unknown


export function useResolveNipDetails<TData = Awaited<ReturnType<typeof resolveNipDetails>>, TError = unknown>(
 schoolId: string,
    nip: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveNipDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveNipDetails>>,
          TError,
          Awaited<ReturnType<typeof resolveNipDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResolveNipDetails<TData = Awaited<ReturnType<typeof resolveNipDetails>>, TError = unknown>(
 schoolId: string,
    nip: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveNipDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveNipDetails>>,
          TError,
          Awaited<ReturnType<typeof resolveNipDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResolveNipDetails<TData = Awaited<ReturnType<typeof resolveNipDetails>>, TError = unknown>(
 schoolId: string,
    nip: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveNipDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useResolveNipDetails<TData = Awaited<ReturnType<typeof resolveNipDetails>>, TError = unknown>(
 schoolId: string,
    nip: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveNipDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getResolveNipDetailsQueryOptions(schoolId,nip,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createChild = (
    schoolId: string,
    createChildRequest: CreateChildRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MemberResponse>(
      {url: `/api/v1/schools/${schoolId}/students/me/children`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createChildRequest, signal
    },
      options);
    }
  


export const getCreateChildMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChild>>, TError,{schoolId: string;data: CreateChildRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createChild>>, TError,{schoolId: string;data: CreateChildRequest}, TContext> => {

const mutationKey = ['createChild'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createChild>>, {schoolId: string;data: CreateChildRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createChild(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateChildMutationResult = NonNullable<Awaited<ReturnType<typeof createChild>>>
    export type CreateChildMutationBody = CreateChildRequest
    export type CreateChildMutationError = unknown

    export const useCreateChild = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChild>>, TError,{schoolId: string;data: CreateChildRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createChild>>,
        TError,
        {schoolId: string;data: CreateChildRequest},
        TContext
      > => {

      const mutationOptions = getCreateChildMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listMyChildren = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MemberResponse[]>(
      {url: `/api/v1/schools/${schoolId}/students/me/children`, method: 'GET', signal
    },
      options);
    }
  



export const getListMyChildrenQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/students/me/children`
    ] as const;
    }

    
export const getListMyChildrenQueryOptions = <TData = Awaited<ReturnType<typeof listMyChildren>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyChildren>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyChildrenQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyChildren>>> = ({ signal }) => listMyChildren(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyChildren>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMyChildrenQueryResult = NonNullable<Awaited<ReturnType<typeof listMyChildren>>>
export type ListMyChildrenQueryError = unknown


export function useListMyChildren<TData = Awaited<ReturnType<typeof listMyChildren>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyChildren>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyChildren>>,
          TError,
          Awaited<ReturnType<typeof listMyChildren>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyChildren<TData = Awaited<ReturnType<typeof listMyChildren>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyChildren>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyChildren>>,
          TError,
          Awaited<ReturnType<typeof listMyChildren>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyChildren<TData = Awaited<ReturnType<typeof listMyChildren>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyChildren>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListMyChildren<TData = Awaited<ReturnType<typeof listMyChildren>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyChildren>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyChildrenQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateChild = (
    schoolId: string,
    childId: string,
    createChildRequest: CreateChildRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MemberResponse>(
      {url: `/api/v1/schools/${schoolId}/students/me/children/${childId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createChildRequest
    },
      options);
    }
  


export const getUpdateChildMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChild>>, TError,{schoolId: string;childId: string;data: CreateChildRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateChild>>, TError,{schoolId: string;childId: string;data: CreateChildRequest}, TContext> => {

const mutationKey = ['updateChild'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateChild>>, {schoolId: string;childId: string;data: CreateChildRequest}> = (props) => {
          const {schoolId,childId,data} = props ?? {};

          return  updateChild(schoolId,childId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateChildMutationResult = NonNullable<Awaited<ReturnType<typeof updateChild>>>
    export type UpdateChildMutationBody = CreateChildRequest
    export type UpdateChildMutationError = unknown

    export const useUpdateChild = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChild>>, TError,{schoolId: string;childId: string;data: CreateChildRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateChild>>,
        TError,
        {schoolId: string;childId: string;data: CreateChildRequest},
        TContext
      > => {

      const mutationOptions = getUpdateChildMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const removeChild = (
    schoolId: string,
    childId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/students/me/children/${childId}`, method: 'DELETE'
    },
      options);
    }
  


export const getRemoveChildMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeChild>>, TError,{schoolId: string;childId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeChild>>, TError,{schoolId: string;childId: string}, TContext> => {

const mutationKey = ['removeChild'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeChild>>, {schoolId: string;childId: string}> = (props) => {
          const {schoolId,childId} = props ?? {};

          return  removeChild(schoolId,childId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveChildMutationResult = NonNullable<Awaited<ReturnType<typeof removeChild>>>
    
    export type RemoveChildMutationError = unknown

    export const useRemoveChild = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeChild>>, TError,{schoolId: string;childId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeChild>>,
        TError,
        {schoolId: string;childId: string},
        TContext
      > => {

      const mutationOptions = getRemoveChildMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const importStudentsFromCsv = (
    schoolId: string,
    importStudentsFromCsvBody: ImportStudentsFromCsvBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(importStudentsFromCsvBody.file !== undefined) {
 formData.append(`file`, importStudentsFromCsvBody.file)
 }

if(importStudentsFromCsvBody.billingMonth !== undefined) {
 formData.append(`billingMonth`, importStudentsFromCsvBody.billingMonth)
 }

      return customInstance<CsvImportResult>(
      {url: `/api/v1/schools/${schoolId}/members/import-csv`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getImportStudentsFromCsvMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importStudentsFromCsv>>, TError,{schoolId: string;data: ImportStudentsFromCsvBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof importStudentsFromCsv>>, TError,{schoolId: string;data: ImportStudentsFromCsvBody}, TContext> => {

const mutationKey = ['importStudentsFromCsv'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importStudentsFromCsv>>, {schoolId: string;data: ImportStudentsFromCsvBody}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  importStudentsFromCsv(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportStudentsFromCsvMutationResult = NonNullable<Awaited<ReturnType<typeof importStudentsFromCsv>>>
    export type ImportStudentsFromCsvMutationBody = ImportStudentsFromCsvBody
    export type ImportStudentsFromCsvMutationError = unknown

    export const useImportStudentsFromCsv = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importStudentsFromCsv>>, TError,{schoolId: string;data: ImportStudentsFromCsvBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importStudentsFromCsv>>,
        TError,
        {schoolId: string;data: ImportStudentsFromCsvBody},
        TContext
      > => {

      const mutationOptions = getImportStudentsFromCsvMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listLocations = (
    schoolId: string,
    params?: ListLocationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/locations`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListLocationsQueryKey = (schoolId?: string,
    params?: ListLocationsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/locations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListLocationsQueryOptions = <TData = Awaited<ReturnType<typeof listLocations>>, TError = unknown>(schoolId: string,
    params?: ListLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLocationsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLocations>>> = ({ signal }) => listLocations(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof listLocations>>>
export type ListLocationsQueryError = unknown


export function useListLocations<TData = Awaited<ReturnType<typeof listLocations>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListLocationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLocations>>,
          TError,
          Awaited<ReturnType<typeof listLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLocations<TData = Awaited<ReturnType<typeof listLocations>>, TError = unknown>(
 schoolId: string,
    params?: ListLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLocations>>,
          TError,
          Awaited<ReturnType<typeof listLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLocations<TData = Awaited<ReturnType<typeof listLocations>>, TError = unknown>(
 schoolId: string,
    params?: ListLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListLocations<TData = Awaited<ReturnType<typeof listLocations>>, TError = unknown>(
 schoolId: string,
    params?: ListLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLocationsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createLocation = (
    schoolId: string,
    createLocationRequest: CreateLocationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/locations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createLocationRequest, signal
    },
      options);
    }
  


export const getCreateLocationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{schoolId: string;data: CreateLocationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{schoolId: string;data: CreateLocationRequest}, TContext> => {

const mutationKey = ['createLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLocation>>, {schoolId: string;data: CreateLocationRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createLocation(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof createLocation>>>
    export type CreateLocationMutationBody = CreateLocationRequest
    export type CreateLocationMutationError = unknown

    export const useCreateLocation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{schoolId: string;data: CreateLocationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLocation>>,
        TError,
        {schoolId: string;data: CreateLocationRequest},
        TContext
      > => {

      const mutationOptions = getCreateLocationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getLocation = (
    schoolId: string,
    locationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/locations/${locationId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLocationQueryKey = (schoolId?: string,
    locationId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/locations/${locationId}`
    ] as const;
    }

    
export const getGetLocationQueryOptions = <TData = Awaited<ReturnType<typeof getLocation>>, TError = unknown>(schoolId: string,
    locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationQueryKey(schoolId,locationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocation>>> = ({ signal }) => getLocation(schoolId,locationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && locationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLocationQueryResult = NonNullable<Awaited<ReturnType<typeof getLocation>>>
export type GetLocationQueryError = unknown


export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = unknown>(
 schoolId: string,
    locationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocation>>,
          TError,
          Awaited<ReturnType<typeof getLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = unknown>(
 schoolId: string,
    locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocation>>,
          TError,
          Awaited<ReturnType<typeof getLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = unknown>(
 schoolId: string,
    locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = unknown>(
 schoolId: string,
    locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationQueryOptions(schoolId,locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateLocation = (
    schoolId: string,
    locationId: string,
    updateLocationRequest: UpdateLocationRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/locations/${locationId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateLocationRequest
    },
      options);
    }
  


export const getUpdateLocationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{schoolId: string;locationId: string;data: UpdateLocationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{schoolId: string;locationId: string;data: UpdateLocationRequest}, TContext> => {

const mutationKey = ['updateLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLocation>>, {schoolId: string;locationId: string;data: UpdateLocationRequest}> = (props) => {
          const {schoolId,locationId,data} = props ?? {};

          return  updateLocation(schoolId,locationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof updateLocation>>>
    export type UpdateLocationMutationBody = UpdateLocationRequest
    export type UpdateLocationMutationError = unknown

    export const useUpdateLocation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{schoolId: string;locationId: string;data: UpdateLocationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLocation>>,
        TError,
        {schoolId: string;locationId: string;data: UpdateLocationRequest},
        TContext
      > => {

      const mutationOptions = getUpdateLocationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteLocation = (
    schoolId: string,
    locationId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/locations/${locationId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteLocationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLocation>>, TError,{schoolId: string;locationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLocation>>, TError,{schoolId: string;locationId: string}, TContext> => {

const mutationKey = ['deleteLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLocation>>, {schoolId: string;locationId: string}> = (props) => {
          const {schoolId,locationId} = props ?? {};

          return  deleteLocation(schoolId,locationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteLocationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLocation>>>
    
    export type DeleteLocationMutationError = unknown

    export const useDeleteLocation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLocation>>, TError,{schoolId: string;locationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLocation>>,
        TError,
        {schoolId: string;locationId: string},
        TContext
      > => {

      const mutationOptions = getDeleteLocationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listMaintenancePeriods = (
    schoolId: string,
    locationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MaintenancePeriodResponse[]>(
      {url: `/api/v1/schools/${schoolId}/locations/${locationId}/maintenance`, method: 'GET', signal
    },
      options);
    }
  



export const getListMaintenancePeriodsQueryKey = (schoolId?: string,
    locationId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/locations/${locationId}/maintenance`
    ] as const;
    }

    
export const getListMaintenancePeriodsQueryOptions = <TData = Awaited<ReturnType<typeof listMaintenancePeriods>>, TError = unknown>(schoolId: string,
    locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMaintenancePeriods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMaintenancePeriodsQueryKey(schoolId,locationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMaintenancePeriods>>> = ({ signal }) => listMaintenancePeriods(schoolId,locationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && locationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMaintenancePeriods>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMaintenancePeriodsQueryResult = NonNullable<Awaited<ReturnType<typeof listMaintenancePeriods>>>
export type ListMaintenancePeriodsQueryError = unknown


export function useListMaintenancePeriods<TData = Awaited<ReturnType<typeof listMaintenancePeriods>>, TError = unknown>(
 schoolId: string,
    locationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMaintenancePeriods>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMaintenancePeriods>>,
          TError,
          Awaited<ReturnType<typeof listMaintenancePeriods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMaintenancePeriods<TData = Awaited<ReturnType<typeof listMaintenancePeriods>>, TError = unknown>(
 schoolId: string,
    locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMaintenancePeriods>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMaintenancePeriods>>,
          TError,
          Awaited<ReturnType<typeof listMaintenancePeriods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMaintenancePeriods<TData = Awaited<ReturnType<typeof listMaintenancePeriods>>, TError = unknown>(
 schoolId: string,
    locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMaintenancePeriods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListMaintenancePeriods<TData = Awaited<ReturnType<typeof listMaintenancePeriods>>, TError = unknown>(
 schoolId: string,
    locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMaintenancePeriods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMaintenancePeriodsQueryOptions(schoolId,locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const addMaintenancePeriod = (
    schoolId: string,
    locationId: string,
    createMaintenancePeriodRequest: CreateMaintenancePeriodRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MaintenancePeriodResponse>(
      {url: `/api/v1/schools/${schoolId}/locations/${locationId}/maintenance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMaintenancePeriodRequest, signal
    },
      options);
    }
  


export const getAddMaintenancePeriodMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addMaintenancePeriod>>, TError,{schoolId: string;locationId: string;data: CreateMaintenancePeriodRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addMaintenancePeriod>>, TError,{schoolId: string;locationId: string;data: CreateMaintenancePeriodRequest}, TContext> => {

const mutationKey = ['addMaintenancePeriod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addMaintenancePeriod>>, {schoolId: string;locationId: string;data: CreateMaintenancePeriodRequest}> = (props) => {
          const {schoolId,locationId,data} = props ?? {};

          return  addMaintenancePeriod(schoolId,locationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddMaintenancePeriodMutationResult = NonNullable<Awaited<ReturnType<typeof addMaintenancePeriod>>>
    export type AddMaintenancePeriodMutationBody = CreateMaintenancePeriodRequest
    export type AddMaintenancePeriodMutationError = unknown

    export const useAddMaintenancePeriod = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addMaintenancePeriod>>, TError,{schoolId: string;locationId: string;data: CreateMaintenancePeriodRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addMaintenancePeriod>>,
        TError,
        {schoolId: string;locationId: string;data: CreateMaintenancePeriodRequest},
        TContext
      > => {

      const mutationOptions = getAddMaintenancePeriodMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteMaintenancePeriod = (
    schoolId: string,
    locationId: string,
    periodId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/locations/${locationId}/maintenance/${periodId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteMaintenancePeriodMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMaintenancePeriod>>, TError,{schoolId: string;locationId: string;periodId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMaintenancePeriod>>, TError,{schoolId: string;locationId: string;periodId: string}, TContext> => {

const mutationKey = ['deleteMaintenancePeriod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMaintenancePeriod>>, {schoolId: string;locationId: string;periodId: string}> = (props) => {
          const {schoolId,locationId,periodId} = props ?? {};

          return  deleteMaintenancePeriod(schoolId,locationId,periodId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMaintenancePeriodMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMaintenancePeriod>>>
    
    export type DeleteMaintenancePeriodMutationError = unknown

    export const useDeleteMaintenancePeriod = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMaintenancePeriod>>, TError,{schoolId: string;locationId: string;periodId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMaintenancePeriod>>,
        TError,
        {schoolId: string;locationId: string;periodId: string},
        TContext
      > => {

      const mutationOptions = getDeleteMaintenancePeriodMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listSchoolHolidays = (
    schoolId: string,
    params?: ListSchoolHolidaysParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SchoolHolidayResponse[]>(
      {url: `/api/v1/schools/${schoolId}/holidays`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListSchoolHolidaysQueryKey = (schoolId?: string,
    params?: ListSchoolHolidaysParams,) => {
    return [
    `/api/v1/schools/${schoolId}/holidays`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListSchoolHolidaysQueryOptions = <TData = Awaited<ReturnType<typeof listSchoolHolidays>>, TError = unknown>(schoolId: string,
    params?: ListSchoolHolidaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolHolidays>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSchoolHolidaysQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchoolHolidays>>> = ({ signal }) => listSchoolHolidays(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSchoolHolidays>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSchoolHolidaysQueryResult = NonNullable<Awaited<ReturnType<typeof listSchoolHolidays>>>
export type ListSchoolHolidaysQueryError = unknown


export function useListSchoolHolidays<TData = Awaited<ReturnType<typeof listSchoolHolidays>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListSchoolHolidaysParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolHolidays>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSchoolHolidays>>,
          TError,
          Awaited<ReturnType<typeof listSchoolHolidays>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSchoolHolidays<TData = Awaited<ReturnType<typeof listSchoolHolidays>>, TError = unknown>(
 schoolId: string,
    params?: ListSchoolHolidaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolHolidays>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSchoolHolidays>>,
          TError,
          Awaited<ReturnType<typeof listSchoolHolidays>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSchoolHolidays<TData = Awaited<ReturnType<typeof listSchoolHolidays>>, TError = unknown>(
 schoolId: string,
    params?: ListSchoolHolidaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolHolidays>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSchoolHolidays<TData = Awaited<ReturnType<typeof listSchoolHolidays>>, TError = unknown>(
 schoolId: string,
    params?: ListSchoolHolidaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolHolidays>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSchoolHolidaysQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createSchoolHolidays = (
    schoolId: string,
    createSchoolHolidaysRequest: CreateSchoolHolidaysRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CreateSchoolHolidaysResponse>(
      {url: `/api/v1/schools/${schoolId}/holidays`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSchoolHolidaysRequest, signal
    },
      options);
    }
  


export const getCreateSchoolHolidaysMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolHolidays>>, TError,{schoolId: string;data: CreateSchoolHolidaysRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSchoolHolidays>>, TError,{schoolId: string;data: CreateSchoolHolidaysRequest}, TContext> => {

const mutationKey = ['createSchoolHolidays'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSchoolHolidays>>, {schoolId: string;data: CreateSchoolHolidaysRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createSchoolHolidays(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSchoolHolidaysMutationResult = NonNullable<Awaited<ReturnType<typeof createSchoolHolidays>>>
    export type CreateSchoolHolidaysMutationBody = CreateSchoolHolidaysRequest
    export type CreateSchoolHolidaysMutationError = unknown

    export const useCreateSchoolHolidays = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolHolidays>>, TError,{schoolId: string;data: CreateSchoolHolidaysRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSchoolHolidays>>,
        TError,
        {schoolId: string;data: CreateSchoolHolidaysRequest},
        TContext
      > => {

      const mutationOptions = getCreateSchoolHolidaysMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const previewSchoolHolidayImpact = (
    schoolId: string,
    schoolHolidayImpactRequest: SchoolHolidayImpactRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SchoolHolidayImpactResponse>(
      {url: `/api/v1/schools/${schoolId}/holidays/impact`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: schoolHolidayImpactRequest, signal
    },
      options);
    }
  


export const getPreviewSchoolHolidayImpactMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewSchoolHolidayImpact>>, TError,{schoolId: string;data: SchoolHolidayImpactRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof previewSchoolHolidayImpact>>, TError,{schoolId: string;data: SchoolHolidayImpactRequest}, TContext> => {

const mutationKey = ['previewSchoolHolidayImpact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewSchoolHolidayImpact>>, {schoolId: string;data: SchoolHolidayImpactRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  previewSchoolHolidayImpact(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PreviewSchoolHolidayImpactMutationResult = NonNullable<Awaited<ReturnType<typeof previewSchoolHolidayImpact>>>
    export type PreviewSchoolHolidayImpactMutationBody = SchoolHolidayImpactRequest
    export type PreviewSchoolHolidayImpactMutationError = unknown

    export const usePreviewSchoolHolidayImpact = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewSchoolHolidayImpact>>, TError,{schoolId: string;data: SchoolHolidayImpactRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewSchoolHolidayImpact>>,
        TError,
        {schoolId: string;data: SchoolHolidayImpactRequest},
        TContext
      > => {

      const mutationOptions = getPreviewSchoolHolidayImpactMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateSchoolHoliday = (
    schoolId: string,
    holidayId: string,
    updateSchoolHolidayRequest: UpdateSchoolHolidayRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SchoolHolidayResponse>(
      {url: `/api/v1/schools/${schoolId}/holidays/${holidayId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSchoolHolidayRequest
    },
      options);
    }
  


export const getUpdateSchoolHolidayMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolHoliday>>, TError,{schoolId: string;holidayId: string;data: UpdateSchoolHolidayRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSchoolHoliday>>, TError,{schoolId: string;holidayId: string;data: UpdateSchoolHolidayRequest}, TContext> => {

const mutationKey = ['updateSchoolHoliday'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSchoolHoliday>>, {schoolId: string;holidayId: string;data: UpdateSchoolHolidayRequest}> = (props) => {
          const {schoolId,holidayId,data} = props ?? {};

          return  updateSchoolHoliday(schoolId,holidayId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSchoolHolidayMutationResult = NonNullable<Awaited<ReturnType<typeof updateSchoolHoliday>>>
    export type UpdateSchoolHolidayMutationBody = UpdateSchoolHolidayRequest
    export type UpdateSchoolHolidayMutationError = unknown

    export const useUpdateSchoolHoliday = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolHoliday>>, TError,{schoolId: string;holidayId: string;data: UpdateSchoolHolidayRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSchoolHoliday>>,
        TError,
        {schoolId: string;holidayId: string;data: UpdateSchoolHolidayRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSchoolHolidayMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteSchoolHoliday = (
    schoolId: string,
    holidayId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/holidays/${holidayId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteSchoolHolidayMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolHoliday>>, TError,{schoolId: string;holidayId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolHoliday>>, TError,{schoolId: string;holidayId: string}, TContext> => {

const mutationKey = ['deleteSchoolHoliday'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSchoolHoliday>>, {schoolId: string;holidayId: string}> = (props) => {
          const {schoolId,holidayId} = props ?? {};

          return  deleteSchoolHoliday(schoolId,holidayId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSchoolHolidayMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSchoolHoliday>>>
    
    export type DeleteSchoolHolidayMutationError = unknown

    export const useDeleteSchoolHoliday = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolHoliday>>, TError,{schoolId: string;holidayId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSchoolHoliday>>,
        TError,
        {schoolId: string;holidayId: string},
        TContext
      > => {

      const mutationOptions = getDeleteSchoolHolidayMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listGameDays = (
    schoolId: string,
    params: ListGameDaysParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GameDaySessionDto[]>(
      {url: `/api/v1/schools/${schoolId}/game-days`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListGameDaysQueryKey = (schoolId?: string,
    params?: ListGameDaysParams,) => {
    return [
    `/api/v1/schools/${schoolId}/game-days`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListGameDaysQueryOptions = <TData = Awaited<ReturnType<typeof listGameDays>>, TError = unknown>(schoolId: string,
    params: ListGameDaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGameDays>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGameDaysQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGameDays>>> = ({ signal }) => listGameDays(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGameDays>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGameDaysQueryResult = NonNullable<Awaited<ReturnType<typeof listGameDays>>>
export type ListGameDaysQueryError = unknown


export function useListGameDays<TData = Awaited<ReturnType<typeof listGameDays>>, TError = unknown>(
 schoolId: string,
    params: ListGameDaysParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGameDays>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGameDays>>,
          TError,
          Awaited<ReturnType<typeof listGameDays>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGameDays<TData = Awaited<ReturnType<typeof listGameDays>>, TError = unknown>(
 schoolId: string,
    params: ListGameDaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGameDays>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGameDays>>,
          TError,
          Awaited<ReturnType<typeof listGameDays>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGameDays<TData = Awaited<ReturnType<typeof listGameDays>>, TError = unknown>(
 schoolId: string,
    params: ListGameDaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGameDays>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListGameDays<TData = Awaited<ReturnType<typeof listGameDays>>, TError = unknown>(
 schoolId: string,
    params: ListGameDaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGameDays>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGameDaysQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const setGameDays = (
    schoolId: string,
    setGameDaysRequest: SetGameDaysRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SetGameDays200>(
      {url: `/api/v1/schools/${schoolId}/game-days`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setGameDaysRequest
    },
      options);
    }
  


export const getSetGameDaysMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setGameDays>>, TError,{schoolId: string;data: SetGameDaysRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setGameDays>>, TError,{schoolId: string;data: SetGameDaysRequest}, TContext> => {

const mutationKey = ['setGameDays'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setGameDays>>, {schoolId: string;data: SetGameDaysRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  setGameDays(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetGameDaysMutationResult = NonNullable<Awaited<ReturnType<typeof setGameDays>>>
    export type SetGameDaysMutationBody = SetGameDaysRequest
    export type SetGameDaysMutationError = unknown

    export const useSetGameDays = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setGameDays>>, TError,{schoolId: string;data: SetGameDaysRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setGameDays>>,
        TError,
        {schoolId: string;data: SetGameDaysRequest},
        TContext
      > => {

      const mutationOptions = getSetGameDaysMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const suggestGameDays = (
    schoolId: string,
    gameDaySuggestionRequest: GameDaySuggestionRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GameDaySuggestionResponse>(
      {url: `/api/v1/schools/${schoolId}/game-days/suggestions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: gameDaySuggestionRequest, signal
    },
      options);
    }
  


export const getSuggestGameDaysMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suggestGameDays>>, TError,{schoolId: string;data: GameDaySuggestionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof suggestGameDays>>, TError,{schoolId: string;data: GameDaySuggestionRequest}, TContext> => {

const mutationKey = ['suggestGameDays'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof suggestGameDays>>, {schoolId: string;data: GameDaySuggestionRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  suggestGameDays(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SuggestGameDaysMutationResult = NonNullable<Awaited<ReturnType<typeof suggestGameDays>>>
    export type SuggestGameDaysMutationBody = GameDaySuggestionRequest
    export type SuggestGameDaysMutationError = unknown

    export const useSuggestGameDays = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suggestGameDays>>, TError,{schoolId: string;data: GameDaySuggestionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof suggestGameDays>>,
        TError,
        {schoolId: string;data: GameDaySuggestionRequest},
        TContext
      > => {

      const mutationOptions = getSuggestGameDaysMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getGameDayRule = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GameDayRuleResponse>(
      {url: `/api/v1/schools/${schoolId}/game-days/rule`, method: 'GET', signal
    },
      options);
    }
  



export const getGetGameDayRuleQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/game-days/rule`
    ] as const;
    }

    
export const getGetGameDayRuleQueryOptions = <TData = Awaited<ReturnType<typeof getGameDayRule>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGameDayRule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGameDayRuleQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGameDayRule>>> = ({ signal }) => getGameDayRule(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGameDayRule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGameDayRuleQueryResult = NonNullable<Awaited<ReturnType<typeof getGameDayRule>>>
export type GetGameDayRuleQueryError = unknown


export function useGetGameDayRule<TData = Awaited<ReturnType<typeof getGameDayRule>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGameDayRule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGameDayRule>>,
          TError,
          Awaited<ReturnType<typeof getGameDayRule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGameDayRule<TData = Awaited<ReturnType<typeof getGameDayRule>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGameDayRule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGameDayRule>>,
          TError,
          Awaited<ReturnType<typeof getGameDayRule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGameDayRule<TData = Awaited<ReturnType<typeof getGameDayRule>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGameDayRule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGameDayRule<TData = Awaited<ReturnType<typeof getGameDayRule>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGameDayRule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGameDayRuleQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateGameDayRule = (
    schoolId: string,
    updateGameDayRuleRequest: UpdateGameDayRuleRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<GameDayRuleResponse>(
      {url: `/api/v1/schools/${schoolId}/game-days/rule`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateGameDayRuleRequest
    },
      options);
    }
  


export const getUpdateGameDayRuleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGameDayRule>>, TError,{schoolId: string;data: UpdateGameDayRuleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGameDayRule>>, TError,{schoolId: string;data: UpdateGameDayRuleRequest}, TContext> => {

const mutationKey = ['updateGameDayRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGameDayRule>>, {schoolId: string;data: UpdateGameDayRuleRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  updateGameDayRule(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateGameDayRuleMutationResult = NonNullable<Awaited<ReturnType<typeof updateGameDayRule>>>
    export type UpdateGameDayRuleMutationBody = UpdateGameDayRuleRequest
    export type UpdateGameDayRuleMutationError = unknown

    export const useUpdateGameDayRule = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGameDayRule>>, TError,{schoolId: string;data: UpdateGameDayRuleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateGameDayRule>>,
        TError,
        {schoolId: string;data: UpdateGameDayRuleRequest},
        TContext
      > => {

      const mutationOptions = getUpdateGameDayRuleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listSchedules = (
    schoolId: string,
    params?: ListSchedulesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ScheduleResponse[]>(
      {url: `/api/v1/schools/${schoolId}/schedules`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListSchedulesQueryKey = (schoolId?: string,
    params?: ListSchedulesParams,) => {
    return [
    `/api/v1/schools/${schoolId}/schedules`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof listSchedules>>, TError = unknown>(schoolId: string,
    params?: ListSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchedules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSchedulesQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchedules>>> = ({ signal }) => listSchedules(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof listSchedules>>>
export type ListSchedulesQueryError = unknown


export function useListSchedules<TData = Awaited<ReturnType<typeof listSchedules>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListSchedulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchedules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSchedules>>,
          TError,
          Awaited<ReturnType<typeof listSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSchedules<TData = Awaited<ReturnType<typeof listSchedules>>, TError = unknown>(
 schoolId: string,
    params?: ListSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchedules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSchedules>>,
          TError,
          Awaited<ReturnType<typeof listSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSchedules<TData = Awaited<ReturnType<typeof listSchedules>>, TError = unknown>(
 schoolId: string,
    params?: ListSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchedules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSchedules<TData = Awaited<ReturnType<typeof listSchedules>>, TError = unknown>(
 schoolId: string,
    params?: ListSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchedules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSchedulesQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createSchedule = (
    schoolId: string,
    createScheduleRequest: CreateScheduleRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ScheduleResponse>(
      {url: `/api/v1/schools/${schoolId}/schedules`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createScheduleRequest, signal
    },
      options);
    }
  


export const getCreateScheduleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchedule>>, TError,{schoolId: string;data: CreateScheduleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSchedule>>, TError,{schoolId: string;data: CreateScheduleRequest}, TContext> => {

const mutationKey = ['createSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSchedule>>, {schoolId: string;data: CreateScheduleRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createSchedule(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof createSchedule>>>
    export type CreateScheduleMutationBody = CreateScheduleRequest
    export type CreateScheduleMutationError = unknown

    export const useCreateSchedule = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchedule>>, TError,{schoolId: string;data: CreateScheduleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSchedule>>,
        TError,
        {schoolId: string;data: CreateScheduleRequest},
        TContext
      > => {

      const mutationOptions = getCreateScheduleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getSchedule = (
    schoolId: string,
    scheduleId: string,
    params?: GetScheduleParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ScheduleResponse>(
      {url: `/api/v1/schools/${schoolId}/schedules/${scheduleId}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetScheduleQueryKey = (schoolId?: string,
    scheduleId?: string,
    params?: GetScheduleParams,) => {
    return [
    `/api/v1/schools/${schoolId}/schedules/${scheduleId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getSchedule>>, TError = unknown>(schoolId: string,
    scheduleId: string,
    params?: GetScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScheduleQueryKey(schoolId,scheduleId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchedule>>> = ({ signal }) => getSchedule(schoolId,scheduleId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && scheduleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getSchedule>>>
export type GetScheduleQueryError = unknown


export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = unknown>(
 schoolId: string,
    scheduleId: string,
    params: undefined |  GetScheduleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchedule>>,
          TError,
          Awaited<ReturnType<typeof getSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = unknown>(
 schoolId: string,
    scheduleId: string,
    params?: GetScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchedule>>,
          TError,
          Awaited<ReturnType<typeof getSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = unknown>(
 schoolId: string,
    scheduleId: string,
    params?: GetScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = unknown>(
 schoolId: string,
    scheduleId: string,
    params?: GetScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScheduleQueryOptions(schoolId,scheduleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateSchedule = (
    schoolId: string,
    scheduleId: string,
    updateScheduleRequest: UpdateScheduleRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ScheduleResponse>(
      {url: `/api/v1/schools/${schoolId}/schedules/${scheduleId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateScheduleRequest
    },
      options);
    }
  


export const getUpdateScheduleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchedule>>, TError,{schoolId: string;scheduleId: string;data: UpdateScheduleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSchedule>>, TError,{schoolId: string;scheduleId: string;data: UpdateScheduleRequest}, TContext> => {

const mutationKey = ['updateSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSchedule>>, {schoolId: string;scheduleId: string;data: UpdateScheduleRequest}> = (props) => {
          const {schoolId,scheduleId,data} = props ?? {};

          return  updateSchedule(schoolId,scheduleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof updateSchedule>>>
    export type UpdateScheduleMutationBody = UpdateScheduleRequest
    export type UpdateScheduleMutationError = unknown

    export const useUpdateSchedule = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchedule>>, TError,{schoolId: string;scheduleId: string;data: UpdateScheduleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSchedule>>,
        TError,
        {schoolId: string;scheduleId: string;data: UpdateScheduleRequest},
        TContext
      > => {

      const mutationOptions = getUpdateScheduleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteSchedule = (
    schoolId: string,
    scheduleId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/schedules/${scheduleId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteScheduleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchedule>>, TError,{schoolId: string;scheduleId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSchedule>>, TError,{schoolId: string;scheduleId: string}, TContext> => {

const mutationKey = ['deleteSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSchedule>>, {schoolId: string;scheduleId: string}> = (props) => {
          const {schoolId,scheduleId} = props ?? {};

          return  deleteSchedule(schoolId,scheduleId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSchedule>>>
    
    export type DeleteScheduleMutationError = unknown

    export const useDeleteSchedule = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchedule>>, TError,{schoolId: string;scheduleId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSchedule>>,
        TError,
        {schoolId: string;scheduleId: string},
        TContext
      > => {

      const mutationOptions = getDeleteScheduleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const generateSessions = (
    schoolId: string,
    scheduleId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/schedules/${scheduleId}/generate-sessions`, method: 'POST', signal
    },
      options);
    }
  


export const getGenerateSessionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateSessions>>, TError,{schoolId: string;scheduleId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generateSessions>>, TError,{schoolId: string;scheduleId: string}, TContext> => {

const mutationKey = ['generateSessions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateSessions>>, {schoolId: string;scheduleId: string}> = (props) => {
          const {schoolId,scheduleId} = props ?? {};

          return  generateSessions(schoolId,scheduleId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateSessionsMutationResult = NonNullable<Awaited<ReturnType<typeof generateSessions>>>
    
    export type GenerateSessionsMutationError = unknown

    export const useGenerateSessions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateSessions>>, TError,{schoolId: string;scheduleId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateSessions>>,
        TError,
        {schoolId: string;scheduleId: string},
        TContext
      > => {

      const mutationOptions = getGenerateSessionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setScheduleEnrollmentBlocked = (
    schoolId: string,
    scheduleId: string,
    setEnrollmentBlockedRequest: SetEnrollmentBlockedRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/schedules/${scheduleId}/enrollment-blocked`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setEnrollmentBlockedRequest, signal
    },
      options);
    }
  


export const getSetScheduleEnrollmentBlockedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setScheduleEnrollmentBlocked>>, TError,{schoolId: string;scheduleId: string;data: SetEnrollmentBlockedRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setScheduleEnrollmentBlocked>>, TError,{schoolId: string;scheduleId: string;data: SetEnrollmentBlockedRequest}, TContext> => {

const mutationKey = ['setScheduleEnrollmentBlocked'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setScheduleEnrollmentBlocked>>, {schoolId: string;scheduleId: string;data: SetEnrollmentBlockedRequest}> = (props) => {
          const {schoolId,scheduleId,data} = props ?? {};

          return  setScheduleEnrollmentBlocked(schoolId,scheduleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetScheduleEnrollmentBlockedMutationResult = NonNullable<Awaited<ReturnType<typeof setScheduleEnrollmentBlocked>>>
    export type SetScheduleEnrollmentBlockedMutationBody = SetEnrollmentBlockedRequest
    export type SetScheduleEnrollmentBlockedMutationError = unknown

    export const useSetScheduleEnrollmentBlocked = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setScheduleEnrollmentBlocked>>, TError,{schoolId: string;scheduleId: string;data: SetEnrollmentBlockedRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setScheduleEnrollmentBlocked>>,
        TError,
        {schoolId: string;scheduleId: string;data: SetEnrollmentBlockedRequest},
        TContext
      > => {

      const mutationOptions = getSetScheduleEnrollmentBlockedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getScheduleMessages = (
    schoolId: string,
    scheduleId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SessionMessageResponse[]>(
      {url: `/api/v1/schools/${schoolId}/schedules/${scheduleId}/messages`, method: 'GET', signal
    },
      options);
    }
  



export const getGetScheduleMessagesQueryKey = (schoolId?: string,
    scheduleId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/schedules/${scheduleId}/messages`
    ] as const;
    }

    
export const getGetScheduleMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getScheduleMessages>>, TError = unknown>(schoolId: string,
    scheduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScheduleMessagesQueryKey(schoolId,scheduleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScheduleMessages>>> = ({ signal }) => getScheduleMessages(schoolId,scheduleId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && scheduleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScheduleMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScheduleMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getScheduleMessages>>>
export type GetScheduleMessagesQueryError = unknown


export function useGetScheduleMessages<TData = Awaited<ReturnType<typeof getScheduleMessages>>, TError = unknown>(
 schoolId: string,
    scheduleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduleMessages>>,
          TError,
          Awaited<ReturnType<typeof getScheduleMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduleMessages<TData = Awaited<ReturnType<typeof getScheduleMessages>>, TError = unknown>(
 schoolId: string,
    scheduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduleMessages>>,
          TError,
          Awaited<ReturnType<typeof getScheduleMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduleMessages<TData = Awaited<ReturnType<typeof getScheduleMessages>>, TError = unknown>(
 schoolId: string,
    scheduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetScheduleMessages<TData = Awaited<ReturnType<typeof getScheduleMessages>>, TError = unknown>(
 schoolId: string,
    scheduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScheduleMessagesQueryOptions(schoolId,scheduleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const sendScheduleMessage = (
    schoolId: string,
    scheduleId: string,
    sendSessionMessageRequest: SendSessionMessageRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/schedules/${scheduleId}/messages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendSessionMessageRequest, signal
    },
      options);
    }
  


export const getSendScheduleMessageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendScheduleMessage>>, TError,{schoolId: string;scheduleId: string;data: SendSessionMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendScheduleMessage>>, TError,{schoolId: string;scheduleId: string;data: SendSessionMessageRequest}, TContext> => {

const mutationKey = ['sendScheduleMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendScheduleMessage>>, {schoolId: string;scheduleId: string;data: SendSessionMessageRequest}> = (props) => {
          const {schoolId,scheduleId,data} = props ?? {};

          return  sendScheduleMessage(schoolId,scheduleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendScheduleMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendScheduleMessage>>>
    export type SendScheduleMessageMutationBody = SendSessionMessageRequest
    export type SendScheduleMessageMutationError = unknown

    export const useSendScheduleMessage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendScheduleMessage>>, TError,{schoolId: string;scheduleId: string;data: SendSessionMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendScheduleMessage>>,
        TError,
        {schoolId: string;scheduleId: string;data: SendSessionMessageRequest},
        TContext
      > => {

      const mutationOptions = getSendScheduleMessageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const sendScheduleTestMessage = (
    schoolId: string,
    scheduleId: string,
    sendSessionMessageRequest: SendSessionMessageRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/schedules/${scheduleId}/messages/test`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendSessionMessageRequest, signal
    },
      options);
    }
  


export const getSendScheduleTestMessageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendScheduleTestMessage>>, TError,{schoolId: string;scheduleId: string;data: SendSessionMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendScheduleTestMessage>>, TError,{schoolId: string;scheduleId: string;data: SendSessionMessageRequest}, TContext> => {

const mutationKey = ['sendScheduleTestMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendScheduleTestMessage>>, {schoolId: string;scheduleId: string;data: SendSessionMessageRequest}> = (props) => {
          const {schoolId,scheduleId,data} = props ?? {};

          return  sendScheduleTestMessage(schoolId,scheduleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendScheduleTestMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendScheduleTestMessage>>>
    export type SendScheduleTestMessageMutationBody = SendSessionMessageRequest
    export type SendScheduleTestMessageMutationError = unknown

    export const useSendScheduleTestMessage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendScheduleTestMessage>>, TError,{schoolId: string;scheduleId: string;data: SendSessionMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendScheduleTestMessage>>,
        TError,
        {schoolId: string;scheduleId: string;data: SendSessionMessageRequest},
        TContext
      > => {

      const mutationOptions = getSendScheduleTestMessageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listTags = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tags`, method: 'GET', signal
    },
      options);
    }
  



export const getListTagsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/tags`
    ] as const;
    }

    
export const getListTagsQueryOptions = <TData = Awaited<ReturnType<typeof listTags>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTagsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTags>>> = ({ signal }) => listTags(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTagsQueryResult = NonNullable<Awaited<ReturnType<typeof listTags>>>
export type ListTagsQueryError = unknown


export function useListTags<TData = Awaited<ReturnType<typeof listTags>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTags>>,
          TError,
          Awaited<ReturnType<typeof listTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTags<TData = Awaited<ReturnType<typeof listTags>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTags>>,
          TError,
          Awaited<ReturnType<typeof listTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTags<TData = Awaited<ReturnType<typeof listTags>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListTags<TData = Awaited<ReturnType<typeof listTags>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTagsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listSessions = (
    schoolId: string,
    params?: ListSessionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SessionResponse[]>(
      {url: `/api/v1/schools/${schoolId}/sessions`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListSessionsQueryKey = (schoolId?: string,
    params?: ListSessionsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/sessions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListSessionsQueryOptions = <TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(schoolId: string,
    params?: ListSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSessionsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSessions>>> = ({ signal }) => listSessions(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof listSessions>>>
export type ListSessionsQueryError = unknown


export function useListSessions<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListSessionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSessions>>,
          TError,
          Awaited<ReturnType<typeof listSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSessions<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
 schoolId: string,
    params?: ListSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSessions>>,
          TError,
          Awaited<ReturnType<typeof listSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSessions<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
 schoolId: string,
    params?: ListSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSessions<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
 schoolId: string,
    params?: ListSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSessionsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createOneTimeSession = (
    schoolId: string,
    createOneTimeSessionRequest: CreateOneTimeSessionRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SessionResponse>(
      {url: `/api/v1/schools/${schoolId}/sessions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOneTimeSessionRequest, signal
    },
      options);
    }
  


export const getCreateOneTimeSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneTimeSession>>, TError,{schoolId: string;data: CreateOneTimeSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createOneTimeSession>>, TError,{schoolId: string;data: CreateOneTimeSessionRequest}, TContext> => {

const mutationKey = ['createOneTimeSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneTimeSession>>, {schoolId: string;data: CreateOneTimeSessionRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createOneTimeSession(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateOneTimeSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createOneTimeSession>>>
    export type CreateOneTimeSessionMutationBody = CreateOneTimeSessionRequest
    export type CreateOneTimeSessionMutationError = unknown

    export const useCreateOneTimeSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneTimeSession>>, TError,{schoolId: string;data: CreateOneTimeSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOneTimeSession>>,
        TError,
        {schoolId: string;data: CreateOneTimeSessionRequest},
        TContext
      > => {

      const mutationOptions = getCreateOneTimeSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getSession = (
    schoolId: string,
    sessionId: string,
    params?: GetSessionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SessionResponse>(
      {url: `/api/v1/schools/${schoolId}/sessions/${sessionId}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetSessionQueryKey = (schoolId?: string,
    sessionId?: string,
    params?: GetSessionParams,) => {
    return [
    `/api/v1/schools/${schoolId}/sessions/${sessionId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSessionQueryOptions = <TData = Awaited<ReturnType<typeof getSession>>, TError = unknown>(schoolId: string,
    sessionId: string,
    params?: GetSessionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionQueryKey(schoolId,sessionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSession>>> = ({ signal }) => getSession(schoolId,sessionId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getSession>>>
export type GetSessionQueryError = unknown


export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = unknown>(
 schoolId: string,
    sessionId: string,
    params: undefined |  GetSessionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSession>>,
          TError,
          Awaited<ReturnType<typeof getSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = unknown>(
 schoolId: string,
    sessionId: string,
    params?: GetSessionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSession>>,
          TError,
          Awaited<ReturnType<typeof getSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = unknown>(
 schoolId: string,
    sessionId: string,
    params?: GetSessionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = unknown>(
 schoolId: string,
    sessionId: string,
    params?: GetSessionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSessionQueryOptions(schoolId,sessionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateSession = (
    schoolId: string,
    sessionId: string,
    updateSessionRequest: UpdateSessionRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/sessions/${sessionId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSessionRequest
    },
      options);
    }
  


export const getUpdateSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSession>>, TError,{schoolId: string;sessionId: string;data: UpdateSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSession>>, TError,{schoolId: string;sessionId: string;data: UpdateSessionRequest}, TContext> => {

const mutationKey = ['updateSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSession>>, {schoolId: string;sessionId: string;data: UpdateSessionRequest}> = (props) => {
          const {schoolId,sessionId,data} = props ?? {};

          return  updateSession(schoolId,sessionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSessionMutationResult = NonNullable<Awaited<ReturnType<typeof updateSession>>>
    export type UpdateSessionMutationBody = UpdateSessionRequest
    export type UpdateSessionMutationError = unknown

    export const useUpdateSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSession>>, TError,{schoolId: string;sessionId: string;data: UpdateSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSession>>,
        TError,
        {schoolId: string;sessionId: string;data: UpdateSessionRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateSessionCoach = (
    schoolId: string,
    sessionId: string,
    updateSessionCoachRequest: UpdateSessionCoachRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/sessions/${sessionId}/coach`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSessionCoachRequest
    },
      options);
    }
  


export const getUpdateSessionCoachMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSessionCoach>>, TError,{schoolId: string;sessionId: string;data: UpdateSessionCoachRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSessionCoach>>, TError,{schoolId: string;sessionId: string;data: UpdateSessionCoachRequest}, TContext> => {

const mutationKey = ['updateSessionCoach'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSessionCoach>>, {schoolId: string;sessionId: string;data: UpdateSessionCoachRequest}> = (props) => {
          const {schoolId,sessionId,data} = props ?? {};

          return  updateSessionCoach(schoolId,sessionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSessionCoachMutationResult = NonNullable<Awaited<ReturnType<typeof updateSessionCoach>>>
    export type UpdateSessionCoachMutationBody = UpdateSessionCoachRequest
    export type UpdateSessionCoachMutationError = unknown

    export const useUpdateSessionCoach = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSessionCoach>>, TError,{schoolId: string;sessionId: string;data: UpdateSessionCoachRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSessionCoach>>,
        TError,
        {schoolId: string;sessionId: string;data: UpdateSessionCoachRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSessionCoachMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateSessionTitle = (
    schoolId: string,
    sessionId: string,
    updateSessionTitleRequest: UpdateSessionTitleRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/sessions/${sessionId}/title`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSessionTitleRequest
    },
      options);
    }
  


export const getUpdateSessionTitleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSessionTitle>>, TError,{schoolId: string;sessionId: string;data: UpdateSessionTitleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSessionTitle>>, TError,{schoolId: string;sessionId: string;data: UpdateSessionTitleRequest}, TContext> => {

const mutationKey = ['updateSessionTitle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSessionTitle>>, {schoolId: string;sessionId: string;data: UpdateSessionTitleRequest}> = (props) => {
          const {schoolId,sessionId,data} = props ?? {};

          return  updateSessionTitle(schoolId,sessionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSessionTitleMutationResult = NonNullable<Awaited<ReturnType<typeof updateSessionTitle>>>
    export type UpdateSessionTitleMutationBody = UpdateSessionTitleRequest
    export type UpdateSessionTitleMutationError = unknown

    export const useUpdateSessionTitle = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSessionTitle>>, TError,{schoolId: string;sessionId: string;data: UpdateSessionTitleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSessionTitle>>,
        TError,
        {schoolId: string;sessionId: string;data: UpdateSessionTitleRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSessionTitleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateSessionTopic = (
    schoolId: string,
    sessionId: string,
    updateSessionTopicRequest: UpdateSessionTopicRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/sessions/${sessionId}/topic`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSessionTopicRequest
    },
      options);
    }
  


export const getUpdateSessionTopicMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSessionTopic>>, TError,{schoolId: string;sessionId: string;data: UpdateSessionTopicRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSessionTopic>>, TError,{schoolId: string;sessionId: string;data: UpdateSessionTopicRequest}, TContext> => {

const mutationKey = ['updateSessionTopic'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSessionTopic>>, {schoolId: string;sessionId: string;data: UpdateSessionTopicRequest}> = (props) => {
          const {schoolId,sessionId,data} = props ?? {};

          return  updateSessionTopic(schoolId,sessionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSessionTopicMutationResult = NonNullable<Awaited<ReturnType<typeof updateSessionTopic>>>
    export type UpdateSessionTopicMutationBody = UpdateSessionTopicRequest
    export type UpdateSessionTopicMutationError = unknown

    export const useUpdateSessionTopic = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSessionTopic>>, TError,{schoolId: string;sessionId: string;data: UpdateSessionTopicRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSessionTopic>>,
        TError,
        {schoolId: string;sessionId: string;data: UpdateSessionTopicRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSessionTopicMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateSessionNotes = (
    schoolId: string,
    sessionId: string,
    updateSessionNotesRequest: UpdateSessionNotesRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/sessions/${sessionId}/notes`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSessionNotesRequest
    },
      options);
    }
  


export const getUpdateSessionNotesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSessionNotes>>, TError,{schoolId: string;sessionId: string;data: UpdateSessionNotesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSessionNotes>>, TError,{schoolId: string;sessionId: string;data: UpdateSessionNotesRequest}, TContext> => {

const mutationKey = ['updateSessionNotes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSessionNotes>>, {schoolId: string;sessionId: string;data: UpdateSessionNotesRequest}> = (props) => {
          const {schoolId,sessionId,data} = props ?? {};

          return  updateSessionNotes(schoolId,sessionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSessionNotesMutationResult = NonNullable<Awaited<ReturnType<typeof updateSessionNotes>>>
    export type UpdateSessionNotesMutationBody = UpdateSessionNotesRequest
    export type UpdateSessionNotesMutationError = unknown

    export const useUpdateSessionNotes = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSessionNotes>>, TError,{schoolId: string;sessionId: string;data: UpdateSessionNotesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSessionNotes>>,
        TError,
        {schoolId: string;sessionId: string;data: UpdateSessionNotesRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSessionNotesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const cancelSession = (
    schoolId: string,
    sessionId: string,
    cancelSessionBody: CancelSessionBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/sessions/${sessionId}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelSessionBody, signal
    },
      options);
    }
  


export const getCancelSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSession>>, TError,{schoolId: string;sessionId: string;data: CancelSessionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelSession>>, TError,{schoolId: string;sessionId: string;data: CancelSessionBody}, TContext> => {

const mutationKey = ['cancelSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelSession>>, {schoolId: string;sessionId: string;data: CancelSessionBody}> = (props) => {
          const {schoolId,sessionId,data} = props ?? {};

          return  cancelSession(schoolId,sessionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelSessionMutationResult = NonNullable<Awaited<ReturnType<typeof cancelSession>>>
    export type CancelSessionMutationBody = CancelSessionBody
    export type CancelSessionMutationError = unknown

    export const useCancelSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSession>>, TError,{schoolId: string;sessionId: string;data: CancelSessionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelSession>>,
        TError,
        {schoolId: string;sessionId: string;data: CancelSessionBody},
        TContext
      > => {

      const mutationOptions = getCancelSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const summarizeSession = (
    schoolId: string,
    sessionId: string,
    summarizeSessionRequest: SummarizeSessionRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/sessions/${sessionId}/summarize`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: summarizeSessionRequest, signal
    },
      options);
    }
  


export const getSummarizeSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof summarizeSession>>, TError,{schoolId: string;sessionId: string;data: SummarizeSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof summarizeSession>>, TError,{schoolId: string;sessionId: string;data: SummarizeSessionRequest}, TContext> => {

const mutationKey = ['summarizeSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof summarizeSession>>, {schoolId: string;sessionId: string;data: SummarizeSessionRequest}> = (props) => {
          const {schoolId,sessionId,data} = props ?? {};

          return  summarizeSession(schoolId,sessionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SummarizeSessionMutationResult = NonNullable<Awaited<ReturnType<typeof summarizeSession>>>
    export type SummarizeSessionMutationBody = SummarizeSessionRequest
    export type SummarizeSessionMutationError = unknown

    export const useSummarizeSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof summarizeSession>>, TError,{schoolId: string;sessionId: string;data: SummarizeSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof summarizeSession>>,
        TError,
        {schoolId: string;sessionId: string;data: SummarizeSessionRequest},
        TContext
      > => {

      const mutationOptions = getSummarizeSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const reopenSession = (
    schoolId: string,
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/sessions/${sessionId}/reopen`, method: 'POST', signal
    },
      options);
    }
  


export const getReopenSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenSession>>, TError,{schoolId: string;sessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reopenSession>>, TError,{schoolId: string;sessionId: string}, TContext> => {

const mutationKey = ['reopenSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenSession>>, {schoolId: string;sessionId: string}> = (props) => {
          const {schoolId,sessionId} = props ?? {};

          return  reopenSession(schoolId,sessionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReopenSessionMutationResult = NonNullable<Awaited<ReturnType<typeof reopenSession>>>
    
    export type ReopenSessionMutationError = unknown

    export const useReopenSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenSession>>, TError,{schoolId: string;sessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reopenSession>>,
        TError,
        {schoolId: string;sessionId: string},
        TContext
      > => {

      const mutationOptions = getReopenSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getSessionMessages = (
    schoolId: string,
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SessionMessageResponse[]>(
      {url: `/api/v1/schools/${schoolId}/sessions/${sessionId}/messages`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSessionMessagesQueryKey = (schoolId?: string,
    sessionId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/sessions/${sessionId}/messages`
    ] as const;
    }

    
export const getGetSessionMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getSessionMessages>>, TError = unknown>(schoolId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionMessagesQueryKey(schoolId,sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSessionMessages>>> = ({ signal }) => getSessionMessages(schoolId,sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSessionMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSessionMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getSessionMessages>>>
export type GetSessionMessagesQueryError = unknown


export function useGetSessionMessages<TData = Awaited<ReturnType<typeof getSessionMessages>>, TError = unknown>(
 schoolId: string,
    sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSessionMessages>>,
          TError,
          Awaited<ReturnType<typeof getSessionMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSessionMessages<TData = Awaited<ReturnType<typeof getSessionMessages>>, TError = unknown>(
 schoolId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSessionMessages>>,
          TError,
          Awaited<ReturnType<typeof getSessionMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSessionMessages<TData = Awaited<ReturnType<typeof getSessionMessages>>, TError = unknown>(
 schoolId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSessionMessages<TData = Awaited<ReturnType<typeof getSessionMessages>>, TError = unknown>(
 schoolId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSessionMessagesQueryOptions(schoolId,sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const sendSessionMessage = (
    schoolId: string,
    sessionId: string,
    sendSessionMessageRequest: SendSessionMessageRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/sessions/${sessionId}/messages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendSessionMessageRequest, signal
    },
      options);
    }
  


export const getSendSessionMessageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSessionMessage>>, TError,{schoolId: string;sessionId: string;data: SendSessionMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendSessionMessage>>, TError,{schoolId: string;sessionId: string;data: SendSessionMessageRequest}, TContext> => {

const mutationKey = ['sendSessionMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendSessionMessage>>, {schoolId: string;sessionId: string;data: SendSessionMessageRequest}> = (props) => {
          const {schoolId,sessionId,data} = props ?? {};

          return  sendSessionMessage(schoolId,sessionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendSessionMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendSessionMessage>>>
    export type SendSessionMessageMutationBody = SendSessionMessageRequest
    export type SendSessionMessageMutationError = unknown

    export const useSendSessionMessage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSessionMessage>>, TError,{schoolId: string;sessionId: string;data: SendSessionMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendSessionMessage>>,
        TError,
        {schoolId: string;sessionId: string;data: SendSessionMessageRequest},
        TContext
      > => {

      const mutationOptions = getSendSessionMessageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const sendSessionTestMessage = (
    schoolId: string,
    sessionId: string,
    sendSessionMessageRequest: SendSessionMessageRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/sessions/${sessionId}/messages/test`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendSessionMessageRequest, signal
    },
      options);
    }
  


export const getSendSessionTestMessageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSessionTestMessage>>, TError,{schoolId: string;sessionId: string;data: SendSessionMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendSessionTestMessage>>, TError,{schoolId: string;sessionId: string;data: SendSessionMessageRequest}, TContext> => {

const mutationKey = ['sendSessionTestMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendSessionTestMessage>>, {schoolId: string;sessionId: string;data: SendSessionMessageRequest}> = (props) => {
          const {schoolId,sessionId,data} = props ?? {};

          return  sendSessionTestMessage(schoolId,sessionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendSessionTestMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendSessionTestMessage>>>
    export type SendSessionTestMessageMutationBody = SendSessionMessageRequest
    export type SendSessionTestMessageMutationError = unknown

    export const useSendSessionTestMessage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSessionTestMessage>>, TError,{schoolId: string;sessionId: string;data: SendSessionMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendSessionTestMessage>>,
        TError,
        {schoolId: string;sessionId: string;data: SendSessionMessageRequest},
        TContext
      > => {

      const mutationOptions = getSendSessionTestMessageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setSessionEnrollmentBlocked = (
    schoolId: string,
    sessionId: string,
    setEnrollmentBlockedRequest: SetEnrollmentBlockedRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/sessions/${sessionId}/enrollment-blocked`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setEnrollmentBlockedRequest, signal
    },
      options);
    }
  


export const getSetSessionEnrollmentBlockedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSessionEnrollmentBlocked>>, TError,{schoolId: string;sessionId: string;data: SetEnrollmentBlockedRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setSessionEnrollmentBlocked>>, TError,{schoolId: string;sessionId: string;data: SetEnrollmentBlockedRequest}, TContext> => {

const mutationKey = ['setSessionEnrollmentBlocked'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSessionEnrollmentBlocked>>, {schoolId: string;sessionId: string;data: SetEnrollmentBlockedRequest}> = (props) => {
          const {schoolId,sessionId,data} = props ?? {};

          return  setSessionEnrollmentBlocked(schoolId,sessionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetSessionEnrollmentBlockedMutationResult = NonNullable<Awaited<ReturnType<typeof setSessionEnrollmentBlocked>>>
    export type SetSessionEnrollmentBlockedMutationBody = SetEnrollmentBlockedRequest
    export type SetSessionEnrollmentBlockedMutationError = unknown

    export const useSetSessionEnrollmentBlocked = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSessionEnrollmentBlocked>>, TError,{schoolId: string;sessionId: string;data: SetEnrollmentBlockedRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSessionEnrollmentBlocked>>,
        TError,
        {schoolId: string;sessionId: string;data: SetEnrollmentBlockedRequest},
        TContext
      > => {

      const mutationOptions = getSetSessionEnrollmentBlockedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setSessionGameDay = (
    schoolId: string,
    sessionId: string,
    setSessionGameDayRequest: SetSessionGameDayRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/sessions/${sessionId}/game-day`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setSessionGameDayRequest, signal
    },
      options);
    }
  


export const getSetSessionGameDayMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSessionGameDay>>, TError,{schoolId: string;sessionId: string;data: SetSessionGameDayRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setSessionGameDay>>, TError,{schoolId: string;sessionId: string;data: SetSessionGameDayRequest}, TContext> => {

const mutationKey = ['setSessionGameDay'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSessionGameDay>>, {schoolId: string;sessionId: string;data: SetSessionGameDayRequest}> = (props) => {
          const {schoolId,sessionId,data} = props ?? {};

          return  setSessionGameDay(schoolId,sessionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetSessionGameDayMutationResult = NonNullable<Awaited<ReturnType<typeof setSessionGameDay>>>
    export type SetSessionGameDayMutationBody = SetSessionGameDayRequest
    export type SetSessionGameDayMutationError = unknown

    export const useSetSessionGameDay = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSessionGameDay>>, TError,{schoolId: string;sessionId: string;data: SetSessionGameDayRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSessionGameDay>>,
        TError,
        {schoolId: string;sessionId: string;data: SetSessionGameDayRequest},
        TContext
      > => {

      const mutationOptions = getSetSessionGameDayMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getPublicSchedules = (
    schoolId: string,
    params?: GetPublicSchedulesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/public/schools/${schoolId}/schedules`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPublicSchedulesQueryKey = (schoolId?: string,
    params?: GetPublicSchedulesParams,) => {
    return [
    `/api/v1/public/schools/${schoolId}/schedules`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPublicSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof getPublicSchedules>>, TError = unknown>(schoolId: string,
    params?: GetPublicSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicSchedules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicSchedulesQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicSchedules>>> = ({ signal }) => getPublicSchedules(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicSchedules>>>
export type GetPublicSchedulesQueryError = unknown


export function useGetPublicSchedules<TData = Awaited<ReturnType<typeof getPublicSchedules>>, TError = unknown>(
 schoolId: string,
    params: undefined |  GetPublicSchedulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicSchedules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicSchedules>>,
          TError,
          Awaited<ReturnType<typeof getPublicSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicSchedules<TData = Awaited<ReturnType<typeof getPublicSchedules>>, TError = unknown>(
 schoolId: string,
    params?: GetPublicSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicSchedules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicSchedules>>,
          TError,
          Awaited<ReturnType<typeof getPublicSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicSchedules<TData = Awaited<ReturnType<typeof getPublicSchedules>>, TError = unknown>(
 schoolId: string,
    params?: GetPublicSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicSchedules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicSchedules<TData = Awaited<ReturnType<typeof getPublicSchedules>>, TError = unknown>(
 schoolId: string,
    params?: GetPublicSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicSchedules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicSchedulesQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getPublicCoaches = (
    schoolId: string,
    params?: GetPublicCoachesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PublicCoachResponse[]>(
      {url: `/api/v1/public/schools/${schoolId}/coaches`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPublicCoachesQueryKey = (schoolId?: string,
    params?: GetPublicCoachesParams,) => {
    return [
    `/api/v1/public/schools/${schoolId}/coaches`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPublicCoachesQueryOptions = <TData = Awaited<ReturnType<typeof getPublicCoaches>>, TError = unknown>(schoolId: string,
    params?: GetPublicCoachesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCoaches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicCoachesQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicCoaches>>> = ({ signal }) => getPublicCoaches(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicCoaches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicCoachesQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicCoaches>>>
export type GetPublicCoachesQueryError = unknown


export function useGetPublicCoaches<TData = Awaited<ReturnType<typeof getPublicCoaches>>, TError = unknown>(
 schoolId: string,
    params: undefined |  GetPublicCoachesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCoaches>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicCoaches>>,
          TError,
          Awaited<ReturnType<typeof getPublicCoaches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicCoaches<TData = Awaited<ReturnType<typeof getPublicCoaches>>, TError = unknown>(
 schoolId: string,
    params?: GetPublicCoachesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCoaches>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicCoaches>>,
          TError,
          Awaited<ReturnType<typeof getPublicCoaches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicCoaches<TData = Awaited<ReturnType<typeof getPublicCoaches>>, TError = unknown>(
 schoolId: string,
    params?: GetPublicCoachesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCoaches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicCoaches<TData = Awaited<ReturnType<typeof getPublicCoaches>>, TError = unknown>(
 schoolId: string,
    params?: GetPublicCoachesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCoaches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicCoachesQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const exportSessionIcs = (
    schoolId: string,
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/calendar/session/${sessionId}.ics`, method: 'GET', signal
    },
      options);
    }
  



export const getExportSessionIcsQueryKey = (schoolId?: string,
    sessionId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/calendar/session/${sessionId}.ics`
    ] as const;
    }

    
export const getExportSessionIcsQueryOptions = <TData = Awaited<ReturnType<typeof exportSessionIcs>>, TError = unknown>(schoolId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSessionIcs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportSessionIcsQueryKey(schoolId,sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportSessionIcs>>> = ({ signal }) => exportSessionIcs(schoolId,sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportSessionIcs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportSessionIcsQueryResult = NonNullable<Awaited<ReturnType<typeof exportSessionIcs>>>
export type ExportSessionIcsQueryError = unknown


export function useExportSessionIcs<TData = Awaited<ReturnType<typeof exportSessionIcs>>, TError = unknown>(
 schoolId: string,
    sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSessionIcs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportSessionIcs>>,
          TError,
          Awaited<ReturnType<typeof exportSessionIcs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportSessionIcs<TData = Awaited<ReturnType<typeof exportSessionIcs>>, TError = unknown>(
 schoolId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSessionIcs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportSessionIcs>>,
          TError,
          Awaited<ReturnType<typeof exportSessionIcs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportSessionIcs<TData = Awaited<ReturnType<typeof exportSessionIcs>>, TError = unknown>(
 schoolId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSessionIcs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExportSessionIcs<TData = Awaited<ReturnType<typeof exportSessionIcs>>, TError = unknown>(
 schoolId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSessionIcs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportSessionIcsQueryOptions(schoolId,sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const exportScheduleIcs = (
    schoolId: string,
    scheduleId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/calendar/schedule/${scheduleId}.ics`, method: 'GET', signal
    },
      options);
    }
  



export const getExportScheduleIcsQueryKey = (schoolId?: string,
    scheduleId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/calendar/schedule/${scheduleId}.ics`
    ] as const;
    }

    
export const getExportScheduleIcsQueryOptions = <TData = Awaited<ReturnType<typeof exportScheduleIcs>>, TError = unknown>(schoolId: string,
    scheduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportScheduleIcs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportScheduleIcsQueryKey(schoolId,scheduleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportScheduleIcs>>> = ({ signal }) => exportScheduleIcs(schoolId,scheduleId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && scheduleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportScheduleIcs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportScheduleIcsQueryResult = NonNullable<Awaited<ReturnType<typeof exportScheduleIcs>>>
export type ExportScheduleIcsQueryError = unknown


export function useExportScheduleIcs<TData = Awaited<ReturnType<typeof exportScheduleIcs>>, TError = unknown>(
 schoolId: string,
    scheduleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportScheduleIcs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportScheduleIcs>>,
          TError,
          Awaited<ReturnType<typeof exportScheduleIcs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportScheduleIcs<TData = Awaited<ReturnType<typeof exportScheduleIcs>>, TError = unknown>(
 schoolId: string,
    scheduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportScheduleIcs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportScheduleIcs>>,
          TError,
          Awaited<ReturnType<typeof exportScheduleIcs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportScheduleIcs<TData = Awaited<ReturnType<typeof exportScheduleIcs>>, TError = unknown>(
 schoolId: string,
    scheduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportScheduleIcs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExportScheduleIcs<TData = Awaited<ReturnType<typeof exportScheduleIcs>>, TError = unknown>(
 schoolId: string,
    scheduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportScheduleIcs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportScheduleIcsQueryOptions(schoolId,scheduleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const calculateEnrollmentPrice = (
    schoolId: string,
    params: CalculateEnrollmentPriceParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EnrollmentPriceCalculationResponse>(
      {url: `/api/v1/schools/${schoolId}/enrollments/calculate-price`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getCalculateEnrollmentPriceQueryKey = (schoolId?: string,
    params?: CalculateEnrollmentPriceParams,) => {
    return [
    `/api/v1/schools/${schoolId}/enrollments/calculate-price`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCalculateEnrollmentPriceQueryOptions = <TData = Awaited<ReturnType<typeof calculateEnrollmentPrice>>, TError = unknown>(schoolId: string,
    params: CalculateEnrollmentPriceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateEnrollmentPrice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCalculateEnrollmentPriceQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof calculateEnrollmentPrice>>> = ({ signal }) => calculateEnrollmentPrice(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof calculateEnrollmentPrice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CalculateEnrollmentPriceQueryResult = NonNullable<Awaited<ReturnType<typeof calculateEnrollmentPrice>>>
export type CalculateEnrollmentPriceQueryError = unknown


export function useCalculateEnrollmentPrice<TData = Awaited<ReturnType<typeof calculateEnrollmentPrice>>, TError = unknown>(
 schoolId: string,
    params: CalculateEnrollmentPriceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateEnrollmentPrice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof calculateEnrollmentPrice>>,
          TError,
          Awaited<ReturnType<typeof calculateEnrollmentPrice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalculateEnrollmentPrice<TData = Awaited<ReturnType<typeof calculateEnrollmentPrice>>, TError = unknown>(
 schoolId: string,
    params: CalculateEnrollmentPriceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateEnrollmentPrice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof calculateEnrollmentPrice>>,
          TError,
          Awaited<ReturnType<typeof calculateEnrollmentPrice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalculateEnrollmentPrice<TData = Awaited<ReturnType<typeof calculateEnrollmentPrice>>, TError = unknown>(
 schoolId: string,
    params: CalculateEnrollmentPriceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateEnrollmentPrice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCalculateEnrollmentPrice<TData = Awaited<ReturnType<typeof calculateEnrollmentPrice>>, TError = unknown>(
 schoolId: string,
    params: CalculateEnrollmentPriceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateEnrollmentPrice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCalculateEnrollmentPriceQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const enrollStudent = (
    schoolId: string,
    enrollStudentRequest: EnrollStudentRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/enrollments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: enrollStudentRequest, signal
    },
      options);
    }
  


export const getEnrollStudentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enrollStudent>>, TError,{schoolId: string;data: EnrollStudentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof enrollStudent>>, TError,{schoolId: string;data: EnrollStudentRequest}, TContext> => {

const mutationKey = ['enrollStudent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enrollStudent>>, {schoolId: string;data: EnrollStudentRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  enrollStudent(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EnrollStudentMutationResult = NonNullable<Awaited<ReturnType<typeof enrollStudent>>>
    export type EnrollStudentMutationBody = EnrollStudentRequest
    export type EnrollStudentMutationError = unknown

    export const useEnrollStudent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enrollStudent>>, TError,{schoolId: string;data: EnrollStudentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enrollStudent>>,
        TError,
        {schoolId: string;data: EnrollStudentRequest},
        TContext
      > => {

      const mutationOptions = getEnrollStudentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listAllEnrollments = (
    schoolId: string,
    params?: ListAllEnrollmentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EnrollmentListResponse>(
      {url: `/api/v1/schools/${schoolId}/enrollments`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListAllEnrollmentsQueryKey = (schoolId?: string,
    params?: ListAllEnrollmentsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/enrollments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListAllEnrollmentsQueryOptions = <TData = Awaited<ReturnType<typeof listAllEnrollments>>, TError = unknown>(schoolId: string,
    params?: ListAllEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAllEnrollmentsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllEnrollments>>> = ({ signal }) => listAllEnrollments(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllEnrollments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAllEnrollmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAllEnrollments>>>
export type ListAllEnrollmentsQueryError = unknown


export function useListAllEnrollments<TData = Awaited<ReturnType<typeof listAllEnrollments>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListAllEnrollmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllEnrollments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllEnrollments>>,
          TError,
          Awaited<ReturnType<typeof listAllEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllEnrollments<TData = Awaited<ReturnType<typeof listAllEnrollments>>, TError = unknown>(
 schoolId: string,
    params?: ListAllEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllEnrollments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllEnrollments>>,
          TError,
          Awaited<ReturnType<typeof listAllEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllEnrollments<TData = Awaited<ReturnType<typeof listAllEnrollments>>, TError = unknown>(
 schoolId: string,
    params?: ListAllEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAllEnrollments<TData = Awaited<ReturnType<typeof listAllEnrollments>>, TError = unknown>(
 schoolId: string,
    params?: ListAllEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAllEnrollmentsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const approveEnrollment = (
    schoolId: string,
    enrollmentId: string,
    params?: ApproveEnrollmentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/enrollments/${enrollmentId}/approve`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getApproveEnrollmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveEnrollment>>, TError,{schoolId: string;enrollmentId: string;params?: ApproveEnrollmentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof approveEnrollment>>, TError,{schoolId: string;enrollmentId: string;params?: ApproveEnrollmentParams}, TContext> => {

const mutationKey = ['approveEnrollment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveEnrollment>>, {schoolId: string;enrollmentId: string;params?: ApproveEnrollmentParams}> = (props) => {
          const {schoolId,enrollmentId,params} = props ?? {};

          return  approveEnrollment(schoolId,enrollmentId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveEnrollmentMutationResult = NonNullable<Awaited<ReturnType<typeof approveEnrollment>>>
    
    export type ApproveEnrollmentMutationError = unknown

    export const useApproveEnrollment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveEnrollment>>, TError,{schoolId: string;enrollmentId: string;params?: ApproveEnrollmentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveEnrollment>>,
        TError,
        {schoolId: string;enrollmentId: string;params?: ApproveEnrollmentParams},
        TContext
      > => {

      const mutationOptions = getApproveEnrollmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getPendingEnrollments = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PendingEnrollmentResponse[]>(
      {url: `/api/v1/schools/${schoolId}/enrollments/pending`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPendingEnrollmentsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/enrollments/pending`
    ] as const;
    }

    
export const getGetPendingEnrollmentsQueryOptions = <TData = Awaited<ReturnType<typeof getPendingEnrollments>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingEnrollmentsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingEnrollments>>> = ({ signal }) => getPendingEnrollments(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingEnrollments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPendingEnrollmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingEnrollments>>>
export type GetPendingEnrollmentsQueryError = unknown


export function useGetPendingEnrollments<TData = Awaited<ReturnType<typeof getPendingEnrollments>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingEnrollments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingEnrollments>>,
          TError,
          Awaited<ReturnType<typeof getPendingEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingEnrollments<TData = Awaited<ReturnType<typeof getPendingEnrollments>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingEnrollments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingEnrollments>>,
          TError,
          Awaited<ReturnType<typeof getPendingEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingEnrollments<TData = Awaited<ReturnType<typeof getPendingEnrollments>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPendingEnrollments<TData = Awaited<ReturnType<typeof getPendingEnrollments>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPendingEnrollmentsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const manualEnroll = (
    schoolId: string,
    manualEnrollRequest: ManualEnrollRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/enrollments/manual`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: manualEnrollRequest, signal
    },
      options);
    }
  


export const getManualEnrollMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof manualEnroll>>, TError,{schoolId: string;data: ManualEnrollRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof manualEnroll>>, TError,{schoolId: string;data: ManualEnrollRequest}, TContext> => {

const mutationKey = ['manualEnroll'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof manualEnroll>>, {schoolId: string;data: ManualEnrollRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  manualEnroll(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ManualEnrollMutationResult = NonNullable<Awaited<ReturnType<typeof manualEnroll>>>
    export type ManualEnrollMutationBody = ManualEnrollRequest
    export type ManualEnrollMutationError = unknown

    export const useManualEnroll = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof manualEnroll>>, TError,{schoolId: string;data: ManualEnrollRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof manualEnroll>>,
        TError,
        {schoolId: string;data: ManualEnrollRequest},
        TContext
      > => {

      const mutationOptions = getManualEnrollMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const inviteAndEnrollStudent = (
    schoolId: string,
    inviteAndEnrollRequest: InviteAndEnrollRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/enrollments/invite-and-enroll`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteAndEnrollRequest, signal
    },
      options);
    }
  


export const getInviteAndEnrollStudentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteAndEnrollStudent>>, TError,{schoolId: string;data: InviteAndEnrollRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteAndEnrollStudent>>, TError,{schoolId: string;data: InviteAndEnrollRequest}, TContext> => {

const mutationKey = ['inviteAndEnrollStudent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteAndEnrollStudent>>, {schoolId: string;data: InviteAndEnrollRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  inviteAndEnrollStudent(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InviteAndEnrollStudentMutationResult = NonNullable<Awaited<ReturnType<typeof inviteAndEnrollStudent>>>
    export type InviteAndEnrollStudentMutationBody = InviteAndEnrollRequest
    export type InviteAndEnrollStudentMutationError = unknown

    export const useInviteAndEnrollStudent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteAndEnrollStudent>>, TError,{schoolId: string;data: InviteAndEnrollRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteAndEnrollStudent>>,
        TError,
        {schoolId: string;data: InviteAndEnrollRequest},
        TContext
      > => {

      const mutationOptions = getInviteAndEnrollStudentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const enrollStudentMonthly = (
    schoolId: string,
    scheduleId: string,
    enrollMonthlyRequest: EnrollMonthlyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/enrollments/schedule/${scheduleId}/monthly`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: enrollMonthlyRequest, signal
    },
      options);
    }
  


export const getEnrollStudentMonthlyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enrollStudentMonthly>>, TError,{schoolId: string;scheduleId: string;data: EnrollMonthlyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof enrollStudentMonthly>>, TError,{schoolId: string;scheduleId: string;data: EnrollMonthlyRequest}, TContext> => {

const mutationKey = ['enrollStudentMonthly'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enrollStudentMonthly>>, {schoolId: string;scheduleId: string;data: EnrollMonthlyRequest}> = (props) => {
          const {schoolId,scheduleId,data} = props ?? {};

          return  enrollStudentMonthly(schoolId,scheduleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EnrollStudentMonthlyMutationResult = NonNullable<Awaited<ReturnType<typeof enrollStudentMonthly>>>
    export type EnrollStudentMonthlyMutationBody = EnrollMonthlyRequest
    export type EnrollStudentMonthlyMutationError = unknown

    export const useEnrollStudentMonthly = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enrollStudentMonthly>>, TError,{schoolId: string;scheduleId: string;data: EnrollMonthlyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enrollStudentMonthly>>,
        TError,
        {schoolId: string;scheduleId: string;data: EnrollMonthlyRequest},
        TContext
      > => {

      const mutationOptions = getEnrollStudentMonthlyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const transferStudentGroup = (
    schoolId: string,
    scheduleId: string,
    studentMemberId: string,
    transferStudentGroupRequest: TransferStudentGroupRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/enrollments/schedule/${scheduleId}/students/${studentMemberId}/transfer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transferStudentGroupRequest, signal
    },
      options);
    }
  


export const getTransferStudentGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transferStudentGroup>>, TError,{schoolId: string;scheduleId: string;studentMemberId: string;data: TransferStudentGroupRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof transferStudentGroup>>, TError,{schoolId: string;scheduleId: string;studentMemberId: string;data: TransferStudentGroupRequest}, TContext> => {

const mutationKey = ['transferStudentGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transferStudentGroup>>, {schoolId: string;scheduleId: string;studentMemberId: string;data: TransferStudentGroupRequest}> = (props) => {
          const {schoolId,scheduleId,studentMemberId,data} = props ?? {};

          return  transferStudentGroup(schoolId,scheduleId,studentMemberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TransferStudentGroupMutationResult = NonNullable<Awaited<ReturnType<typeof transferStudentGroup>>>
    export type TransferStudentGroupMutationBody = TransferStudentGroupRequest
    export type TransferStudentGroupMutationError = unknown

    export const useTransferStudentGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transferStudentGroup>>, TError,{schoolId: string;scheduleId: string;studentMemberId: string;data: TransferStudentGroupRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof transferStudentGroup>>,
        TError,
        {schoolId: string;scheduleId: string;studentMemberId: string;data: TransferStudentGroupRequest},
        TContext
      > => {

      const mutationOptions = getTransferStudentGroupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const unenrollStudentGroup = (
    schoolId: string,
    scheduleId: string,
    studentMemberId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/enrollments/schedule/${scheduleId}/students/${studentMemberId}/unenroll`, method: 'POST', signal
    },
      options);
    }
  


export const getUnenrollStudentGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unenrollStudentGroup>>, TError,{schoolId: string;scheduleId: string;studentMemberId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unenrollStudentGroup>>, TError,{schoolId: string;scheduleId: string;studentMemberId: string}, TContext> => {

const mutationKey = ['unenrollStudentGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unenrollStudentGroup>>, {schoolId: string;scheduleId: string;studentMemberId: string}> = (props) => {
          const {schoolId,scheduleId,studentMemberId} = props ?? {};

          return  unenrollStudentGroup(schoolId,scheduleId,studentMemberId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnenrollStudentGroupMutationResult = NonNullable<Awaited<ReturnType<typeof unenrollStudentGroup>>>
    
    export type UnenrollStudentGroupMutationError = unknown

    export const useUnenrollStudentGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unenrollStudentGroup>>, TError,{schoolId: string;scheduleId: string;studentMemberId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unenrollStudentGroup>>,
        TError,
        {schoolId: string;scheduleId: string;studentMemberId: string},
        TContext
      > => {

      const mutationOptions = getUnenrollStudentGroupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const bulkTransferStudentGroup = (
    schoolId: string,
    scheduleId: string,
    bulkTransferStudentGroupRequest: BulkTransferStudentGroupRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/enrollments/schedule/${scheduleId}/transfer-bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkTransferStudentGroupRequest, signal
    },
      options);
    }
  


export const getBulkTransferStudentGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkTransferStudentGroup>>, TError,{schoolId: string;scheduleId: string;data: BulkTransferStudentGroupRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkTransferStudentGroup>>, TError,{schoolId: string;scheduleId: string;data: BulkTransferStudentGroupRequest}, TContext> => {

const mutationKey = ['bulkTransferStudentGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkTransferStudentGroup>>, {schoolId: string;scheduleId: string;data: BulkTransferStudentGroupRequest}> = (props) => {
          const {schoolId,scheduleId,data} = props ?? {};

          return  bulkTransferStudentGroup(schoolId,scheduleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkTransferStudentGroupMutationResult = NonNullable<Awaited<ReturnType<typeof bulkTransferStudentGroup>>>
    export type BulkTransferStudentGroupMutationBody = BulkTransferStudentGroupRequest
    export type BulkTransferStudentGroupMutationError = unknown

    export const useBulkTransferStudentGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkTransferStudentGroup>>, TError,{schoolId: string;scheduleId: string;data: BulkTransferStudentGroupRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkTransferStudentGroup>>,
        TError,
        {schoolId: string;scheduleId: string;data: BulkTransferStudentGroupRequest},
        TContext
      > => {

      const mutationOptions = getBulkTransferStudentGroupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listEnrollmentsForSession = (
    schoolId: string,
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/enrollments/session/${sessionId}`, method: 'GET', signal
    },
      options);
    }
  



export const getListEnrollmentsForSessionQueryKey = (schoolId?: string,
    sessionId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/enrollments/session/${sessionId}`
    ] as const;
    }

    
export const getListEnrollmentsForSessionQueryOptions = <TData = Awaited<ReturnType<typeof listEnrollmentsForSession>>, TError = unknown>(schoolId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrollmentsForSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEnrollmentsForSessionQueryKey(schoolId,sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEnrollmentsForSession>>> = ({ signal }) => listEnrollmentsForSession(schoolId,sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEnrollmentsForSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEnrollmentsForSessionQueryResult = NonNullable<Awaited<ReturnType<typeof listEnrollmentsForSession>>>
export type ListEnrollmentsForSessionQueryError = unknown


export function useListEnrollmentsForSession<TData = Awaited<ReturnType<typeof listEnrollmentsForSession>>, TError = unknown>(
 schoolId: string,
    sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrollmentsForSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEnrollmentsForSession>>,
          TError,
          Awaited<ReturnType<typeof listEnrollmentsForSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEnrollmentsForSession<TData = Awaited<ReturnType<typeof listEnrollmentsForSession>>, TError = unknown>(
 schoolId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrollmentsForSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEnrollmentsForSession>>,
          TError,
          Awaited<ReturnType<typeof listEnrollmentsForSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEnrollmentsForSession<TData = Awaited<ReturnType<typeof listEnrollmentsForSession>>, TError = unknown>(
 schoolId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrollmentsForSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListEnrollmentsForSession<TData = Awaited<ReturnType<typeof listEnrollmentsForSession>>, TError = unknown>(
 schoolId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrollmentsForSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEnrollmentsForSessionQueryOptions(schoolId,sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listStudentEnrollments = (
    schoolId: string,
    studentMemberId: string,
    params?: ListStudentEnrollmentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EnrollmentListResponse>(
      {url: `/api/v1/schools/${schoolId}/enrollments/student/${studentMemberId}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListStudentEnrollmentsQueryKey = (schoolId?: string,
    studentMemberId?: string,
    params?: ListStudentEnrollmentsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/enrollments/student/${studentMemberId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListStudentEnrollmentsQueryOptions = <TData = Awaited<ReturnType<typeof listStudentEnrollments>>, TError = unknown>(schoolId: string,
    studentMemberId: string,
    params?: ListStudentEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStudentEnrollmentsQueryKey(schoolId,studentMemberId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStudentEnrollments>>> = ({ signal }) => listStudentEnrollments(schoolId,studentMemberId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && studentMemberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStudentEnrollments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStudentEnrollmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listStudentEnrollments>>>
export type ListStudentEnrollmentsQueryError = unknown


export function useListStudentEnrollments<TData = Awaited<ReturnType<typeof listStudentEnrollments>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string,
    params: undefined |  ListStudentEnrollmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentEnrollments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStudentEnrollments>>,
          TError,
          Awaited<ReturnType<typeof listStudentEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStudentEnrollments<TData = Awaited<ReturnType<typeof listStudentEnrollments>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string,
    params?: ListStudentEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentEnrollments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStudentEnrollments>>,
          TError,
          Awaited<ReturnType<typeof listStudentEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStudentEnrollments<TData = Awaited<ReturnType<typeof listStudentEnrollments>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string,
    params?: ListStudentEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListStudentEnrollments<TData = Awaited<ReturnType<typeof listStudentEnrollments>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string,
    params?: ListStudentEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStudentEnrollmentsQueryOptions(schoolId,studentMemberId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listMyEnrollments = (
    schoolId: string,
    params?: ListMyEnrollmentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/enrollments/student/me`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListMyEnrollmentsQueryKey = (schoolId?: string,
    params?: ListMyEnrollmentsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/enrollments/student/me`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListMyEnrollmentsQueryOptions = <TData = Awaited<ReturnType<typeof listMyEnrollments>>, TError = unknown>(schoolId: string,
    params?: ListMyEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyEnrollmentsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyEnrollments>>> = ({ signal }) => listMyEnrollments(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyEnrollments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMyEnrollmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyEnrollments>>>
export type ListMyEnrollmentsQueryError = unknown


export function useListMyEnrollments<TData = Awaited<ReturnType<typeof listMyEnrollments>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListMyEnrollmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyEnrollments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyEnrollments>>,
          TError,
          Awaited<ReturnType<typeof listMyEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyEnrollments<TData = Awaited<ReturnType<typeof listMyEnrollments>>, TError = unknown>(
 schoolId: string,
    params?: ListMyEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyEnrollments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyEnrollments>>,
          TError,
          Awaited<ReturnType<typeof listMyEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyEnrollments<TData = Awaited<ReturnType<typeof listMyEnrollments>>, TError = unknown>(
 schoolId: string,
    params?: ListMyEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListMyEnrollments<TData = Awaited<ReturnType<typeof listMyEnrollments>>, TError = unknown>(
 schoolId: string,
    params?: ListMyEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyEnrollmentsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const cancelEnrollment = (
    schoolId: string,
    enrollmentId: string,
    params?: CancelEnrollmentParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/enrollments/${enrollmentId}`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getCancelEnrollmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEnrollment>>, TError,{schoolId: string;enrollmentId: string;params?: CancelEnrollmentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelEnrollment>>, TError,{schoolId: string;enrollmentId: string;params?: CancelEnrollmentParams}, TContext> => {

const mutationKey = ['cancelEnrollment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelEnrollment>>, {schoolId: string;enrollmentId: string;params?: CancelEnrollmentParams}> = (props) => {
          const {schoolId,enrollmentId,params} = props ?? {};

          return  cancelEnrollment(schoolId,enrollmentId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelEnrollmentMutationResult = NonNullable<Awaited<ReturnType<typeof cancelEnrollment>>>
    
    export type CancelEnrollmentMutationError = unknown

    export const useCancelEnrollment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEnrollment>>, TError,{schoolId: string;enrollmentId: string;params?: CancelEnrollmentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelEnrollment>>,
        TError,
        {schoolId: string;enrollmentId: string;params?: CancelEnrollmentParams},
        TContext
      > => {

      const mutationOptions = getCancelEnrollmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const transferSession = (
    schoolId: string,
    enrollmentId: string,
    transferSessionRequest: TransferSessionRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/enrollments/${enrollmentId}/transfer-session`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transferSessionRequest, signal
    },
      options);
    }
  


export const getTransferSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transferSession>>, TError,{schoolId: string;enrollmentId: string;data: TransferSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof transferSession>>, TError,{schoolId: string;enrollmentId: string;data: TransferSessionRequest}, TContext> => {

const mutationKey = ['transferSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transferSession>>, {schoolId: string;enrollmentId: string;data: TransferSessionRequest}> = (props) => {
          const {schoolId,enrollmentId,data} = props ?? {};

          return  transferSession(schoolId,enrollmentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TransferSessionMutationResult = NonNullable<Awaited<ReturnType<typeof transferSession>>>
    export type TransferSessionMutationBody = TransferSessionRequest
    export type TransferSessionMutationError = unknown

    export const useTransferSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transferSession>>, TError,{schoolId: string;enrollmentId: string;data: TransferSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof transferSession>>,
        TError,
        {schoolId: string;enrollmentId: string;data: TransferSessionRequest},
        TContext
      > => {

      const mutationOptions = getTransferSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const markAttendance = (
    schoolId: string,
    markAttendanceRequest: MarkAttendanceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/attendance/mark`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: markAttendanceRequest, signal
    },
      options);
    }
  


export const getMarkAttendanceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAttendance>>, TError,{schoolId: string;data: MarkAttendanceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markAttendance>>, TError,{schoolId: string;data: MarkAttendanceRequest}, TContext> => {

const mutationKey = ['markAttendance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAttendance>>, {schoolId: string;data: MarkAttendanceRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  markAttendance(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkAttendanceMutationResult = NonNullable<Awaited<ReturnType<typeof markAttendance>>>
    export type MarkAttendanceMutationBody = MarkAttendanceRequest
    export type MarkAttendanceMutationError = unknown

    export const useMarkAttendance = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAttendance>>, TError,{schoolId: string;data: MarkAttendanceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markAttendance>>,
        TError,
        {schoolId: string;data: MarkAttendanceRequest},
        TContext
      > => {

      const mutationOptions = getMarkAttendanceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteAttendance = (
    schoolId: string,
    enrollmentId: string,
    params?: DeleteAttendanceParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/attendance/${enrollmentId}`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteAttendanceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttendance>>, TError,{schoolId: string;enrollmentId: string;params?: DeleteAttendanceParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAttendance>>, TError,{schoolId: string;enrollmentId: string;params?: DeleteAttendanceParams}, TContext> => {

const mutationKey = ['deleteAttendance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAttendance>>, {schoolId: string;enrollmentId: string;params?: DeleteAttendanceParams}> = (props) => {
          const {schoolId,enrollmentId,params} = props ?? {};

          return  deleteAttendance(schoolId,enrollmentId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAttendanceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAttendance>>>
    
    export type DeleteAttendanceMutationError = unknown

    export const useDeleteAttendance = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttendance>>, TError,{schoolId: string;enrollmentId: string;params?: DeleteAttendanceParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAttendance>>,
        TError,
        {schoolId: string;enrollmentId: string;params?: DeleteAttendanceParams},
        TContext
      > => {

      const mutationOptions = getDeleteAttendanceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const bulkMarkAttendance = (
    schoolId: string,
    bulkMarkAttendanceRequest: BulkMarkAttendanceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AttendanceSyncResult[]>(
      {url: `/api/v1/schools/${schoolId}/attendance/bulk-mark`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkMarkAttendanceRequest, signal
    },
      options);
    }
  


export const getBulkMarkAttendanceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkMarkAttendance>>, TError,{schoolId: string;data: BulkMarkAttendanceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkMarkAttendance>>, TError,{schoolId: string;data: BulkMarkAttendanceRequest}, TContext> => {

const mutationKey = ['bulkMarkAttendance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkMarkAttendance>>, {schoolId: string;data: BulkMarkAttendanceRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  bulkMarkAttendance(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkMarkAttendanceMutationResult = NonNullable<Awaited<ReturnType<typeof bulkMarkAttendance>>>
    export type BulkMarkAttendanceMutationBody = BulkMarkAttendanceRequest
    export type BulkMarkAttendanceMutationError = unknown

    export const useBulkMarkAttendance = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkMarkAttendance>>, TError,{schoolId: string;data: BulkMarkAttendanceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkMarkAttendance>>,
        TError,
        {schoolId: string;data: BulkMarkAttendanceRequest},
        TContext
      > => {

      const mutationOptions = getBulkMarkAttendanceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAttendanceForSession = (
    schoolId: string,
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/attendance/session/${sessionId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAttendanceForSessionQueryKey = (schoolId?: string,
    sessionId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/attendance/session/${sessionId}`
    ] as const;
    }

    
export const getGetAttendanceForSessionQueryOptions = <TData = Awaited<ReturnType<typeof getAttendanceForSession>>, TError = unknown>(schoolId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttendanceForSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttendanceForSessionQueryKey(schoolId,sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttendanceForSession>>> = ({ signal }) => getAttendanceForSession(schoolId,sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttendanceForSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttendanceForSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getAttendanceForSession>>>
export type GetAttendanceForSessionQueryError = unknown


export function useGetAttendanceForSession<TData = Awaited<ReturnType<typeof getAttendanceForSession>>, TError = unknown>(
 schoolId: string,
    sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttendanceForSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttendanceForSession>>,
          TError,
          Awaited<ReturnType<typeof getAttendanceForSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttendanceForSession<TData = Awaited<ReturnType<typeof getAttendanceForSession>>, TError = unknown>(
 schoolId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttendanceForSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttendanceForSession>>,
          TError,
          Awaited<ReturnType<typeof getAttendanceForSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttendanceForSession<TData = Awaited<ReturnType<typeof getAttendanceForSession>>, TError = unknown>(
 schoolId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttendanceForSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAttendanceForSession<TData = Awaited<ReturnType<typeof getAttendanceForSession>>, TError = unknown>(
 schoolId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttendanceForSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAttendanceForSessionQueryOptions(schoolId,sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const confirmAttendance = (
    schoolId: string,
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/attendance/session/${sessionId}/confirm`, method: 'POST', signal
    },
      options);
    }
  


export const getConfirmAttendanceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmAttendance>>, TError,{schoolId: string;sessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmAttendance>>, TError,{schoolId: string;sessionId: string}, TContext> => {

const mutationKey = ['confirmAttendance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmAttendance>>, {schoolId: string;sessionId: string}> = (props) => {
          const {schoolId,sessionId} = props ?? {};

          return  confirmAttendance(schoolId,sessionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmAttendanceMutationResult = NonNullable<Awaited<ReturnType<typeof confirmAttendance>>>
    
    export type ConfirmAttendanceMutationError = unknown

    export const useConfirmAttendance = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmAttendance>>, TError,{schoolId: string;sessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmAttendance>>,
        TError,
        {schoolId: string;sessionId: string},
        TContext
      > => {

      const mutationOptions = getConfirmAttendanceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const enrollStudentGroup = (
    schoolId: string,
    enrollStudentGroupRequest: EnrollStudentGroupRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/enrollments/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: enrollStudentGroupRequest, signal
    },
      options);
    }
  


export const getEnrollStudentGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enrollStudentGroup>>, TError,{schoolId: string;data: EnrollStudentGroupRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof enrollStudentGroup>>, TError,{schoolId: string;data: EnrollStudentGroupRequest}, TContext> => {

const mutationKey = ['enrollStudentGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enrollStudentGroup>>, {schoolId: string;data: EnrollStudentGroupRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  enrollStudentGroup(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EnrollStudentGroupMutationResult = NonNullable<Awaited<ReturnType<typeof enrollStudentGroup>>>
    export type EnrollStudentGroupMutationBody = EnrollStudentGroupRequest
    export type EnrollStudentGroupMutationError = unknown

    export const useEnrollStudentGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enrollStudentGroup>>, TError,{schoolId: string;data: EnrollStudentGroupRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enrollStudentGroup>>,
        TError,
        {schoolId: string;data: EnrollStudentGroupRequest},
        TContext
      > => {

      const mutationOptions = getEnrollStudentGroupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const resignStudentGroup = (
    schoolId: string,
    resignStudentGroupRequest: ResignStudentGroupRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/enrollments/groups/resign`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resignStudentGroupRequest, signal
    },
      options);
    }
  


export const getResignStudentGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resignStudentGroup>>, TError,{schoolId: string;data: ResignStudentGroupRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resignStudentGroup>>, TError,{schoolId: string;data: ResignStudentGroupRequest}, TContext> => {

const mutationKey = ['resignStudentGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resignStudentGroup>>, {schoolId: string;data: ResignStudentGroupRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  resignStudentGroup(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResignStudentGroupMutationResult = NonNullable<Awaited<ReturnType<typeof resignStudentGroup>>>
    export type ResignStudentGroupMutationBody = ResignStudentGroupRequest
    export type ResignStudentGroupMutationError = unknown

    export const useResignStudentGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resignStudentGroup>>, TError,{schoolId: string;data: ResignStudentGroupRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resignStudentGroup>>,
        TError,
        {schoolId: string;data: ResignStudentGroupRequest},
        TContext
      > => {

      const mutationOptions = getResignStudentGroupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateSubscriptionEndDate = (
    schoolId: string,
    updateSubscriptionEndDateRequest: UpdateSubscriptionEndDateRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/enrollments/groups/end-date`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateSubscriptionEndDateRequest, signal
    },
      options);
    }
  


export const getUpdateSubscriptionEndDateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSubscriptionEndDate>>, TError,{schoolId: string;data: UpdateSubscriptionEndDateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSubscriptionEndDate>>, TError,{schoolId: string;data: UpdateSubscriptionEndDateRequest}, TContext> => {

const mutationKey = ['updateSubscriptionEndDate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSubscriptionEndDate>>, {schoolId: string;data: UpdateSubscriptionEndDateRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  updateSubscriptionEndDate(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSubscriptionEndDateMutationResult = NonNullable<Awaited<ReturnType<typeof updateSubscriptionEndDate>>>
    export type UpdateSubscriptionEndDateMutationBody = UpdateSubscriptionEndDateRequest
    export type UpdateSubscriptionEndDateMutationError = unknown

    export const useUpdateSubscriptionEndDate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSubscriptionEndDate>>, TError,{schoolId: string;data: UpdateSubscriptionEndDateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSubscriptionEndDate>>,
        TError,
        {schoolId: string;data: UpdateSubscriptionEndDateRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSubscriptionEndDateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const transferStudentGroupNextMonth = (
    schoolId: string,
    transferStudentGroupNextMonthRequest: TransferStudentGroupNextMonthRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/enrollments/groups/transfer-next-month`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transferStudentGroupNextMonthRequest, signal
    },
      options);
    }
  


export const getTransferStudentGroupNextMonthMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transferStudentGroupNextMonth>>, TError,{schoolId: string;data: TransferStudentGroupNextMonthRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof transferStudentGroupNextMonth>>, TError,{schoolId: string;data: TransferStudentGroupNextMonthRequest}, TContext> => {

const mutationKey = ['transferStudentGroupNextMonth'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transferStudentGroupNextMonth>>, {schoolId: string;data: TransferStudentGroupNextMonthRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  transferStudentGroupNextMonth(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TransferStudentGroupNextMonthMutationResult = NonNullable<Awaited<ReturnType<typeof transferStudentGroupNextMonth>>>
    export type TransferStudentGroupNextMonthMutationBody = TransferStudentGroupNextMonthRequest
    export type TransferStudentGroupNextMonthMutationError = unknown

    export const useTransferStudentGroupNextMonth = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transferStudentGroupNextMonth>>, TError,{schoolId: string;data: TransferStudentGroupNextMonthRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof transferStudentGroupNextMonth>>,
        TError,
        {schoolId: string;data: TransferStudentGroupNextMonthRequest},
        TContext
      > => {

      const mutationOptions = getTransferStudentGroupNextMonthMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getScheduleEnrollmentsBySchedule = (
    schoolId: string,
    scheduleId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ScheduleEnrollmentResponse[]>(
      {url: `/api/v1/schools/${schoolId}/enrollments/groups/schedule/${scheduleId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetScheduleEnrollmentsByScheduleQueryKey = (schoolId?: string,
    scheduleId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/enrollments/groups/schedule/${scheduleId}`
    ] as const;
    }

    
export const getGetScheduleEnrollmentsByScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>, TError = unknown>(schoolId: string,
    scheduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScheduleEnrollmentsByScheduleQueryKey(schoolId,scheduleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>> = ({ signal }) => getScheduleEnrollmentsBySchedule(schoolId,scheduleId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && scheduleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScheduleEnrollmentsByScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>>
export type GetScheduleEnrollmentsByScheduleQueryError = unknown


export function useGetScheduleEnrollmentsBySchedule<TData = Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>, TError = unknown>(
 schoolId: string,
    scheduleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>,
          TError,
          Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduleEnrollmentsBySchedule<TData = Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>, TError = unknown>(
 schoolId: string,
    scheduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>,
          TError,
          Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduleEnrollmentsBySchedule<TData = Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>, TError = unknown>(
 schoolId: string,
    scheduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetScheduleEnrollmentsBySchedule<TData = Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>, TError = unknown>(
 schoolId: string,
    scheduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleEnrollmentsBySchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScheduleEnrollmentsByScheduleQueryOptions(schoolId,scheduleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getScheduleEnrollmentsByStudent = (
    schoolId: string,
    studentMemberId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ScheduleEnrollmentResponse[]>(
      {url: `/api/v1/schools/${schoolId}/enrollments/groups/student/${studentMemberId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetScheduleEnrollmentsByStudentQueryKey = (schoolId?: string,
    studentMemberId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/enrollments/groups/student/${studentMemberId}`
    ] as const;
    }

    
export const getGetScheduleEnrollmentsByStudentQueryOptions = <TData = Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>, TError = unknown>(schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScheduleEnrollmentsByStudentQueryKey(schoolId,studentMemberId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>> = ({ signal }) => getScheduleEnrollmentsByStudent(schoolId,studentMemberId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && studentMemberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScheduleEnrollmentsByStudentQueryResult = NonNullable<Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>>
export type GetScheduleEnrollmentsByStudentQueryError = unknown


export function useGetScheduleEnrollmentsByStudent<TData = Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>,
          TError,
          Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduleEnrollmentsByStudent<TData = Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>,
          TError,
          Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduleEnrollmentsByStudent<TData = Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetScheduleEnrollmentsByStudent<TData = Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleEnrollmentsByStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScheduleEnrollmentsByStudentQueryOptions(schoolId,studentMemberId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createSubscriptionSuspension = (
    schoolId: string,
    studentMemberId: string,
    scheduleId: string,
    createSubscriptionSuspensionRequest: CreateSubscriptionSuspensionRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SubscriptionSuspensionResponse>(
      {url: `/api/v1/schools/${schoolId}/suspensions/students/${studentMemberId}/schedules/${scheduleId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSubscriptionSuspensionRequest, signal
    },
      options);
    }
  


export const getCreateSubscriptionSuspensionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionSuspension>>, TError,{schoolId: string;studentMemberId: string;scheduleId: string;data: CreateSubscriptionSuspensionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionSuspension>>, TError,{schoolId: string;studentMemberId: string;scheduleId: string;data: CreateSubscriptionSuspensionRequest}, TContext> => {

const mutationKey = ['createSubscriptionSuspension'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSubscriptionSuspension>>, {schoolId: string;studentMemberId: string;scheduleId: string;data: CreateSubscriptionSuspensionRequest}> = (props) => {
          const {schoolId,studentMemberId,scheduleId,data} = props ?? {};

          return  createSubscriptionSuspension(schoolId,studentMemberId,scheduleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSubscriptionSuspensionMutationResult = NonNullable<Awaited<ReturnType<typeof createSubscriptionSuspension>>>
    export type CreateSubscriptionSuspensionMutationBody = CreateSubscriptionSuspensionRequest
    export type CreateSubscriptionSuspensionMutationError = unknown

    export const useCreateSubscriptionSuspension = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionSuspension>>, TError,{schoolId: string;studentMemberId: string;scheduleId: string;data: CreateSubscriptionSuspensionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSubscriptionSuspension>>,
        TError,
        {schoolId: string;studentMemberId: string;scheduleId: string;data: CreateSubscriptionSuspensionRequest},
        TContext
      > => {

      const mutationOptions = getCreateSubscriptionSuspensionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateSubscriptionSuspension = (
    schoolId: string,
    suspensionId: string,
    updateSubscriptionSuspensionRequest: UpdateSubscriptionSuspensionRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SubscriptionSuspensionResponse>(
      {url: `/api/v1/schools/${schoolId}/suspensions/${suspensionId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSubscriptionSuspensionRequest
    },
      options);
    }
  


export const getUpdateSubscriptionSuspensionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSubscriptionSuspension>>, TError,{schoolId: string;suspensionId: string;data: UpdateSubscriptionSuspensionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSubscriptionSuspension>>, TError,{schoolId: string;suspensionId: string;data: UpdateSubscriptionSuspensionRequest}, TContext> => {

const mutationKey = ['updateSubscriptionSuspension'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSubscriptionSuspension>>, {schoolId: string;suspensionId: string;data: UpdateSubscriptionSuspensionRequest}> = (props) => {
          const {schoolId,suspensionId,data} = props ?? {};

          return  updateSubscriptionSuspension(schoolId,suspensionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSubscriptionSuspensionMutationResult = NonNullable<Awaited<ReturnType<typeof updateSubscriptionSuspension>>>
    export type UpdateSubscriptionSuspensionMutationBody = UpdateSubscriptionSuspensionRequest
    export type UpdateSubscriptionSuspensionMutationError = unknown

    export const useUpdateSubscriptionSuspension = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSubscriptionSuspension>>, TError,{schoolId: string;suspensionId: string;data: UpdateSubscriptionSuspensionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSubscriptionSuspension>>,
        TError,
        {schoolId: string;suspensionId: string;data: UpdateSubscriptionSuspensionRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSubscriptionSuspensionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const cancelSubscriptionSuspension = (
    schoolId: string,
    suspensionId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/suspensions/${suspensionId}`, method: 'DELETE'
    },
      options);
    }
  


export const getCancelSubscriptionSuspensionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSubscriptionSuspension>>, TError,{schoolId: string;suspensionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelSubscriptionSuspension>>, TError,{schoolId: string;suspensionId: string}, TContext> => {

const mutationKey = ['cancelSubscriptionSuspension'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelSubscriptionSuspension>>, {schoolId: string;suspensionId: string}> = (props) => {
          const {schoolId,suspensionId} = props ?? {};

          return  cancelSubscriptionSuspension(schoolId,suspensionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelSubscriptionSuspensionMutationResult = NonNullable<Awaited<ReturnType<typeof cancelSubscriptionSuspension>>>
    
    export type CancelSubscriptionSuspensionMutationError = unknown

    export const useCancelSubscriptionSuspension = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSubscriptionSuspension>>, TError,{schoolId: string;suspensionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelSubscriptionSuspension>>,
        TError,
        {schoolId: string;suspensionId: string},
        TContext
      > => {

      const mutationOptions = getCancelSubscriptionSuspensionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getSuspensionsByStudent = (
    schoolId: string,
    studentMemberId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SubscriptionSuspensionResponse[]>(
      {url: `/api/v1/schools/${schoolId}/suspensions/student/${studentMemberId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSuspensionsByStudentQueryKey = (schoolId?: string,
    studentMemberId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/suspensions/student/${studentMemberId}`
    ] as const;
    }

    
export const getGetSuspensionsByStudentQueryOptions = <TData = Awaited<ReturnType<typeof getSuspensionsByStudent>>, TError = unknown>(schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspensionsByStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSuspensionsByStudentQueryKey(schoolId,studentMemberId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuspensionsByStudent>>> = ({ signal }) => getSuspensionsByStudent(schoolId,studentMemberId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && studentMemberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSuspensionsByStudent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuspensionsByStudentQueryResult = NonNullable<Awaited<ReturnType<typeof getSuspensionsByStudent>>>
export type GetSuspensionsByStudentQueryError = unknown


export function useGetSuspensionsByStudent<TData = Awaited<ReturnType<typeof getSuspensionsByStudent>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspensionsByStudent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuspensionsByStudent>>,
          TError,
          Awaited<ReturnType<typeof getSuspensionsByStudent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuspensionsByStudent<TData = Awaited<ReturnType<typeof getSuspensionsByStudent>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspensionsByStudent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuspensionsByStudent>>,
          TError,
          Awaited<ReturnType<typeof getSuspensionsByStudent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuspensionsByStudent<TData = Awaited<ReturnType<typeof getSuspensionsByStudent>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspensionsByStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSuspensionsByStudent<TData = Awaited<ReturnType<typeof getSuspensionsByStudent>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspensionsByStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSuspensionsByStudentQueryOptions(schoolId,studentMemberId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getSuspensionsBySchedule = (
    schoolId: string,
    scheduleId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SubscriptionSuspensionResponse[]>(
      {url: `/api/v1/schools/${schoolId}/suspensions/schedule/${scheduleId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSuspensionsByScheduleQueryKey = (schoolId?: string,
    scheduleId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/suspensions/schedule/${scheduleId}`
    ] as const;
    }

    
export const getGetSuspensionsByScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getSuspensionsBySchedule>>, TError = unknown>(schoolId: string,
    scheduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspensionsBySchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSuspensionsByScheduleQueryKey(schoolId,scheduleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuspensionsBySchedule>>> = ({ signal }) => getSuspensionsBySchedule(schoolId,scheduleId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && scheduleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSuspensionsBySchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuspensionsByScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getSuspensionsBySchedule>>>
export type GetSuspensionsByScheduleQueryError = unknown


export function useGetSuspensionsBySchedule<TData = Awaited<ReturnType<typeof getSuspensionsBySchedule>>, TError = unknown>(
 schoolId: string,
    scheduleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspensionsBySchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuspensionsBySchedule>>,
          TError,
          Awaited<ReturnType<typeof getSuspensionsBySchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuspensionsBySchedule<TData = Awaited<ReturnType<typeof getSuspensionsBySchedule>>, TError = unknown>(
 schoolId: string,
    scheduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspensionsBySchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuspensionsBySchedule>>,
          TError,
          Awaited<ReturnType<typeof getSuspensionsBySchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuspensionsBySchedule<TData = Awaited<ReturnType<typeof getSuspensionsBySchedule>>, TError = unknown>(
 schoolId: string,
    scheduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspensionsBySchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSuspensionsBySchedule<TData = Awaited<ReturnType<typeof getSuspensionsBySchedule>>, TError = unknown>(
 schoolId: string,
    scheduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspensionsBySchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSuspensionsByScheduleQueryOptions(schoolId,scheduleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const joinWaitlist = (
    schoolId: string,
    joinWaitlistRequest: JoinWaitlistRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/waitlist`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: joinWaitlistRequest, signal
    },
      options);
    }
  


export const getJoinWaitlistMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinWaitlist>>, TError,{schoolId: string;data: JoinWaitlistRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof joinWaitlist>>, TError,{schoolId: string;data: JoinWaitlistRequest}, TContext> => {

const mutationKey = ['joinWaitlist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinWaitlist>>, {schoolId: string;data: JoinWaitlistRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  joinWaitlist(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type JoinWaitlistMutationResult = NonNullable<Awaited<ReturnType<typeof joinWaitlist>>>
    export type JoinWaitlistMutationBody = JoinWaitlistRequest
    export type JoinWaitlistMutationError = unknown

    export const useJoinWaitlist = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinWaitlist>>, TError,{schoolId: string;data: JoinWaitlistRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof joinWaitlist>>,
        TError,
        {schoolId: string;data: JoinWaitlistRequest},
        TContext
      > => {

      const mutationOptions = getJoinWaitlistMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const queryWaitlists = (
    schoolId: string,
    params?: QueryWaitlistsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/waitlist`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getQueryWaitlistsQueryKey = (schoolId?: string,
    params?: QueryWaitlistsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/waitlist`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getQueryWaitlistsQueryOptions = <TData = Awaited<ReturnType<typeof queryWaitlists>>, TError = unknown>(schoolId: string,
    params?: QueryWaitlistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queryWaitlists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueryWaitlistsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof queryWaitlists>>> = ({ signal }) => queryWaitlists(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queryWaitlists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueryWaitlistsQueryResult = NonNullable<Awaited<ReturnType<typeof queryWaitlists>>>
export type QueryWaitlistsQueryError = unknown


export function useQueryWaitlists<TData = Awaited<ReturnType<typeof queryWaitlists>>, TError = unknown>(
 schoolId: string,
    params: undefined |  QueryWaitlistsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queryWaitlists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryWaitlists>>,
          TError,
          Awaited<ReturnType<typeof queryWaitlists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueryWaitlists<TData = Awaited<ReturnType<typeof queryWaitlists>>, TError = unknown>(
 schoolId: string,
    params?: QueryWaitlistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queryWaitlists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryWaitlists>>,
          TError,
          Awaited<ReturnType<typeof queryWaitlists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueryWaitlists<TData = Awaited<ReturnType<typeof queryWaitlists>>, TError = unknown>(
 schoolId: string,
    params?: QueryWaitlistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queryWaitlists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueryWaitlists<TData = Awaited<ReturnType<typeof queryWaitlists>>, TError = unknown>(
 schoolId: string,
    params?: QueryWaitlistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queryWaitlists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueryWaitlistsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listMyWaitlists = (
    schoolId: string,
    params?: ListMyWaitlistsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/waitlist/student/me`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListMyWaitlistsQueryKey = (schoolId?: string,
    params?: ListMyWaitlistsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/waitlist/student/me`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListMyWaitlistsQueryOptions = <TData = Awaited<ReturnType<typeof listMyWaitlists>>, TError = unknown>(schoolId: string,
    params?: ListMyWaitlistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyWaitlists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyWaitlistsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyWaitlists>>> = ({ signal }) => listMyWaitlists(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyWaitlists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMyWaitlistsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyWaitlists>>>
export type ListMyWaitlistsQueryError = unknown


export function useListMyWaitlists<TData = Awaited<ReturnType<typeof listMyWaitlists>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListMyWaitlistsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyWaitlists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyWaitlists>>,
          TError,
          Awaited<ReturnType<typeof listMyWaitlists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyWaitlists<TData = Awaited<ReturnType<typeof listMyWaitlists>>, TError = unknown>(
 schoolId: string,
    params?: ListMyWaitlistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyWaitlists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyWaitlists>>,
          TError,
          Awaited<ReturnType<typeof listMyWaitlists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyWaitlists<TData = Awaited<ReturnType<typeof listMyWaitlists>>, TError = unknown>(
 schoolId: string,
    params?: ListMyWaitlistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyWaitlists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListMyWaitlists<TData = Awaited<ReturnType<typeof listMyWaitlists>>, TError = unknown>(
 schoolId: string,
    params?: ListMyWaitlistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyWaitlists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyWaitlistsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateWaitlistExpiry = (
    schoolId: string,
    id: string,
    updateWaitlistExpiryRequest: UpdateWaitlistExpiryRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/waitlist/${id}/expiry`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateWaitlistExpiryRequest
    },
      options);
    }
  


export const getUpdateWaitlistExpiryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWaitlistExpiry>>, TError,{schoolId: string;id: string;data: UpdateWaitlistExpiryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWaitlistExpiry>>, TError,{schoolId: string;id: string;data: UpdateWaitlistExpiryRequest}, TContext> => {

const mutationKey = ['updateWaitlistExpiry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWaitlistExpiry>>, {schoolId: string;id: string;data: UpdateWaitlistExpiryRequest}> = (props) => {
          const {schoolId,id,data} = props ?? {};

          return  updateWaitlistExpiry(schoolId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWaitlistExpiryMutationResult = NonNullable<Awaited<ReturnType<typeof updateWaitlistExpiry>>>
    export type UpdateWaitlistExpiryMutationBody = UpdateWaitlistExpiryRequest
    export type UpdateWaitlistExpiryMutationError = unknown

    export const useUpdateWaitlistExpiry = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWaitlistExpiry>>, TError,{schoolId: string;id: string;data: UpdateWaitlistExpiryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWaitlistExpiry>>,
        TError,
        {schoolId: string;id: string;data: UpdateWaitlistExpiryRequest},
        TContext
      > => {

      const mutationOptions = getUpdateWaitlistExpiryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const cancelWaitlist = (
    schoolId: string,
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/waitlist/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getCancelWaitlistMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelWaitlist>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelWaitlist>>, TError,{schoolId: string;id: string}, TContext> => {

const mutationKey = ['cancelWaitlist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelWaitlist>>, {schoolId: string;id: string}> = (props) => {
          const {schoolId,id} = props ?? {};

          return  cancelWaitlist(schoolId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelWaitlistMutationResult = NonNullable<Awaited<ReturnType<typeof cancelWaitlist>>>
    
    export type CancelWaitlistMutationError = unknown

    export const useCancelWaitlist = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelWaitlist>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelWaitlist>>,
        TError,
        {schoolId: string;id: string},
        TContext
      > => {

      const mutationOptions = getCancelWaitlistMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const promoteWaitlistEntry = (
    schoolId: string,
    id: string,
    params?: PromoteWaitlistEntryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/waitlist/${id}/promote`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPromoteWaitlistEntryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteWaitlistEntry>>, TError,{schoolId: string;id: string;params?: PromoteWaitlistEntryParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof promoteWaitlistEntry>>, TError,{schoolId: string;id: string;params?: PromoteWaitlistEntryParams}, TContext> => {

const mutationKey = ['promoteWaitlistEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof promoteWaitlistEntry>>, {schoolId: string;id: string;params?: PromoteWaitlistEntryParams}> = (props) => {
          const {schoolId,id,params} = props ?? {};

          return  promoteWaitlistEntry(schoolId,id,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PromoteWaitlistEntryMutationResult = NonNullable<Awaited<ReturnType<typeof promoteWaitlistEntry>>>
    
    export type PromoteWaitlistEntryMutationError = unknown

    export const usePromoteWaitlistEntry = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteWaitlistEntry>>, TError,{schoolId: string;id: string;params?: PromoteWaitlistEntryParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof promoteWaitlistEntry>>,
        TError,
        {schoolId: string;id: string;params?: PromoteWaitlistEntryParams},
        TContext
      > => {

      const mutationOptions = getPromoteWaitlistEntryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const claimWaitlistEntry = (
    schoolId: string,
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ClaimWaitlistResponse>(
      {url: `/api/v1/schools/${schoolId}/waitlist/${id}/claim`, method: 'POST', signal
    },
      options);
    }
  


export const getClaimWaitlistEntryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimWaitlistEntry>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof claimWaitlistEntry>>, TError,{schoolId: string;id: string}, TContext> => {

const mutationKey = ['claimWaitlistEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimWaitlistEntry>>, {schoolId: string;id: string}> = (props) => {
          const {schoolId,id} = props ?? {};

          return  claimWaitlistEntry(schoolId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClaimWaitlistEntryMutationResult = NonNullable<Awaited<ReturnType<typeof claimWaitlistEntry>>>
    
    export type ClaimWaitlistEntryMutationError = unknown

    export const useClaimWaitlistEntry = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimWaitlistEntry>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof claimWaitlistEntry>>,
        TError,
        {schoolId: string;id: string},
        TContext
      > => {

      const mutationOptions = getClaimWaitlistEntryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const recordPayment = (
    schoolId: string,
    recordPaymentRequest: RecordPaymentRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/payments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: recordPaymentRequest, signal
    },
      options);
    }
  


export const getRecordPaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordPayment>>, TError,{schoolId: string;data: RecordPaymentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof recordPayment>>, TError,{schoolId: string;data: RecordPaymentRequest}, TContext> => {

const mutationKey = ['recordPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordPayment>>, {schoolId: string;data: RecordPaymentRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  recordPayment(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RecordPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof recordPayment>>>
    export type RecordPaymentMutationBody = RecordPaymentRequest
    export type RecordPaymentMutationError = unknown

    export const useRecordPayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordPayment>>, TError,{schoolId: string;data: RecordPaymentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordPayment>>,
        TError,
        {schoolId: string;data: RecordPaymentRequest},
        TContext
      > => {

      const mutationOptions = getRecordPaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listPayments = (
    schoolId: string,
    params?: ListPaymentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PaymentResponse[]>(
      {url: `/api/v1/schools/${schoolId}/payments`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListPaymentsQueryKey = (schoolId?: string,
    params?: ListPaymentsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/payments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof listPayments>>, TError = unknown>(schoolId: string,
    params?: ListPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPaymentsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayments>>> = ({ signal }) => listPayments(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof listPayments>>>
export type ListPaymentsQueryError = unknown


export function useListPayments<TData = Awaited<ReturnType<typeof listPayments>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListPaymentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayments>>,
          TError,
          Awaited<ReturnType<typeof listPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayments<TData = Awaited<ReturnType<typeof listPayments>>, TError = unknown>(
 schoolId: string,
    params?: ListPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayments>>,
          TError,
          Awaited<ReturnType<typeof listPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayments<TData = Awaited<ReturnType<typeof listPayments>>, TError = unknown>(
 schoolId: string,
    params?: ListPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListPayments<TData = Awaited<ReturnType<typeof listPayments>>, TError = unknown>(
 schoolId: string,
    params?: ListPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPaymentsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const cancelPayment = (
    schoolId: string,
    paymentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/payments/${paymentId}/cancel`, method: 'POST', signal
    },
      options);
    }
  


export const getCancelPaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPayment>>, TError,{schoolId: string;paymentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelPayment>>, TError,{schoolId: string;paymentId: string}, TContext> => {

const mutationKey = ['cancelPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelPayment>>, {schoolId: string;paymentId: string}> = (props) => {
          const {schoolId,paymentId} = props ?? {};

          return  cancelPayment(schoolId,paymentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof cancelPayment>>>
    
    export type CancelPaymentMutationError = unknown

    export const useCancelPayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPayment>>, TError,{schoolId: string;paymentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelPayment>>,
        TError,
        {schoolId: string;paymentId: string},
        TContext
      > => {

      const mutationOptions = getCancelPaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getStudentBalance = (
    schoolId: string,
    studentMemberId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<StudentBalanceResponse>(
      {url: `/api/v1/schools/${schoolId}/payments/balance/${studentMemberId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetStudentBalanceQueryKey = (schoolId?: string,
    studentMemberId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/payments/balance/${studentMemberId}`
    ] as const;
    }

    
export const getGetStudentBalanceQueryOptions = <TData = Awaited<ReturnType<typeof getStudentBalance>>, TError = unknown>(schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentBalance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStudentBalanceQueryKey(schoolId,studentMemberId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudentBalance>>> = ({ signal }) => getStudentBalance(schoolId,studentMemberId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && studentMemberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStudentBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStudentBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof getStudentBalance>>>
export type GetStudentBalanceQueryError = unknown


export function useGetStudentBalance<TData = Awaited<ReturnType<typeof getStudentBalance>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentBalance>>,
          TError,
          Awaited<ReturnType<typeof getStudentBalance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStudentBalance<TData = Awaited<ReturnType<typeof getStudentBalance>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentBalance>>,
          TError,
          Awaited<ReturnType<typeof getStudentBalance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStudentBalance<TData = Awaited<ReturnType<typeof getStudentBalance>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentBalance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetStudentBalance<TData = Awaited<ReturnType<typeof getStudentBalance>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentBalance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStudentBalanceQueryOptions(schoolId,studentMemberId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const payStudentBalance = (
    schoolId: string,
    payStudentBalanceRequest: PayStudentBalanceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PaymentResponse>(
      {url: `/api/v1/schools/${schoolId}/payments/pay-balance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: payStudentBalanceRequest, signal
    },
      options);
    }
  


export const getPayStudentBalanceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof payStudentBalance>>, TError,{schoolId: string;data: PayStudentBalanceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof payStudentBalance>>, TError,{schoolId: string;data: PayStudentBalanceRequest}, TContext> => {

const mutationKey = ['payStudentBalance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof payStudentBalance>>, {schoolId: string;data: PayStudentBalanceRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  payStudentBalance(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PayStudentBalanceMutationResult = NonNullable<Awaited<ReturnType<typeof payStudentBalance>>>
    export type PayStudentBalanceMutationBody = PayStudentBalanceRequest
    export type PayStudentBalanceMutationError = unknown

    export const usePayStudentBalance = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof payStudentBalance>>, TError,{schoolId: string;data: PayStudentBalanceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof payStudentBalance>>,
        TError,
        {schoolId: string;data: PayStudentBalanceRequest},
        TContext
      > => {

      const mutationOptions = getPayStudentBalanceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const payStudentBalanceWithVouchers = (
    schoolId: string,
    studentMemberId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PayStudentBalanceWithVouchersResponse>(
      {url: `/api/v1/schools/${schoolId}/payments/balance/${studentMemberId}/pay-with-vouchers`, method: 'POST', signal
    },
      options);
    }
  


export const getPayStudentBalanceWithVouchersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof payStudentBalanceWithVouchers>>, TError,{schoolId: string;studentMemberId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof payStudentBalanceWithVouchers>>, TError,{schoolId: string;studentMemberId: string}, TContext> => {

const mutationKey = ['payStudentBalanceWithVouchers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof payStudentBalanceWithVouchers>>, {schoolId: string;studentMemberId: string}> = (props) => {
          const {schoolId,studentMemberId} = props ?? {};

          return  payStudentBalanceWithVouchers(schoolId,studentMemberId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PayStudentBalanceWithVouchersMutationResult = NonNullable<Awaited<ReturnType<typeof payStudentBalanceWithVouchers>>>
    
    export type PayStudentBalanceWithVouchersMutationError = unknown

    export const usePayStudentBalanceWithVouchers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof payStudentBalanceWithVouchers>>, TError,{schoolId: string;studentMemberId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof payStudentBalanceWithVouchers>>,
        TError,
        {schoolId: string;studentMemberId: string},
        TContext
      > => {

      const mutationOptions = getPayStudentBalanceWithVouchersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const reconcileStudentBalance = (
    schoolId: string,
    studentMemberId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/payments/reconcile/${studentMemberId}`, method: 'POST', signal
    },
      options);
    }
  


export const getReconcileStudentBalanceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconcileStudentBalance>>, TError,{schoolId: string;studentMemberId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reconcileStudentBalance>>, TError,{schoolId: string;studentMemberId: string}, TContext> => {

const mutationKey = ['reconcileStudentBalance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reconcileStudentBalance>>, {schoolId: string;studentMemberId: string}> = (props) => {
          const {schoolId,studentMemberId} = props ?? {};

          return  reconcileStudentBalance(schoolId,studentMemberId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReconcileStudentBalanceMutationResult = NonNullable<Awaited<ReturnType<typeof reconcileStudentBalance>>>
    
    export type ReconcileStudentBalanceMutationError = unknown

    export const useReconcileStudentBalance = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconcileStudentBalance>>, TError,{schoolId: string;studentMemberId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reconcileStudentBalance>>,
        TError,
        {schoolId: string;studentMemberId: string},
        TContext
      > => {

      const mutationOptions = getReconcileStudentBalanceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const initializeOnlinePayment = (
    schoolId: string,
    paymentId: string,
    params: InitializeOnlinePaymentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GatewayTransactionResult>(
      {url: `/api/v1/schools/${schoolId}/payments/${paymentId}/pay-online`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getInitializeOnlinePaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeOnlinePayment>>, TError,{schoolId: string;paymentId: string;params: InitializeOnlinePaymentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof initializeOnlinePayment>>, TError,{schoolId: string;paymentId: string;params: InitializeOnlinePaymentParams}, TContext> => {

const mutationKey = ['initializeOnlinePayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initializeOnlinePayment>>, {schoolId: string;paymentId: string;params: InitializeOnlinePaymentParams}> = (props) => {
          const {schoolId,paymentId,params} = props ?? {};

          return  initializeOnlinePayment(schoolId,paymentId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InitializeOnlinePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof initializeOnlinePayment>>>
    
    export type InitializeOnlinePaymentMutationError = unknown

    export const useInitializeOnlinePayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeOnlinePayment>>, TError,{schoolId: string;paymentId: string;params: InitializeOnlinePaymentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof initializeOnlinePayment>>,
        TError,
        {schoolId: string;paymentId: string;params: InitializeOnlinePaymentParams},
        TContext
      > => {

      const mutationOptions = getInitializeOnlinePaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const refundPayment = (
    schoolId: string,
    paymentId: string,
    refundPaymentRequest: RefundPaymentRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PaymentResponse>(
      {url: `/api/v1/schools/${schoolId}/payments/${paymentId}/refund`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refundPaymentRequest, signal
    },
      options);
    }
  


export const getRefundPaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refundPayment>>, TError,{schoolId: string;paymentId: string;data: RefundPaymentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof refundPayment>>, TError,{schoolId: string;paymentId: string;data: RefundPaymentRequest}, TContext> => {

const mutationKey = ['refundPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refundPayment>>, {schoolId: string;paymentId: string;data: RefundPaymentRequest}> = (props) => {
          const {schoolId,paymentId,data} = props ?? {};

          return  refundPayment(schoolId,paymentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RefundPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof refundPayment>>>
    export type RefundPaymentMutationBody = RefundPaymentRequest
    export type RefundPaymentMutationError = unknown

    export const useRefundPayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refundPayment>>, TError,{schoolId: string;paymentId: string;data: RefundPaymentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refundPayment>>,
        TError,
        {schoolId: string;paymentId: string;data: RefundPaymentRequest},
        TContext
      > => {

      const mutationOptions = getRefundPaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const completePayment = (
    schoolId: string,
    paymentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/payments/${paymentId}/complete`, method: 'POST', signal
    },
      options);
    }
  


export const getCompletePaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completePayment>>, TError,{schoolId: string;paymentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof completePayment>>, TError,{schoolId: string;paymentId: string}, TContext> => {

const mutationKey = ['completePayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completePayment>>, {schoolId: string;paymentId: string}> = (props) => {
          const {schoolId,paymentId} = props ?? {};

          return  completePayment(schoolId,paymentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompletePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof completePayment>>>
    
    export type CompletePaymentMutationError = unknown

    export const useCompletePayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completePayment>>, TError,{schoolId: string;paymentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completePayment>>,
        TError,
        {schoolId: string;paymentId: string},
        TContext
      > => {

      const mutationOptions = getCompletePaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const paymentGatewayCallback = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/payments/gateway-callback`, method: 'POST', signal
    },
      options);
    }
  


export const getPaymentGatewayCallbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentGatewayCallback>>, TError,{schoolId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentGatewayCallback>>, TError,{schoolId: string}, TContext> => {

const mutationKey = ['paymentGatewayCallback'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentGatewayCallback>>, {schoolId: string}> = (props) => {
          const {schoolId} = props ?? {};

          return  paymentGatewayCallback(schoolId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PaymentGatewayCallbackMutationResult = NonNullable<Awaited<ReturnType<typeof paymentGatewayCallback>>>
    
    export type PaymentGatewayCallbackMutationError = unknown

    export const usePaymentGatewayCallback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentGatewayCallback>>, TError,{schoolId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof paymentGatewayCallback>>,
        TError,
        {schoolId: string},
        TContext
      > => {

      const mutationOptions = getPaymentGatewayCallbackMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deletePayment = (
    schoolId: string,
    paymentId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/payments/${paymentId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeletePaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayment>>, TError,{schoolId: string;paymentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePayment>>, TError,{schoolId: string;paymentId: string}, TContext> => {

const mutationKey = ['deletePayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePayment>>, {schoolId: string;paymentId: string}> = (props) => {
          const {schoolId,paymentId} = props ?? {};

          return  deletePayment(schoolId,paymentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof deletePayment>>>
    
    export type DeletePaymentMutationError = unknown

    export const useDeletePayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayment>>, TError,{schoolId: string;paymentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePayment>>,
        TError,
        {schoolId: string;paymentId: string},
        TContext
      > => {

      const mutationOptions = getDeletePaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createSubscription = (
    schoolId: string,
    createSubscriptionRequest: CreateSubscriptionRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/subscriptions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSubscriptionRequest, signal
    },
      options);
    }
  


export const getCreateSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscription>>, TError,{schoolId: string;data: CreateSubscriptionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSubscription>>, TError,{schoolId: string;data: CreateSubscriptionRequest}, TContext> => {

const mutationKey = ['createSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSubscription>>, {schoolId: string;data: CreateSubscriptionRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createSubscription(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof createSubscription>>>
    export type CreateSubscriptionMutationBody = CreateSubscriptionRequest
    export type CreateSubscriptionMutationError = unknown

    export const useCreateSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscription>>, TError,{schoolId: string;data: CreateSubscriptionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSubscription>>,
        TError,
        {schoolId: string;data: CreateSubscriptionRequest},
        TContext
      > => {

      const mutationOptions = getCreateSubscriptionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listStudentSubscriptions = (
    schoolId: string,
    studentMemberId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SubscriptionResponse[]>(
      {url: `/api/v1/schools/${schoolId}/subscriptions/student/${studentMemberId}`, method: 'GET', signal
    },
      options);
    }
  



export const getListStudentSubscriptionsQueryKey = (schoolId?: string,
    studentMemberId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/subscriptions/student/${studentMemberId}`
    ] as const;
    }

    
export const getListStudentSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof listStudentSubscriptions>>, TError = unknown>(schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStudentSubscriptionsQueryKey(schoolId,studentMemberId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStudentSubscriptions>>> = ({ signal }) => listStudentSubscriptions(schoolId,studentMemberId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && studentMemberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStudentSubscriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStudentSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listStudentSubscriptions>>>
export type ListStudentSubscriptionsQueryError = unknown


export function useListStudentSubscriptions<TData = Awaited<ReturnType<typeof listStudentSubscriptions>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentSubscriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStudentSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof listStudentSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStudentSubscriptions<TData = Awaited<ReturnType<typeof listStudentSubscriptions>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentSubscriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStudentSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof listStudentSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStudentSubscriptions<TData = Awaited<ReturnType<typeof listStudentSubscriptions>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListStudentSubscriptions<TData = Awaited<ReturnType<typeof listStudentSubscriptions>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStudentSubscriptionsQueryOptions(schoolId,studentMemberId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const optOutSubscription = (
    schoolId: string,
    subscriptionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/subscriptions/${subscriptionId}/opt-out`, method: 'POST', signal
    },
      options);
    }
  


export const getOptOutSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof optOutSubscription>>, TError,{schoolId: string;subscriptionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof optOutSubscription>>, TError,{schoolId: string;subscriptionId: string}, TContext> => {

const mutationKey = ['optOutSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof optOutSubscription>>, {schoolId: string;subscriptionId: string}> = (props) => {
          const {schoolId,subscriptionId} = props ?? {};

          return  optOutSubscription(schoolId,subscriptionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OptOutSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof optOutSubscription>>>
    
    export type OptOutSubscriptionMutationError = unknown

    export const useOptOutSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof optOutSubscription>>, TError,{schoolId: string;subscriptionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof optOutSubscription>>,
        TError,
        {schoolId: string;subscriptionId: string},
        TContext
      > => {

      const mutationOptions = getOptOutSubscriptionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getResignationPreview = (
    schoolId: string,
    subscriptionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ResignationPreviewResponse>(
      {url: `/api/v1/schools/${schoolId}/subscriptions/${subscriptionId}/resignation-preview`, method: 'GET', signal
    },
      options);
    }
  



export const getGetResignationPreviewQueryKey = (schoolId?: string,
    subscriptionId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/subscriptions/${subscriptionId}/resignation-preview`
    ] as const;
    }

    
export const getGetResignationPreviewQueryOptions = <TData = Awaited<ReturnType<typeof getResignationPreview>>, TError = unknown>(schoolId: string,
    subscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResignationPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResignationPreviewQueryKey(schoolId,subscriptionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResignationPreview>>> = ({ signal }) => getResignationPreview(schoolId,subscriptionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && subscriptionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResignationPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResignationPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getResignationPreview>>>
export type GetResignationPreviewQueryError = unknown


export function useGetResignationPreview<TData = Awaited<ReturnType<typeof getResignationPreview>>, TError = unknown>(
 schoolId: string,
    subscriptionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResignationPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResignationPreview>>,
          TError,
          Awaited<ReturnType<typeof getResignationPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResignationPreview<TData = Awaited<ReturnType<typeof getResignationPreview>>, TError = unknown>(
 schoolId: string,
    subscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResignationPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResignationPreview>>,
          TError,
          Awaited<ReturnType<typeof getResignationPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResignationPreview<TData = Awaited<ReturnType<typeof getResignationPreview>>, TError = unknown>(
 schoolId: string,
    subscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResignationPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResignationPreview<TData = Awaited<ReturnType<typeof getResignationPreview>>, TError = unknown>(
 schoolId: string,
    subscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResignationPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResignationPreviewQueryOptions(schoolId,subscriptionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const reactivateSubscription = (
    schoolId: string,
    subscriptionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/subscriptions/${subscriptionId}/reactivate`, method: 'POST', signal
    },
      options);
    }
  


export const getReactivateSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateSubscription>>, TError,{schoolId: string;subscriptionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reactivateSubscription>>, TError,{schoolId: string;subscriptionId: string}, TContext> => {

const mutationKey = ['reactivateSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactivateSubscription>>, {schoolId: string;subscriptionId: string}> = (props) => {
          const {schoolId,subscriptionId} = props ?? {};

          return  reactivateSubscription(schoolId,subscriptionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReactivateSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof reactivateSubscription>>>
    
    export type ReactivateSubscriptionMutationError = unknown

    export const useReactivateSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateSubscription>>, TError,{schoolId: string;subscriptionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reactivateSubscription>>,
        TError,
        {schoolId: string;subscriptionId: string},
        TContext
      > => {

      const mutationOptions = getReactivateSubscriptionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const resignSubscription = (
    schoolId: string,
    subscriptionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/subscriptions/${subscriptionId}/resign`, method: 'POST', signal
    },
      options);
    }
  


export const getResignSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resignSubscription>>, TError,{schoolId: string;subscriptionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resignSubscription>>, TError,{schoolId: string;subscriptionId: string}, TContext> => {

const mutationKey = ['resignSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resignSubscription>>, {schoolId: string;subscriptionId: string}> = (props) => {
          const {schoolId,subscriptionId} = props ?? {};

          return  resignSubscription(schoolId,subscriptionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResignSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof resignSubscription>>>
    
    export type ResignSubscriptionMutationError = unknown

    export const useResignSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resignSubscription>>, TError,{schoolId: string;subscriptionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resignSubscription>>,
        TError,
        {schoolId: string;subscriptionId: string},
        TContext
      > => {

      const mutationOptions = getResignSubscriptionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const toggleSubscriptionAutoPay = (
    schoolId: string,
    subscriptionId: string,
    toggleAutoPayRequest: ToggleAutoPayRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/subscriptions/${subscriptionId}/toggle-autopay`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: toggleAutoPayRequest, signal
    },
      options);
    }
  


export const getToggleSubscriptionAutoPayMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleSubscriptionAutoPay>>, TError,{schoolId: string;subscriptionId: string;data: ToggleAutoPayRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleSubscriptionAutoPay>>, TError,{schoolId: string;subscriptionId: string;data: ToggleAutoPayRequest}, TContext> => {

const mutationKey = ['toggleSubscriptionAutoPay'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleSubscriptionAutoPay>>, {schoolId: string;subscriptionId: string;data: ToggleAutoPayRequest}> = (props) => {
          const {schoolId,subscriptionId,data} = props ?? {};

          return  toggleSubscriptionAutoPay(schoolId,subscriptionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ToggleSubscriptionAutoPayMutationResult = NonNullable<Awaited<ReturnType<typeof toggleSubscriptionAutoPay>>>
    export type ToggleSubscriptionAutoPayMutationBody = ToggleAutoPayRequest
    export type ToggleSubscriptionAutoPayMutationError = unknown

    export const useToggleSubscriptionAutoPay = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleSubscriptionAutoPay>>, TError,{schoolId: string;subscriptionId: string;data: ToggleAutoPayRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleSubscriptionAutoPay>>,
        TError,
        {schoolId: string;subscriptionId: string;data: ToggleAutoPayRequest},
        TContext
      > => {

      const mutationOptions = getToggleSubscriptionAutoPayMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listAdminSubscriptions = (
    schoolId: string,
    params?: ListAdminSubscriptionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SubscriptionsListResponse>(
      {url: `/api/v1/schools/${schoolId}/subscriptions/admin`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListAdminSubscriptionsQueryKey = (schoolId?: string,
    params?: ListAdminSubscriptionsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/subscriptions/admin`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListAdminSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminSubscriptions>>, TError = unknown>(schoolId: string,
    params?: ListAdminSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminSubscriptionsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminSubscriptions>>> = ({ signal }) => listAdminSubscriptions(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminSubscriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminSubscriptions>>>
export type ListAdminSubscriptionsQueryError = unknown


export function useListAdminSubscriptions<TData = Awaited<ReturnType<typeof listAdminSubscriptions>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListAdminSubscriptionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminSubscriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof listAdminSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminSubscriptions<TData = Awaited<ReturnType<typeof listAdminSubscriptions>>, TError = unknown>(
 schoolId: string,
    params?: ListAdminSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminSubscriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof listAdminSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminSubscriptions<TData = Awaited<ReturnType<typeof listAdminSubscriptions>>, TError = unknown>(
 schoolId: string,
    params?: ListAdminSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAdminSubscriptions<TData = Awaited<ReturnType<typeof listAdminSubscriptions>>, TError = unknown>(
 schoolId: string,
    params?: ListAdminSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminSubscriptionsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listStudentPaymentTokens = (
    schoolId: string,
    studentMemberId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<StudentPaymentTokenDto[]>(
      {url: `/api/v1/schools/${schoolId}/payment-tokens/student/${studentMemberId}`, method: 'GET', signal
    },
      options);
    }
  



export const getListStudentPaymentTokensQueryKey = (schoolId?: string,
    studentMemberId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/payment-tokens/student/${studentMemberId}`
    ] as const;
    }

    
export const getListStudentPaymentTokensQueryOptions = <TData = Awaited<ReturnType<typeof listStudentPaymentTokens>>, TError = unknown>(schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentPaymentTokens>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStudentPaymentTokensQueryKey(schoolId,studentMemberId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStudentPaymentTokens>>> = ({ signal }) => listStudentPaymentTokens(schoolId,studentMemberId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && studentMemberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStudentPaymentTokens>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStudentPaymentTokensQueryResult = NonNullable<Awaited<ReturnType<typeof listStudentPaymentTokens>>>
export type ListStudentPaymentTokensQueryError = unknown


export function useListStudentPaymentTokens<TData = Awaited<ReturnType<typeof listStudentPaymentTokens>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentPaymentTokens>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStudentPaymentTokens>>,
          TError,
          Awaited<ReturnType<typeof listStudentPaymentTokens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStudentPaymentTokens<TData = Awaited<ReturnType<typeof listStudentPaymentTokens>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentPaymentTokens>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStudentPaymentTokens>>,
          TError,
          Awaited<ReturnType<typeof listStudentPaymentTokens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStudentPaymentTokens<TData = Awaited<ReturnType<typeof listStudentPaymentTokens>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentPaymentTokens>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListStudentPaymentTokens<TData = Awaited<ReturnType<typeof listStudentPaymentTokens>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentPaymentTokens>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStudentPaymentTokensQueryOptions(schoolId,studentMemberId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const deleteStudentPaymentToken = (
    schoolId: string,
    tokenId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/payment-tokens/${tokenId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteStudentPaymentTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStudentPaymentToken>>, TError,{schoolId: string;tokenId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStudentPaymentToken>>, TError,{schoolId: string;tokenId: string}, TContext> => {

const mutationKey = ['deleteStudentPaymentToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStudentPaymentToken>>, {schoolId: string;tokenId: string}> = (props) => {
          const {schoolId,tokenId} = props ?? {};

          return  deleteStudentPaymentToken(schoolId,tokenId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteStudentPaymentTokenMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStudentPaymentToken>>>
    
    export type DeleteStudentPaymentTokenMutationError = unknown

    export const useDeleteStudentPaymentToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStudentPaymentToken>>, TError,{schoolId: string;tokenId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStudentPaymentToken>>,
        TError,
        {schoolId: string;tokenId: string},
        TContext
      > => {

      const mutationOptions = getDeleteStudentPaymentTokenMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listBills = (
    schoolId: string,
    params?: ListBillsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BillResponse[]>(
      {url: `/api/v1/schools/${schoolId}/billing/bills`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListBillsQueryKey = (schoolId?: string,
    params?: ListBillsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/billing/bills`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListBillsQueryOptions = <TData = Awaited<ReturnType<typeof listBills>>, TError = unknown>(schoolId: string,
    params?: ListBillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBillsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBills>>> = ({ signal }) => listBills(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBills>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBillsQueryResult = NonNullable<Awaited<ReturnType<typeof listBills>>>
export type ListBillsQueryError = unknown


export function useListBills<TData = Awaited<ReturnType<typeof listBills>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListBillsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBills>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBills>>,
          TError,
          Awaited<ReturnType<typeof listBills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBills<TData = Awaited<ReturnType<typeof listBills>>, TError = unknown>(
 schoolId: string,
    params?: ListBillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBills>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBills>>,
          TError,
          Awaited<ReturnType<typeof listBills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBills<TData = Awaited<ReturnType<typeof listBills>>, TError = unknown>(
 schoolId: string,
    params?: ListBillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListBills<TData = Awaited<ReturnType<typeof listBills>>, TError = unknown>(
 schoolId: string,
    params?: ListBillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBillsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createCustomBill = (
    schoolId: string,
    createCustomBillRequest: CreateCustomBillRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BillResponse>(
      {url: `/api/v1/schools/${schoolId}/billing/bills`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCustomBillRequest, signal
    },
      options);
    }
  


export const getCreateCustomBillMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomBill>>, TError,{schoolId: string;data: CreateCustomBillRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomBill>>, TError,{schoolId: string;data: CreateCustomBillRequest}, TContext> => {

const mutationKey = ['createCustomBill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomBill>>, {schoolId: string;data: CreateCustomBillRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createCustomBill(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomBillMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomBill>>>
    export type CreateCustomBillMutationBody = CreateCustomBillRequest
    export type CreateCustomBillMutationError = unknown

    export const useCreateCustomBill = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomBill>>, TError,{schoolId: string;data: CreateCustomBillRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCustomBill>>,
        TError,
        {schoolId: string;data: CreateCustomBillRequest},
        TContext
      > => {

      const mutationOptions = getCreateCustomBillMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const exportBillsExcel = (
    schoolId: string,
    params?: ExportBillsExcelParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/billing/bills/export-excel`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getExportBillsExcelQueryKey = (schoolId?: string,
    params?: ExportBillsExcelParams,) => {
    return [
    `/api/v1/schools/${schoolId}/billing/bills/export-excel`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getExportBillsExcelQueryOptions = <TData = Awaited<ReturnType<typeof exportBillsExcel>>, TError = unknown>(schoolId: string,
    params?: ExportBillsExcelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportBillsExcel>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportBillsExcelQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportBillsExcel>>> = ({ signal }) => exportBillsExcel(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportBillsExcel>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportBillsExcelQueryResult = NonNullable<Awaited<ReturnType<typeof exportBillsExcel>>>
export type ExportBillsExcelQueryError = unknown


export function useExportBillsExcel<TData = Awaited<ReturnType<typeof exportBillsExcel>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ExportBillsExcelParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportBillsExcel>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportBillsExcel>>,
          TError,
          Awaited<ReturnType<typeof exportBillsExcel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportBillsExcel<TData = Awaited<ReturnType<typeof exportBillsExcel>>, TError = unknown>(
 schoolId: string,
    params?: ExportBillsExcelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportBillsExcel>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportBillsExcel>>,
          TError,
          Awaited<ReturnType<typeof exportBillsExcel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportBillsExcel<TData = Awaited<ReturnType<typeof exportBillsExcel>>, TError = unknown>(
 schoolId: string,
    params?: ExportBillsExcelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportBillsExcel>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExportBillsExcel<TData = Awaited<ReturnType<typeof exportBillsExcel>>, TError = unknown>(
 schoolId: string,
    params?: ExportBillsExcelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportBillsExcel>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportBillsExcelQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getAdminBillingMetrics = (
    schoolId: string,
    params?: GetAdminBillingMetricsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BillingAdminMetricsResponse>(
      {url: `/api/v1/schools/${schoolId}/billing/bills/admin-metrics`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAdminBillingMetricsQueryKey = (schoolId?: string,
    params?: GetAdminBillingMetricsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/billing/bills/admin-metrics`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminBillingMetricsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminBillingMetrics>>, TError = unknown>(schoolId: string,
    params?: GetAdminBillingMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminBillingMetrics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminBillingMetricsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminBillingMetrics>>> = ({ signal }) => getAdminBillingMetrics(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminBillingMetrics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminBillingMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminBillingMetrics>>>
export type GetAdminBillingMetricsQueryError = unknown


export function useGetAdminBillingMetrics<TData = Awaited<ReturnType<typeof getAdminBillingMetrics>>, TError = unknown>(
 schoolId: string,
    params: undefined |  GetAdminBillingMetricsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminBillingMetrics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminBillingMetrics>>,
          TError,
          Awaited<ReturnType<typeof getAdminBillingMetrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminBillingMetrics<TData = Awaited<ReturnType<typeof getAdminBillingMetrics>>, TError = unknown>(
 schoolId: string,
    params?: GetAdminBillingMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminBillingMetrics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminBillingMetrics>>,
          TError,
          Awaited<ReturnType<typeof getAdminBillingMetrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminBillingMetrics<TData = Awaited<ReturnType<typeof getAdminBillingMetrics>>, TError = unknown>(
 schoolId: string,
    params?: GetAdminBillingMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminBillingMetrics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminBillingMetrics<TData = Awaited<ReturnType<typeof getAdminBillingMetrics>>, TError = unknown>(
 schoolId: string,
    params?: GetAdminBillingMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminBillingMetrics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminBillingMetricsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listStudentNegativeBalances = (
    schoolId: string,
    params?: ListStudentNegativeBalancesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<StudentNegativeBalancesResponse>(
      {url: `/api/v1/schools/${schoolId}/billing/bills/negative-balances`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListStudentNegativeBalancesQueryKey = (schoolId?: string,
    params?: ListStudentNegativeBalancesParams,) => {
    return [
    `/api/v1/schools/${schoolId}/billing/bills/negative-balances`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListStudentNegativeBalancesQueryOptions = <TData = Awaited<ReturnType<typeof listStudentNegativeBalances>>, TError = unknown>(schoolId: string,
    params?: ListStudentNegativeBalancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentNegativeBalances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStudentNegativeBalancesQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStudentNegativeBalances>>> = ({ signal }) => listStudentNegativeBalances(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStudentNegativeBalances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStudentNegativeBalancesQueryResult = NonNullable<Awaited<ReturnType<typeof listStudentNegativeBalances>>>
export type ListStudentNegativeBalancesQueryError = unknown


export function useListStudentNegativeBalances<TData = Awaited<ReturnType<typeof listStudentNegativeBalances>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListStudentNegativeBalancesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentNegativeBalances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStudentNegativeBalances>>,
          TError,
          Awaited<ReturnType<typeof listStudentNegativeBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStudentNegativeBalances<TData = Awaited<ReturnType<typeof listStudentNegativeBalances>>, TError = unknown>(
 schoolId: string,
    params?: ListStudentNegativeBalancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentNegativeBalances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStudentNegativeBalances>>,
          TError,
          Awaited<ReturnType<typeof listStudentNegativeBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStudentNegativeBalances<TData = Awaited<ReturnType<typeof listStudentNegativeBalances>>, TError = unknown>(
 schoolId: string,
    params?: ListStudentNegativeBalancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentNegativeBalances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListStudentNegativeBalances<TData = Awaited<ReturnType<typeof listStudentNegativeBalances>>, TError = unknown>(
 schoolId: string,
    params?: ListStudentNegativeBalancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentNegativeBalances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStudentNegativeBalancesQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const exportNegativeBalancesExcel = (
    schoolId: string,
    params?: ExportNegativeBalancesExcelParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/billing/bills/negative-balances/export-excel`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getExportNegativeBalancesExcelQueryKey = (schoolId?: string,
    params?: ExportNegativeBalancesExcelParams,) => {
    return [
    `/api/v1/schools/${schoolId}/billing/bills/negative-balances/export-excel`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getExportNegativeBalancesExcelQueryOptions = <TData = Awaited<ReturnType<typeof exportNegativeBalancesExcel>>, TError = unknown>(schoolId: string,
    params?: ExportNegativeBalancesExcelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportNegativeBalancesExcel>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportNegativeBalancesExcelQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportNegativeBalancesExcel>>> = ({ signal }) => exportNegativeBalancesExcel(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportNegativeBalancesExcel>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportNegativeBalancesExcelQueryResult = NonNullable<Awaited<ReturnType<typeof exportNegativeBalancesExcel>>>
export type ExportNegativeBalancesExcelQueryError = unknown


export function useExportNegativeBalancesExcel<TData = Awaited<ReturnType<typeof exportNegativeBalancesExcel>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ExportNegativeBalancesExcelParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportNegativeBalancesExcel>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportNegativeBalancesExcel>>,
          TError,
          Awaited<ReturnType<typeof exportNegativeBalancesExcel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportNegativeBalancesExcel<TData = Awaited<ReturnType<typeof exportNegativeBalancesExcel>>, TError = unknown>(
 schoolId: string,
    params?: ExportNegativeBalancesExcelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportNegativeBalancesExcel>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportNegativeBalancesExcel>>,
          TError,
          Awaited<ReturnType<typeof exportNegativeBalancesExcel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportNegativeBalancesExcel<TData = Awaited<ReturnType<typeof exportNegativeBalancesExcel>>, TError = unknown>(
 schoolId: string,
    params?: ExportNegativeBalancesExcelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportNegativeBalancesExcel>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExportNegativeBalancesExcel<TData = Awaited<ReturnType<typeof exportNegativeBalancesExcel>>, TError = unknown>(
 schoolId: string,
    params?: ExportNegativeBalancesExcelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportNegativeBalancesExcel>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportNegativeBalancesExcelQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const cancelBill = (
    schoolId: string,
    billId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/billing/bills/${billId}/cancel`, method: 'POST', signal
    },
      options);
    }
  


export const getCancelBillMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelBill>>, TError,{schoolId: string;billId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelBill>>, TError,{schoolId: string;billId: string}, TContext> => {

const mutationKey = ['cancelBill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelBill>>, {schoolId: string;billId: string}> = (props) => {
          const {schoolId,billId} = props ?? {};

          return  cancelBill(schoolId,billId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelBillMutationResult = NonNullable<Awaited<ReturnType<typeof cancelBill>>>
    
    export type CancelBillMutationError = unknown

    export const useCancelBill = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelBill>>, TError,{schoolId: string;billId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelBill>>,
        TError,
        {schoolId: string;billId: string},
        TContext
      > => {

      const mutationOptions = getCancelBillMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const uncancelBill = (
    schoolId: string,
    billId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/billing/bills/${billId}/uncancel`, method: 'POST', signal
    },
      options);
    }
  


export const getUncancelBillMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uncancelBill>>, TError,{schoolId: string;billId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uncancelBill>>, TError,{schoolId: string;billId: string}, TContext> => {

const mutationKey = ['uncancelBill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uncancelBill>>, {schoolId: string;billId: string}> = (props) => {
          const {schoolId,billId} = props ?? {};

          return  uncancelBill(schoolId,billId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UncancelBillMutationResult = NonNullable<Awaited<ReturnType<typeof uncancelBill>>>
    
    export type UncancelBillMutationError = unknown

    export const useUncancelBill = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uncancelBill>>, TError,{schoolId: string;billId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uncancelBill>>,
        TError,
        {schoolId: string;billId: string},
        TContext
      > => {

      const mutationOptions = getUncancelBillMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listStudentBills = (
    schoolId: string,
    studentMemberId: string,
    params?: ListStudentBillsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BillResponse[]>(
      {url: `/api/v1/schools/${schoolId}/billing/bills/student/${studentMemberId}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListStudentBillsQueryKey = (schoolId?: string,
    studentMemberId?: string,
    params?: ListStudentBillsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/billing/bills/student/${studentMemberId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListStudentBillsQueryOptions = <TData = Awaited<ReturnType<typeof listStudentBills>>, TError = unknown>(schoolId: string,
    studentMemberId: string,
    params?: ListStudentBillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentBills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStudentBillsQueryKey(schoolId,studentMemberId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStudentBills>>> = ({ signal }) => listStudentBills(schoolId,studentMemberId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && studentMemberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStudentBills>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStudentBillsQueryResult = NonNullable<Awaited<ReturnType<typeof listStudentBills>>>
export type ListStudentBillsQueryError = unknown


export function useListStudentBills<TData = Awaited<ReturnType<typeof listStudentBills>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string,
    params: undefined |  ListStudentBillsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentBills>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStudentBills>>,
          TError,
          Awaited<ReturnType<typeof listStudentBills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStudentBills<TData = Awaited<ReturnType<typeof listStudentBills>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string,
    params?: ListStudentBillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentBills>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStudentBills>>,
          TError,
          Awaited<ReturnType<typeof listStudentBills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStudentBills<TData = Awaited<ReturnType<typeof listStudentBills>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string,
    params?: ListStudentBillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentBills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListStudentBills<TData = Awaited<ReturnType<typeof listStudentBills>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string,
    params?: ListStudentBillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentBills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStudentBillsQueryOptions(schoolId,studentMemberId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const initializeBillOnlinePayment = (
    schoolId: string,
    billId: string,
    params: InitializeBillOnlinePaymentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GatewayTransactionResult>(
      {url: `/api/v1/schools/${schoolId}/billing/bills/${billId}/pay-online`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getInitializeBillOnlinePaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeBillOnlinePayment>>, TError,{schoolId: string;billId: string;params: InitializeBillOnlinePaymentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof initializeBillOnlinePayment>>, TError,{schoolId: string;billId: string;params: InitializeBillOnlinePaymentParams}, TContext> => {

const mutationKey = ['initializeBillOnlinePayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initializeBillOnlinePayment>>, {schoolId: string;billId: string;params: InitializeBillOnlinePaymentParams}> = (props) => {
          const {schoolId,billId,params} = props ?? {};

          return  initializeBillOnlinePayment(schoolId,billId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InitializeBillOnlinePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof initializeBillOnlinePayment>>>
    
    export type InitializeBillOnlinePaymentMutationError = unknown

    export const useInitializeBillOnlinePayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeBillOnlinePayment>>, TError,{schoolId: string;billId: string;params: InitializeBillOnlinePaymentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof initializeBillOnlinePayment>>,
        TError,
        {schoolId: string;billId: string;params: InitializeBillOnlinePaymentParams},
        TContext
      > => {

      const mutationOptions = getInitializeBillOnlinePaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const reportAbsence = (
    schoolId: string,
    reportAbsenceRequest: ReportAbsenceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/credits/report-absence`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportAbsenceRequest, signal
    },
      options);
    }
  


export const getReportAbsenceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportAbsence>>, TError,{schoolId: string;data: ReportAbsenceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reportAbsence>>, TError,{schoolId: string;data: ReportAbsenceRequest}, TContext> => {

const mutationKey = ['reportAbsence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportAbsence>>, {schoolId: string;data: ReportAbsenceRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  reportAbsence(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReportAbsenceMutationResult = NonNullable<Awaited<ReturnType<typeof reportAbsence>>>
    export type ReportAbsenceMutationBody = ReportAbsenceRequest
    export type ReportAbsenceMutationError = unknown

    export const useReportAbsence = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportAbsence>>, TError,{schoolId: string;data: ReportAbsenceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reportAbsence>>,
        TError,
        {schoolId: string;data: ReportAbsenceRequest},
        TContext
      > => {

      const mutationOptions = getReportAbsenceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const cancelAbsence = (
    schoolId: string,
    cancelAbsenceRequest: CancelAbsenceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/credits/cancel-absence`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelAbsenceRequest, signal
    },
      options);
    }
  


export const getCancelAbsenceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAbsence>>, TError,{schoolId: string;data: CancelAbsenceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelAbsence>>, TError,{schoolId: string;data: CancelAbsenceRequest}, TContext> => {

const mutationKey = ['cancelAbsence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelAbsence>>, {schoolId: string;data: CancelAbsenceRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  cancelAbsence(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelAbsenceMutationResult = NonNullable<Awaited<ReturnType<typeof cancelAbsence>>>
    export type CancelAbsenceMutationBody = CancelAbsenceRequest
    export type CancelAbsenceMutationError = unknown

    export const useCancelAbsence = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAbsence>>, TError,{schoolId: string;data: CancelAbsenceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelAbsence>>,
        TError,
        {schoolId: string;data: CancelAbsenceRequest},
        TContext
      > => {

      const mutationOptions = getCancelAbsenceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const redeemCredit = (
    schoolId: string,
    redeemCreditRequest: RedeemCreditRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/credits/redeem`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: redeemCreditRequest, signal
    },
      options);
    }
  


export const getRedeemCreditMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemCredit>>, TError,{schoolId: string;data: RedeemCreditRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof redeemCredit>>, TError,{schoolId: string;data: RedeemCreditRequest}, TContext> => {

const mutationKey = ['redeemCredit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeemCredit>>, {schoolId: string;data: RedeemCreditRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  redeemCredit(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RedeemCreditMutationResult = NonNullable<Awaited<ReturnType<typeof redeemCredit>>>
    export type RedeemCreditMutationBody = RedeemCreditRequest
    export type RedeemCreditMutationError = unknown

    export const useRedeemCredit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemCredit>>, TError,{schoolId: string;data: RedeemCreditRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof redeemCredit>>,
        TError,
        {schoolId: string;data: RedeemCreditRequest},
        TContext
      > => {

      const mutationOptions = getRedeemCreditMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listStudentCredits = (
    schoolId: string,
    studentMemberId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MakeUpCreditResponse[]>(
      {url: `/api/v1/schools/${schoolId}/credits/student/${studentMemberId}`, method: 'GET', signal
    },
      options);
    }
  



export const getListStudentCreditsQueryKey = (schoolId?: string,
    studentMemberId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/credits/student/${studentMemberId}`
    ] as const;
    }

    
export const getListStudentCreditsQueryOptions = <TData = Awaited<ReturnType<typeof listStudentCredits>>, TError = unknown>(schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentCredits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStudentCreditsQueryKey(schoolId,studentMemberId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStudentCredits>>> = ({ signal }) => listStudentCredits(schoolId,studentMemberId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && studentMemberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStudentCredits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStudentCreditsQueryResult = NonNullable<Awaited<ReturnType<typeof listStudentCredits>>>
export type ListStudentCreditsQueryError = unknown


export function useListStudentCredits<TData = Awaited<ReturnType<typeof listStudentCredits>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentCredits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStudentCredits>>,
          TError,
          Awaited<ReturnType<typeof listStudentCredits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStudentCredits<TData = Awaited<ReturnType<typeof listStudentCredits>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentCredits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStudentCredits>>,
          TError,
          Awaited<ReturnType<typeof listStudentCredits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStudentCredits<TData = Awaited<ReturnType<typeof listStudentCredits>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentCredits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListStudentCredits<TData = Awaited<ReturnType<typeof listStudentCredits>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentCredits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStudentCreditsQueryOptions(schoolId,studentMemberId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listUsableStudentCredits = (
    schoolId: string,
    studentMemberId: string,
    params?: ListUsableStudentCreditsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MakeUpCreditResponse[]>(
      {url: `/api/v1/schools/${schoolId}/credits/student/${studentMemberId}/usable`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListUsableStudentCreditsQueryKey = (schoolId?: string,
    studentMemberId?: string,
    params?: ListUsableStudentCreditsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/credits/student/${studentMemberId}/usable`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListUsableStudentCreditsQueryOptions = <TData = Awaited<ReturnType<typeof listUsableStudentCredits>>, TError = unknown>(schoolId: string,
    studentMemberId: string,
    params?: ListUsableStudentCreditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsableStudentCredits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsableStudentCreditsQueryKey(schoolId,studentMemberId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsableStudentCredits>>> = ({ signal }) => listUsableStudentCredits(schoolId,studentMemberId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && studentMemberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsableStudentCredits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsableStudentCreditsQueryResult = NonNullable<Awaited<ReturnType<typeof listUsableStudentCredits>>>
export type ListUsableStudentCreditsQueryError = unknown


export function useListUsableStudentCredits<TData = Awaited<ReturnType<typeof listUsableStudentCredits>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string,
    params: undefined |  ListUsableStudentCreditsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsableStudentCredits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsableStudentCredits>>,
          TError,
          Awaited<ReturnType<typeof listUsableStudentCredits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsableStudentCredits<TData = Awaited<ReturnType<typeof listUsableStudentCredits>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string,
    params?: ListUsableStudentCreditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsableStudentCredits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsableStudentCredits>>,
          TError,
          Awaited<ReturnType<typeof listUsableStudentCredits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsableStudentCredits<TData = Awaited<ReturnType<typeof listUsableStudentCredits>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string,
    params?: ListUsableStudentCreditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsableStudentCredits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListUsableStudentCredits<TData = Awaited<ReturnType<typeof listUsableStudentCredits>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string,
    params?: ListUsableStudentCreditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsableStudentCredits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsableStudentCreditsQueryOptions(schoolId,studentMemberId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const issueManualCredit = (
    schoolId: string,
    studentMemberId: string,
    issueManualCreditRequest: IssueManualCreditRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MakeUpCreditResponse>(
      {url: `/api/v1/schools/${schoolId}/credits/student/${studentMemberId}/manual`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: issueManualCreditRequest, signal
    },
      options);
    }
  


export const getIssueManualCreditMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof issueManualCredit>>, TError,{schoolId: string;studentMemberId: string;data: IssueManualCreditRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof issueManualCredit>>, TError,{schoolId: string;studentMemberId: string;data: IssueManualCreditRequest}, TContext> => {

const mutationKey = ['issueManualCredit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof issueManualCredit>>, {schoolId: string;studentMemberId: string;data: IssueManualCreditRequest}> = (props) => {
          const {schoolId,studentMemberId,data} = props ?? {};

          return  issueManualCredit(schoolId,studentMemberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IssueManualCreditMutationResult = NonNullable<Awaited<ReturnType<typeof issueManualCredit>>>
    export type IssueManualCreditMutationBody = IssueManualCreditRequest
    export type IssueManualCreditMutationError = unknown

    export const useIssueManualCredit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof issueManualCredit>>, TError,{schoolId: string;studentMemberId: string;data: IssueManualCreditRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof issueManualCredit>>,
        TError,
        {schoolId: string;studentMemberId: string;data: IssueManualCreditRequest},
        TContext
      > => {

      const mutationOptions = getIssueManualCreditMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listActiveCreditsAdmin = (
    schoolId: string,
    params?: ListActiveCreditsAdminParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AdminMakeUpCreditResponse[]>(
      {url: `/api/v1/schools/${schoolId}/credits/admin-list`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListActiveCreditsAdminQueryKey = (schoolId?: string,
    params?: ListActiveCreditsAdminParams,) => {
    return [
    `/api/v1/schools/${schoolId}/credits/admin-list`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListActiveCreditsAdminQueryOptions = <TData = Awaited<ReturnType<typeof listActiveCreditsAdmin>>, TError = unknown>(schoolId: string,
    params?: ListActiveCreditsAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActiveCreditsAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListActiveCreditsAdminQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActiveCreditsAdmin>>> = ({ signal }) => listActiveCreditsAdmin(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listActiveCreditsAdmin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListActiveCreditsAdminQueryResult = NonNullable<Awaited<ReturnType<typeof listActiveCreditsAdmin>>>
export type ListActiveCreditsAdminQueryError = unknown


export function useListActiveCreditsAdmin<TData = Awaited<ReturnType<typeof listActiveCreditsAdmin>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListActiveCreditsAdminParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActiveCreditsAdmin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActiveCreditsAdmin>>,
          TError,
          Awaited<ReturnType<typeof listActiveCreditsAdmin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActiveCreditsAdmin<TData = Awaited<ReturnType<typeof listActiveCreditsAdmin>>, TError = unknown>(
 schoolId: string,
    params?: ListActiveCreditsAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActiveCreditsAdmin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActiveCreditsAdmin>>,
          TError,
          Awaited<ReturnType<typeof listActiveCreditsAdmin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActiveCreditsAdmin<TData = Awaited<ReturnType<typeof listActiveCreditsAdmin>>, TError = unknown>(
 schoolId: string,
    params?: ListActiveCreditsAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActiveCreditsAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListActiveCreditsAdmin<TData = Awaited<ReturnType<typeof listActiveCreditsAdmin>>, TError = unknown>(
 schoolId: string,
    params?: ListActiveCreditsAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActiveCreditsAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListActiveCreditsAdminQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateCreditExpiryAdmin = (
    schoolId: string,
    creditId: string,
    updateMakeUpCreditExpiryRequest: UpdateMakeUpCreditExpiryRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MakeUpCreditResponse>(
      {url: `/api/v1/schools/${schoolId}/credits/${creditId}/expiry`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateMakeUpCreditExpiryRequest
    },
      options);
    }
  


export const getUpdateCreditExpiryAdminMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCreditExpiryAdmin>>, TError,{schoolId: string;creditId: string;data: UpdateMakeUpCreditExpiryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCreditExpiryAdmin>>, TError,{schoolId: string;creditId: string;data: UpdateMakeUpCreditExpiryRequest}, TContext> => {

const mutationKey = ['updateCreditExpiryAdmin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCreditExpiryAdmin>>, {schoolId: string;creditId: string;data: UpdateMakeUpCreditExpiryRequest}> = (props) => {
          const {schoolId,creditId,data} = props ?? {};

          return  updateCreditExpiryAdmin(schoolId,creditId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCreditExpiryAdminMutationResult = NonNullable<Awaited<ReturnType<typeof updateCreditExpiryAdmin>>>
    export type UpdateCreditExpiryAdminMutationBody = UpdateMakeUpCreditExpiryRequest
    export type UpdateCreditExpiryAdminMutationError = unknown

    export const useUpdateCreditExpiryAdmin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCreditExpiryAdmin>>, TError,{schoolId: string;creditId: string;data: UpdateMakeUpCreditExpiryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCreditExpiryAdmin>>,
        TError,
        {schoolId: string;creditId: string;data: UpdateMakeUpCreditExpiryRequest},
        TContext
      > => {

      const mutationOptions = getUpdateCreditExpiryAdminMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteCreditAdmin = (
    schoolId: string,
    creditId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/credits/${creditId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCreditAdminMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCreditAdmin>>, TError,{schoolId: string;creditId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCreditAdmin>>, TError,{schoolId: string;creditId: string}, TContext> => {

const mutationKey = ['deleteCreditAdmin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCreditAdmin>>, {schoolId: string;creditId: string}> = (props) => {
          const {schoolId,creditId} = props ?? {};

          return  deleteCreditAdmin(schoolId,creditId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCreditAdminMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCreditAdmin>>>
    
    export type DeleteCreditAdminMutationError = unknown

    export const useDeleteCreditAdmin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCreditAdmin>>, TError,{schoolId: string;creditId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCreditAdmin>>,
        TError,
        {schoolId: string;creditId: string},
        TContext
      > => {

      const mutationOptions = getDeleteCreditAdminMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listInvoices = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<InvoiceResponse[]>(
      {url: `/api/v1/schools/${schoolId}/invoices`, method: 'GET', signal
    },
      options);
    }
  



export const getListInvoicesQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/invoices`
    ] as const;
    }

    
export const getListInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof listInvoices>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvoicesQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoices>>> = ({ signal }) => listInvoices(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listInvoices>>>
export type ListInvoicesQueryError = unknown


export function useListInvoices<TData = Awaited<ReturnType<typeof listInvoices>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvoices>>,
          TError,
          Awaited<ReturnType<typeof listInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInvoices<TData = Awaited<ReturnType<typeof listInvoices>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvoices>>,
          TError,
          Awaited<ReturnType<typeof listInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInvoices<TData = Awaited<ReturnType<typeof listInvoices>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListInvoices<TData = Awaited<ReturnType<typeof listInvoices>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInvoicesQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listStudentInvoices = (
    schoolId: string,
    studentMemberId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<StudentInvoiceResponse[]>(
      {url: `/api/v1/schools/${schoolId}/invoices/student/${studentMemberId}`, method: 'GET', signal
    },
      options);
    }
  



export const getListStudentInvoicesQueryKey = (schoolId?: string,
    studentMemberId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/invoices/student/${studentMemberId}`
    ] as const;
    }

    
export const getListStudentInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof listStudentInvoices>>, TError = unknown>(schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStudentInvoicesQueryKey(schoolId,studentMemberId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStudentInvoices>>> = ({ signal }) => listStudentInvoices(schoolId,studentMemberId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && studentMemberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStudentInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStudentInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listStudentInvoices>>>
export type ListStudentInvoicesQueryError = unknown


export function useListStudentInvoices<TData = Awaited<ReturnType<typeof listStudentInvoices>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStudentInvoices>>,
          TError,
          Awaited<ReturnType<typeof listStudentInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStudentInvoices<TData = Awaited<ReturnType<typeof listStudentInvoices>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStudentInvoices>>,
          TError,
          Awaited<ReturnType<typeof listStudentInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStudentInvoices<TData = Awaited<ReturnType<typeof listStudentInvoices>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListStudentInvoices<TData = Awaited<ReturnType<typeof listStudentInvoices>>, TError = unknown>(
 schoolId: string,
    studentMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudentInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStudentInvoicesQueryOptions(schoolId,studentMemberId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const retryInvoice = (
    schoolId: string,
    invoiceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<InvoiceResponse>(
      {url: `/api/v1/schools/${schoolId}/invoices/${invoiceId}/retry`, method: 'POST', signal
    },
      options);
    }
  


export const getRetryInvoiceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryInvoice>>, TError,{schoolId: string;invoiceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof retryInvoice>>, TError,{schoolId: string;invoiceId: string}, TContext> => {

const mutationKey = ['retryInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryInvoice>>, {schoolId: string;invoiceId: string}> = (props) => {
          const {schoolId,invoiceId} = props ?? {};

          return  retryInvoice(schoolId,invoiceId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RetryInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof retryInvoice>>>
    
    export type RetryInvoiceMutationError = unknown

    export const useRetryInvoice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryInvoice>>, TError,{schoolId: string;invoiceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryInvoice>>,
        TError,
        {schoolId: string;invoiceId: string},
        TContext
      > => {

      const mutationOptions = getRetryInvoiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const downloadInvoicePdf = (
    schoolId: string,
    invoiceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/invoices/${invoiceId}/download`, method: 'GET', signal
    },
      options);
    }
  



export const getDownloadInvoicePdfQueryKey = (schoolId?: string,
    invoiceId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/invoices/${invoiceId}/download`
    ] as const;
    }

    
export const getDownloadInvoicePdfQueryOptions = <TData = Awaited<ReturnType<typeof downloadInvoicePdf>>, TError = unknown>(schoolId: string,
    invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadInvoicePdfQueryKey(schoolId,invoiceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadInvoicePdf>>> = ({ signal }) => downloadInvoicePdf(schoolId,invoiceId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && invoiceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadInvoicePdfQueryResult = NonNullable<Awaited<ReturnType<typeof downloadInvoicePdf>>>
export type DownloadInvoicePdfQueryError = unknown


export function useDownloadInvoicePdf<TData = Awaited<ReturnType<typeof downloadInvoicePdf>>, TError = unknown>(
 schoolId: string,
    invoiceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadInvoicePdf>>,
          TError,
          Awaited<ReturnType<typeof downloadInvoicePdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadInvoicePdf<TData = Awaited<ReturnType<typeof downloadInvoicePdf>>, TError = unknown>(
 schoolId: string,
    invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadInvoicePdf>>,
          TError,
          Awaited<ReturnType<typeof downloadInvoicePdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadInvoicePdf<TData = Awaited<ReturnType<typeof downloadInvoicePdf>>, TError = unknown>(
 schoolId: string,
    invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDownloadInvoicePdf<TData = Awaited<ReturnType<typeof downloadInvoicePdf>>, TError = unknown>(
 schoolId: string,
    invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadInvoicePdfQueryOptions(schoolId,invoiceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const recordCoachPayment = (
    schoolId: string,
    recordCoachPaymentRequest: RecordCoachPaymentRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coaches/payments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: recordCoachPaymentRequest, signal
    },
      options);
    }
  


export const getRecordCoachPaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordCoachPayment>>, TError,{schoolId: string;data: RecordCoachPaymentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof recordCoachPayment>>, TError,{schoolId: string;data: RecordCoachPaymentRequest}, TContext> => {

const mutationKey = ['recordCoachPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordCoachPayment>>, {schoolId: string;data: RecordCoachPaymentRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  recordCoachPayment(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RecordCoachPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof recordCoachPayment>>>
    export type RecordCoachPaymentMutationBody = RecordCoachPaymentRequest
    export type RecordCoachPaymentMutationError = unknown

    export const useRecordCoachPayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordCoachPayment>>, TError,{schoolId: string;data: RecordCoachPaymentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordCoachPayment>>,
        TError,
        {schoolId: string;data: RecordCoachPaymentRequest},
        TContext
      > => {

      const mutationOptions = getRecordCoachPaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteBill = (
    schoolId: string,
    id: string,
    params?: DeleteBillParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/billing/bills/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteBillMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBill>>, TError,{schoolId: string;id: string;params?: DeleteBillParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBill>>, TError,{schoolId: string;id: string;params?: DeleteBillParams}, TContext> => {

const mutationKey = ['deleteBill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBill>>, {schoolId: string;id: string;params?: DeleteBillParams}> = (props) => {
          const {schoolId,id,params} = props ?? {};

          return  deleteBill(schoolId,id,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBillMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBill>>>
    
    export type DeleteBillMutationError = unknown

    export const useDeleteBill = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBill>>, TError,{schoolId: string;id: string;params?: DeleteBillParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBill>>,
        TError,
        {schoolId: string;id: string;params?: DeleteBillParams},
        TContext
      > => {

      const mutationOptions = getDeleteBillMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateBill = (
    schoolId: string,
    id: string,
    updateBillRequest: UpdateBillRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/billing/bills/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateBillRequest
    },
      options);
    }
  


export const getUpdateBillMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBill>>, TError,{schoolId: string;id: string;data: UpdateBillRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBill>>, TError,{schoolId: string;id: string;data: UpdateBillRequest}, TContext> => {

const mutationKey = ['updateBill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBill>>, {schoolId: string;id: string;data: UpdateBillRequest}> = (props) => {
          const {schoolId,id,data} = props ?? {};

          return  updateBill(schoolId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateBillMutationResult = NonNullable<Awaited<ReturnType<typeof updateBill>>>
    export type UpdateBillMutationBody = UpdateBillRequest
    export type UpdateBillMutationError = unknown

    export const useUpdateBill = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBill>>, TError,{schoolId: string;id: string;data: UpdateBillRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateBill>>,
        TError,
        {schoolId: string;id: string;data: UpdateBillRequest},
        TContext
      > => {

      const mutationOptions = getUpdateBillMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getSchoolIntegrations = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SchoolIntegrationsResponse>(
      {url: `/api/v1/schools/${schoolId}/integrations`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSchoolIntegrationsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/integrations`
    ] as const;
    }

    
export const getGetSchoolIntegrationsQueryOptions = <TData = Awaited<ReturnType<typeof getSchoolIntegrations>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolIntegrations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSchoolIntegrationsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchoolIntegrations>>> = ({ signal }) => getSchoolIntegrations(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchoolIntegrations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSchoolIntegrationsQueryResult = NonNullable<Awaited<ReturnType<typeof getSchoolIntegrations>>>
export type GetSchoolIntegrationsQueryError = unknown


export function useGetSchoolIntegrations<TData = Awaited<ReturnType<typeof getSchoolIntegrations>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolIntegrations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchoolIntegrations>>,
          TError,
          Awaited<ReturnType<typeof getSchoolIntegrations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchoolIntegrations<TData = Awaited<ReturnType<typeof getSchoolIntegrations>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolIntegrations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchoolIntegrations>>,
          TError,
          Awaited<ReturnType<typeof getSchoolIntegrations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchoolIntegrations<TData = Awaited<ReturnType<typeof getSchoolIntegrations>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolIntegrations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSchoolIntegrations<TData = Awaited<ReturnType<typeof getSchoolIntegrations>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolIntegrations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSchoolIntegrationsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateSchoolIntegrations = (
    schoolId: string,
    updateSchoolIntegrationsRequest: UpdateSchoolIntegrationsRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SchoolIntegrationsResponse>(
      {url: `/api/v1/schools/${schoolId}/integrations`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSchoolIntegrationsRequest
    },
      options);
    }
  


export const getUpdateSchoolIntegrationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolIntegrations>>, TError,{schoolId: string;data: UpdateSchoolIntegrationsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSchoolIntegrations>>, TError,{schoolId: string;data: UpdateSchoolIntegrationsRequest}, TContext> => {

const mutationKey = ['updateSchoolIntegrations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSchoolIntegrations>>, {schoolId: string;data: UpdateSchoolIntegrationsRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  updateSchoolIntegrations(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSchoolIntegrationsMutationResult = NonNullable<Awaited<ReturnType<typeof updateSchoolIntegrations>>>
    export type UpdateSchoolIntegrationsMutationBody = UpdateSchoolIntegrationsRequest
    export type UpdateSchoolIntegrationsMutationError = unknown

    export const useUpdateSchoolIntegrations = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolIntegrations>>, TError,{schoolId: string;data: UpdateSchoolIntegrationsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSchoolIntegrations>>,
        TError,
        {schoolId: string;data: UpdateSchoolIntegrationsRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSchoolIntegrationsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listPaymentGateways = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PaymentGatewayConfigResponse[]>(
      {url: `/api/v1/schools/${schoolId}/gateways`, method: 'GET', signal
    },
      options);
    }
  



export const getListPaymentGatewaysQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/gateways`
    ] as const;
    }

    
export const getListPaymentGatewaysQueryOptions = <TData = Awaited<ReturnType<typeof listPaymentGateways>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentGateways>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPaymentGatewaysQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPaymentGateways>>> = ({ signal }) => listPaymentGateways(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPaymentGateways>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPaymentGatewaysQueryResult = NonNullable<Awaited<ReturnType<typeof listPaymentGateways>>>
export type ListPaymentGatewaysQueryError = unknown


export function useListPaymentGateways<TData = Awaited<ReturnType<typeof listPaymentGateways>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentGateways>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPaymentGateways>>,
          TError,
          Awaited<ReturnType<typeof listPaymentGateways>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPaymentGateways<TData = Awaited<ReturnType<typeof listPaymentGateways>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentGateways>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPaymentGateways>>,
          TError,
          Awaited<ReturnType<typeof listPaymentGateways>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPaymentGateways<TData = Awaited<ReturnType<typeof listPaymentGateways>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentGateways>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListPaymentGateways<TData = Awaited<ReturnType<typeof listPaymentGateways>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentGateways>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPaymentGatewaysQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createPaymentGateway = (
    schoolId: string,
    upsertPaymentGatewayConfigRequest: UpsertPaymentGatewayConfigRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PaymentGatewayConfigResponse>(
      {url: `/api/v1/schools/${schoolId}/gateways`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertPaymentGatewayConfigRequest, signal
    },
      options);
    }
  


export const getCreatePaymentGatewayMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentGateway>>, TError,{schoolId: string;data: UpsertPaymentGatewayConfigRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createPaymentGateway>>, TError,{schoolId: string;data: UpsertPaymentGatewayConfigRequest}, TContext> => {

const mutationKey = ['createPaymentGateway'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPaymentGateway>>, {schoolId: string;data: UpsertPaymentGatewayConfigRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createPaymentGateway(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePaymentGatewayMutationResult = NonNullable<Awaited<ReturnType<typeof createPaymentGateway>>>
    export type CreatePaymentGatewayMutationBody = UpsertPaymentGatewayConfigRequest
    export type CreatePaymentGatewayMutationError = unknown

    export const useCreatePaymentGateway = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentGateway>>, TError,{schoolId: string;data: UpsertPaymentGatewayConfigRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPaymentGateway>>,
        TError,
        {schoolId: string;data: UpsertPaymentGatewayConfigRequest},
        TContext
      > => {

      const mutationOptions = getCreatePaymentGatewayMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updatePaymentGateway = (
    schoolId: string,
    id: string,
    upsertPaymentGatewayConfigRequest: UpsertPaymentGatewayConfigRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PaymentGatewayConfigResponse>(
      {url: `/api/v1/schools/${schoolId}/gateways/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertPaymentGatewayConfigRequest
    },
      options);
    }
  


export const getUpdatePaymentGatewayMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentGateway>>, TError,{schoolId: string;id: string;data: UpsertPaymentGatewayConfigRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePaymentGateway>>, TError,{schoolId: string;id: string;data: UpsertPaymentGatewayConfigRequest}, TContext> => {

const mutationKey = ['updatePaymentGateway'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePaymentGateway>>, {schoolId: string;id: string;data: UpsertPaymentGatewayConfigRequest}> = (props) => {
          const {schoolId,id,data} = props ?? {};

          return  updatePaymentGateway(schoolId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePaymentGatewayMutationResult = NonNullable<Awaited<ReturnType<typeof updatePaymentGateway>>>
    export type UpdatePaymentGatewayMutationBody = UpsertPaymentGatewayConfigRequest
    export type UpdatePaymentGatewayMutationError = unknown

    export const useUpdatePaymentGateway = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentGateway>>, TError,{schoolId: string;id: string;data: UpsertPaymentGatewayConfigRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePaymentGateway>>,
        TError,
        {schoolId: string;id: string;data: UpsertPaymentGatewayConfigRequest},
        TContext
      > => {

      const mutationOptions = getUpdatePaymentGatewayMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deletePaymentGateway = (
    schoolId: string,
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/gateways/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeletePaymentGatewayMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePaymentGateway>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePaymentGateway>>, TError,{schoolId: string;id: string}, TContext> => {

const mutationKey = ['deletePaymentGateway'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePaymentGateway>>, {schoolId: string;id: string}> = (props) => {
          const {schoolId,id} = props ?? {};

          return  deletePaymentGateway(schoolId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePaymentGatewayMutationResult = NonNullable<Awaited<ReturnType<typeof deletePaymentGateway>>>
    
    export type DeletePaymentGatewayMutationError = unknown

    export const useDeletePaymentGateway = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePaymentGateway>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePaymentGateway>>,
        TError,
        {schoolId: string;id: string},
        TContext
      > => {

      const mutationOptions = getDeletePaymentGatewayMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const activatePaymentGateway = (
    schoolId: string,
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PaymentGatewayConfigResponse>(
      {url: `/api/v1/schools/${schoolId}/gateways/${id}/activate`, method: 'POST', signal
    },
      options);
    }
  


export const getActivatePaymentGatewayMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activatePaymentGateway>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activatePaymentGateway>>, TError,{schoolId: string;id: string}, TContext> => {

const mutationKey = ['activatePaymentGateway'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activatePaymentGateway>>, {schoolId: string;id: string}> = (props) => {
          const {schoolId,id} = props ?? {};

          return  activatePaymentGateway(schoolId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivatePaymentGatewayMutationResult = NonNullable<Awaited<ReturnType<typeof activatePaymentGateway>>>
    
    export type ActivatePaymentGatewayMutationError = unknown

    export const useActivatePaymentGateway = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activatePaymentGateway>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activatePaymentGateway>>,
        TError,
        {schoolId: string;id: string},
        TContext
      > => {

      const mutationOptions = getActivatePaymentGatewayMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const generateCoupons = (
    schoolId: string,
    generateCouponsRequest: GenerateCouponsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coupons/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateCouponsRequest, signal
    },
      options);
    }
  


export const getGenerateCouponsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCoupons>>, TError,{schoolId: string;data: GenerateCouponsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generateCoupons>>, TError,{schoolId: string;data: GenerateCouponsRequest}, TContext> => {

const mutationKey = ['generateCoupons'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateCoupons>>, {schoolId: string;data: GenerateCouponsRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  generateCoupons(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateCouponsMutationResult = NonNullable<Awaited<ReturnType<typeof generateCoupons>>>
    export type GenerateCouponsMutationBody = GenerateCouponsRequest
    export type GenerateCouponsMutationError = unknown

    export const useGenerateCoupons = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCoupons>>, TError,{schoolId: string;data: GenerateCouponsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateCoupons>>,
        TError,
        {schoolId: string;data: GenerateCouponsRequest},
        TContext
      > => {

      const mutationOptions = getGenerateCouponsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const redeemCoupon = (
    schoolId: string,
    redeemCouponRequest: RedeemCouponRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coupons/redeem`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: redeemCouponRequest, signal
    },
      options);
    }
  


export const getRedeemCouponMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemCoupon>>, TError,{schoolId: string;data: RedeemCouponRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof redeemCoupon>>, TError,{schoolId: string;data: RedeemCouponRequest}, TContext> => {

const mutationKey = ['redeemCoupon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeemCoupon>>, {schoolId: string;data: RedeemCouponRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  redeemCoupon(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RedeemCouponMutationResult = NonNullable<Awaited<ReturnType<typeof redeemCoupon>>>
    export type RedeemCouponMutationBody = RedeemCouponRequest
    export type RedeemCouponMutationError = unknown

    export const useRedeemCoupon = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemCoupon>>, TError,{schoolId: string;data: RedeemCouponRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof redeemCoupon>>,
        TError,
        {schoolId: string;data: RedeemCouponRequest},
        TContext
      > => {

      const mutationOptions = getRedeemCouponMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listCoupons = (
    schoolId: string,
    params?: ListCouponsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DiscountCouponResponse[]>(
      {url: `/api/v1/schools/${schoolId}/coupons`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListCouponsQueryKey = (schoolId?: string,
    params?: ListCouponsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/coupons`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListCouponsQueryOptions = <TData = Awaited<ReturnType<typeof listCoupons>>, TError = unknown>(schoolId: string,
    params?: ListCouponsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCouponsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCoupons>>> = ({ signal }) => listCoupons(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCouponsQueryResult = NonNullable<Awaited<ReturnType<typeof listCoupons>>>
export type ListCouponsQueryError = unknown


export function useListCoupons<TData = Awaited<ReturnType<typeof listCoupons>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListCouponsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCoupons>>,
          TError,
          Awaited<ReturnType<typeof listCoupons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCoupons<TData = Awaited<ReturnType<typeof listCoupons>>, TError = unknown>(
 schoolId: string,
    params?: ListCouponsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCoupons>>,
          TError,
          Awaited<ReturnType<typeof listCoupons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCoupons<TData = Awaited<ReturnType<typeof listCoupons>>, TError = unknown>(
 schoolId: string,
    params?: ListCouponsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCoupons<TData = Awaited<ReturnType<typeof listCoupons>>, TError = unknown>(
 schoolId: string,
    params?: ListCouponsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCouponsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getCouponQrCode = (
    schoolId: string,
    code: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coupons/code/${code}/qr`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCouponQrCodeQueryKey = (schoolId?: string,
    code?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/coupons/code/${code}/qr`
    ] as const;
    }

    
export const getGetCouponQrCodeQueryOptions = <TData = Awaited<ReturnType<typeof getCouponQrCode>>, TError = unknown>(schoolId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponQrCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCouponQrCodeQueryKey(schoolId,code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCouponQrCode>>> = ({ signal }) => getCouponQrCode(schoolId,code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCouponQrCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCouponQrCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getCouponQrCode>>>
export type GetCouponQrCodeQueryError = unknown


export function useGetCouponQrCode<TData = Awaited<ReturnType<typeof getCouponQrCode>>, TError = unknown>(
 schoolId: string,
    code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponQrCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCouponQrCode>>,
          TError,
          Awaited<ReturnType<typeof getCouponQrCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCouponQrCode<TData = Awaited<ReturnType<typeof getCouponQrCode>>, TError = unknown>(
 schoolId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponQrCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCouponQrCode>>,
          TError,
          Awaited<ReturnType<typeof getCouponQrCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCouponQrCode<TData = Awaited<ReturnType<typeof getCouponQrCode>>, TError = unknown>(
 schoolId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponQrCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCouponQrCode<TData = Awaited<ReturnType<typeof getCouponQrCode>>, TError = unknown>(
 schoolId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponQrCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCouponQrCodeQueryOptions(schoolId,code,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getCouponByCode = (
    schoolId: string,
    code: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DiscountCouponResponse>(
      {url: `/api/v1/schools/${schoolId}/coupons/code/${code}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCouponByCodeQueryKey = (schoolId?: string,
    code?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/coupons/code/${code}`
    ] as const;
    }

    
export const getGetCouponByCodeQueryOptions = <TData = Awaited<ReturnType<typeof getCouponByCode>>, TError = unknown>(schoolId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCouponByCodeQueryKey(schoolId,code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCouponByCode>>> = ({ signal }) => getCouponByCode(schoolId,code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCouponByCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCouponByCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getCouponByCode>>>
export type GetCouponByCodeQueryError = unknown


export function useGetCouponByCode<TData = Awaited<ReturnType<typeof getCouponByCode>>, TError = unknown>(
 schoolId: string,
    code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponByCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCouponByCode>>,
          TError,
          Awaited<ReturnType<typeof getCouponByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCouponByCode<TData = Awaited<ReturnType<typeof getCouponByCode>>, TError = unknown>(
 schoolId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponByCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCouponByCode>>,
          TError,
          Awaited<ReturnType<typeof getCouponByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCouponByCode<TData = Awaited<ReturnType<typeof getCouponByCode>>, TError = unknown>(
 schoolId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCouponByCode<TData = Awaited<ReturnType<typeof getCouponByCode>>, TError = unknown>(
 schoolId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCouponByCodeQueryOptions(schoolId,code,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getCouponUsages = (
    schoolId: string,
    couponId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DiscountCouponUsageResponse[]>(
      {url: `/api/v1/schools/${schoolId}/coupons/${couponId}/usages`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCouponUsagesQueryKey = (schoolId?: string,
    couponId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/coupons/${couponId}/usages`
    ] as const;
    }

    
export const getGetCouponUsagesQueryOptions = <TData = Awaited<ReturnType<typeof getCouponUsages>>, TError = unknown>(schoolId: string,
    couponId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponUsages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCouponUsagesQueryKey(schoolId,couponId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCouponUsages>>> = ({ signal }) => getCouponUsages(schoolId,couponId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && couponId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCouponUsages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCouponUsagesQueryResult = NonNullable<Awaited<ReturnType<typeof getCouponUsages>>>
export type GetCouponUsagesQueryError = unknown


export function useGetCouponUsages<TData = Awaited<ReturnType<typeof getCouponUsages>>, TError = unknown>(
 schoolId: string,
    couponId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponUsages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCouponUsages>>,
          TError,
          Awaited<ReturnType<typeof getCouponUsages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCouponUsages<TData = Awaited<ReturnType<typeof getCouponUsages>>, TError = unknown>(
 schoolId: string,
    couponId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponUsages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCouponUsages>>,
          TError,
          Awaited<ReturnType<typeof getCouponUsages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCouponUsages<TData = Awaited<ReturnType<typeof getCouponUsages>>, TError = unknown>(
 schoolId: string,
    couponId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponUsages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCouponUsages<TData = Awaited<ReturnType<typeof getCouponUsages>>, TError = unknown>(
 schoolId: string,
    couponId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponUsages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCouponUsagesQueryOptions(schoolId,couponId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const deleteCoupon = (
    schoolId: string,
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coupons/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCouponMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCoupon>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCoupon>>, TError,{schoolId: string;id: string}, TContext> => {

const mutationKey = ['deleteCoupon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCoupon>>, {schoolId: string;id: string}> = (props) => {
          const {schoolId,id} = props ?? {};

          return  deleteCoupon(schoolId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCouponMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCoupon>>>
    
    export type DeleteCouponMutationError = unknown

    export const useDeleteCoupon = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCoupon>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCoupon>>,
        TError,
        {schoolId: string;id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCouponMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createPriceList = (
    schoolId: string,
    createPriceListRequest: CreatePriceListRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/pricelists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPriceListRequest, signal
    },
      options);
    }
  


export const getCreatePriceListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPriceList>>, TError,{schoolId: string;data: CreatePriceListRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createPriceList>>, TError,{schoolId: string;data: CreatePriceListRequest}, TContext> => {

const mutationKey = ['createPriceList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPriceList>>, {schoolId: string;data: CreatePriceListRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createPriceList(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePriceListMutationResult = NonNullable<Awaited<ReturnType<typeof createPriceList>>>
    export type CreatePriceListMutationBody = CreatePriceListRequest
    export type CreatePriceListMutationError = unknown

    export const useCreatePriceList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPriceList>>, TError,{schoolId: string;data: CreatePriceListRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPriceList>>,
        TError,
        {schoolId: string;data: CreatePriceListRequest},
        TContext
      > => {

      const mutationOptions = getCreatePriceListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listPriceLists = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/pricelists`, method: 'GET', signal
    },
      options);
    }
  



export const getListPriceListsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/pricelists`
    ] as const;
    }

    
export const getListPriceListsQueryOptions = <TData = Awaited<ReturnType<typeof listPriceLists>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPriceLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPriceListsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPriceLists>>> = ({ signal }) => listPriceLists(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPriceLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPriceListsQueryResult = NonNullable<Awaited<ReturnType<typeof listPriceLists>>>
export type ListPriceListsQueryError = unknown


export function useListPriceLists<TData = Awaited<ReturnType<typeof listPriceLists>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPriceLists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPriceLists>>,
          TError,
          Awaited<ReturnType<typeof listPriceLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPriceLists<TData = Awaited<ReturnType<typeof listPriceLists>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPriceLists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPriceLists>>,
          TError,
          Awaited<ReturnType<typeof listPriceLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPriceLists<TData = Awaited<ReturnType<typeof listPriceLists>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPriceLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListPriceLists<TData = Awaited<ReturnType<typeof listPriceLists>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPriceLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPriceListsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getPriceList = (
    schoolId: string,
    priceListId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/pricelists/${priceListId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPriceListQueryKey = (schoolId?: string,
    priceListId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/pricelists/${priceListId}`
    ] as const;
    }

    
export const getGetPriceListQueryOptions = <TData = Awaited<ReturnType<typeof getPriceList>>, TError = unknown>(schoolId: string,
    priceListId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPriceListQueryKey(schoolId,priceListId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPriceList>>> = ({ signal }) => getPriceList(schoolId,priceListId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && priceListId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPriceList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPriceListQueryResult = NonNullable<Awaited<ReturnType<typeof getPriceList>>>
export type GetPriceListQueryError = unknown


export function useGetPriceList<TData = Awaited<ReturnType<typeof getPriceList>>, TError = unknown>(
 schoolId: string,
    priceListId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPriceList>>,
          TError,
          Awaited<ReturnType<typeof getPriceList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPriceList<TData = Awaited<ReturnType<typeof getPriceList>>, TError = unknown>(
 schoolId: string,
    priceListId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPriceList>>,
          TError,
          Awaited<ReturnType<typeof getPriceList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPriceList<TData = Awaited<ReturnType<typeof getPriceList>>, TError = unknown>(
 schoolId: string,
    priceListId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPriceList<TData = Awaited<ReturnType<typeof getPriceList>>, TError = unknown>(
 schoolId: string,
    priceListId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPriceListQueryOptions(schoolId,priceListId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updatePriceList = (
    schoolId: string,
    priceListId: string,
    updatePriceListRequest: UpdatePriceListRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/pricelists/${priceListId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePriceListRequest
    },
      options);
    }
  


export const getUpdatePriceListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePriceList>>, TError,{schoolId: string;priceListId: string;data: UpdatePriceListRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePriceList>>, TError,{schoolId: string;priceListId: string;data: UpdatePriceListRequest}, TContext> => {

const mutationKey = ['updatePriceList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePriceList>>, {schoolId: string;priceListId: string;data: UpdatePriceListRequest}> = (props) => {
          const {schoolId,priceListId,data} = props ?? {};

          return  updatePriceList(schoolId,priceListId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePriceListMutationResult = NonNullable<Awaited<ReturnType<typeof updatePriceList>>>
    export type UpdatePriceListMutationBody = UpdatePriceListRequest
    export type UpdatePriceListMutationError = unknown

    export const useUpdatePriceList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePriceList>>, TError,{schoolId: string;priceListId: string;data: UpdatePriceListRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePriceList>>,
        TError,
        {schoolId: string;priceListId: string;data: UpdatePriceListRequest},
        TContext
      > => {

      const mutationOptions = getUpdatePriceListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deletePriceList = (
    schoolId: string,
    priceListId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/pricelists/${priceListId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeletePriceListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePriceList>>, TError,{schoolId: string;priceListId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePriceList>>, TError,{schoolId: string;priceListId: string}, TContext> => {

const mutationKey = ['deletePriceList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePriceList>>, {schoolId: string;priceListId: string}> = (props) => {
          const {schoolId,priceListId} = props ?? {};

          return  deletePriceList(schoolId,priceListId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePriceListMutationResult = NonNullable<Awaited<ReturnType<typeof deletePriceList>>>
    
    export type DeletePriceListMutationError = unknown

    export const useDeletePriceList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePriceList>>, TError,{schoolId: string;priceListId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePriceList>>,
        TError,
        {schoolId: string;priceListId: string},
        TContext
      > => {

      const mutationOptions = getDeletePriceListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const resolvePriceListItem = (
    schoolId: string,
    priceListId: string,
    params: ResolvePriceListItemParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PriceListItemResponse>(
      {url: `/api/v1/schools/${schoolId}/pricelists/${priceListId}/resolve`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getResolvePriceListItemQueryKey = (schoolId?: string,
    priceListId?: string,
    params?: ResolvePriceListItemParams,) => {
    return [
    `/api/v1/schools/${schoolId}/pricelists/${priceListId}/resolve`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getResolvePriceListItemQueryOptions = <TData = Awaited<ReturnType<typeof resolvePriceListItem>>, TError = void>(schoolId: string,
    priceListId: string,
    params: ResolvePriceListItemParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolvePriceListItem>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getResolvePriceListItemQueryKey(schoolId,priceListId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof resolvePriceListItem>>> = ({ signal }) => resolvePriceListItem(schoolId,priceListId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && priceListId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resolvePriceListItem>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ResolvePriceListItemQueryResult = NonNullable<Awaited<ReturnType<typeof resolvePriceListItem>>>
export type ResolvePriceListItemQueryError = void


export function useResolvePriceListItem<TData = Awaited<ReturnType<typeof resolvePriceListItem>>, TError = void>(
 schoolId: string,
    priceListId: string,
    params: ResolvePriceListItemParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolvePriceListItem>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolvePriceListItem>>,
          TError,
          Awaited<ReturnType<typeof resolvePriceListItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResolvePriceListItem<TData = Awaited<ReturnType<typeof resolvePriceListItem>>, TError = void>(
 schoolId: string,
    priceListId: string,
    params: ResolvePriceListItemParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolvePriceListItem>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolvePriceListItem>>,
          TError,
          Awaited<ReturnType<typeof resolvePriceListItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResolvePriceListItem<TData = Awaited<ReturnType<typeof resolvePriceListItem>>, TError = void>(
 schoolId: string,
    priceListId: string,
    params: ResolvePriceListItemParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolvePriceListItem>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useResolvePriceListItem<TData = Awaited<ReturnType<typeof resolvePriceListItem>>, TError = void>(
 schoolId: string,
    priceListId: string,
    params: ResolvePriceListItemParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolvePriceListItem>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getResolvePriceListItemQueryOptions(schoolId,priceListId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const addPriceListItem = (
    schoolId: string,
    priceListId: string,
    createPriceListItemRequest: CreatePriceListItemRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/pricelists/${priceListId}/items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPriceListItemRequest, signal
    },
      options);
    }
  


export const getAddPriceListItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPriceListItem>>, TError,{schoolId: string;priceListId: string;data: CreatePriceListItemRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addPriceListItem>>, TError,{schoolId: string;priceListId: string;data: CreatePriceListItemRequest}, TContext> => {

const mutationKey = ['addPriceListItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addPriceListItem>>, {schoolId: string;priceListId: string;data: CreatePriceListItemRequest}> = (props) => {
          const {schoolId,priceListId,data} = props ?? {};

          return  addPriceListItem(schoolId,priceListId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddPriceListItemMutationResult = NonNullable<Awaited<ReturnType<typeof addPriceListItem>>>
    export type AddPriceListItemMutationBody = CreatePriceListItemRequest
    export type AddPriceListItemMutationError = unknown

    export const useAddPriceListItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPriceListItem>>, TError,{schoolId: string;priceListId: string;data: CreatePriceListItemRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addPriceListItem>>,
        TError,
        {schoolId: string;priceListId: string;data: CreatePriceListItemRequest},
        TContext
      > => {

      const mutationOptions = getAddPriceListItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updatePriceListItem = (
    schoolId: string,
    priceListId: string,
    itemId: string,
    updatePriceListItemRequest: UpdatePriceListItemRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/pricelists/${priceListId}/items/${itemId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePriceListItemRequest
    },
      options);
    }
  


export const getUpdatePriceListItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePriceListItem>>, TError,{schoolId: string;priceListId: string;itemId: string;data: UpdatePriceListItemRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePriceListItem>>, TError,{schoolId: string;priceListId: string;itemId: string;data: UpdatePriceListItemRequest}, TContext> => {

const mutationKey = ['updatePriceListItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePriceListItem>>, {schoolId: string;priceListId: string;itemId: string;data: UpdatePriceListItemRequest}> = (props) => {
          const {schoolId,priceListId,itemId,data} = props ?? {};

          return  updatePriceListItem(schoolId,priceListId,itemId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePriceListItemMutationResult = NonNullable<Awaited<ReturnType<typeof updatePriceListItem>>>
    export type UpdatePriceListItemMutationBody = UpdatePriceListItemRequest
    export type UpdatePriceListItemMutationError = unknown

    export const useUpdatePriceListItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePriceListItem>>, TError,{schoolId: string;priceListId: string;itemId: string;data: UpdatePriceListItemRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePriceListItem>>,
        TError,
        {schoolId: string;priceListId: string;itemId: string;data: UpdatePriceListItemRequest},
        TContext
      > => {

      const mutationOptions = getUpdatePriceListItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const removePriceListItem = (
    schoolId: string,
    priceListId: string,
    itemId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/pricelists/${priceListId}/items/${itemId}`, method: 'DELETE'
    },
      options);
    }
  


export const getRemovePriceListItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removePriceListItem>>, TError,{schoolId: string;priceListId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removePriceListItem>>, TError,{schoolId: string;priceListId: string;itemId: string}, TContext> => {

const mutationKey = ['removePriceListItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removePriceListItem>>, {schoolId: string;priceListId: string;itemId: string}> = (props) => {
          const {schoolId,priceListId,itemId} = props ?? {};

          return  removePriceListItem(schoolId,priceListId,itemId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemovePriceListItemMutationResult = NonNullable<Awaited<ReturnType<typeof removePriceListItem>>>
    
    export type RemovePriceListItemMutationError = unknown

    export const useRemovePriceListItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removePriceListItem>>, TError,{schoolId: string;priceListId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removePriceListItem>>,
        TError,
        {schoolId: string;priceListId: string;itemId: string},
        TContext
      > => {

      const mutationOptions = getRemovePriceListItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listCoachAvailability = (
    schoolId: string,
    coachMemberId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coaches/${coachMemberId}/availability`, method: 'GET', signal
    },
      options);
    }
  



export const getListCoachAvailabilityQueryKey = (schoolId?: string,
    coachMemberId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/coaches/${coachMemberId}/availability`
    ] as const;
    }

    
export const getListCoachAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof listCoachAvailability>>, TError = unknown>(schoolId: string,
    coachMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoachAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCoachAvailabilityQueryKey(schoolId,coachMemberId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCoachAvailability>>> = ({ signal }) => listCoachAvailability(schoolId,coachMemberId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && coachMemberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCoachAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCoachAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof listCoachAvailability>>>
export type ListCoachAvailabilityQueryError = unknown


export function useListCoachAvailability<TData = Awaited<ReturnType<typeof listCoachAvailability>>, TError = unknown>(
 schoolId: string,
    coachMemberId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoachAvailability>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCoachAvailability>>,
          TError,
          Awaited<ReturnType<typeof listCoachAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCoachAvailability<TData = Awaited<ReturnType<typeof listCoachAvailability>>, TError = unknown>(
 schoolId: string,
    coachMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoachAvailability>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCoachAvailability>>,
          TError,
          Awaited<ReturnType<typeof listCoachAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCoachAvailability<TData = Awaited<ReturnType<typeof listCoachAvailability>>, TError = unknown>(
 schoolId: string,
    coachMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoachAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCoachAvailability<TData = Awaited<ReturnType<typeof listCoachAvailability>>, TError = unknown>(
 schoolId: string,
    coachMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoachAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCoachAvailabilityQueryOptions(schoolId,coachMemberId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const setDateRangeUnavailability = (
    schoolId: string,
    coachMemberId: string,
    setDateRangeUnavailabilityRequest: SetDateRangeUnavailabilityRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coaches/${coachMemberId}/availability/date-range`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setDateRangeUnavailabilityRequest, signal
    },
      options);
    }
  


export const getSetDateRangeUnavailabilityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDateRangeUnavailability>>, TError,{schoolId: string;coachMemberId: string;data: SetDateRangeUnavailabilityRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setDateRangeUnavailability>>, TError,{schoolId: string;coachMemberId: string;data: SetDateRangeUnavailabilityRequest}, TContext> => {

const mutationKey = ['setDateRangeUnavailability'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDateRangeUnavailability>>, {schoolId: string;coachMemberId: string;data: SetDateRangeUnavailabilityRequest}> = (props) => {
          const {schoolId,coachMemberId,data} = props ?? {};

          return  setDateRangeUnavailability(schoolId,coachMemberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetDateRangeUnavailabilityMutationResult = NonNullable<Awaited<ReturnType<typeof setDateRangeUnavailability>>>
    export type SetDateRangeUnavailabilityMutationBody = SetDateRangeUnavailabilityRequest
    export type SetDateRangeUnavailabilityMutationError = unknown

    export const useSetDateRangeUnavailability = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDateRangeUnavailability>>, TError,{schoolId: string;coachMemberId: string;data: SetDateRangeUnavailabilityRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDateRangeUnavailability>>,
        TError,
        {schoolId: string;coachMemberId: string;data: SetDateRangeUnavailabilityRequest},
        TContext
      > => {

      const mutationOptions = getSetDateRangeUnavailabilityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setRecurringUnavailability = (
    schoolId: string,
    coachMemberId: string,
    setRecurringUnavailabilityRequest: SetRecurringUnavailabilityRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coaches/${coachMemberId}/availability/recurring`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setRecurringUnavailabilityRequest, signal
    },
      options);
    }
  


export const getSetRecurringUnavailabilityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setRecurringUnavailability>>, TError,{schoolId: string;coachMemberId: string;data: SetRecurringUnavailabilityRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setRecurringUnavailability>>, TError,{schoolId: string;coachMemberId: string;data: SetRecurringUnavailabilityRequest}, TContext> => {

const mutationKey = ['setRecurringUnavailability'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setRecurringUnavailability>>, {schoolId: string;coachMemberId: string;data: SetRecurringUnavailabilityRequest}> = (props) => {
          const {schoolId,coachMemberId,data} = props ?? {};

          return  setRecurringUnavailability(schoolId,coachMemberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetRecurringUnavailabilityMutationResult = NonNullable<Awaited<ReturnType<typeof setRecurringUnavailability>>>
    export type SetRecurringUnavailabilityMutationBody = SetRecurringUnavailabilityRequest
    export type SetRecurringUnavailabilityMutationError = unknown

    export const useSetRecurringUnavailability = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setRecurringUnavailability>>, TError,{schoolId: string;coachMemberId: string;data: SetRecurringUnavailabilityRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setRecurringUnavailability>>,
        TError,
        {schoolId: string;coachMemberId: string;data: SetRecurringUnavailabilityRequest},
        TContext
      > => {

      const mutationOptions = getSetRecurringUnavailabilityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteCoachAvailability = (
    schoolId: string,
    coachMemberId: string,
    availabilityId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coaches/${coachMemberId}/availability/${availabilityId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCoachAvailabilityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCoachAvailability>>, TError,{schoolId: string;coachMemberId: string;availabilityId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCoachAvailability>>, TError,{schoolId: string;coachMemberId: string;availabilityId: string}, TContext> => {

const mutationKey = ['deleteCoachAvailability'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCoachAvailability>>, {schoolId: string;coachMemberId: string;availabilityId: string}> = (props) => {
          const {schoolId,coachMemberId,availabilityId} = props ?? {};

          return  deleteCoachAvailability(schoolId,coachMemberId,availabilityId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCoachAvailabilityMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCoachAvailability>>>
    
    export type DeleteCoachAvailabilityMutationError = unknown

    export const useDeleteCoachAvailability = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCoachAvailability>>, TError,{schoolId: string;coachMemberId: string;availabilityId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCoachAvailability>>,
        TError,
        {schoolId: string;coachMemberId: string;availabilityId: string},
        TContext
      > => {

      const mutationOptions = getDeleteCoachAvailabilityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listPendingSubstitutions = (
    schoolId: string,
    coachMemberId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coaches/${coachMemberId}/substitutions`, method: 'GET', signal
    },
      options);
    }
  



export const getListPendingSubstitutionsQueryKey = (schoolId?: string,
    coachMemberId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/coaches/${coachMemberId}/substitutions`
    ] as const;
    }

    
export const getListPendingSubstitutionsQueryOptions = <TData = Awaited<ReturnType<typeof listPendingSubstitutions>>, TError = unknown>(schoolId: string,
    coachMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingSubstitutions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPendingSubstitutionsQueryKey(schoolId,coachMemberId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPendingSubstitutions>>> = ({ signal }) => listPendingSubstitutions(schoolId,coachMemberId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && coachMemberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPendingSubstitutions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPendingSubstitutionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPendingSubstitutions>>>
export type ListPendingSubstitutionsQueryError = unknown


export function useListPendingSubstitutions<TData = Awaited<ReturnType<typeof listPendingSubstitutions>>, TError = unknown>(
 schoolId: string,
    coachMemberId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingSubstitutions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPendingSubstitutions>>,
          TError,
          Awaited<ReturnType<typeof listPendingSubstitutions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingSubstitutions<TData = Awaited<ReturnType<typeof listPendingSubstitutions>>, TError = unknown>(
 schoolId: string,
    coachMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingSubstitutions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPendingSubstitutions>>,
          TError,
          Awaited<ReturnType<typeof listPendingSubstitutions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingSubstitutions<TData = Awaited<ReturnType<typeof listPendingSubstitutions>>, TError = unknown>(
 schoolId: string,
    coachMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingSubstitutions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListPendingSubstitutions<TData = Awaited<ReturnType<typeof listPendingSubstitutions>>, TError = unknown>(
 schoolId: string,
    coachMemberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingSubstitutions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPendingSubstitutionsQueryOptions(schoolId,coachMemberId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const requestSubstitution = (
    schoolId: string,
    coachMemberId: string,
    requestSubstitutionRequest: RequestSubstitutionRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coaches/${coachMemberId}/substitutions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestSubstitutionRequest, signal
    },
      options);
    }
  


export const getRequestSubstitutionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestSubstitution>>, TError,{schoolId: string;coachMemberId: string;data: RequestSubstitutionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestSubstitution>>, TError,{schoolId: string;coachMemberId: string;data: RequestSubstitutionRequest}, TContext> => {

const mutationKey = ['requestSubstitution'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestSubstitution>>, {schoolId: string;coachMemberId: string;data: RequestSubstitutionRequest}> = (props) => {
          const {schoolId,coachMemberId,data} = props ?? {};

          return  requestSubstitution(schoolId,coachMemberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequestSubstitutionMutationResult = NonNullable<Awaited<ReturnType<typeof requestSubstitution>>>
    export type RequestSubstitutionMutationBody = RequestSubstitutionRequest
    export type RequestSubstitutionMutationError = unknown

    export const useRequestSubstitution = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestSubstitution>>, TError,{schoolId: string;coachMemberId: string;data: RequestSubstitutionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestSubstitution>>,
        TError,
        {schoolId: string;coachMemberId: string;data: RequestSubstitutionRequest},
        TContext
      > => {

      const mutationOptions = getRequestSubstitutionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const respondToSubstitution = (
    schoolId: string,
    coachMemberId: string,
    substitutionId: string,
    respondToSubstitutionRequest: RespondToSubstitutionRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coaches/${coachMemberId}/substitutions/${substitutionId}/respond`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: respondToSubstitutionRequest, signal
    },
      options);
    }
  


export const getRespondToSubstitutionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof respondToSubstitution>>, TError,{schoolId: string;coachMemberId: string;substitutionId: string;data: RespondToSubstitutionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof respondToSubstitution>>, TError,{schoolId: string;coachMemberId: string;substitutionId: string;data: RespondToSubstitutionRequest}, TContext> => {

const mutationKey = ['respondToSubstitution'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof respondToSubstitution>>, {schoolId: string;coachMemberId: string;substitutionId: string;data: RespondToSubstitutionRequest}> = (props) => {
          const {schoolId,coachMemberId,substitutionId,data} = props ?? {};

          return  respondToSubstitution(schoolId,coachMemberId,substitutionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RespondToSubstitutionMutationResult = NonNullable<Awaited<ReturnType<typeof respondToSubstitution>>>
    export type RespondToSubstitutionMutationBody = RespondToSubstitutionRequest
    export type RespondToSubstitutionMutationError = unknown

    export const useRespondToSubstitution = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof respondToSubstitution>>, TError,{schoolId: string;coachMemberId: string;substitutionId: string;data: RespondToSubstitutionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof respondToSubstitution>>,
        TError,
        {schoolId: string;coachMemberId: string;substitutionId: string;data: RespondToSubstitutionRequest},
        TContext
      > => {

      const mutationOptions = getRespondToSubstitutionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const coachRecordPayment = (
    schoolId: string,
    coachMemberId: string,
    coachRecordPaymentRequest: CoachRecordPaymentRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coaches/${coachMemberId}/payments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: coachRecordPaymentRequest, signal
    },
      options);
    }
  


export const getCoachRecordPaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachRecordPayment>>, TError,{schoolId: string;coachMemberId: string;data: CoachRecordPaymentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof coachRecordPayment>>, TError,{schoolId: string;coachMemberId: string;data: CoachRecordPaymentRequest}, TContext> => {

const mutationKey = ['coachRecordPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachRecordPayment>>, {schoolId: string;coachMemberId: string;data: CoachRecordPaymentRequest}> = (props) => {
          const {schoolId,coachMemberId,data} = props ?? {};

          return  coachRecordPayment(schoolId,coachMemberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachRecordPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof coachRecordPayment>>>
    export type CoachRecordPaymentMutationBody = CoachRecordPaymentRequest
    export type CoachRecordPaymentMutationError = unknown

    export const useCoachRecordPayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachRecordPayment>>, TError,{schoolId: string;coachMemberId: string;data: CoachRecordPaymentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof coachRecordPayment>>,
        TError,
        {schoolId: string;coachMemberId: string;data: CoachRecordPaymentRequest},
        TContext
      > => {

      const mutationOptions = getCoachRecordPaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getCoachCashSettlement = (
    schoolId: string,
    coachMemberId: string,
    params?: GetCoachCashSettlementParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoachCashSettlementSummary>(
      {url: `/api/v1/schools/${schoolId}/coaches/${coachMemberId}/cash-settlements`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCoachCashSettlementQueryKey = (schoolId?: string,
    coachMemberId?: string,
    params?: GetCoachCashSettlementParams,) => {
    return [
    `/api/v1/schools/${schoolId}/coaches/${coachMemberId}/cash-settlements`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCoachCashSettlementQueryOptions = <TData = Awaited<ReturnType<typeof getCoachCashSettlement>>, TError = unknown>(schoolId: string,
    coachMemberId: string,
    params?: GetCoachCashSettlementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachCashSettlement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoachCashSettlementQueryKey(schoolId,coachMemberId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoachCashSettlement>>> = ({ signal }) => getCoachCashSettlement(schoolId,coachMemberId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && coachMemberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoachCashSettlement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCoachCashSettlementQueryResult = NonNullable<Awaited<ReturnType<typeof getCoachCashSettlement>>>
export type GetCoachCashSettlementQueryError = unknown


export function useGetCoachCashSettlement<TData = Awaited<ReturnType<typeof getCoachCashSettlement>>, TError = unknown>(
 schoolId: string,
    coachMemberId: string,
    params: undefined |  GetCoachCashSettlementParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachCashSettlement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoachCashSettlement>>,
          TError,
          Awaited<ReturnType<typeof getCoachCashSettlement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCoachCashSettlement<TData = Awaited<ReturnType<typeof getCoachCashSettlement>>, TError = unknown>(
 schoolId: string,
    coachMemberId: string,
    params?: GetCoachCashSettlementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachCashSettlement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoachCashSettlement>>,
          TError,
          Awaited<ReturnType<typeof getCoachCashSettlement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCoachCashSettlement<TData = Awaited<ReturnType<typeof getCoachCashSettlement>>, TError = unknown>(
 schoolId: string,
    coachMemberId: string,
    params?: GetCoachCashSettlementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachCashSettlement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCoachCashSettlement<TData = Awaited<ReturnType<typeof getCoachCashSettlement>>, TError = unknown>(
 schoolId: string,
    coachMemberId: string,
    params?: GetCoachCashSettlementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachCashSettlement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCoachCashSettlementQueryOptions(schoolId,coachMemberId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listPendingUnavailabilityRequests = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coaches/unavailability-requests`, method: 'GET', signal
    },
      options);
    }
  



export const getListPendingUnavailabilityRequestsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/coaches/unavailability-requests`
    ] as const;
    }

    
export const getListPendingUnavailabilityRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPendingUnavailabilityRequestsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>> = ({ signal }) => listPendingUnavailabilityRequests(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPendingUnavailabilityRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>>
export type ListPendingUnavailabilityRequestsQueryError = unknown


export function useListPendingUnavailabilityRequests<TData = Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>,
          TError,
          Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingUnavailabilityRequests<TData = Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>,
          TError,
          Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingUnavailabilityRequests<TData = Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListPendingUnavailabilityRequests<TData = Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingUnavailabilityRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPendingUnavailabilityRequestsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const respondToUnavailabilityRequest = (
    schoolId: string,
    id: string,
    respondToUnavailabilityRequest: RespondToUnavailabilityRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/coaches/unavailability-requests/${id}/respond`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: respondToUnavailabilityRequest, signal
    },
      options);
    }
  


export const getRespondToUnavailabilityRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof respondToUnavailabilityRequest>>, TError,{schoolId: string;id: string;data: RespondToUnavailabilityRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof respondToUnavailabilityRequest>>, TError,{schoolId: string;id: string;data: RespondToUnavailabilityRequest}, TContext> => {

const mutationKey = ['respondToUnavailabilityRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof respondToUnavailabilityRequest>>, {schoolId: string;id: string;data: RespondToUnavailabilityRequest}> = (props) => {
          const {schoolId,id,data} = props ?? {};

          return  respondToUnavailabilityRequest(schoolId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RespondToUnavailabilityRequestMutationResult = NonNullable<Awaited<ReturnType<typeof respondToUnavailabilityRequest>>>
    export type RespondToUnavailabilityRequestMutationBody = RespondToUnavailabilityRequest
    export type RespondToUnavailabilityRequestMutationError = unknown

    export const useRespondToUnavailabilityRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof respondToUnavailabilityRequest>>, TError,{schoolId: string;id: string;data: RespondToUnavailabilityRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof respondToUnavailabilityRequest>>,
        TError,
        {schoolId: string;id: string;data: RespondToUnavailabilityRequest},
        TContext
      > => {

      const mutationOptions = getRespondToUnavailabilityRequestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listNotifications = (
    schoolId: string,
    params?: ListNotificationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/notifications`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListNotificationsQueryKey = (schoolId?: string,
    params?: ListNotificationsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/notifications`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listNotifications>>, TError = unknown>(schoolId: string,
    params?: ListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotifications>>> = ({ signal }) => listNotifications(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listNotifications>>>
export type ListNotificationsQueryError = unknown


export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = unknown>(
 schoolId: string,
    params?: ListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = unknown>(
 schoolId: string,
    params?: ListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = unknown>(
 schoolId: string,
    params?: ListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNotificationsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getUnreadCount = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/notifications/unread-count`, method: 'GET', signal
    },
      options);
    }
  



export const getGetUnreadCountQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/notifications/unread-count`
    ] as const;
    }

    
export const getGetUnreadCountQueryOptions = <TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnreadCountQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnreadCount>>> = ({ signal }) => getUnreadCount(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUnreadCountQueryResult = NonNullable<Awaited<ReturnType<typeof getUnreadCount>>>
export type GetUnreadCountQueryError = unknown


export function useGetUnreadCount<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getUnreadCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnreadCount<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getUnreadCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnreadCount<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUnreadCount<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUnreadCountQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const markNotificationRead = (
    schoolId: string,
    notificationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/notifications/${notificationId}/read`, method: 'POST', signal
    },
      options);
    }
  


export const getMarkNotificationReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{schoolId: string;notificationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{schoolId: string;notificationId: string}, TContext> => {

const mutationKey = ['markNotificationRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markNotificationRead>>, {schoolId: string;notificationId: string}> = (props) => {
          const {schoolId,notificationId} = props ?? {};

          return  markNotificationRead(schoolId,notificationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkNotificationReadMutationResult = NonNullable<Awaited<ReturnType<typeof markNotificationRead>>>
    
    export type MarkNotificationReadMutationError = unknown

    export const useMarkNotificationRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{schoolId: string;notificationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markNotificationRead>>,
        TError,
        {schoolId: string;notificationId: string},
        TContext
      > => {

      const mutationOptions = getMarkNotificationReadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const markAllNotificationsRead = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/notifications/read-all`, method: 'POST', signal
    },
      options);
    }
  


export const getMarkAllNotificationsReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError,{schoolId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError,{schoolId: string}, TContext> => {

const mutationKey = ['markAllNotificationsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAllNotificationsRead>>, {schoolId: string}> = (props) => {
          const {schoolId} = props ?? {};

          return  markAllNotificationsRead(schoolId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkAllNotificationsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAllNotificationsRead>>>
    
    export type MarkAllNotificationsReadMutationError = unknown

    export const useMarkAllNotificationsRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError,{schoolId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markAllNotificationsRead>>,
        TError,
        {schoolId: string},
        TContext
      > => {

      const mutationOptions = getMarkAllNotificationsReadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const registerSchoolPushToken = (
    schoolId: string,
    registerPushTokenRequest: RegisterPushTokenRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/notifications/push-tokens`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerPushTokenRequest, signal
    },
      options);
    }
  


export const getRegisterSchoolPushTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerSchoolPushToken>>, TError,{schoolId: string;data: RegisterPushTokenRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof registerSchoolPushToken>>, TError,{schoolId: string;data: RegisterPushTokenRequest}, TContext> => {

const mutationKey = ['registerSchoolPushToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerSchoolPushToken>>, {schoolId: string;data: RegisterPushTokenRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  registerSchoolPushToken(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegisterSchoolPushTokenMutationResult = NonNullable<Awaited<ReturnType<typeof registerSchoolPushToken>>>
    export type RegisterSchoolPushTokenMutationBody = RegisterPushTokenRequest
    export type RegisterSchoolPushTokenMutationError = unknown

    export const useRegisterSchoolPushToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerSchoolPushToken>>, TError,{schoolId: string;data: RegisterPushTokenRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registerSchoolPushToken>>,
        TError,
        {schoolId: string;data: RegisterPushTokenRequest},
        TContext
      > => {

      const mutationOptions = getRegisterSchoolPushTokenMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const unregisterSchoolPushToken = (
    schoolId: string,
    token: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/notifications/push-tokens/${token}`, method: 'DELETE'
    },
      options);
    }
  


export const getUnregisterSchoolPushTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unregisterSchoolPushToken>>, TError,{schoolId: string;token: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unregisterSchoolPushToken>>, TError,{schoolId: string;token: string}, TContext> => {

const mutationKey = ['unregisterSchoolPushToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unregisterSchoolPushToken>>, {schoolId: string;token: string}> = (props) => {
          const {schoolId,token} = props ?? {};

          return  unregisterSchoolPushToken(schoolId,token,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnregisterSchoolPushTokenMutationResult = NonNullable<Awaited<ReturnType<typeof unregisterSchoolPushToken>>>
    
    export type UnregisterSchoolPushTokenMutationError = unknown

    export const useUnregisterSchoolPushToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unregisterSchoolPushToken>>, TError,{schoolId: string;token: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unregisterSchoolPushToken>>,
        TError,
        {schoolId: string;token: string},
        TContext
      > => {

      const mutationOptions = getUnregisterSchoolPushTokenMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const registerPushToken = (
    registerPushTokenRequest: RegisterPushTokenRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/notifications/push-tokens`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerPushTokenRequest, signal
    },
      options);
    }
  


export const getRegisterPushTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerPushToken>>, TError,{data: RegisterPushTokenRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof registerPushToken>>, TError,{data: RegisterPushTokenRequest}, TContext> => {

const mutationKey = ['registerPushToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerPushToken>>, {data: RegisterPushTokenRequest}> = (props) => {
          const {data} = props ?? {};

          return  registerPushToken(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegisterPushTokenMutationResult = NonNullable<Awaited<ReturnType<typeof registerPushToken>>>
    export type RegisterPushTokenMutationBody = RegisterPushTokenRequest
    export type RegisterPushTokenMutationError = unknown

    export const useRegisterPushToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerPushToken>>, TError,{data: RegisterPushTokenRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registerPushToken>>,
        TError,
        {data: RegisterPushTokenRequest},
        TContext
      > => {

      const mutationOptions = getRegisterPushTokenMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const unregisterPushToken = (
    token: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/notifications/push-tokens/${token}`, method: 'DELETE'
    },
      options);
    }
  


export const getUnregisterPushTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unregisterPushToken>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unregisterPushToken>>, TError,{token: string}, TContext> => {

const mutationKey = ['unregisterPushToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unregisterPushToken>>, {token: string}> = (props) => {
          const {token} = props ?? {};

          return  unregisterPushToken(token,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnregisterPushTokenMutationResult = NonNullable<Awaited<ReturnType<typeof unregisterPushToken>>>
    
    export type UnregisterPushTokenMutationError = unknown

    export const useUnregisterPushToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unregisterPushToken>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unregisterPushToken>>,
        TError,
        {token: string},
        TContext
      > => {

      const mutationOptions = getUnregisterPushTokenMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const uploadAttachment = (
    schoolId: string,
    uploadAttachmentBody: UploadAttachmentBody,
    params?: UploadAttachmentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, uploadAttachmentBody.file)

      return customInstance<AttachmentResponse>(
      {url: `/api/v1/schools/${schoolId}/attachments`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData,
        params, signal
    },
      options);
    }
  


export const getUploadAttachmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAttachment>>, TError,{schoolId: string;data: UploadAttachmentBody;params?: UploadAttachmentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadAttachment>>, TError,{schoolId: string;data: UploadAttachmentBody;params?: UploadAttachmentParams}, TContext> => {

const mutationKey = ['uploadAttachment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadAttachment>>, {schoolId: string;data: UploadAttachmentBody;params?: UploadAttachmentParams}> = (props) => {
          const {schoolId,data,params} = props ?? {};

          return  uploadAttachment(schoolId,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadAttachment>>>
    export type UploadAttachmentMutationBody = UploadAttachmentBody
    export type UploadAttachmentMutationError = unknown

    export const useUploadAttachment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAttachment>>, TError,{schoolId: string;data: UploadAttachmentBody;params?: UploadAttachmentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadAttachment>>,
        TError,
        {schoolId: string;data: UploadAttachmentBody;params?: UploadAttachmentParams},
        TContext
      > => {

      const mutationOptions = getUploadAttachmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listAttachments = (
    schoolId: string,
    params?: ListAttachmentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AttachmentResponse[]>(
      {url: `/api/v1/schools/${schoolId}/attachments`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListAttachmentsQueryKey = (schoolId?: string,
    params?: ListAttachmentsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/attachments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListAttachmentsQueryOptions = <TData = Awaited<ReturnType<typeof listAttachments>>, TError = unknown>(schoolId: string,
    params?: ListAttachmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAttachments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAttachmentsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAttachments>>> = ({ signal }) => listAttachments(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAttachments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAttachmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAttachments>>>
export type ListAttachmentsQueryError = unknown


export function useListAttachments<TData = Awaited<ReturnType<typeof listAttachments>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListAttachmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAttachments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAttachments>>,
          TError,
          Awaited<ReturnType<typeof listAttachments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAttachments<TData = Awaited<ReturnType<typeof listAttachments>>, TError = unknown>(
 schoolId: string,
    params?: ListAttachmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAttachments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAttachments>>,
          TError,
          Awaited<ReturnType<typeof listAttachments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAttachments<TData = Awaited<ReturnType<typeof listAttachments>>, TError = unknown>(
 schoolId: string,
    params?: ListAttachmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAttachments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAttachments<TData = Awaited<ReturnType<typeof listAttachments>>, TError = unknown>(
 schoolId: string,
    params?: ListAttachmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAttachments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAttachmentsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getAttachment = (
    schoolId: string,
    attachmentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AttachmentResponse>(
      {url: `/api/v1/schools/${schoolId}/attachments/${attachmentId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAttachmentQueryKey = (schoolId?: string,
    attachmentId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/attachments/${attachmentId}`
    ] as const;
    }

    
export const getGetAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof getAttachment>>, TError = unknown>(schoolId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttachmentQueryKey(schoolId,attachmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttachment>>> = ({ signal }) => getAttachment(schoolId,attachmentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && attachmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof getAttachment>>>
export type GetAttachmentQueryError = unknown


export function useGetAttachment<TData = Awaited<ReturnType<typeof getAttachment>>, TError = unknown>(
 schoolId: string,
    attachmentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttachment>>,
          TError,
          Awaited<ReturnType<typeof getAttachment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttachment<TData = Awaited<ReturnType<typeof getAttachment>>, TError = unknown>(
 schoolId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttachment>>,
          TError,
          Awaited<ReturnType<typeof getAttachment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttachment<TData = Awaited<ReturnType<typeof getAttachment>>, TError = unknown>(
 schoolId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAttachment<TData = Awaited<ReturnType<typeof getAttachment>>, TError = unknown>(
 schoolId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAttachmentQueryOptions(schoolId,attachmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const deleteAttachment = (
    schoolId: string,
    attachmentId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/attachments/${attachmentId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAttachmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttachment>>, TError,{schoolId: string;attachmentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAttachment>>, TError,{schoolId: string;attachmentId: string}, TContext> => {

const mutationKey = ['deleteAttachment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAttachment>>, {schoolId: string;attachmentId: string}> = (props) => {
          const {schoolId,attachmentId} = props ?? {};

          return  deleteAttachment(schoolId,attachmentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAttachment>>>
    
    export type DeleteAttachmentMutationError = unknown

    export const useDeleteAttachment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttachment>>, TError,{schoolId: string;attachmentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAttachment>>,
        TError,
        {schoolId: string;attachmentId: string},
        TContext
      > => {

      const mutationOptions = getDeleteAttachmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateAttachment = (
    schoolId: string,
    attachmentId: string,
    updateMediaRequest: UpdateMediaRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<AttachmentResponse>(
      {url: `/api/v1/schools/${schoolId}/attachments/${attachmentId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMediaRequest
    },
      options);
    }
  


export const getUpdateAttachmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAttachment>>, TError,{schoolId: string;attachmentId: string;data: UpdateMediaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAttachment>>, TError,{schoolId: string;attachmentId: string;data: UpdateMediaRequest}, TContext> => {

const mutationKey = ['updateAttachment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAttachment>>, {schoolId: string;attachmentId: string;data: UpdateMediaRequest}> = (props) => {
          const {schoolId,attachmentId,data} = props ?? {};

          return  updateAttachment(schoolId,attachmentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateAttachment>>>
    export type UpdateAttachmentMutationBody = UpdateMediaRequest
    export type UpdateAttachmentMutationError = unknown

    export const useUpdateAttachment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAttachment>>, TError,{schoolId: string;attachmentId: string;data: UpdateMediaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAttachment>>,
        TError,
        {schoolId: string;attachmentId: string;data: UpdateMediaRequest},
        TContext
      > => {

      const mutationOptions = getUpdateAttachmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAttachmentUsages = (
    schoolId: string,
    attachmentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AttachmentUsagesResponse>(
      {url: `/api/v1/schools/${schoolId}/attachments/${attachmentId}/usages`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAttachmentUsagesQueryKey = (schoolId?: string,
    attachmentId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/attachments/${attachmentId}/usages`
    ] as const;
    }

    
export const getGetAttachmentUsagesQueryOptions = <TData = Awaited<ReturnType<typeof getAttachmentUsages>>, TError = unknown>(schoolId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentUsages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttachmentUsagesQueryKey(schoolId,attachmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttachmentUsages>>> = ({ signal }) => getAttachmentUsages(schoolId,attachmentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && attachmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttachmentUsages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttachmentUsagesQueryResult = NonNullable<Awaited<ReturnType<typeof getAttachmentUsages>>>
export type GetAttachmentUsagesQueryError = unknown


export function useGetAttachmentUsages<TData = Awaited<ReturnType<typeof getAttachmentUsages>>, TError = unknown>(
 schoolId: string,
    attachmentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentUsages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttachmentUsages>>,
          TError,
          Awaited<ReturnType<typeof getAttachmentUsages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttachmentUsages<TData = Awaited<ReturnType<typeof getAttachmentUsages>>, TError = unknown>(
 schoolId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentUsages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttachmentUsages>>,
          TError,
          Awaited<ReturnType<typeof getAttachmentUsages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttachmentUsages<TData = Awaited<ReturnType<typeof getAttachmentUsages>>, TError = unknown>(
 schoolId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentUsages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAttachmentUsages<TData = Awaited<ReturnType<typeof getAttachmentUsages>>, TError = unknown>(
 schoolId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentUsages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAttachmentUsagesQueryOptions(schoolId,attachmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const addExternalAttachment = (
    schoolId: string,
    addExternalMediaRequest: AddExternalMediaRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AttachmentResponse>(
      {url: `/api/v1/schools/${schoolId}/attachments/external`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addExternalMediaRequest, signal
    },
      options);
    }
  


export const getAddExternalAttachmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addExternalAttachment>>, TError,{schoolId: string;data: AddExternalMediaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addExternalAttachment>>, TError,{schoolId: string;data: AddExternalMediaRequest}, TContext> => {

const mutationKey = ['addExternalAttachment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addExternalAttachment>>, {schoolId: string;data: AddExternalMediaRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  addExternalAttachment(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddExternalAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof addExternalAttachment>>>
    export type AddExternalAttachmentMutationBody = AddExternalMediaRequest
    export type AddExternalAttachmentMutationError = unknown

    export const useAddExternalAttachment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addExternalAttachment>>, TError,{schoolId: string;data: AddExternalMediaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addExternalAttachment>>,
        TError,
        {schoolId: string;data: AddExternalMediaRequest},
        TContext
      > => {

      const mutationOptions = getAddExternalAttachmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listActiveRegulations = (
    schoolId: string,
    params?: ListActiveRegulationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RegulationResponse[]>(
      {url: `/api/v1/schools/${schoolId}/regulations`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListActiveRegulationsQueryKey = (schoolId?: string,
    params?: ListActiveRegulationsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/regulations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListActiveRegulationsQueryOptions = <TData = Awaited<ReturnType<typeof listActiveRegulations>>, TError = unknown>(schoolId: string,
    params?: ListActiveRegulationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActiveRegulations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListActiveRegulationsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActiveRegulations>>> = ({ signal }) => listActiveRegulations(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listActiveRegulations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListActiveRegulationsQueryResult = NonNullable<Awaited<ReturnType<typeof listActiveRegulations>>>
export type ListActiveRegulationsQueryError = unknown


export function useListActiveRegulations<TData = Awaited<ReturnType<typeof listActiveRegulations>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListActiveRegulationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActiveRegulations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActiveRegulations>>,
          TError,
          Awaited<ReturnType<typeof listActiveRegulations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActiveRegulations<TData = Awaited<ReturnType<typeof listActiveRegulations>>, TError = unknown>(
 schoolId: string,
    params?: ListActiveRegulationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActiveRegulations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActiveRegulations>>,
          TError,
          Awaited<ReturnType<typeof listActiveRegulations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActiveRegulations<TData = Awaited<ReturnType<typeof listActiveRegulations>>, TError = unknown>(
 schoolId: string,
    params?: ListActiveRegulationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActiveRegulations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListActiveRegulations<TData = Awaited<ReturnType<typeof listActiveRegulations>>, TError = unknown>(
 schoolId: string,
    params?: ListActiveRegulationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActiveRegulations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListActiveRegulationsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const defineRegulation = (
    schoolId: string,
    defineRegulationRequest: DefineRegulationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RegulationResponse>(
      {url: `/api/v1/schools/${schoolId}/regulations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: defineRegulationRequest, signal
    },
      options);
    }
  


export const getDefineRegulationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof defineRegulation>>, TError,{schoolId: string;data: DefineRegulationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof defineRegulation>>, TError,{schoolId: string;data: DefineRegulationRequest}, TContext> => {

const mutationKey = ['defineRegulation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof defineRegulation>>, {schoolId: string;data: DefineRegulationRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  defineRegulation(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DefineRegulationMutationResult = NonNullable<Awaited<ReturnType<typeof defineRegulation>>>
    export type DefineRegulationMutationBody = DefineRegulationRequest
    export type DefineRegulationMutationError = unknown

    export const useDefineRegulation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof defineRegulation>>, TError,{schoolId: string;data: DefineRegulationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof defineRegulation>>,
        TError,
        {schoolId: string;data: DefineRegulationRequest},
        TContext
      > => {

      const mutationOptions = getDefineRegulationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getCurrentRegulation = (
    schoolId: string,
    params: GetCurrentRegulationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RegulationResponse>(
      {url: `/api/v1/schools/${schoolId}/regulations/current`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCurrentRegulationQueryKey = (schoolId?: string,
    params?: GetCurrentRegulationParams,) => {
    return [
    `/api/v1/schools/${schoolId}/regulations/current`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCurrentRegulationQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentRegulation>>, TError = void>(schoolId: string,
    params: GetCurrentRegulationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentRegulation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentRegulationQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentRegulation>>> = ({ signal }) => getCurrentRegulation(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentRegulation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentRegulationQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentRegulation>>>
export type GetCurrentRegulationQueryError = void


export function useGetCurrentRegulation<TData = Awaited<ReturnType<typeof getCurrentRegulation>>, TError = void>(
 schoolId: string,
    params: GetCurrentRegulationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentRegulation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentRegulation>>,
          TError,
          Awaited<ReturnType<typeof getCurrentRegulation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentRegulation<TData = Awaited<ReturnType<typeof getCurrentRegulation>>, TError = void>(
 schoolId: string,
    params: GetCurrentRegulationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentRegulation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentRegulation>>,
          TError,
          Awaited<ReturnType<typeof getCurrentRegulation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentRegulation<TData = Awaited<ReturnType<typeof getCurrentRegulation>>, TError = void>(
 schoolId: string,
    params: GetCurrentRegulationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentRegulation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCurrentRegulation<TData = Awaited<ReturnType<typeof getCurrentRegulation>>, TError = void>(
 schoolId: string,
    params: GetCurrentRegulationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentRegulation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentRegulationQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listAllRegulationsForAdmin = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RegulationResponse[]>(
      {url: `/api/v1/schools/${schoolId}/regulations/admin`, method: 'GET', signal
    },
      options);
    }
  



export const getListAllRegulationsForAdminQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/regulations/admin`
    ] as const;
    }

    
export const getListAllRegulationsForAdminQueryOptions = <TData = Awaited<ReturnType<typeof listAllRegulationsForAdmin>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllRegulationsForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAllRegulationsForAdminQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllRegulationsForAdmin>>> = ({ signal }) => listAllRegulationsForAdmin(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllRegulationsForAdmin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAllRegulationsForAdminQueryResult = NonNullable<Awaited<ReturnType<typeof listAllRegulationsForAdmin>>>
export type ListAllRegulationsForAdminQueryError = unknown


export function useListAllRegulationsForAdmin<TData = Awaited<ReturnType<typeof listAllRegulationsForAdmin>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllRegulationsForAdmin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllRegulationsForAdmin>>,
          TError,
          Awaited<ReturnType<typeof listAllRegulationsForAdmin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllRegulationsForAdmin<TData = Awaited<ReturnType<typeof listAllRegulationsForAdmin>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllRegulationsForAdmin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllRegulationsForAdmin>>,
          TError,
          Awaited<ReturnType<typeof listAllRegulationsForAdmin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllRegulationsForAdmin<TData = Awaited<ReturnType<typeof listAllRegulationsForAdmin>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllRegulationsForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAllRegulationsForAdmin<TData = Awaited<ReturnType<typeof listAllRegulationsForAdmin>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllRegulationsForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAllRegulationsForAdminQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateRegulation = (
    schoolId: string,
    id: string,
    updateRegulationRequest: UpdateRegulationRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RegulationResponse>(
      {url: `/api/v1/schools/${schoolId}/regulations/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateRegulationRequest
    },
      options);
    }
  


export const getUpdateRegulationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRegulation>>, TError,{schoolId: string;id: string;data: UpdateRegulationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRegulation>>, TError,{schoolId: string;id: string;data: UpdateRegulationRequest}, TContext> => {

const mutationKey = ['updateRegulation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRegulation>>, {schoolId: string;id: string;data: UpdateRegulationRequest}> = (props) => {
          const {schoolId,id,data} = props ?? {};

          return  updateRegulation(schoolId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateRegulationMutationResult = NonNullable<Awaited<ReturnType<typeof updateRegulation>>>
    export type UpdateRegulationMutationBody = UpdateRegulationRequest
    export type UpdateRegulationMutationError = unknown

    export const useUpdateRegulation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRegulation>>, TError,{schoolId: string;id: string;data: UpdateRegulationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRegulation>>,
        TError,
        {schoolId: string;id: string;data: UpdateRegulationRequest},
        TContext
      > => {

      const mutationOptions = getUpdateRegulationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteRegulation = (
    schoolId: string,
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/regulations/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteRegulationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRegulation>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRegulation>>, TError,{schoolId: string;id: string}, TContext> => {

const mutationKey = ['deleteRegulation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRegulation>>, {schoolId: string;id: string}> = (props) => {
          const {schoolId,id} = props ?? {};

          return  deleteRegulation(schoolId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRegulationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRegulation>>>
    
    export type DeleteRegulationMutationError = unknown

    export const useDeleteRegulation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRegulation>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRegulation>>,
        TError,
        {schoolId: string;id: string},
        TContext
      > => {

      const mutationOptions = getDeleteRegulationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const resetRegulationsAcceptance = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/regulations/reset-acceptance`, method: 'POST', signal
    },
      options);
    }
  


export const getResetRegulationsAcceptanceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetRegulationsAcceptance>>, TError,{schoolId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resetRegulationsAcceptance>>, TError,{schoolId: string}, TContext> => {

const mutationKey = ['resetRegulationsAcceptance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetRegulationsAcceptance>>, {schoolId: string}> = (props) => {
          const {schoolId} = props ?? {};

          return  resetRegulationsAcceptance(schoolId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetRegulationsAcceptanceMutationResult = NonNullable<Awaited<ReturnType<typeof resetRegulationsAcceptance>>>
    
    export type ResetRegulationsAcceptanceMutationError = unknown

    export const useResetRegulationsAcceptance = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetRegulationsAcceptance>>, TError,{schoolId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetRegulationsAcceptance>>,
        TError,
        {schoolId: string},
        TContext
      > => {

      const mutationOptions = getResetRegulationsAcceptanceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getIndividualClassSettings = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IndividualClassSettingsResponse>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/settings`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIndividualClassSettingsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/individual-classes/settings`
    ] as const;
    }

    
export const getGetIndividualClassSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getIndividualClassSettings>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndividualClassSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIndividualClassSettingsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIndividualClassSettings>>> = ({ signal }) => getIndividualClassSettings(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIndividualClassSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIndividualClassSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getIndividualClassSettings>>>
export type GetIndividualClassSettingsQueryError = unknown


export function useGetIndividualClassSettings<TData = Awaited<ReturnType<typeof getIndividualClassSettings>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndividualClassSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIndividualClassSettings>>,
          TError,
          Awaited<ReturnType<typeof getIndividualClassSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIndividualClassSettings<TData = Awaited<ReturnType<typeof getIndividualClassSettings>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndividualClassSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIndividualClassSettings>>,
          TError,
          Awaited<ReturnType<typeof getIndividualClassSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIndividualClassSettings<TData = Awaited<ReturnType<typeof getIndividualClassSettings>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndividualClassSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetIndividualClassSettings<TData = Awaited<ReturnType<typeof getIndividualClassSettings>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndividualClassSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIndividualClassSettingsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateIndividualClassSettings = (
    schoolId: string,
    updateIndividualClassSettingsRequest: UpdateIndividualClassSettingsRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<IndividualClassSettingsResponse>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateIndividualClassSettingsRequest
    },
      options);
    }
  


export const getUpdateIndividualClassSettingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIndividualClassSettings>>, TError,{schoolId: string;data: UpdateIndividualClassSettingsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateIndividualClassSettings>>, TError,{schoolId: string;data: UpdateIndividualClassSettingsRequest}, TContext> => {

const mutationKey = ['updateIndividualClassSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateIndividualClassSettings>>, {schoolId: string;data: UpdateIndividualClassSettingsRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  updateIndividualClassSettings(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateIndividualClassSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateIndividualClassSettings>>>
    export type UpdateIndividualClassSettingsMutationBody = UpdateIndividualClassSettingsRequest
    export type UpdateIndividualClassSettingsMutationError = unknown

    export const useUpdateIndividualClassSettings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIndividualClassSettings>>, TError,{schoolId: string;data: UpdateIndividualClassSettingsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateIndividualClassSettings>>,
        TError,
        {schoolId: string;data: UpdateIndividualClassSettingsRequest},
        TContext
      > => {

      const mutationOptions = getUpdateIndividualClassSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listIndividualClassCoaches = (
    schoolId: string,
    params?: ListIndividualClassCoachesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IndividualCoachResponse[]>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/coaches`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListIndividualClassCoachesQueryKey = (schoolId?: string,
    params?: ListIndividualClassCoachesParams,) => {
    return [
    `/api/v1/schools/${schoolId}/individual-classes/coaches`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListIndividualClassCoachesQueryOptions = <TData = Awaited<ReturnType<typeof listIndividualClassCoaches>>, TError = unknown>(schoolId: string,
    params?: ListIndividualClassCoachesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualClassCoaches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIndividualClassCoachesQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIndividualClassCoaches>>> = ({ signal }) => listIndividualClassCoaches(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIndividualClassCoaches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListIndividualClassCoachesQueryResult = NonNullable<Awaited<ReturnType<typeof listIndividualClassCoaches>>>
export type ListIndividualClassCoachesQueryError = unknown


export function useListIndividualClassCoaches<TData = Awaited<ReturnType<typeof listIndividualClassCoaches>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListIndividualClassCoachesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualClassCoaches>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIndividualClassCoaches>>,
          TError,
          Awaited<ReturnType<typeof listIndividualClassCoaches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIndividualClassCoaches<TData = Awaited<ReturnType<typeof listIndividualClassCoaches>>, TError = unknown>(
 schoolId: string,
    params?: ListIndividualClassCoachesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualClassCoaches>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIndividualClassCoaches>>,
          TError,
          Awaited<ReturnType<typeof listIndividualClassCoaches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIndividualClassCoaches<TData = Awaited<ReturnType<typeof listIndividualClassCoaches>>, TError = unknown>(
 schoolId: string,
    params?: ListIndividualClassCoachesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualClassCoaches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListIndividualClassCoaches<TData = Awaited<ReturnType<typeof listIndividualClassCoaches>>, TError = unknown>(
 schoolId: string,
    params?: ListIndividualClassCoachesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualClassCoaches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListIndividualClassCoachesQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const setCoachIndividualClassesEligibility = (
    schoolId: string,
    coachMemberId: string,
    updateCoachIndividualClassesRequest: UpdateCoachIndividualClassesRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<IndividualCoachResponse>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/coaches/${coachMemberId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCoachIndividualClassesRequest
    },
      options);
    }
  


export const getSetCoachIndividualClassesEligibilityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCoachIndividualClassesEligibility>>, TError,{schoolId: string;coachMemberId: string;data: UpdateCoachIndividualClassesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setCoachIndividualClassesEligibility>>, TError,{schoolId: string;coachMemberId: string;data: UpdateCoachIndividualClassesRequest}, TContext> => {

const mutationKey = ['setCoachIndividualClassesEligibility'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setCoachIndividualClassesEligibility>>, {schoolId: string;coachMemberId: string;data: UpdateCoachIndividualClassesRequest}> = (props) => {
          const {schoolId,coachMemberId,data} = props ?? {};

          return  setCoachIndividualClassesEligibility(schoolId,coachMemberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetCoachIndividualClassesEligibilityMutationResult = NonNullable<Awaited<ReturnType<typeof setCoachIndividualClassesEligibility>>>
    export type SetCoachIndividualClassesEligibilityMutationBody = UpdateCoachIndividualClassesRequest
    export type SetCoachIndividualClassesEligibilityMutationError = unknown

    export const useSetCoachIndividualClassesEligibility = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCoachIndividualClassesEligibility>>, TError,{schoolId: string;coachMemberId: string;data: UpdateCoachIndividualClassesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setCoachIndividualClassesEligibility>>,
        TError,
        {schoolId: string;coachMemberId: string;data: UpdateCoachIndividualClassesRequest},
        TContext
      > => {

      const mutationOptions = getSetCoachIndividualClassesEligibilityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listFreeIndividualSlots = (
    schoolId: string,
    params?: ListFreeIndividualSlotsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IndividualSlotResponse[]>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/slots`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListFreeIndividualSlotsQueryKey = (schoolId?: string,
    params?: ListFreeIndividualSlotsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/individual-classes/slots`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListFreeIndividualSlotsQueryOptions = <TData = Awaited<ReturnType<typeof listFreeIndividualSlots>>, TError = unknown>(schoolId: string,
    params?: ListFreeIndividualSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFreeIndividualSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFreeIndividualSlotsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFreeIndividualSlots>>> = ({ signal }) => listFreeIndividualSlots(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFreeIndividualSlots>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListFreeIndividualSlotsQueryResult = NonNullable<Awaited<ReturnType<typeof listFreeIndividualSlots>>>
export type ListFreeIndividualSlotsQueryError = unknown


export function useListFreeIndividualSlots<TData = Awaited<ReturnType<typeof listFreeIndividualSlots>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListFreeIndividualSlotsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFreeIndividualSlots>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFreeIndividualSlots>>,
          TError,
          Awaited<ReturnType<typeof listFreeIndividualSlots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFreeIndividualSlots<TData = Awaited<ReturnType<typeof listFreeIndividualSlots>>, TError = unknown>(
 schoolId: string,
    params?: ListFreeIndividualSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFreeIndividualSlots>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFreeIndividualSlots>>,
          TError,
          Awaited<ReturnType<typeof listFreeIndividualSlots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFreeIndividualSlots<TData = Awaited<ReturnType<typeof listFreeIndividualSlots>>, TError = unknown>(
 schoolId: string,
    params?: ListFreeIndividualSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFreeIndividualSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListFreeIndividualSlots<TData = Awaited<ReturnType<typeof listFreeIndividualSlots>>, TError = unknown>(
 schoolId: string,
    params?: ListFreeIndividualSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFreeIndividualSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFreeIndividualSlotsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getIndividualSlotPrice = (
    schoolId: string,
    sessionId: string,
    params: GetIndividualSlotPriceParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IndividualPricePreviewResponse>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/slots/${sessionId}/price`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetIndividualSlotPriceQueryKey = (schoolId?: string,
    sessionId?: string,
    params?: GetIndividualSlotPriceParams,) => {
    return [
    `/api/v1/schools/${schoolId}/individual-classes/slots/${sessionId}/price`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetIndividualSlotPriceQueryOptions = <TData = Awaited<ReturnType<typeof getIndividualSlotPrice>>, TError = unknown>(schoolId: string,
    sessionId: string,
    params: GetIndividualSlotPriceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndividualSlotPrice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIndividualSlotPriceQueryKey(schoolId,sessionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIndividualSlotPrice>>> = ({ signal }) => getIndividualSlotPrice(schoolId,sessionId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIndividualSlotPrice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIndividualSlotPriceQueryResult = NonNullable<Awaited<ReturnType<typeof getIndividualSlotPrice>>>
export type GetIndividualSlotPriceQueryError = unknown


export function useGetIndividualSlotPrice<TData = Awaited<ReturnType<typeof getIndividualSlotPrice>>, TError = unknown>(
 schoolId: string,
    sessionId: string,
    params: GetIndividualSlotPriceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndividualSlotPrice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIndividualSlotPrice>>,
          TError,
          Awaited<ReturnType<typeof getIndividualSlotPrice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIndividualSlotPrice<TData = Awaited<ReturnType<typeof getIndividualSlotPrice>>, TError = unknown>(
 schoolId: string,
    sessionId: string,
    params: GetIndividualSlotPriceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndividualSlotPrice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIndividualSlotPrice>>,
          TError,
          Awaited<ReturnType<typeof getIndividualSlotPrice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIndividualSlotPrice<TData = Awaited<ReturnType<typeof getIndividualSlotPrice>>, TError = unknown>(
 schoolId: string,
    sessionId: string,
    params: GetIndividualSlotPriceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndividualSlotPrice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetIndividualSlotPrice<TData = Awaited<ReturnType<typeof getIndividualSlotPrice>>, TError = unknown>(
 schoolId: string,
    sessionId: string,
    params: GetIndividualSlotPriceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndividualSlotPrice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIndividualSlotPriceQueryOptions(schoolId,sessionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createIndividualBooking = (
    schoolId: string,
    createIndividualBookingRequest: CreateIndividualBookingRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MyIndividualBookingResponse>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/bookings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createIndividualBookingRequest, signal
    },
      options);
    }
  


export const getCreateIndividualBookingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createIndividualBooking>>, TError,{schoolId: string;data: CreateIndividualBookingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createIndividualBooking>>, TError,{schoolId: string;data: CreateIndividualBookingRequest}, TContext> => {

const mutationKey = ['createIndividualBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createIndividualBooking>>, {schoolId: string;data: CreateIndividualBookingRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createIndividualBooking(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateIndividualBookingMutationResult = NonNullable<Awaited<ReturnType<typeof createIndividualBooking>>>
    export type CreateIndividualBookingMutationBody = CreateIndividualBookingRequest
    export type CreateIndividualBookingMutationError = unknown

    export const useCreateIndividualBooking = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createIndividualBooking>>, TError,{schoolId: string;data: CreateIndividualBookingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createIndividualBooking>>,
        TError,
        {schoolId: string;data: CreateIndividualBookingRequest},
        TContext
      > => {

      const mutationOptions = getCreateIndividualBookingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listMyIndividualBookings = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MyIndividualBookingResponse[]>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/bookings/me`, method: 'GET', signal
    },
      options);
    }
  



export const getListMyIndividualBookingsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/individual-classes/bookings/me`
    ] as const;
    }

    
export const getListMyIndividualBookingsQueryOptions = <TData = Awaited<ReturnType<typeof listMyIndividualBookings>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyIndividualBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyIndividualBookingsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyIndividualBookings>>> = ({ signal }) => listMyIndividualBookings(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyIndividualBookings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMyIndividualBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyIndividualBookings>>>
export type ListMyIndividualBookingsQueryError = unknown


export function useListMyIndividualBookings<TData = Awaited<ReturnType<typeof listMyIndividualBookings>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyIndividualBookings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyIndividualBookings>>,
          TError,
          Awaited<ReturnType<typeof listMyIndividualBookings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyIndividualBookings<TData = Awaited<ReturnType<typeof listMyIndividualBookings>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyIndividualBookings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyIndividualBookings>>,
          TError,
          Awaited<ReturnType<typeof listMyIndividualBookings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyIndividualBookings<TData = Awaited<ReturnType<typeof listMyIndividualBookings>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyIndividualBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListMyIndividualBookings<TData = Awaited<ReturnType<typeof listMyIndividualBookings>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyIndividualBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyIndividualBookingsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const cancelIndividualBooking = (
    schoolId: string,
    bookingId: string,
    cancelIndividualBookingRequest: CancelIndividualBookingRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/bookings/${bookingId}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelIndividualBookingRequest, signal
    },
      options);
    }
  


export const getCancelIndividualBookingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelIndividualBooking>>, TError,{schoolId: string;bookingId: string;data: CancelIndividualBookingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelIndividualBooking>>, TError,{schoolId: string;bookingId: string;data: CancelIndividualBookingRequest}, TContext> => {

const mutationKey = ['cancelIndividualBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelIndividualBooking>>, {schoolId: string;bookingId: string;data: CancelIndividualBookingRequest}> = (props) => {
          const {schoolId,bookingId,data} = props ?? {};

          return  cancelIndividualBooking(schoolId,bookingId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelIndividualBookingMutationResult = NonNullable<Awaited<ReturnType<typeof cancelIndividualBooking>>>
    export type CancelIndividualBookingMutationBody = CancelIndividualBookingRequest
    export type CancelIndividualBookingMutationError = unknown

    export const useCancelIndividualBooking = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelIndividualBooking>>, TError,{schoolId: string;bookingId: string;data: CancelIndividualBookingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelIndividualBooking>>,
        TError,
        {schoolId: string;bookingId: string;data: CancelIndividualBookingRequest},
        TContext
      > => {

      const mutationOptions = getCancelIndividualBookingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const resignIndividualFixedSlot = (
    schoolId: string,
    scheduleEnrollmentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/fixed-slots/${scheduleEnrollmentId}/resign`, method: 'POST', signal
    },
      options);
    }
  


export const getResignIndividualFixedSlotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resignIndividualFixedSlot>>, TError,{schoolId: string;scheduleEnrollmentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resignIndividualFixedSlot>>, TError,{schoolId: string;scheduleEnrollmentId: string}, TContext> => {

const mutationKey = ['resignIndividualFixedSlot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resignIndividualFixedSlot>>, {schoolId: string;scheduleEnrollmentId: string}> = (props) => {
          const {schoolId,scheduleEnrollmentId} = props ?? {};

          return  resignIndividualFixedSlot(schoolId,scheduleEnrollmentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResignIndividualFixedSlotMutationResult = NonNullable<Awaited<ReturnType<typeof resignIndividualFixedSlot>>>
    
    export type ResignIndividualFixedSlotMutationError = unknown

    export const useResignIndividualFixedSlot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resignIndividualFixedSlot>>, TError,{schoolId: string;scheduleEnrollmentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resignIndividualFixedSlot>>,
        TError,
        {schoolId: string;scheduleEnrollmentId: string},
        TContext
      > => {

      const mutationOptions = getResignIndividualFixedSlotMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listCoachIndividualSlots = (
    schoolId: string,
    params?: ListCoachIndividualSlotsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IndividualSlotResponse[]>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/coach/slots`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListCoachIndividualSlotsQueryKey = (schoolId?: string,
    params?: ListCoachIndividualSlotsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/individual-classes/coach/slots`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListCoachIndividualSlotsQueryOptions = <TData = Awaited<ReturnType<typeof listCoachIndividualSlots>>, TError = unknown>(schoolId: string,
    params?: ListCoachIndividualSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoachIndividualSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCoachIndividualSlotsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCoachIndividualSlots>>> = ({ signal }) => listCoachIndividualSlots(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCoachIndividualSlots>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCoachIndividualSlotsQueryResult = NonNullable<Awaited<ReturnType<typeof listCoachIndividualSlots>>>
export type ListCoachIndividualSlotsQueryError = unknown


export function useListCoachIndividualSlots<TData = Awaited<ReturnType<typeof listCoachIndividualSlots>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListCoachIndividualSlotsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoachIndividualSlots>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCoachIndividualSlots>>,
          TError,
          Awaited<ReturnType<typeof listCoachIndividualSlots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCoachIndividualSlots<TData = Awaited<ReturnType<typeof listCoachIndividualSlots>>, TError = unknown>(
 schoolId: string,
    params?: ListCoachIndividualSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoachIndividualSlots>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCoachIndividualSlots>>,
          TError,
          Awaited<ReturnType<typeof listCoachIndividualSlots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCoachIndividualSlots<TData = Awaited<ReturnType<typeof listCoachIndividualSlots>>, TError = unknown>(
 schoolId: string,
    params?: ListCoachIndividualSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoachIndividualSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCoachIndividualSlots<TData = Awaited<ReturnType<typeof listCoachIndividualSlots>>, TError = unknown>(
 schoolId: string,
    params?: ListCoachIndividualSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoachIndividualSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCoachIndividualSlotsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createIndividualSlot = (
    schoolId: string,
    createIndividualSlotRequest: CreateIndividualSlotRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IndividualSlotResponse[]>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/coach/slots`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createIndividualSlotRequest, signal
    },
      options);
    }
  


export const getCreateIndividualSlotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createIndividualSlot>>, TError,{schoolId: string;data: CreateIndividualSlotRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createIndividualSlot>>, TError,{schoolId: string;data: CreateIndividualSlotRequest}, TContext> => {

const mutationKey = ['createIndividualSlot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createIndividualSlot>>, {schoolId: string;data: CreateIndividualSlotRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createIndividualSlot(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateIndividualSlotMutationResult = NonNullable<Awaited<ReturnType<typeof createIndividualSlot>>>
    export type CreateIndividualSlotMutationBody = CreateIndividualSlotRequest
    export type CreateIndividualSlotMutationError = unknown

    export const useCreateIndividualSlot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createIndividualSlot>>, TError,{schoolId: string;data: CreateIndividualSlotRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createIndividualSlot>>,
        TError,
        {schoolId: string;data: CreateIndividualSlotRequest},
        TContext
      > => {

      const mutationOptions = getCreateIndividualSlotMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateIndividualSlot = (
    schoolId: string,
    sessionId: string,
    updateIndividualSlotRequest: UpdateIndividualSlotRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<IndividualSlotResponse>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/coach/slots/${sessionId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateIndividualSlotRequest
    },
      options);
    }
  


export const getUpdateIndividualSlotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIndividualSlot>>, TError,{schoolId: string;sessionId: string;data: UpdateIndividualSlotRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateIndividualSlot>>, TError,{schoolId: string;sessionId: string;data: UpdateIndividualSlotRequest}, TContext> => {

const mutationKey = ['updateIndividualSlot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateIndividualSlot>>, {schoolId: string;sessionId: string;data: UpdateIndividualSlotRequest}> = (props) => {
          const {schoolId,sessionId,data} = props ?? {};

          return  updateIndividualSlot(schoolId,sessionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateIndividualSlotMutationResult = NonNullable<Awaited<ReturnType<typeof updateIndividualSlot>>>
    export type UpdateIndividualSlotMutationBody = UpdateIndividualSlotRequest
    export type UpdateIndividualSlotMutationError = unknown

    export const useUpdateIndividualSlot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIndividualSlot>>, TError,{schoolId: string;sessionId: string;data: UpdateIndividualSlotRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateIndividualSlot>>,
        TError,
        {schoolId: string;sessionId: string;data: UpdateIndividualSlotRequest},
        TContext
      > => {

      const mutationOptions = getUpdateIndividualSlotMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const cancelIndividualSlot = (
    schoolId: string,
    sessionId: string,
    cancelIndividualSlotRequest: CancelIndividualSlotRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/coach/slots/${sessionId}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelIndividualSlotRequest, signal
    },
      options);
    }
  


export const getCancelIndividualSlotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelIndividualSlot>>, TError,{schoolId: string;sessionId: string;data: CancelIndividualSlotRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelIndividualSlot>>, TError,{schoolId: string;sessionId: string;data: CancelIndividualSlotRequest}, TContext> => {

const mutationKey = ['cancelIndividualSlot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelIndividualSlot>>, {schoolId: string;sessionId: string;data: CancelIndividualSlotRequest}> = (props) => {
          const {schoolId,sessionId,data} = props ?? {};

          return  cancelIndividualSlot(schoolId,sessionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelIndividualSlotMutationResult = NonNullable<Awaited<ReturnType<typeof cancelIndividualSlot>>>
    export type CancelIndividualSlotMutationBody = CancelIndividualSlotRequest
    export type CancelIndividualSlotMutationError = unknown

    export const useCancelIndividualSlot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelIndividualSlot>>, TError,{schoolId: string;sessionId: string;data: CancelIndividualSlotRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelIndividualSlot>>,
        TError,
        {schoolId: string;sessionId: string;data: CancelIndividualSlotRequest},
        TContext
      > => {

      const mutationOptions = getCancelIndividualSlotMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listIndividualSchedules = (
    schoolId: string,
    params?: ListIndividualSchedulesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IndividualScheduleResponse[]>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/coach/schedules`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListIndividualSchedulesQueryKey = (schoolId?: string,
    params?: ListIndividualSchedulesParams,) => {
    return [
    `/api/v1/schools/${schoolId}/individual-classes/coach/schedules`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListIndividualSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof listIndividualSchedules>>, TError = unknown>(schoolId: string,
    params?: ListIndividualSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualSchedules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIndividualSchedulesQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIndividualSchedules>>> = ({ signal }) => listIndividualSchedules(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIndividualSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListIndividualSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof listIndividualSchedules>>>
export type ListIndividualSchedulesQueryError = unknown


export function useListIndividualSchedules<TData = Awaited<ReturnType<typeof listIndividualSchedules>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListIndividualSchedulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualSchedules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIndividualSchedules>>,
          TError,
          Awaited<ReturnType<typeof listIndividualSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIndividualSchedules<TData = Awaited<ReturnType<typeof listIndividualSchedules>>, TError = unknown>(
 schoolId: string,
    params?: ListIndividualSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualSchedules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIndividualSchedules>>,
          TError,
          Awaited<ReturnType<typeof listIndividualSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIndividualSchedules<TData = Awaited<ReturnType<typeof listIndividualSchedules>>, TError = unknown>(
 schoolId: string,
    params?: ListIndividualSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualSchedules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListIndividualSchedules<TData = Awaited<ReturnType<typeof listIndividualSchedules>>, TError = unknown>(
 schoolId: string,
    params?: ListIndividualSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualSchedules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListIndividualSchedulesQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const endIndividualSchedule = (
    schoolId: string,
    scheduleId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/coach/schedules/${scheduleId}/end`, method: 'POST', signal
    },
      options);
    }
  


export const getEndIndividualScheduleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endIndividualSchedule>>, TError,{schoolId: string;scheduleId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof endIndividualSchedule>>, TError,{schoolId: string;scheduleId: string}, TContext> => {

const mutationKey = ['endIndividualSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof endIndividualSchedule>>, {schoolId: string;scheduleId: string}> = (props) => {
          const {schoolId,scheduleId} = props ?? {};

          return  endIndividualSchedule(schoolId,scheduleId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EndIndividualScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof endIndividualSchedule>>>
    
    export type EndIndividualScheduleMutationError = unknown

    export const useEndIndividualSchedule = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endIndividualSchedule>>, TError,{schoolId: string;scheduleId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof endIndividualSchedule>>,
        TError,
        {schoolId: string;scheduleId: string},
        TContext
      > => {

      const mutationOptions = getEndIndividualScheduleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listIndividualBookingRequests = (
    schoolId: string,
    params?: ListIndividualBookingRequestsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoachIndividualBookingResponse[]>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/coach/requests`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListIndividualBookingRequestsQueryKey = (schoolId?: string,
    params?: ListIndividualBookingRequestsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/individual-classes/coach/requests`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListIndividualBookingRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listIndividualBookingRequests>>, TError = unknown>(schoolId: string,
    params?: ListIndividualBookingRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualBookingRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIndividualBookingRequestsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIndividualBookingRequests>>> = ({ signal }) => listIndividualBookingRequests(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIndividualBookingRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListIndividualBookingRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listIndividualBookingRequests>>>
export type ListIndividualBookingRequestsQueryError = unknown


export function useListIndividualBookingRequests<TData = Awaited<ReturnType<typeof listIndividualBookingRequests>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListIndividualBookingRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualBookingRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIndividualBookingRequests>>,
          TError,
          Awaited<ReturnType<typeof listIndividualBookingRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIndividualBookingRequests<TData = Awaited<ReturnType<typeof listIndividualBookingRequests>>, TError = unknown>(
 schoolId: string,
    params?: ListIndividualBookingRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualBookingRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIndividualBookingRequests>>,
          TError,
          Awaited<ReturnType<typeof listIndividualBookingRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIndividualBookingRequests<TData = Awaited<ReturnType<typeof listIndividualBookingRequests>>, TError = unknown>(
 schoolId: string,
    params?: ListIndividualBookingRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualBookingRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListIndividualBookingRequests<TData = Awaited<ReturnType<typeof listIndividualBookingRequests>>, TError = unknown>(
 schoolId: string,
    params?: ListIndividualBookingRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualBookingRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListIndividualBookingRequestsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const approveIndividualBooking = (
    schoolId: string,
    bookingId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/coach/bookings/${bookingId}/approve`, method: 'POST', signal
    },
      options);
    }
  


export const getApproveIndividualBookingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveIndividualBooking>>, TError,{schoolId: string;bookingId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof approveIndividualBooking>>, TError,{schoolId: string;bookingId: string}, TContext> => {

const mutationKey = ['approveIndividualBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveIndividualBooking>>, {schoolId: string;bookingId: string}> = (props) => {
          const {schoolId,bookingId} = props ?? {};

          return  approveIndividualBooking(schoolId,bookingId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveIndividualBookingMutationResult = NonNullable<Awaited<ReturnType<typeof approveIndividualBooking>>>
    
    export type ApproveIndividualBookingMutationError = unknown

    export const useApproveIndividualBooking = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveIndividualBooking>>, TError,{schoolId: string;bookingId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveIndividualBooking>>,
        TError,
        {schoolId: string;bookingId: string},
        TContext
      > => {

      const mutationOptions = getApproveIndividualBookingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const rejectIndividualBooking = (
    schoolId: string,
    bookingId: string,
    rejectIndividualBookingRequest: RejectIndividualBookingRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/coach/bookings/${bookingId}/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rejectIndividualBookingRequest, signal
    },
      options);
    }
  


export const getRejectIndividualBookingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectIndividualBooking>>, TError,{schoolId: string;bookingId: string;data: RejectIndividualBookingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectIndividualBooking>>, TError,{schoolId: string;bookingId: string;data: RejectIndividualBookingRequest}, TContext> => {

const mutationKey = ['rejectIndividualBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectIndividualBooking>>, {schoolId: string;bookingId: string;data: RejectIndividualBookingRequest}> = (props) => {
          const {schoolId,bookingId,data} = props ?? {};

          return  rejectIndividualBooking(schoolId,bookingId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectIndividualBookingMutationResult = NonNullable<Awaited<ReturnType<typeof rejectIndividualBooking>>>
    export type RejectIndividualBookingMutationBody = RejectIndividualBookingRequest
    export type RejectIndividualBookingMutationError = unknown

    export const useRejectIndividualBooking = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectIndividualBooking>>, TError,{schoolId: string;bookingId: string;data: RejectIndividualBookingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectIndividualBooking>>,
        TError,
        {schoolId: string;bookingId: string;data: RejectIndividualBookingRequest},
        TContext
      > => {

      const mutationOptions = getRejectIndividualBookingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const coachCancelIndividualBooking = (
    schoolId: string,
    bookingId: string,
    coachCancelIndividualBookingRequest: CoachCancelIndividualBookingRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/coach/bookings/${bookingId}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: coachCancelIndividualBookingRequest, signal
    },
      options);
    }
  


export const getCoachCancelIndividualBookingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachCancelIndividualBooking>>, TError,{schoolId: string;bookingId: string;data: CoachCancelIndividualBookingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof coachCancelIndividualBooking>>, TError,{schoolId: string;bookingId: string;data: CoachCancelIndividualBookingRequest}, TContext> => {

const mutationKey = ['coachCancelIndividualBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachCancelIndividualBooking>>, {schoolId: string;bookingId: string;data: CoachCancelIndividualBookingRequest}> = (props) => {
          const {schoolId,bookingId,data} = props ?? {};

          return  coachCancelIndividualBooking(schoolId,bookingId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachCancelIndividualBookingMutationResult = NonNullable<Awaited<ReturnType<typeof coachCancelIndividualBooking>>>
    export type CoachCancelIndividualBookingMutationBody = CoachCancelIndividualBookingRequest
    export type CoachCancelIndividualBookingMutationError = unknown

    export const useCoachCancelIndividualBooking = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachCancelIndividualBooking>>, TError,{schoolId: string;bookingId: string;data: CoachCancelIndividualBookingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof coachCancelIndividualBooking>>,
        TError,
        {schoolId: string;bookingId: string;data: CoachCancelIndividualBookingRequest},
        TContext
      > => {

      const mutationOptions = getCoachCancelIndividualBookingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listIndividualOnSiteBills = (
    schoolId: string,
    params?: ListIndividualOnSiteBillsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<OnSiteBillResponse[]>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/coach/bills`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListIndividualOnSiteBillsQueryKey = (schoolId?: string,
    params?: ListIndividualOnSiteBillsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/individual-classes/coach/bills`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListIndividualOnSiteBillsQueryOptions = <TData = Awaited<ReturnType<typeof listIndividualOnSiteBills>>, TError = unknown>(schoolId: string,
    params?: ListIndividualOnSiteBillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualOnSiteBills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIndividualOnSiteBillsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIndividualOnSiteBills>>> = ({ signal }) => listIndividualOnSiteBills(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIndividualOnSiteBills>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListIndividualOnSiteBillsQueryResult = NonNullable<Awaited<ReturnType<typeof listIndividualOnSiteBills>>>
export type ListIndividualOnSiteBillsQueryError = unknown


export function useListIndividualOnSiteBills<TData = Awaited<ReturnType<typeof listIndividualOnSiteBills>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListIndividualOnSiteBillsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualOnSiteBills>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIndividualOnSiteBills>>,
          TError,
          Awaited<ReturnType<typeof listIndividualOnSiteBills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIndividualOnSiteBills<TData = Awaited<ReturnType<typeof listIndividualOnSiteBills>>, TError = unknown>(
 schoolId: string,
    params?: ListIndividualOnSiteBillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualOnSiteBills>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIndividualOnSiteBills>>,
          TError,
          Awaited<ReturnType<typeof listIndividualOnSiteBills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIndividualOnSiteBills<TData = Awaited<ReturnType<typeof listIndividualOnSiteBills>>, TError = unknown>(
 schoolId: string,
    params?: ListIndividualOnSiteBillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualOnSiteBills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListIndividualOnSiteBills<TData = Awaited<ReturnType<typeof listIndividualOnSiteBills>>, TError = unknown>(
 schoolId: string,
    params?: ListIndividualOnSiteBillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIndividualOnSiteBills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListIndividualOnSiteBillsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const markIndividualBillPaid = (
    schoolId: string,
    billId: string,
    markIndividualBillPaidRequest: MarkIndividualBillPaidRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/individual-classes/coach/bills/${billId}/mark-paid`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: markIndividualBillPaidRequest, signal
    },
      options);
    }
  


export const getMarkIndividualBillPaidMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markIndividualBillPaid>>, TError,{schoolId: string;billId: string;data: MarkIndividualBillPaidRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markIndividualBillPaid>>, TError,{schoolId: string;billId: string;data: MarkIndividualBillPaidRequest}, TContext> => {

const mutationKey = ['markIndividualBillPaid'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markIndividualBillPaid>>, {schoolId: string;billId: string;data: MarkIndividualBillPaidRequest}> = (props) => {
          const {schoolId,billId,data} = props ?? {};

          return  markIndividualBillPaid(schoolId,billId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkIndividualBillPaidMutationResult = NonNullable<Awaited<ReturnType<typeof markIndividualBillPaid>>>
    export type MarkIndividualBillPaidMutationBody = MarkIndividualBillPaidRequest
    export type MarkIndividualBillPaidMutationError = unknown

    export const useMarkIndividualBillPaid = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markIndividualBillPaid>>, TError,{schoolId: string;billId: string;data: MarkIndividualBillPaidRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markIndividualBillPaid>>,
        TError,
        {schoolId: string;billId: string;data: MarkIndividualBillPaidRequest},
        TContext
      > => {

      const mutationOptions = getMarkIndividualBillPaidMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listEmailTemplates = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EmailTemplateResponse[]>(
      {url: `/api/v1/schools/${schoolId}/mailing/templates`, method: 'GET', signal
    },
      options);
    }
  



export const getListEmailTemplatesQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/mailing/templates`
    ] as const;
    }

    
export const getListEmailTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listEmailTemplates>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmailTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmailTemplatesQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmailTemplates>>> = ({ signal }) => listEmailTemplates(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmailTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEmailTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listEmailTemplates>>>
export type ListEmailTemplatesQueryError = unknown


export function useListEmailTemplates<TData = Awaited<ReturnType<typeof listEmailTemplates>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmailTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmailTemplates>>,
          TError,
          Awaited<ReturnType<typeof listEmailTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmailTemplates<TData = Awaited<ReturnType<typeof listEmailTemplates>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmailTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmailTemplates>>,
          TError,
          Awaited<ReturnType<typeof listEmailTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmailTemplates<TData = Awaited<ReturnType<typeof listEmailTemplates>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmailTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListEmailTemplates<TData = Awaited<ReturnType<typeof listEmailTemplates>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmailTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEmailTemplatesQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createEmailTemplate = (
    schoolId: string,
    createEmailTemplateRequest: CreateEmailTemplateRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EmailTemplateResponse>(
      {url: `/api/v1/schools/${schoolId}/mailing/templates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createEmailTemplateRequest, signal
    },
      options);
    }
  


export const getCreateEmailTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmailTemplate>>, TError,{schoolId: string;data: CreateEmailTemplateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmailTemplate>>, TError,{schoolId: string;data: CreateEmailTemplateRequest}, TContext> => {

const mutationKey = ['createEmailTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmailTemplate>>, {schoolId: string;data: CreateEmailTemplateRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createEmailTemplate(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateEmailTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createEmailTemplate>>>
    export type CreateEmailTemplateMutationBody = CreateEmailTemplateRequest
    export type CreateEmailTemplateMutationError = unknown

    export const useCreateEmailTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmailTemplate>>, TError,{schoolId: string;data: CreateEmailTemplateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEmailTemplate>>,
        TError,
        {schoolId: string;data: CreateEmailTemplateRequest},
        TContext
      > => {

      const mutationOptions = getCreateEmailTemplateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getEmailTemplate = (
    schoolId: string,
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EmailTemplateResponse>(
      {url: `/api/v1/schools/${schoolId}/mailing/templates/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetEmailTemplateQueryKey = (schoolId?: string,
    id?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/mailing/templates/${id}`
    ] as const;
    }

    
export const getGetEmailTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getEmailTemplate>>, TError = unknown>(schoolId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailTemplateQueryKey(schoolId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailTemplate>>> = ({ signal }) => getEmailTemplate(schoolId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmailTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailTemplate>>>
export type GetEmailTemplateQueryError = unknown


export function useGetEmailTemplate<TData = Awaited<ReturnType<typeof getEmailTemplate>>, TError = unknown>(
 schoolId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailTemplate>>,
          TError,
          Awaited<ReturnType<typeof getEmailTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailTemplate<TData = Awaited<ReturnType<typeof getEmailTemplate>>, TError = unknown>(
 schoolId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailTemplate>>,
          TError,
          Awaited<ReturnType<typeof getEmailTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailTemplate<TData = Awaited<ReturnType<typeof getEmailTemplate>>, TError = unknown>(
 schoolId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmailTemplate<TData = Awaited<ReturnType<typeof getEmailTemplate>>, TError = unknown>(
 schoolId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmailTemplateQueryOptions(schoolId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateEmailTemplate = (
    schoolId: string,
    id: string,
    updateEmailTemplateRequest: UpdateEmailTemplateRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<EmailTemplateResponse>(
      {url: `/api/v1/schools/${schoolId}/mailing/templates/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateEmailTemplateRequest
    },
      options);
    }
  


export const getUpdateEmailTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailTemplate>>, TError,{schoolId: string;id: string;data: UpdateEmailTemplateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmailTemplate>>, TError,{schoolId: string;id: string;data: UpdateEmailTemplateRequest}, TContext> => {

const mutationKey = ['updateEmailTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmailTemplate>>, {schoolId: string;id: string;data: UpdateEmailTemplateRequest}> = (props) => {
          const {schoolId,id,data} = props ?? {};

          return  updateEmailTemplate(schoolId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmailTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmailTemplate>>>
    export type UpdateEmailTemplateMutationBody = UpdateEmailTemplateRequest
    export type UpdateEmailTemplateMutationError = unknown

    export const useUpdateEmailTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailTemplate>>, TError,{schoolId: string;id: string;data: UpdateEmailTemplateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEmailTemplate>>,
        TError,
        {schoolId: string;id: string;data: UpdateEmailTemplateRequest},
        TContext
      > => {

      const mutationOptions = getUpdateEmailTemplateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteEmailTemplate = (
    schoolId: string,
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/mailing/templates/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteEmailTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmailTemplate>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmailTemplate>>, TError,{schoolId: string;id: string}, TContext> => {

const mutationKey = ['deleteEmailTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmailTemplate>>, {schoolId: string;id: string}> = (props) => {
          const {schoolId,id} = props ?? {};

          return  deleteEmailTemplate(schoolId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmailTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmailTemplate>>>
    
    export type DeleteEmailTemplateMutationError = unknown

    export const useDeleteEmailTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmailTemplate>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmailTemplate>>,
        TError,
        {schoolId: string;id: string},
        TContext
      > => {

      const mutationOptions = getDeleteEmailTemplateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listMailingCampaigns = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MailingCampaignResponse[]>(
      {url: `/api/v1/schools/${schoolId}/mailing/campaigns`, method: 'GET', signal
    },
      options);
    }
  



export const getListMailingCampaignsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/mailing/campaigns`
    ] as const;
    }

    
export const getListMailingCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof listMailingCampaigns>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailingCampaigns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMailingCampaignsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMailingCampaigns>>> = ({ signal }) => listMailingCampaigns(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMailingCampaigns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMailingCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof listMailingCampaigns>>>
export type ListMailingCampaignsQueryError = unknown


export function useListMailingCampaigns<TData = Awaited<ReturnType<typeof listMailingCampaigns>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailingCampaigns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMailingCampaigns>>,
          TError,
          Awaited<ReturnType<typeof listMailingCampaigns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMailingCampaigns<TData = Awaited<ReturnType<typeof listMailingCampaigns>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailingCampaigns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMailingCampaigns>>,
          TError,
          Awaited<ReturnType<typeof listMailingCampaigns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMailingCampaigns<TData = Awaited<ReturnType<typeof listMailingCampaigns>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailingCampaigns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListMailingCampaigns<TData = Awaited<ReturnType<typeof listMailingCampaigns>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailingCampaigns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMailingCampaignsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createMailingCampaign = (
    schoolId: string,
    createMailingCampaignRequest: CreateMailingCampaignRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MailingCampaignResponse>(
      {url: `/api/v1/schools/${schoolId}/mailing/campaigns`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMailingCampaignRequest, signal
    },
      options);
    }
  


export const getCreateMailingCampaignMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMailingCampaign>>, TError,{schoolId: string;data: CreateMailingCampaignRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createMailingCampaign>>, TError,{schoolId: string;data: CreateMailingCampaignRequest}, TContext> => {

const mutationKey = ['createMailingCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMailingCampaign>>, {schoolId: string;data: CreateMailingCampaignRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createMailingCampaign(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateMailingCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof createMailingCampaign>>>
    export type CreateMailingCampaignMutationBody = CreateMailingCampaignRequest
    export type CreateMailingCampaignMutationError = unknown

    export const useCreateMailingCampaign = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMailingCampaign>>, TError,{schoolId: string;data: CreateMailingCampaignRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMailingCampaign>>,
        TError,
        {schoolId: string;data: CreateMailingCampaignRequest},
        TContext
      > => {

      const mutationOptions = getCreateMailingCampaignMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getMailingCampaign = (
    schoolId: string,
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MailingCampaignDetailResponse>(
      {url: `/api/v1/schools/${schoolId}/mailing/campaigns/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMailingCampaignQueryKey = (schoolId?: string,
    id?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/mailing/campaigns/${id}`
    ] as const;
    }

    
export const getGetMailingCampaignQueryOptions = <TData = Awaited<ReturnType<typeof getMailingCampaign>>, TError = unknown>(schoolId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailingCampaign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMailingCampaignQueryKey(schoolId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMailingCampaign>>> = ({ signal }) => getMailingCampaign(schoolId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMailingCampaign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMailingCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof getMailingCampaign>>>
export type GetMailingCampaignQueryError = unknown


export function useGetMailingCampaign<TData = Awaited<ReturnType<typeof getMailingCampaign>>, TError = unknown>(
 schoolId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailingCampaign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailingCampaign>>,
          TError,
          Awaited<ReturnType<typeof getMailingCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailingCampaign<TData = Awaited<ReturnType<typeof getMailingCampaign>>, TError = unknown>(
 schoolId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailingCampaign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailingCampaign>>,
          TError,
          Awaited<ReturnType<typeof getMailingCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailingCampaign<TData = Awaited<ReturnType<typeof getMailingCampaign>>, TError = unknown>(
 schoolId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailingCampaign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMailingCampaign<TData = Awaited<ReturnType<typeof getMailingCampaign>>, TError = unknown>(
 schoolId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailingCampaign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMailingCampaignQueryOptions(schoolId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateMailingCampaign = (
    schoolId: string,
    id: string,
    updateMailingCampaignRequest: UpdateMailingCampaignRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MailingCampaignResponse>(
      {url: `/api/v1/schools/${schoolId}/mailing/campaigns/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMailingCampaignRequest
    },
      options);
    }
  


export const getUpdateMailingCampaignMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMailingCampaign>>, TError,{schoolId: string;id: string;data: UpdateMailingCampaignRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMailingCampaign>>, TError,{schoolId: string;id: string;data: UpdateMailingCampaignRequest}, TContext> => {

const mutationKey = ['updateMailingCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMailingCampaign>>, {schoolId: string;id: string;data: UpdateMailingCampaignRequest}> = (props) => {
          const {schoolId,id,data} = props ?? {};

          return  updateMailingCampaign(schoolId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMailingCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof updateMailingCampaign>>>
    export type UpdateMailingCampaignMutationBody = UpdateMailingCampaignRequest
    export type UpdateMailingCampaignMutationError = unknown

    export const useUpdateMailingCampaign = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMailingCampaign>>, TError,{schoolId: string;id: string;data: UpdateMailingCampaignRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMailingCampaign>>,
        TError,
        {schoolId: string;id: string;data: UpdateMailingCampaignRequest},
        TContext
      > => {

      const mutationOptions = getUpdateMailingCampaignMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteMailingCampaign = (
    schoolId: string,
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/mailing/campaigns/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteMailingCampaignMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMailingCampaign>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMailingCampaign>>, TError,{schoolId: string;id: string}, TContext> => {

const mutationKey = ['deleteMailingCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMailingCampaign>>, {schoolId: string;id: string}> = (props) => {
          const {schoolId,id} = props ?? {};

          return  deleteMailingCampaign(schoolId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMailingCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMailingCampaign>>>
    
    export type DeleteMailingCampaignMutationError = unknown

    export const useDeleteMailingCampaign = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMailingCampaign>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMailingCampaign>>,
        TError,
        {schoolId: string;id: string},
        TContext
      > => {

      const mutationOptions = getDeleteMailingCampaignMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const previewMailingRecipients = (
    schoolId: string,
    params: PreviewMailingRecipientsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RecipientPreviewResponse>(
      {url: `/api/v1/schools/${schoolId}/mailing/recipients-preview`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getPreviewMailingRecipientsQueryKey = (schoolId?: string,
    params?: PreviewMailingRecipientsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/mailing/recipients-preview`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPreviewMailingRecipientsQueryOptions = <TData = Awaited<ReturnType<typeof previewMailingRecipients>>, TError = unknown>(schoolId: string,
    params: PreviewMailingRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewMailingRecipients>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewMailingRecipientsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewMailingRecipients>>> = ({ signal }) => previewMailingRecipients(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewMailingRecipients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewMailingRecipientsQueryResult = NonNullable<Awaited<ReturnType<typeof previewMailingRecipients>>>
export type PreviewMailingRecipientsQueryError = unknown


export function usePreviewMailingRecipients<TData = Awaited<ReturnType<typeof previewMailingRecipients>>, TError = unknown>(
 schoolId: string,
    params: PreviewMailingRecipientsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewMailingRecipients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewMailingRecipients>>,
          TError,
          Awaited<ReturnType<typeof previewMailingRecipients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewMailingRecipients<TData = Awaited<ReturnType<typeof previewMailingRecipients>>, TError = unknown>(
 schoolId: string,
    params: PreviewMailingRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewMailingRecipients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewMailingRecipients>>,
          TError,
          Awaited<ReturnType<typeof previewMailingRecipients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewMailingRecipients<TData = Awaited<ReturnType<typeof previewMailingRecipients>>, TError = unknown>(
 schoolId: string,
    params: PreviewMailingRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewMailingRecipients>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePreviewMailingRecipients<TData = Awaited<ReturnType<typeof previewMailingRecipients>>, TError = unknown>(
 schoolId: string,
    params: PreviewMailingRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewMailingRecipients>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewMailingRecipientsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listMailingWorkflows = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MailingWorkflowResponse[]>(
      {url: `/api/v1/schools/${schoolId}/mailing/workflows`, method: 'GET', signal
    },
      options);
    }
  



export const getListMailingWorkflowsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/mailing/workflows`
    ] as const;
    }

    
export const getListMailingWorkflowsQueryOptions = <TData = Awaited<ReturnType<typeof listMailingWorkflows>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMailingWorkflowsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMailingWorkflows>>> = ({ signal }) => listMailingWorkflows(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMailingWorkflows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMailingWorkflowsQueryResult = NonNullable<Awaited<ReturnType<typeof listMailingWorkflows>>>
export type ListMailingWorkflowsQueryError = unknown


export function useListMailingWorkflows<TData = Awaited<ReturnType<typeof listMailingWorkflows>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailingWorkflows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMailingWorkflows>>,
          TError,
          Awaited<ReturnType<typeof listMailingWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMailingWorkflows<TData = Awaited<ReturnType<typeof listMailingWorkflows>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailingWorkflows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMailingWorkflows>>,
          TError,
          Awaited<ReturnType<typeof listMailingWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMailingWorkflows<TData = Awaited<ReturnType<typeof listMailingWorkflows>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListMailingWorkflows<TData = Awaited<ReturnType<typeof listMailingWorkflows>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMailingWorkflowsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createMailingWorkflow = (
    schoolId: string,
    createMailingWorkflowRequest: CreateMailingWorkflowRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MailingWorkflowResponse>(
      {url: `/api/v1/schools/${schoolId}/mailing/workflows`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMailingWorkflowRequest, signal
    },
      options);
    }
  


export const getCreateMailingWorkflowMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMailingWorkflow>>, TError,{schoolId: string;data: CreateMailingWorkflowRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createMailingWorkflow>>, TError,{schoolId: string;data: CreateMailingWorkflowRequest}, TContext> => {

const mutationKey = ['createMailingWorkflow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMailingWorkflow>>, {schoolId: string;data: CreateMailingWorkflowRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createMailingWorkflow(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateMailingWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof createMailingWorkflow>>>
    export type CreateMailingWorkflowMutationBody = CreateMailingWorkflowRequest
    export type CreateMailingWorkflowMutationError = unknown

    export const useCreateMailingWorkflow = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMailingWorkflow>>, TError,{schoolId: string;data: CreateMailingWorkflowRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMailingWorkflow>>,
        TError,
        {schoolId: string;data: CreateMailingWorkflowRequest},
        TContext
      > => {

      const mutationOptions = getCreateMailingWorkflowMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getMailingWorkflow = (
    schoolId: string,
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MailingWorkflowResponse>(
      {url: `/api/v1/schools/${schoolId}/mailing/workflows/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMailingWorkflowQueryKey = (schoolId?: string,
    id?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/mailing/workflows/${id}`
    ] as const;
    }

    
export const getGetMailingWorkflowQueryOptions = <TData = Awaited<ReturnType<typeof getMailingWorkflow>>, TError = unknown>(schoolId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailingWorkflow>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMailingWorkflowQueryKey(schoolId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMailingWorkflow>>> = ({ signal }) => getMailingWorkflow(schoolId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMailingWorkflow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMailingWorkflowQueryResult = NonNullable<Awaited<ReturnType<typeof getMailingWorkflow>>>
export type GetMailingWorkflowQueryError = unknown


export function useGetMailingWorkflow<TData = Awaited<ReturnType<typeof getMailingWorkflow>>, TError = unknown>(
 schoolId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailingWorkflow>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailingWorkflow>>,
          TError,
          Awaited<ReturnType<typeof getMailingWorkflow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailingWorkflow<TData = Awaited<ReturnType<typeof getMailingWorkflow>>, TError = unknown>(
 schoolId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailingWorkflow>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailingWorkflow>>,
          TError,
          Awaited<ReturnType<typeof getMailingWorkflow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailingWorkflow<TData = Awaited<ReturnType<typeof getMailingWorkflow>>, TError = unknown>(
 schoolId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailingWorkflow>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMailingWorkflow<TData = Awaited<ReturnType<typeof getMailingWorkflow>>, TError = unknown>(
 schoolId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailingWorkflow>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMailingWorkflowQueryOptions(schoolId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateMailingWorkflow = (
    schoolId: string,
    id: string,
    updateMailingWorkflowRequest: UpdateMailingWorkflowRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MailingWorkflowResponse>(
      {url: `/api/v1/schools/${schoolId}/mailing/workflows/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMailingWorkflowRequest
    },
      options);
    }
  


export const getUpdateMailingWorkflowMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMailingWorkflow>>, TError,{schoolId: string;id: string;data: UpdateMailingWorkflowRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMailingWorkflow>>, TError,{schoolId: string;id: string;data: UpdateMailingWorkflowRequest}, TContext> => {

const mutationKey = ['updateMailingWorkflow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMailingWorkflow>>, {schoolId: string;id: string;data: UpdateMailingWorkflowRequest}> = (props) => {
          const {schoolId,id,data} = props ?? {};

          return  updateMailingWorkflow(schoolId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMailingWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof updateMailingWorkflow>>>
    export type UpdateMailingWorkflowMutationBody = UpdateMailingWorkflowRequest
    export type UpdateMailingWorkflowMutationError = unknown

    export const useUpdateMailingWorkflow = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMailingWorkflow>>, TError,{schoolId: string;id: string;data: UpdateMailingWorkflowRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMailingWorkflow>>,
        TError,
        {schoolId: string;id: string;data: UpdateMailingWorkflowRequest},
        TContext
      > => {

      const mutationOptions = getUpdateMailingWorkflowMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteMailingWorkflow = (
    schoolId: string,
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/mailing/workflows/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteMailingWorkflowMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMailingWorkflow>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMailingWorkflow>>, TError,{schoolId: string;id: string}, TContext> => {

const mutationKey = ['deleteMailingWorkflow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMailingWorkflow>>, {schoolId: string;id: string}> = (props) => {
          const {schoolId,id} = props ?? {};

          return  deleteMailingWorkflow(schoolId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMailingWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMailingWorkflow>>>
    
    export type DeleteMailingWorkflowMutationError = unknown

    export const useDeleteMailingWorkflow = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMailingWorkflow>>, TError,{schoolId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMailingWorkflow>>,
        TError,
        {schoolId: string;id: string},
        TContext
      > => {

      const mutationOptions = getDeleteMailingWorkflowMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAvailablePlaceholders = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PlaceholderInfo[]>(
      {url: `/api/v1/schools/${schoolId}/mailing/placeholders`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAvailablePlaceholdersQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/mailing/placeholders`
    ] as const;
    }

    
export const getGetAvailablePlaceholdersQueryOptions = <TData = Awaited<ReturnType<typeof getAvailablePlaceholders>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailablePlaceholders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailablePlaceholdersQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailablePlaceholders>>> = ({ signal }) => getAvailablePlaceholders(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAvailablePlaceholders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAvailablePlaceholdersQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailablePlaceholders>>>
export type GetAvailablePlaceholdersQueryError = unknown


export function useGetAvailablePlaceholders<TData = Awaited<ReturnType<typeof getAvailablePlaceholders>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailablePlaceholders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailablePlaceholders>>,
          TError,
          Awaited<ReturnType<typeof getAvailablePlaceholders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailablePlaceholders<TData = Awaited<ReturnType<typeof getAvailablePlaceholders>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailablePlaceholders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailablePlaceholders>>,
          TError,
          Awaited<ReturnType<typeof getAvailablePlaceholders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailablePlaceholders<TData = Awaited<ReturnType<typeof getAvailablePlaceholders>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailablePlaceholders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAvailablePlaceholders<TData = Awaited<ReturnType<typeof getAvailablePlaceholders>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailablePlaceholders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAvailablePlaceholdersQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getDefaultEmailTemplate = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EmailTemplateResponse>(
      {url: `/api/v1/schools/${schoolId}/default-email-template`, method: 'GET', signal
    },
      options);
    }
  



export const getGetDefaultEmailTemplateQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/default-email-template`
    ] as const;
    }

    
export const getGetDefaultEmailTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getDefaultEmailTemplate>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultEmailTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDefaultEmailTemplateQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefaultEmailTemplate>>> = ({ signal }) => getDefaultEmailTemplate(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDefaultEmailTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDefaultEmailTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getDefaultEmailTemplate>>>
export type GetDefaultEmailTemplateQueryError = unknown


export function useGetDefaultEmailTemplate<TData = Awaited<ReturnType<typeof getDefaultEmailTemplate>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultEmailTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultEmailTemplate>>,
          TError,
          Awaited<ReturnType<typeof getDefaultEmailTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefaultEmailTemplate<TData = Awaited<ReturnType<typeof getDefaultEmailTemplate>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultEmailTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultEmailTemplate>>,
          TError,
          Awaited<ReturnType<typeof getDefaultEmailTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefaultEmailTemplate<TData = Awaited<ReturnType<typeof getDefaultEmailTemplate>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultEmailTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDefaultEmailTemplate<TData = Awaited<ReturnType<typeof getDefaultEmailTemplate>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultEmailTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDefaultEmailTemplateQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateDefaultEmailTemplate = (
    schoolId: string,
    updateEmailTemplateRequest: UpdateEmailTemplateRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<EmailTemplateResponse>(
      {url: `/api/v1/schools/${schoolId}/default-email-template`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateEmailTemplateRequest
    },
      options);
    }
  


export const getUpdateDefaultEmailTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDefaultEmailTemplate>>, TError,{schoolId: string;data: UpdateEmailTemplateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDefaultEmailTemplate>>, TError,{schoolId: string;data: UpdateEmailTemplateRequest}, TContext> => {

const mutationKey = ['updateDefaultEmailTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDefaultEmailTemplate>>, {schoolId: string;data: UpdateEmailTemplateRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  updateDefaultEmailTemplate(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDefaultEmailTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateDefaultEmailTemplate>>>
    export type UpdateDefaultEmailTemplateMutationBody = UpdateEmailTemplateRequest
    export type UpdateDefaultEmailTemplateMutationError = unknown

    export const useUpdateDefaultEmailTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDefaultEmailTemplate>>, TError,{schoolId: string;data: UpdateEmailTemplateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDefaultEmailTemplate>>,
        TError,
        {schoolId: string;data: UpdateEmailTemplateRequest},
        TContext
      > => {

      const mutationOptions = getUpdateDefaultEmailTemplateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const previewGroupMessageRecipients = (
    schoolId: string,
    params: PreviewGroupMessageRecipientsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/group-message/recipients-preview`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getPreviewGroupMessageRecipientsQueryKey = (schoolId?: string,
    params?: PreviewGroupMessageRecipientsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/group-message/recipients-preview`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPreviewGroupMessageRecipientsQueryOptions = <TData = Awaited<ReturnType<typeof previewGroupMessageRecipients>>, TError = unknown>(schoolId: string,
    params: PreviewGroupMessageRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewGroupMessageRecipients>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewGroupMessageRecipientsQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewGroupMessageRecipients>>> = ({ signal }) => previewGroupMessageRecipients(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewGroupMessageRecipients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewGroupMessageRecipientsQueryResult = NonNullable<Awaited<ReturnType<typeof previewGroupMessageRecipients>>>
export type PreviewGroupMessageRecipientsQueryError = unknown


export function usePreviewGroupMessageRecipients<TData = Awaited<ReturnType<typeof previewGroupMessageRecipients>>, TError = unknown>(
 schoolId: string,
    params: PreviewGroupMessageRecipientsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewGroupMessageRecipients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewGroupMessageRecipients>>,
          TError,
          Awaited<ReturnType<typeof previewGroupMessageRecipients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewGroupMessageRecipients<TData = Awaited<ReturnType<typeof previewGroupMessageRecipients>>, TError = unknown>(
 schoolId: string,
    params: PreviewGroupMessageRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewGroupMessageRecipients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewGroupMessageRecipients>>,
          TError,
          Awaited<ReturnType<typeof previewGroupMessageRecipients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewGroupMessageRecipients<TData = Awaited<ReturnType<typeof previewGroupMessageRecipients>>, TError = unknown>(
 schoolId: string,
    params: PreviewGroupMessageRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewGroupMessageRecipients>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePreviewGroupMessageRecipients<TData = Awaited<ReturnType<typeof previewGroupMessageRecipients>>, TError = unknown>(
 schoolId: string,
    params: PreviewGroupMessageRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewGroupMessageRecipients>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewGroupMessageRecipientsQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const sendGroupMessage = (
    schoolId: string,
    createMailingCampaignRequest: CreateMailingCampaignRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MailingCampaignResponse>(
      {url: `/api/v1/schools/${schoolId}/group-message/send`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMailingCampaignRequest, signal
    },
      options);
    }
  


export const getSendGroupMessageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendGroupMessage>>, TError,{schoolId: string;data: CreateMailingCampaignRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendGroupMessage>>, TError,{schoolId: string;data: CreateMailingCampaignRequest}, TContext> => {

const mutationKey = ['sendGroupMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendGroupMessage>>, {schoolId: string;data: CreateMailingCampaignRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  sendGroupMessage(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendGroupMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendGroupMessage>>>
    export type SendGroupMessageMutationBody = CreateMailingCampaignRequest
    export type SendGroupMessageMutationError = unknown

    export const useSendGroupMessage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendGroupMessage>>, TError,{schoolId: string;data: CreateMailingCampaignRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendGroupMessage>>,
        TError,
        {schoolId: string;data: CreateMailingCampaignRequest},
        TContext
      > => {

      const mutationOptions = getSendGroupMessageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getActivePromo = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PromoResponse>(
      {url: `/api/v1/schools/${schoolId}/promos/active`, method: 'GET', signal
    },
      options);
    }
  



export const getGetActivePromoQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/promos/active`
    ] as const;
    }

    
export const getGetActivePromoQueryOptions = <TData = Awaited<ReturnType<typeof getActivePromo>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivePromo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivePromoQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivePromo>>> = ({ signal }) => getActivePromo(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivePromo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivePromoQueryResult = NonNullable<Awaited<ReturnType<typeof getActivePromo>>>
export type GetActivePromoQueryError = unknown


export function useGetActivePromo<TData = Awaited<ReturnType<typeof getActivePromo>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivePromo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivePromo>>,
          TError,
          Awaited<ReturnType<typeof getActivePromo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivePromo<TData = Awaited<ReturnType<typeof getActivePromo>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivePromo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivePromo>>,
          TError,
          Awaited<ReturnType<typeof getActivePromo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivePromo<TData = Awaited<ReturnType<typeof getActivePromo>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivePromo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActivePromo<TData = Awaited<ReturnType<typeof getActivePromo>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivePromo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivePromoQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listPromos = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PromoResponse[]>(
      {url: `/api/v1/schools/${schoolId}/promos`, method: 'GET', signal
    },
      options);
    }
  



export const getListPromosQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/promos`
    ] as const;
    }

    
export const getListPromosQueryOptions = <TData = Awaited<ReturnType<typeof listPromos>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromos>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPromosQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPromos>>> = ({ signal }) => listPromos(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPromos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPromosQueryResult = NonNullable<Awaited<ReturnType<typeof listPromos>>>
export type ListPromosQueryError = unknown


export function useListPromos<TData = Awaited<ReturnType<typeof listPromos>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromos>>,
          TError,
          Awaited<ReturnType<typeof listPromos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPromos<TData = Awaited<ReturnType<typeof listPromos>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromos>>,
          TError,
          Awaited<ReturnType<typeof listPromos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPromos<TData = Awaited<ReturnType<typeof listPromos>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromos>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListPromos<TData = Awaited<ReturnType<typeof listPromos>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromos>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPromosQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createPromo = (
    schoolId: string,
    createPromoRequest: CreatePromoRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PromoResponse>(
      {url: `/api/v1/schools/${schoolId}/promos`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPromoRequest, signal
    },
      options);
    }
  


export const getCreatePromoMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPromo>>, TError,{schoolId: string;data: CreatePromoRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createPromo>>, TError,{schoolId: string;data: CreatePromoRequest}, TContext> => {

const mutationKey = ['createPromo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPromo>>, {schoolId: string;data: CreatePromoRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createPromo(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePromoMutationResult = NonNullable<Awaited<ReturnType<typeof createPromo>>>
    export type CreatePromoMutationBody = CreatePromoRequest
    export type CreatePromoMutationError = void

    export const useCreatePromo = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPromo>>, TError,{schoolId: string;data: CreatePromoRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPromo>>,
        TError,
        {schoolId: string;data: CreatePromoRequest},
        TContext
      > => {

      const mutationOptions = getCreatePromoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getPromo = (
    schoolId: string,
    promoId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PromoResponse>(
      {url: `/api/v1/schools/${schoolId}/promos/${promoId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPromoQueryKey = (schoolId?: string,
    promoId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/promos/${promoId}`
    ] as const;
    }

    
export const getGetPromoQueryOptions = <TData = Awaited<ReturnType<typeof getPromo>>, TError = void>(schoolId: string,
    promoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromoQueryKey(schoolId,promoId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPromo>>> = ({ signal }) => getPromo(schoolId,promoId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && promoId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPromo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPromoQueryResult = NonNullable<Awaited<ReturnType<typeof getPromo>>>
export type GetPromoQueryError = void


export function useGetPromo<TData = Awaited<ReturnType<typeof getPromo>>, TError = void>(
 schoolId: string,
    promoId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromo>>,
          TError,
          Awaited<ReturnType<typeof getPromo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromo<TData = Awaited<ReturnType<typeof getPromo>>, TError = void>(
 schoolId: string,
    promoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromo>>,
          TError,
          Awaited<ReturnType<typeof getPromo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromo<TData = Awaited<ReturnType<typeof getPromo>>, TError = void>(
 schoolId: string,
    promoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPromo<TData = Awaited<ReturnType<typeof getPromo>>, TError = void>(
 schoolId: string,
    promoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPromoQueryOptions(schoolId,promoId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updatePromo = (
    schoolId: string,
    promoId: string,
    updatePromoRequest: UpdatePromoRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PromoResponse>(
      {url: `/api/v1/schools/${schoolId}/promos/${promoId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePromoRequest
    },
      options);
    }
  


export const getUpdatePromoMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePromo>>, TError,{schoolId: string;promoId: string;data: UpdatePromoRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePromo>>, TError,{schoolId: string;promoId: string;data: UpdatePromoRequest}, TContext> => {

const mutationKey = ['updatePromo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePromo>>, {schoolId: string;promoId: string;data: UpdatePromoRequest}> = (props) => {
          const {schoolId,promoId,data} = props ?? {};

          return  updatePromo(schoolId,promoId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePromoMutationResult = NonNullable<Awaited<ReturnType<typeof updatePromo>>>
    export type UpdatePromoMutationBody = UpdatePromoRequest
    export type UpdatePromoMutationError = void

    export const useUpdatePromo = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePromo>>, TError,{schoolId: string;promoId: string;data: UpdatePromoRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePromo>>,
        TError,
        {schoolId: string;promoId: string;data: UpdatePromoRequest},
        TContext
      > => {

      const mutationOptions = getUpdatePromoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deletePromo = (
    schoolId: string,
    promoId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/promos/${promoId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeletePromoMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePromo>>, TError,{schoolId: string;promoId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePromo>>, TError,{schoolId: string;promoId: string}, TContext> => {

const mutationKey = ['deletePromo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePromo>>, {schoolId: string;promoId: string}> = (props) => {
          const {schoolId,promoId} = props ?? {};

          return  deletePromo(schoolId,promoId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePromoMutationResult = NonNullable<Awaited<ReturnType<typeof deletePromo>>>
    
    export type DeletePromoMutationError = void

    export const useDeletePromo = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePromo>>, TError,{schoolId: string;promoId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePromo>>,
        TError,
        {schoolId: string;promoId: string},
        TContext
      > => {

      const mutationOptions = getDeletePromoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const togglePromoActive = (
    schoolId: string,
    promoId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PromoResponse>(
      {url: `/api/v1/schools/${schoolId}/promos/${promoId}/toggle`, method: 'PATCH'
    },
      options);
    }
  


export const getTogglePromoActiveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof togglePromoActive>>, TError,{schoolId: string;promoId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof togglePromoActive>>, TError,{schoolId: string;promoId: string}, TContext> => {

const mutationKey = ['togglePromoActive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof togglePromoActive>>, {schoolId: string;promoId: string}> = (props) => {
          const {schoolId,promoId} = props ?? {};

          return  togglePromoActive(schoolId,promoId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TogglePromoActiveMutationResult = NonNullable<Awaited<ReturnType<typeof togglePromoActive>>>
    
    export type TogglePromoActiveMutationError = void

    export const useTogglePromoActive = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof togglePromoActive>>, TError,{schoolId: string;promoId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof togglePromoActive>>,
        TError,
        {schoolId: string;promoId: string},
        TContext
      > => {

      const mutationOptions = getTogglePromoActiveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const resetPromoDisplay = (
    schoolId: string,
    promoId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PromoResponse>(
      {url: `/api/v1/schools/${schoolId}/promos/${promoId}/reset-display`, method: 'POST', signal
    },
      options);
    }
  


export const getResetPromoDisplayMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPromoDisplay>>, TError,{schoolId: string;promoId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPromoDisplay>>, TError,{schoolId: string;promoId: string}, TContext> => {

const mutationKey = ['resetPromoDisplay'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPromoDisplay>>, {schoolId: string;promoId: string}> = (props) => {
          const {schoolId,promoId} = props ?? {};

          return  resetPromoDisplay(schoolId,promoId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetPromoDisplayMutationResult = NonNullable<Awaited<ReturnType<typeof resetPromoDisplay>>>
    
    export type ResetPromoDisplayMutationError = void

    export const useResetPromoDisplay = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPromoDisplay>>, TError,{schoolId: string;promoId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPromoDisplay>>,
        TError,
        {schoolId: string;promoId: string},
        TContext
      > => {

      const mutationOptions = getResetPromoDisplayMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listTournaments = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TournamentSummaryResponse[]>(
      {url: `/api/v1/schools/${schoolId}/tournaments`, method: 'GET', signal
    },
      options);
    }
  



export const getListTournamentsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/tournaments`
    ] as const;
    }

    
export const getListTournamentsQueryOptions = <TData = Awaited<ReturnType<typeof listTournaments>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournaments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTournamentsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTournaments>>> = ({ signal }) => listTournaments(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTournaments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTournamentsQueryResult = NonNullable<Awaited<ReturnType<typeof listTournaments>>>
export type ListTournamentsQueryError = unknown


export function useListTournaments<TData = Awaited<ReturnType<typeof listTournaments>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournaments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTournaments>>,
          TError,
          Awaited<ReturnType<typeof listTournaments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTournaments<TData = Awaited<ReturnType<typeof listTournaments>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournaments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTournaments>>,
          TError,
          Awaited<ReturnType<typeof listTournaments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTournaments<TData = Awaited<ReturnType<typeof listTournaments>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournaments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListTournaments<TData = Awaited<ReturnType<typeof listTournaments>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournaments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTournamentsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createTournament = (
    schoolId: string,
    createTournamentRequest: CreateTournamentRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TournamentResponse>(
      {url: `/api/v1/schools/${schoolId}/tournaments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTournamentRequest, signal
    },
      options);
    }
  


export const getCreateTournamentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTournament>>, TError,{schoolId: string;data: CreateTournamentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createTournament>>, TError,{schoolId: string;data: CreateTournamentRequest}, TContext> => {

const mutationKey = ['createTournament'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTournament>>, {schoolId: string;data: CreateTournamentRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createTournament(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTournamentMutationResult = NonNullable<Awaited<ReturnType<typeof createTournament>>>
    export type CreateTournamentMutationBody = CreateTournamentRequest
    export type CreateTournamentMutationError = unknown

    export const useCreateTournament = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTournament>>, TError,{schoolId: string;data: CreateTournamentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTournament>>,
        TError,
        {schoolId: string;data: CreateTournamentRequest},
        TContext
      > => {

      const mutationOptions = getCreateTournamentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createTournamentFromSession = (
    schoolId: string,
    createTournamentFromSessionRequest: CreateTournamentFromSessionRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TournamentResponse>(
      {url: `/api/v1/schools/${schoolId}/tournaments/from-session`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTournamentFromSessionRequest, signal
    },
      options);
    }
  


export const getCreateTournamentFromSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTournamentFromSession>>, TError,{schoolId: string;data: CreateTournamentFromSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createTournamentFromSession>>, TError,{schoolId: string;data: CreateTournamentFromSessionRequest}, TContext> => {

const mutationKey = ['createTournamentFromSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTournamentFromSession>>, {schoolId: string;data: CreateTournamentFromSessionRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createTournamentFromSession(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTournamentFromSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createTournamentFromSession>>>
    export type CreateTournamentFromSessionMutationBody = CreateTournamentFromSessionRequest
    export type CreateTournamentFromSessionMutationError = unknown

    export const useCreateTournamentFromSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTournamentFromSession>>, TError,{schoolId: string;data: CreateTournamentFromSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTournamentFromSession>>,
        TError,
        {schoolId: string;data: CreateTournamentFromSessionRequest},
        TContext
      > => {

      const mutationOptions = getCreateTournamentFromSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getTournament = (
    schoolId: string,
    tournamentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TournamentResponse>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetTournamentQueryKey = (schoolId?: string,
    tournamentId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/tournaments/${tournamentId}`
    ] as const;
    }

    
export const getGetTournamentQueryOptions = <TData = Awaited<ReturnType<typeof getTournament>>, TError = unknown>(schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournament>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTournamentQueryKey(schoolId,tournamentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTournament>>> = ({ signal }) => getTournament(schoolId,tournamentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && tournamentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTournament>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTournamentQueryResult = NonNullable<Awaited<ReturnType<typeof getTournament>>>
export type GetTournamentQueryError = unknown


export function useGetTournament<TData = Awaited<ReturnType<typeof getTournament>>, TError = unknown>(
 schoolId: string,
    tournamentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournament>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTournament>>,
          TError,
          Awaited<ReturnType<typeof getTournament>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTournament<TData = Awaited<ReturnType<typeof getTournament>>, TError = unknown>(
 schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournament>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTournament>>,
          TError,
          Awaited<ReturnType<typeof getTournament>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTournament<TData = Awaited<ReturnType<typeof getTournament>>, TError = unknown>(
 schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournament>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTournament<TData = Awaited<ReturnType<typeof getTournament>>, TError = unknown>(
 schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournament>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTournamentQueryOptions(schoolId,tournamentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateTournament = (
    schoolId: string,
    tournamentId: string,
    updateTournamentRequest: UpdateTournamentRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TournamentResponse>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTournamentRequest
    },
      options);
    }
  


export const getUpdateTournamentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTournament>>, TError,{schoolId: string;tournamentId: string;data: UpdateTournamentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTournament>>, TError,{schoolId: string;tournamentId: string;data: UpdateTournamentRequest}, TContext> => {

const mutationKey = ['updateTournament'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTournament>>, {schoolId: string;tournamentId: string;data: UpdateTournamentRequest}> = (props) => {
          const {schoolId,tournamentId,data} = props ?? {};

          return  updateTournament(schoolId,tournamentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTournamentMutationResult = NonNullable<Awaited<ReturnType<typeof updateTournament>>>
    export type UpdateTournamentMutationBody = UpdateTournamentRequest
    export type UpdateTournamentMutationError = unknown

    export const useUpdateTournament = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTournament>>, TError,{schoolId: string;tournamentId: string;data: UpdateTournamentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTournament>>,
        TError,
        {schoolId: string;tournamentId: string;data: UpdateTournamentRequest},
        TContext
      > => {

      const mutationOptions = getUpdateTournamentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteTournament = (
    schoolId: string,
    tournamentId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteTournamentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTournament>>, TError,{schoolId: string;tournamentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTournament>>, TError,{schoolId: string;tournamentId: string}, TContext> => {

const mutationKey = ['deleteTournament'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTournament>>, {schoolId: string;tournamentId: string}> = (props) => {
          const {schoolId,tournamentId} = props ?? {};

          return  deleteTournament(schoolId,tournamentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTournamentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTournament>>>
    
    export type DeleteTournamentMutationError = unknown

    export const useDeleteTournament = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTournament>>, TError,{schoolId: string;tournamentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTournament>>,
        TError,
        {schoolId: string;tournamentId: string},
        TContext
      > => {

      const mutationOptions = getDeleteTournamentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getTournamentMonthlyRanking = (
    schoolId: string,
    tournamentId: string,
    params?: GetTournamentMonthlyRankingParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TournamentMonthlyRankingResponse>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/monthly-ranking`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetTournamentMonthlyRankingQueryKey = (schoolId?: string,
    tournamentId?: string,
    params?: GetTournamentMonthlyRankingParams,) => {
    return [
    `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/monthly-ranking`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTournamentMonthlyRankingQueryOptions = <TData = Awaited<ReturnType<typeof getTournamentMonthlyRanking>>, TError = unknown>(schoolId: string,
    tournamentId: string,
    params?: GetTournamentMonthlyRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournamentMonthlyRanking>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTournamentMonthlyRankingQueryKey(schoolId,tournamentId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTournamentMonthlyRanking>>> = ({ signal }) => getTournamentMonthlyRanking(schoolId,tournamentId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && tournamentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTournamentMonthlyRanking>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTournamentMonthlyRankingQueryResult = NonNullable<Awaited<ReturnType<typeof getTournamentMonthlyRanking>>>
export type GetTournamentMonthlyRankingQueryError = unknown


export function useGetTournamentMonthlyRanking<TData = Awaited<ReturnType<typeof getTournamentMonthlyRanking>>, TError = unknown>(
 schoolId: string,
    tournamentId: string,
    params: undefined |  GetTournamentMonthlyRankingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournamentMonthlyRanking>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTournamentMonthlyRanking>>,
          TError,
          Awaited<ReturnType<typeof getTournamentMonthlyRanking>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTournamentMonthlyRanking<TData = Awaited<ReturnType<typeof getTournamentMonthlyRanking>>, TError = unknown>(
 schoolId: string,
    tournamentId: string,
    params?: GetTournamentMonthlyRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournamentMonthlyRanking>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTournamentMonthlyRanking>>,
          TError,
          Awaited<ReturnType<typeof getTournamentMonthlyRanking>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTournamentMonthlyRanking<TData = Awaited<ReturnType<typeof getTournamentMonthlyRanking>>, TError = unknown>(
 schoolId: string,
    tournamentId: string,
    params?: GetTournamentMonthlyRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournamentMonthlyRanking>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTournamentMonthlyRanking<TData = Awaited<ReturnType<typeof getTournamentMonthlyRanking>>, TError = unknown>(
 schoolId: string,
    tournamentId: string,
    params?: GetTournamentMonthlyRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournamentMonthlyRanking>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTournamentMonthlyRankingQueryOptions(schoolId,tournamentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const changeTournamentStatus = (
    schoolId: string,
    tournamentId: string,
    changeTournamentStatusRequest: ChangeTournamentStatusRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TournamentResponse>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changeTournamentStatusRequest, signal
    },
      options);
    }
  


export const getChangeTournamentStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeTournamentStatus>>, TError,{schoolId: string;tournamentId: string;data: ChangeTournamentStatusRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changeTournamentStatus>>, TError,{schoolId: string;tournamentId: string;data: ChangeTournamentStatusRequest}, TContext> => {

const mutationKey = ['changeTournamentStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeTournamentStatus>>, {schoolId: string;tournamentId: string;data: ChangeTournamentStatusRequest}> = (props) => {
          const {schoolId,tournamentId,data} = props ?? {};

          return  changeTournamentStatus(schoolId,tournamentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeTournamentStatusMutationResult = NonNullable<Awaited<ReturnType<typeof changeTournamentStatus>>>
    export type ChangeTournamentStatusMutationBody = ChangeTournamentStatusRequest
    export type ChangeTournamentStatusMutationError = unknown

    export const useChangeTournamentStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeTournamentStatus>>, TError,{schoolId: string;tournamentId: string;data: ChangeTournamentStatusRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeTournamentStatus>>,
        TError,
        {schoolId: string;tournamentId: string;data: ChangeTournamentStatusRequest},
        TContext
      > => {

      const mutationOptions = getChangeTournamentStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateTournamentCourts = (
    schoolId: string,
    tournamentId: string,
    updateTournamentCourtsRequest: UpdateTournamentCourtsRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TournamentCourtResponse[]>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/courts`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTournamentCourtsRequest
    },
      options);
    }
  


export const getUpdateTournamentCourtsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTournamentCourts>>, TError,{schoolId: string;tournamentId: string;data: UpdateTournamentCourtsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTournamentCourts>>, TError,{schoolId: string;tournamentId: string;data: UpdateTournamentCourtsRequest}, TContext> => {

const mutationKey = ['updateTournamentCourts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTournamentCourts>>, {schoolId: string;tournamentId: string;data: UpdateTournamentCourtsRequest}> = (props) => {
          const {schoolId,tournamentId,data} = props ?? {};

          return  updateTournamentCourts(schoolId,tournamentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTournamentCourtsMutationResult = NonNullable<Awaited<ReturnType<typeof updateTournamentCourts>>>
    export type UpdateTournamentCourtsMutationBody = UpdateTournamentCourtsRequest
    export type UpdateTournamentCourtsMutationError = unknown

    export const useUpdateTournamentCourts = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTournamentCourts>>, TError,{schoolId: string;tournamentId: string;data: UpdateTournamentCourtsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTournamentCourts>>,
        TError,
        {schoolId: string;tournamentId: string;data: UpdateTournamentCourtsRequest},
        TContext
      > => {

      const mutationOptions = getUpdateTournamentCourtsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createTournamentTimeBlock = (
    schoolId: string,
    tournamentId: string,
    upsertTournamentTimeBlockRequest: UpsertTournamentTimeBlockRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TournamentTimeBlockResponse>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/time-blocks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertTournamentTimeBlockRequest, signal
    },
      options);
    }
  


export const getCreateTournamentTimeBlockMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTournamentTimeBlock>>, TError,{schoolId: string;tournamentId: string;data: UpsertTournamentTimeBlockRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createTournamentTimeBlock>>, TError,{schoolId: string;tournamentId: string;data: UpsertTournamentTimeBlockRequest}, TContext> => {

const mutationKey = ['createTournamentTimeBlock'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTournamentTimeBlock>>, {schoolId: string;tournamentId: string;data: UpsertTournamentTimeBlockRequest}> = (props) => {
          const {schoolId,tournamentId,data} = props ?? {};

          return  createTournamentTimeBlock(schoolId,tournamentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTournamentTimeBlockMutationResult = NonNullable<Awaited<ReturnType<typeof createTournamentTimeBlock>>>
    export type CreateTournamentTimeBlockMutationBody = UpsertTournamentTimeBlockRequest
    export type CreateTournamentTimeBlockMutationError = unknown

    export const useCreateTournamentTimeBlock = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTournamentTimeBlock>>, TError,{schoolId: string;tournamentId: string;data: UpsertTournamentTimeBlockRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTournamentTimeBlock>>,
        TError,
        {schoolId: string;tournamentId: string;data: UpsertTournamentTimeBlockRequest},
        TContext
      > => {

      const mutationOptions = getCreateTournamentTimeBlockMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateTournamentTimeBlock = (
    schoolId: string,
    tournamentId: string,
    timeBlockId: string,
    upsertTournamentTimeBlockRequest: UpsertTournamentTimeBlockRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TournamentTimeBlockResponse>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/time-blocks/${timeBlockId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertTournamentTimeBlockRequest
    },
      options);
    }
  


export const getUpdateTournamentTimeBlockMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTournamentTimeBlock>>, TError,{schoolId: string;tournamentId: string;timeBlockId: string;data: UpsertTournamentTimeBlockRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTournamentTimeBlock>>, TError,{schoolId: string;tournamentId: string;timeBlockId: string;data: UpsertTournamentTimeBlockRequest}, TContext> => {

const mutationKey = ['updateTournamentTimeBlock'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTournamentTimeBlock>>, {schoolId: string;tournamentId: string;timeBlockId: string;data: UpsertTournamentTimeBlockRequest}> = (props) => {
          const {schoolId,tournamentId,timeBlockId,data} = props ?? {};

          return  updateTournamentTimeBlock(schoolId,tournamentId,timeBlockId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTournamentTimeBlockMutationResult = NonNullable<Awaited<ReturnType<typeof updateTournamentTimeBlock>>>
    export type UpdateTournamentTimeBlockMutationBody = UpsertTournamentTimeBlockRequest
    export type UpdateTournamentTimeBlockMutationError = unknown

    export const useUpdateTournamentTimeBlock = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTournamentTimeBlock>>, TError,{schoolId: string;tournamentId: string;timeBlockId: string;data: UpsertTournamentTimeBlockRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTournamentTimeBlock>>,
        TError,
        {schoolId: string;tournamentId: string;timeBlockId: string;data: UpsertTournamentTimeBlockRequest},
        TContext
      > => {

      const mutationOptions = getUpdateTournamentTimeBlockMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteTournamentTimeBlock = (
    schoolId: string,
    tournamentId: string,
    timeBlockId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/time-blocks/${timeBlockId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteTournamentTimeBlockMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTournamentTimeBlock>>, TError,{schoolId: string;tournamentId: string;timeBlockId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTournamentTimeBlock>>, TError,{schoolId: string;tournamentId: string;timeBlockId: string}, TContext> => {

const mutationKey = ['deleteTournamentTimeBlock'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTournamentTimeBlock>>, {schoolId: string;tournamentId: string;timeBlockId: string}> = (props) => {
          const {schoolId,tournamentId,timeBlockId} = props ?? {};

          return  deleteTournamentTimeBlock(schoolId,tournamentId,timeBlockId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTournamentTimeBlockMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTournamentTimeBlock>>>
    
    export type DeleteTournamentTimeBlockMutationError = unknown

    export const useDeleteTournamentTimeBlock = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTournamentTimeBlock>>, TError,{schoolId: string;tournamentId: string;timeBlockId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTournamentTimeBlock>>,
        TError,
        {schoolId: string;tournamentId: string;timeBlockId: string},
        TContext
      > => {

      const mutationOptions = getDeleteTournamentTimeBlockMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listTournamentStaff = (
    schoolId: string,
    tournamentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TournamentStaffResponse[]>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/staff`, method: 'GET', signal
    },
      options);
    }
  



export const getListTournamentStaffQueryKey = (schoolId?: string,
    tournamentId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/staff`
    ] as const;
    }

    
export const getListTournamentStaffQueryOptions = <TData = Awaited<ReturnType<typeof listTournamentStaff>>, TError = unknown>(schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournamentStaff>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTournamentStaffQueryKey(schoolId,tournamentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTournamentStaff>>> = ({ signal }) => listTournamentStaff(schoolId,tournamentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && tournamentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTournamentStaff>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTournamentStaffQueryResult = NonNullable<Awaited<ReturnType<typeof listTournamentStaff>>>
export type ListTournamentStaffQueryError = unknown


export function useListTournamentStaff<TData = Awaited<ReturnType<typeof listTournamentStaff>>, TError = unknown>(
 schoolId: string,
    tournamentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournamentStaff>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTournamentStaff>>,
          TError,
          Awaited<ReturnType<typeof listTournamentStaff>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTournamentStaff<TData = Awaited<ReturnType<typeof listTournamentStaff>>, TError = unknown>(
 schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournamentStaff>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTournamentStaff>>,
          TError,
          Awaited<ReturnType<typeof listTournamentStaff>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTournamentStaff<TData = Awaited<ReturnType<typeof listTournamentStaff>>, TError = unknown>(
 schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournamentStaff>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListTournamentStaff<TData = Awaited<ReturnType<typeof listTournamentStaff>>, TError = unknown>(
 schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournamentStaff>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTournamentStaffQueryOptions(schoolId,tournamentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const addTournamentStaff = (
    schoolId: string,
    tournamentId: string,
    addTournamentStaffRequest: AddTournamentStaffRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TournamentStaffResponse>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/staff`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addTournamentStaffRequest, signal
    },
      options);
    }
  


export const getAddTournamentStaffMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addTournamentStaff>>, TError,{schoolId: string;tournamentId: string;data: AddTournamentStaffRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addTournamentStaff>>, TError,{schoolId: string;tournamentId: string;data: AddTournamentStaffRequest}, TContext> => {

const mutationKey = ['addTournamentStaff'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addTournamentStaff>>, {schoolId: string;tournamentId: string;data: AddTournamentStaffRequest}> = (props) => {
          const {schoolId,tournamentId,data} = props ?? {};

          return  addTournamentStaff(schoolId,tournamentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddTournamentStaffMutationResult = NonNullable<Awaited<ReturnType<typeof addTournamentStaff>>>
    export type AddTournamentStaffMutationBody = AddTournamentStaffRequest
    export type AddTournamentStaffMutationError = unknown

    export const useAddTournamentStaff = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addTournamentStaff>>, TError,{schoolId: string;tournamentId: string;data: AddTournamentStaffRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addTournamentStaff>>,
        TError,
        {schoolId: string;tournamentId: string;data: AddTournamentStaffRequest},
        TContext
      > => {

      const mutationOptions = getAddTournamentStaffMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const removeTournamentStaff = (
    schoolId: string,
    tournamentId: string,
    staffId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/staff/${staffId}`, method: 'DELETE'
    },
      options);
    }
  


export const getRemoveTournamentStaffMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTournamentStaff>>, TError,{schoolId: string;tournamentId: string;staffId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeTournamentStaff>>, TError,{schoolId: string;tournamentId: string;staffId: string}, TContext> => {

const mutationKey = ['removeTournamentStaff'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeTournamentStaff>>, {schoolId: string;tournamentId: string;staffId: string}> = (props) => {
          const {schoolId,tournamentId,staffId} = props ?? {};

          return  removeTournamentStaff(schoolId,tournamentId,staffId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveTournamentStaffMutationResult = NonNullable<Awaited<ReturnType<typeof removeTournamentStaff>>>
    
    export type RemoveTournamentStaffMutationError = unknown

    export const useRemoveTournamentStaff = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTournamentStaff>>, TError,{schoolId: string;tournamentId: string;staffId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeTournamentStaff>>,
        TError,
        {schoolId: string;tournamentId: string;staffId: string},
        TContext
      > => {

      const mutationOptions = getRemoveTournamentStaffMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setCoachTournamentAccess = (
    schoolId: string,
    coachMemberId: string,
    updateCoachTournamentAccessRequest: UpdateCoachTournamentAccessRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CoachTournamentAccessResponse>(
      {url: `/api/v1/schools/${schoolId}/tournaments/coaches/${coachMemberId}/access`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCoachTournamentAccessRequest
    },
      options);
    }
  


export const getSetCoachTournamentAccessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCoachTournamentAccess>>, TError,{schoolId: string;coachMemberId: string;data: UpdateCoachTournamentAccessRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setCoachTournamentAccess>>, TError,{schoolId: string;coachMemberId: string;data: UpdateCoachTournamentAccessRequest}, TContext> => {

const mutationKey = ['setCoachTournamentAccess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setCoachTournamentAccess>>, {schoolId: string;coachMemberId: string;data: UpdateCoachTournamentAccessRequest}> = (props) => {
          const {schoolId,coachMemberId,data} = props ?? {};

          return  setCoachTournamentAccess(schoolId,coachMemberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetCoachTournamentAccessMutationResult = NonNullable<Awaited<ReturnType<typeof setCoachTournamentAccess>>>
    export type SetCoachTournamentAccessMutationBody = UpdateCoachTournamentAccessRequest
    export type SetCoachTournamentAccessMutationError = unknown

    export const useSetCoachTournamentAccess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCoachTournamentAccess>>, TError,{schoolId: string;coachMemberId: string;data: UpdateCoachTournamentAccessRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setCoachTournamentAccess>>,
        TError,
        {schoolId: string;coachMemberId: string;data: UpdateCoachTournamentAccessRequest},
        TContext
      > => {

      const mutationOptions = getSetCoachTournamentAccessMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createTournamentCategory = (
    schoolId: string,
    tournamentId: string,
    upsertTournamentCategoryRequest: UpsertTournamentCategoryRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TournamentCategoryResponse>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertTournamentCategoryRequest, signal
    },
      options);
    }
  


export const getCreateTournamentCategoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTournamentCategory>>, TError,{schoolId: string;tournamentId: string;data: UpsertTournamentCategoryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createTournamentCategory>>, TError,{schoolId: string;tournamentId: string;data: UpsertTournamentCategoryRequest}, TContext> => {

const mutationKey = ['createTournamentCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTournamentCategory>>, {schoolId: string;tournamentId: string;data: UpsertTournamentCategoryRequest}> = (props) => {
          const {schoolId,tournamentId,data} = props ?? {};

          return  createTournamentCategory(schoolId,tournamentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTournamentCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createTournamentCategory>>>
    export type CreateTournamentCategoryMutationBody = UpsertTournamentCategoryRequest
    export type CreateTournamentCategoryMutationError = unknown

    export const useCreateTournamentCategory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTournamentCategory>>, TError,{schoolId: string;tournamentId: string;data: UpsertTournamentCategoryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTournamentCategory>>,
        TError,
        {schoolId: string;tournamentId: string;data: UpsertTournamentCategoryRequest},
        TContext
      > => {

      const mutationOptions = getCreateTournamentCategoryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateTournamentCategory = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
    upsertTournamentCategoryRequest: UpsertTournamentCategoryRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TournamentCategoryResponse>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertTournamentCategoryRequest
    },
      options);
    }
  


export const getUpdateTournamentCategoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTournamentCategory>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: UpsertTournamentCategoryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTournamentCategory>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: UpsertTournamentCategoryRequest}, TContext> => {

const mutationKey = ['updateTournamentCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTournamentCategory>>, {schoolId: string;tournamentId: string;categoryId: string;data: UpsertTournamentCategoryRequest}> = (props) => {
          const {schoolId,tournamentId,categoryId,data} = props ?? {};

          return  updateTournamentCategory(schoolId,tournamentId,categoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTournamentCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateTournamentCategory>>>
    export type UpdateTournamentCategoryMutationBody = UpsertTournamentCategoryRequest
    export type UpdateTournamentCategoryMutationError = unknown

    export const useUpdateTournamentCategory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTournamentCategory>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: UpsertTournamentCategoryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTournamentCategory>>,
        TError,
        {schoolId: string;tournamentId: string;categoryId: string;data: UpsertTournamentCategoryRequest},
        TContext
      > => {

      const mutationOptions = getUpdateTournamentCategoryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteTournamentCategory = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteTournamentCategoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTournamentCategory>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTournamentCategory>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext> => {

const mutationKey = ['deleteTournamentCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTournamentCategory>>, {schoolId: string;tournamentId: string;categoryId: string}> = (props) => {
          const {schoolId,tournamentId,categoryId} = props ?? {};

          return  deleteTournamentCategory(schoolId,tournamentId,categoryId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTournamentCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTournamentCategory>>>
    
    export type DeleteTournamentCategoryMutationError = unknown

    export const useDeleteTournamentCategory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTournamentCategory>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTournamentCategory>>,
        TError,
        {schoolId: string;tournamentId: string;categoryId: string},
        TContext
      > => {

      const mutationOptions = getDeleteTournamentCategoryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listTournamentPlayers = (
    schoolId: string,
    tournamentId: string,
    params?: ListTournamentPlayersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TournamentPlayerResponse[]>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/players`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListTournamentPlayersQueryKey = (schoolId?: string,
    tournamentId?: string,
    params?: ListTournamentPlayersParams,) => {
    return [
    `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/players`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListTournamentPlayersQueryOptions = <TData = Awaited<ReturnType<typeof listTournamentPlayers>>, TError = unknown>(schoolId: string,
    tournamentId: string,
    params?: ListTournamentPlayersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournamentPlayers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTournamentPlayersQueryKey(schoolId,tournamentId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTournamentPlayers>>> = ({ signal }) => listTournamentPlayers(schoolId,tournamentId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && tournamentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTournamentPlayers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTournamentPlayersQueryResult = NonNullable<Awaited<ReturnType<typeof listTournamentPlayers>>>
export type ListTournamentPlayersQueryError = unknown


export function useListTournamentPlayers<TData = Awaited<ReturnType<typeof listTournamentPlayers>>, TError = unknown>(
 schoolId: string,
    tournamentId: string,
    params: undefined |  ListTournamentPlayersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournamentPlayers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTournamentPlayers>>,
          TError,
          Awaited<ReturnType<typeof listTournamentPlayers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTournamentPlayers<TData = Awaited<ReturnType<typeof listTournamentPlayers>>, TError = unknown>(
 schoolId: string,
    tournamentId: string,
    params?: ListTournamentPlayersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournamentPlayers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTournamentPlayers>>,
          TError,
          Awaited<ReturnType<typeof listTournamentPlayers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTournamentPlayers<TData = Awaited<ReturnType<typeof listTournamentPlayers>>, TError = unknown>(
 schoolId: string,
    tournamentId: string,
    params?: ListTournamentPlayersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournamentPlayers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListTournamentPlayers<TData = Awaited<ReturnType<typeof listTournamentPlayers>>, TError = unknown>(
 schoolId: string,
    tournamentId: string,
    params?: ListTournamentPlayersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournamentPlayers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTournamentPlayersQueryOptions(schoolId,tournamentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listTournamentEntries = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TournamentEntryResponse[]>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}/entries`, method: 'GET', signal
    },
      options);
    }
  



export const getListTournamentEntriesQueryKey = (schoolId?: string,
    tournamentId?: string,
    categoryId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}/entries`
    ] as const;
    }

    
export const getListTournamentEntriesQueryOptions = <TData = Awaited<ReturnType<typeof listTournamentEntries>>, TError = unknown>(schoolId: string,
    tournamentId: string,
    categoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournamentEntries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTournamentEntriesQueryKey(schoolId,tournamentId,categoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTournamentEntries>>> = ({ signal }) => listTournamentEntries(schoolId,tournamentId,categoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && tournamentId && categoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTournamentEntries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTournamentEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof listTournamentEntries>>>
export type ListTournamentEntriesQueryError = unknown


export function useListTournamentEntries<TData = Awaited<ReturnType<typeof listTournamentEntries>>, TError = unknown>(
 schoolId: string,
    tournamentId: string,
    categoryId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournamentEntries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTournamentEntries>>,
          TError,
          Awaited<ReturnType<typeof listTournamentEntries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTournamentEntries<TData = Awaited<ReturnType<typeof listTournamentEntries>>, TError = unknown>(
 schoolId: string,
    tournamentId: string,
    categoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournamentEntries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTournamentEntries>>,
          TError,
          Awaited<ReturnType<typeof listTournamentEntries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTournamentEntries<TData = Awaited<ReturnType<typeof listTournamentEntries>>, TError = unknown>(
 schoolId: string,
    tournamentId: string,
    categoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournamentEntries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListTournamentEntries<TData = Awaited<ReturnType<typeof listTournamentEntries>>, TError = unknown>(
 schoolId: string,
    tournamentId: string,
    categoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTournamentEntries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTournamentEntriesQueryOptions(schoolId,tournamentId,categoryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createTournamentEntry = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
    upsertTournamentEntryRequest: UpsertTournamentEntryRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TournamentEntryResponse>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}/entries`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertTournamentEntryRequest, signal
    },
      options);
    }
  


export const getCreateTournamentEntryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTournamentEntry>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: UpsertTournamentEntryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createTournamentEntry>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: UpsertTournamentEntryRequest}, TContext> => {

const mutationKey = ['createTournamentEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTournamentEntry>>, {schoolId: string;tournamentId: string;categoryId: string;data: UpsertTournamentEntryRequest}> = (props) => {
          const {schoolId,tournamentId,categoryId,data} = props ?? {};

          return  createTournamentEntry(schoolId,tournamentId,categoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTournamentEntryMutationResult = NonNullable<Awaited<ReturnType<typeof createTournamentEntry>>>
    export type CreateTournamentEntryMutationBody = UpsertTournamentEntryRequest
    export type CreateTournamentEntryMutationError = unknown

    export const useCreateTournamentEntry = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTournamentEntry>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: UpsertTournamentEntryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTournamentEntry>>,
        TError,
        {schoolId: string;tournamentId: string;categoryId: string;data: UpsertTournamentEntryRequest},
        TContext
      > => {

      const mutationOptions = getCreateTournamentEntryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateTournamentEntry = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
    entryId: string,
    upsertTournamentEntryRequest: UpsertTournamentEntryRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TournamentEntryResponse>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}/entries/${entryId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertTournamentEntryRequest
    },
      options);
    }
  


export const getUpdateTournamentEntryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTournamentEntry>>, TError,{schoolId: string;tournamentId: string;categoryId: string;entryId: string;data: UpsertTournamentEntryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTournamentEntry>>, TError,{schoolId: string;tournamentId: string;categoryId: string;entryId: string;data: UpsertTournamentEntryRequest}, TContext> => {

const mutationKey = ['updateTournamentEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTournamentEntry>>, {schoolId: string;tournamentId: string;categoryId: string;entryId: string;data: UpsertTournamentEntryRequest}> = (props) => {
          const {schoolId,tournamentId,categoryId,entryId,data} = props ?? {};

          return  updateTournamentEntry(schoolId,tournamentId,categoryId,entryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTournamentEntryMutationResult = NonNullable<Awaited<ReturnType<typeof updateTournamentEntry>>>
    export type UpdateTournamentEntryMutationBody = UpsertTournamentEntryRequest
    export type UpdateTournamentEntryMutationError = unknown

    export const useUpdateTournamentEntry = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTournamentEntry>>, TError,{schoolId: string;tournamentId: string;categoryId: string;entryId: string;data: UpsertTournamentEntryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTournamentEntry>>,
        TError,
        {schoolId: string;tournamentId: string;categoryId: string;entryId: string;data: UpsertTournamentEntryRequest},
        TContext
      > => {

      const mutationOptions = getUpdateTournamentEntryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteTournamentEntry = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
    entryId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}/entries/${entryId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteTournamentEntryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTournamentEntry>>, TError,{schoolId: string;tournamentId: string;categoryId: string;entryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTournamentEntry>>, TError,{schoolId: string;tournamentId: string;categoryId: string;entryId: string}, TContext> => {

const mutationKey = ['deleteTournamentEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTournamentEntry>>, {schoolId: string;tournamentId: string;categoryId: string;entryId: string}> = (props) => {
          const {schoolId,tournamentId,categoryId,entryId} = props ?? {};

          return  deleteTournamentEntry(schoolId,tournamentId,categoryId,entryId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTournamentEntryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTournamentEntry>>>
    
    export type DeleteTournamentEntryMutationError = unknown

    export const useDeleteTournamentEntry = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTournamentEntry>>, TError,{schoolId: string;tournamentId: string;categoryId: string;entryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTournamentEntry>>,
        TError,
        {schoolId: string;tournamentId: string;categoryId: string;entryId: string},
        TContext
      > => {

      const mutationOptions = getDeleteTournamentEntryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const importTournamentEntries = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
    importTournamentEntriesRequest: ImportTournamentEntriesRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ImportTournamentEntriesResponse>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}/entries/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: importTournamentEntriesRequest, signal
    },
      options);
    }
  


export const getImportTournamentEntriesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTournamentEntries>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: ImportTournamentEntriesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof importTournamentEntries>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: ImportTournamentEntriesRequest}, TContext> => {

const mutationKey = ['importTournamentEntries'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importTournamentEntries>>, {schoolId: string;tournamentId: string;categoryId: string;data: ImportTournamentEntriesRequest}> = (props) => {
          const {schoolId,tournamentId,categoryId,data} = props ?? {};

          return  importTournamentEntries(schoolId,tournamentId,categoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportTournamentEntriesMutationResult = NonNullable<Awaited<ReturnType<typeof importTournamentEntries>>>
    export type ImportTournamentEntriesMutationBody = ImportTournamentEntriesRequest
    export type ImportTournamentEntriesMutationError = unknown

    export const useImportTournamentEntries = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTournamentEntries>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: ImportTournamentEntriesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importTournamentEntries>>,
        TError,
        {schoolId: string;tournamentId: string;categoryId: string;data: ImportTournamentEntriesRequest},
        TContext
      > => {

      const mutationOptions = getImportTournamentEntriesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getTournamentBoard = (
    schoolId: string,
    tournamentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TournamentBoardResponse>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/board`, method: 'GET', signal
    },
      options);
    }
  



export const getGetTournamentBoardQueryKey = (schoolId?: string,
    tournamentId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/board`
    ] as const;
    }

    
export const getGetTournamentBoardQueryOptions = <TData = Awaited<ReturnType<typeof getTournamentBoard>>, TError = unknown>(schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournamentBoard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTournamentBoardQueryKey(schoolId,tournamentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTournamentBoard>>> = ({ signal }) => getTournamentBoard(schoolId,tournamentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && tournamentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTournamentBoard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTournamentBoardQueryResult = NonNullable<Awaited<ReturnType<typeof getTournamentBoard>>>
export type GetTournamentBoardQueryError = unknown


export function useGetTournamentBoard<TData = Awaited<ReturnType<typeof getTournamentBoard>>, TError = unknown>(
 schoolId: string,
    tournamentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournamentBoard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTournamentBoard>>,
          TError,
          Awaited<ReturnType<typeof getTournamentBoard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTournamentBoard<TData = Awaited<ReturnType<typeof getTournamentBoard>>, TError = unknown>(
 schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournamentBoard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTournamentBoard>>,
          TError,
          Awaited<ReturnType<typeof getTournamentBoard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTournamentBoard<TData = Awaited<ReturnType<typeof getTournamentBoard>>, TError = unknown>(
 schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournamentBoard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTournamentBoard<TData = Awaited<ReturnType<typeof getTournamentBoard>>, TError = unknown>(
 schoolId: string,
    tournamentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournamentBoard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTournamentBoardQueryOptions(schoolId,tournamentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const finishSimpleTournament = (
    schoolId: string,
    tournamentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/finish`, method: 'POST', signal
    },
      options);
    }
  


export const getFinishSimpleTournamentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishSimpleTournament>>, TError,{schoolId: string;tournamentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof finishSimpleTournament>>, TError,{schoolId: string;tournamentId: string}, TContext> => {

const mutationKey = ['finishSimpleTournament'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishSimpleTournament>>, {schoolId: string;tournamentId: string}> = (props) => {
          const {schoolId,tournamentId} = props ?? {};

          return  finishSimpleTournament(schoolId,tournamentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FinishSimpleTournamentMutationResult = NonNullable<Awaited<ReturnType<typeof finishSimpleTournament>>>
    
    export type FinishSimpleTournamentMutationError = unknown

    export const useFinishSimpleTournament = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishSimpleTournament>>, TError,{schoolId: string;tournamentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof finishSimpleTournament>>,
        TError,
        {schoolId: string;tournamentId: string},
        TContext
      > => {

      const mutationOptions = getFinishSimpleTournamentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setTournamentGroupManualOrder = (
    schoolId: string,
    tournamentId: string,
    groupId: string,
    setTournamentGroupManualOrderRequest: SetTournamentGroupManualOrderRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/groups/${groupId}/manual-order`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setTournamentGroupManualOrderRequest
    },
      options);
    }
  


export const getSetTournamentGroupManualOrderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTournamentGroupManualOrder>>, TError,{schoolId: string;tournamentId: string;groupId: string;data: SetTournamentGroupManualOrderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setTournamentGroupManualOrder>>, TError,{schoolId: string;tournamentId: string;groupId: string;data: SetTournamentGroupManualOrderRequest}, TContext> => {

const mutationKey = ['setTournamentGroupManualOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setTournamentGroupManualOrder>>, {schoolId: string;tournamentId: string;groupId: string;data: SetTournamentGroupManualOrderRequest}> = (props) => {
          const {schoolId,tournamentId,groupId,data} = props ?? {};

          return  setTournamentGroupManualOrder(schoolId,tournamentId,groupId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetTournamentGroupManualOrderMutationResult = NonNullable<Awaited<ReturnType<typeof setTournamentGroupManualOrder>>>
    export type SetTournamentGroupManualOrderMutationBody = SetTournamentGroupManualOrderRequest
    export type SetTournamentGroupManualOrderMutationError = unknown

    export const useSetTournamentGroupManualOrder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTournamentGroupManualOrder>>, TError,{schoolId: string;tournamentId: string;groupId: string;data: SetTournamentGroupManualOrderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setTournamentGroupManualOrder>>,
        TError,
        {schoolId: string;tournamentId: string;groupId: string;data: SetTournamentGroupManualOrderRequest},
        TContext
      > => {

      const mutationOptions = getSetTournamentGroupManualOrderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setTournamentMatchLineup = (
    schoolId: string,
    tournamentId: string,
    matchId: string,
    setTournamentMatchLineupRequest: SetTournamentMatchLineupRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/matches/${matchId}/lineup`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setTournamentMatchLineupRequest
    },
      options);
    }
  


export const getSetTournamentMatchLineupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTournamentMatchLineup>>, TError,{schoolId: string;tournamentId: string;matchId: string;data: SetTournamentMatchLineupRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setTournamentMatchLineup>>, TError,{schoolId: string;tournamentId: string;matchId: string;data: SetTournamentMatchLineupRequest}, TContext> => {

const mutationKey = ['setTournamentMatchLineup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setTournamentMatchLineup>>, {schoolId: string;tournamentId: string;matchId: string;data: SetTournamentMatchLineupRequest}> = (props) => {
          const {schoolId,tournamentId,matchId,data} = props ?? {};

          return  setTournamentMatchLineup(schoolId,tournamentId,matchId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetTournamentMatchLineupMutationResult = NonNullable<Awaited<ReturnType<typeof setTournamentMatchLineup>>>
    export type SetTournamentMatchLineupMutationBody = SetTournamentMatchLineupRequest
    export type SetTournamentMatchLineupMutationError = unknown

    export const useSetTournamentMatchLineup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTournamentMatchLineup>>, TError,{schoolId: string;tournamentId: string;matchId: string;data: SetTournamentMatchLineupRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setTournamentMatchLineup>>,
        TError,
        {schoolId: string;tournamentId: string;matchId: string;data: SetTournamentMatchLineupRequest},
        TContext
      > => {

      const mutationOptions = getSetTournamentMatchLineupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const walkoverTournamentMatch = (
    schoolId: string,
    tournamentId: string,
    matchId: string,
    tournamentSideRequest: TournamentSideRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/matches/${matchId}/walkover`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tournamentSideRequest, signal
    },
      options);
    }
  


export const getWalkoverTournamentMatchMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof walkoverTournamentMatch>>, TError,{schoolId: string;tournamentId: string;matchId: string;data: TournamentSideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof walkoverTournamentMatch>>, TError,{schoolId: string;tournamentId: string;matchId: string;data: TournamentSideRequest}, TContext> => {

const mutationKey = ['walkoverTournamentMatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof walkoverTournamentMatch>>, {schoolId: string;tournamentId: string;matchId: string;data: TournamentSideRequest}> = (props) => {
          const {schoolId,tournamentId,matchId,data} = props ?? {};

          return  walkoverTournamentMatch(schoolId,tournamentId,matchId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WalkoverTournamentMatchMutationResult = NonNullable<Awaited<ReturnType<typeof walkoverTournamentMatch>>>
    export type WalkoverTournamentMatchMutationBody = TournamentSideRequest
    export type WalkoverTournamentMatchMutationError = unknown

    export const useWalkoverTournamentMatch = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof walkoverTournamentMatch>>, TError,{schoolId: string;tournamentId: string;matchId: string;data: TournamentSideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof walkoverTournamentMatch>>,
        TError,
        {schoolId: string;tournamentId: string;matchId: string;data: TournamentSideRequest},
        TContext
      > => {

      const mutationOptions = getWalkoverTournamentMatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const reorderTournamentQueue = (
    schoolId: string,
    tournamentId: string,
    reorderTournamentQueueRequest: ReorderTournamentQueueRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/queue`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: reorderTournamentQueueRequest
    },
      options);
    }
  


export const getReorderTournamentQueueMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderTournamentQueue>>, TError,{schoolId: string;tournamentId: string;data: ReorderTournamentQueueRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderTournamentQueue>>, TError,{schoolId: string;tournamentId: string;data: ReorderTournamentQueueRequest}, TContext> => {

const mutationKey = ['reorderTournamentQueue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderTournamentQueue>>, {schoolId: string;tournamentId: string;data: ReorderTournamentQueueRequest}> = (props) => {
          const {schoolId,tournamentId,data} = props ?? {};

          return  reorderTournamentQueue(schoolId,tournamentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReorderTournamentQueueMutationResult = NonNullable<Awaited<ReturnType<typeof reorderTournamentQueue>>>
    export type ReorderTournamentQueueMutationBody = ReorderTournamentQueueRequest
    export type ReorderTournamentQueueMutationError = unknown

    export const useReorderTournamentQueue = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderTournamentQueue>>, TError,{schoolId: string;tournamentId: string;data: ReorderTournamentQueueRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reorderTournamentQueue>>,
        TError,
        {schoolId: string;tournamentId: string;data: ReorderTournamentQueueRequest},
        TContext
      > => {

      const mutationOptions = getReorderTournamentQueueMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setTournamentCourtAvailability = (
    schoolId: string,
    tournamentId: string,
    courtId: string,
    setTournamentCourtAvailabilityRequest: SetTournamentCourtAvailabilityRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/courts/${courtId}/availability`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setTournamentCourtAvailabilityRequest
    },
      options);
    }
  


export const getSetTournamentCourtAvailabilityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTournamentCourtAvailability>>, TError,{schoolId: string;tournamentId: string;courtId: string;data: SetTournamentCourtAvailabilityRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setTournamentCourtAvailability>>, TError,{schoolId: string;tournamentId: string;courtId: string;data: SetTournamentCourtAvailabilityRequest}, TContext> => {

const mutationKey = ['setTournamentCourtAvailability'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setTournamentCourtAvailability>>, {schoolId: string;tournamentId: string;courtId: string;data: SetTournamentCourtAvailabilityRequest}> = (props) => {
          const {schoolId,tournamentId,courtId,data} = props ?? {};

          return  setTournamentCourtAvailability(schoolId,tournamentId,courtId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetTournamentCourtAvailabilityMutationResult = NonNullable<Awaited<ReturnType<typeof setTournamentCourtAvailability>>>
    export type SetTournamentCourtAvailabilityMutationBody = SetTournamentCourtAvailabilityRequest
    export type SetTournamentCourtAvailabilityMutationError = unknown

    export const useSetTournamentCourtAvailability = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTournamentCourtAvailability>>, TError,{schoolId: string;tournamentId: string;courtId: string;data: SetTournamentCourtAvailabilityRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setTournamentCourtAvailability>>,
        TError,
        {schoolId: string;tournamentId: string;courtId: string;data: SetTournamentCourtAvailabilityRequest},
        TContext
      > => {

      const mutationOptions = getSetTournamentCourtAvailabilityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setupTournamentGroups = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
    setupTournamentGroupsRequest: SetupTournamentGroupsRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}/groups`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setupTournamentGroupsRequest
    },
      options);
    }
  


export const getSetupTournamentGroupsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setupTournamentGroups>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: SetupTournamentGroupsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setupTournamentGroups>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: SetupTournamentGroupsRequest}, TContext> => {

const mutationKey = ['setupTournamentGroups'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setupTournamentGroups>>, {schoolId: string;tournamentId: string;categoryId: string;data: SetupTournamentGroupsRequest}> = (props) => {
          const {schoolId,tournamentId,categoryId,data} = props ?? {};

          return  setupTournamentGroups(schoolId,tournamentId,categoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetupTournamentGroupsMutationResult = NonNullable<Awaited<ReturnType<typeof setupTournamentGroups>>>
    export type SetupTournamentGroupsMutationBody = SetupTournamentGroupsRequest
    export type SetupTournamentGroupsMutationError = unknown

    export const useSetupTournamentGroups = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setupTournamentGroups>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: SetupTournamentGroupsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setupTournamentGroups>>,
        TError,
        {schoolId: string;tournamentId: string;categoryId: string;data: SetupTournamentGroupsRequest},
        TContext
      > => {

      const mutationOptions = getSetupTournamentGroupsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const autoSeedTournamentGroups = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
    setupTournamentGroupsRequest: SetupTournamentGroupsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}/groups/auto-seed`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setupTournamentGroupsRequest, signal
    },
      options);
    }
  


export const getAutoSeedTournamentGroupsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof autoSeedTournamentGroups>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: SetupTournamentGroupsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof autoSeedTournamentGroups>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: SetupTournamentGroupsRequest}, TContext> => {

const mutationKey = ['autoSeedTournamentGroups'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof autoSeedTournamentGroups>>, {schoolId: string;tournamentId: string;categoryId: string;data: SetupTournamentGroupsRequest}> = (props) => {
          const {schoolId,tournamentId,categoryId,data} = props ?? {};

          return  autoSeedTournamentGroups(schoolId,tournamentId,categoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AutoSeedTournamentGroupsMutationResult = NonNullable<Awaited<ReturnType<typeof autoSeedTournamentGroups>>>
    export type AutoSeedTournamentGroupsMutationBody = SetupTournamentGroupsRequest
    export type AutoSeedTournamentGroupsMutationError = unknown

    export const useAutoSeedTournamentGroups = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof autoSeedTournamentGroups>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: SetupTournamentGroupsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof autoSeedTournamentGroups>>,
        TError,
        {schoolId: string;tournamentId: string;categoryId: string;data: SetupTournamentGroupsRequest},
        TContext
      > => {

      const mutationOptions = getAutoSeedTournamentGroupsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const assignTournamentGroupEntries = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
    assignTournamentGroupEntriesRequest: AssignTournamentGroupEntriesRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}/groups/entries`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: assignTournamentGroupEntriesRequest
    },
      options);
    }
  


export const getAssignTournamentGroupEntriesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignTournamentGroupEntries>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: AssignTournamentGroupEntriesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof assignTournamentGroupEntries>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: AssignTournamentGroupEntriesRequest}, TContext> => {

const mutationKey = ['assignTournamentGroupEntries'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignTournamentGroupEntries>>, {schoolId: string;tournamentId: string;categoryId: string;data: AssignTournamentGroupEntriesRequest}> = (props) => {
          const {schoolId,tournamentId,categoryId,data} = props ?? {};

          return  assignTournamentGroupEntries(schoolId,tournamentId,categoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssignTournamentGroupEntriesMutationResult = NonNullable<Awaited<ReturnType<typeof assignTournamentGroupEntries>>>
    export type AssignTournamentGroupEntriesMutationBody = AssignTournamentGroupEntriesRequest
    export type AssignTournamentGroupEntriesMutationError = unknown

    export const useAssignTournamentGroupEntries = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignTournamentGroupEntries>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: AssignTournamentGroupEntriesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignTournamentGroupEntries>>,
        TError,
        {schoolId: string;tournamentId: string;categoryId: string;data: AssignTournamentGroupEntriesRequest},
        TContext
      > => {

      const mutationOptions = getAssignTournamentGroupEntriesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const generateTournamentDraw = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}/draw`, method: 'POST', signal
    },
      options);
    }
  


export const getGenerateTournamentDrawMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateTournamentDraw>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generateTournamentDraw>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext> => {

const mutationKey = ['generateTournamentDraw'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateTournamentDraw>>, {schoolId: string;tournamentId: string;categoryId: string}> = (props) => {
          const {schoolId,tournamentId,categoryId} = props ?? {};

          return  generateTournamentDraw(schoolId,tournamentId,categoryId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateTournamentDrawMutationResult = NonNullable<Awaited<ReturnType<typeof generateTournamentDraw>>>
    
    export type GenerateTournamentDrawMutationError = unknown

    export const useGenerateTournamentDraw = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateTournamentDraw>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateTournamentDraw>>,
        TError,
        {schoolId: string;tournamentId: string;categoryId: string},
        TContext
      > => {

      const mutationOptions = getGenerateTournamentDrawMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const resetTournamentDraw = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}/draw`, method: 'DELETE'
    },
      options);
    }
  


export const getResetTournamentDrawMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetTournamentDraw>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resetTournamentDraw>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext> => {

const mutationKey = ['resetTournamentDraw'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetTournamentDraw>>, {schoolId: string;tournamentId: string;categoryId: string}> = (props) => {
          const {schoolId,tournamentId,categoryId} = props ?? {};

          return  resetTournamentDraw(schoolId,tournamentId,categoryId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetTournamentDrawMutationResult = NonNullable<Awaited<ReturnType<typeof resetTournamentDraw>>>
    
    export type ResetTournamentDrawMutationError = unknown

    export const useResetTournamentDraw = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetTournamentDraw>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetTournamentDraw>>,
        TError,
        {schoolId: string;tournamentId: string;categoryId: string},
        TContext
      > => {

      const mutationOptions = getResetTournamentDrawMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const generateTournamentAmericanoRound = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}/americano/rounds`, method: 'POST', signal
    },
      options);
    }
  


export const getGenerateTournamentAmericanoRoundMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateTournamentAmericanoRound>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generateTournamentAmericanoRound>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext> => {

const mutationKey = ['generateTournamentAmericanoRound'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateTournamentAmericanoRound>>, {schoolId: string;tournamentId: string;categoryId: string}> = (props) => {
          const {schoolId,tournamentId,categoryId} = props ?? {};

          return  generateTournamentAmericanoRound(schoolId,tournamentId,categoryId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateTournamentAmericanoRoundMutationResult = NonNullable<Awaited<ReturnType<typeof generateTournamentAmericanoRound>>>
    
    export type GenerateTournamentAmericanoRoundMutationError = unknown

    export const useGenerateTournamentAmericanoRound = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateTournamentAmericanoRound>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateTournamentAmericanoRound>>,
        TError,
        {schoolId: string;tournamentId: string;categoryId: string},
        TContext
      > => {

      const mutationOptions = getGenerateTournamentAmericanoRoundMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const finishTournamentAmericanoRound = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}/americano/rounds/finish`, method: 'POST', signal
    },
      options);
    }
  


export const getFinishTournamentAmericanoRoundMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishTournamentAmericanoRound>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof finishTournamentAmericanoRound>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext> => {

const mutationKey = ['finishTournamentAmericanoRound'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishTournamentAmericanoRound>>, {schoolId: string;tournamentId: string;categoryId: string}> = (props) => {
          const {schoolId,tournamentId,categoryId} = props ?? {};

          return  finishTournamentAmericanoRound(schoolId,tournamentId,categoryId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FinishTournamentAmericanoRoundMutationResult = NonNullable<Awaited<ReturnType<typeof finishTournamentAmericanoRound>>>
    
    export type FinishTournamentAmericanoRoundMutationError = unknown

    export const useFinishTournamentAmericanoRound = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishTournamentAmericanoRound>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof finishTournamentAmericanoRound>>,
        TError,
        {schoolId: string;tournamentId: string;categoryId: string},
        TContext
      > => {

      const mutationOptions = getFinishTournamentAmericanoRoundMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const generateAllTournamentAmericanoGames = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
    generateTournamentAmericanoGamesRequest: GenerateTournamentAmericanoGamesRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}/americano/games`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateTournamentAmericanoGamesRequest, signal
    },
      options);
    }
  


export const getGenerateAllTournamentAmericanoGamesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateAllTournamentAmericanoGames>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: GenerateTournamentAmericanoGamesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generateAllTournamentAmericanoGames>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: GenerateTournamentAmericanoGamesRequest}, TContext> => {

const mutationKey = ['generateAllTournamentAmericanoGames'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateAllTournamentAmericanoGames>>, {schoolId: string;tournamentId: string;categoryId: string;data: GenerateTournamentAmericanoGamesRequest}> = (props) => {
          const {schoolId,tournamentId,categoryId,data} = props ?? {};

          return  generateAllTournamentAmericanoGames(schoolId,tournamentId,categoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateAllTournamentAmericanoGamesMutationResult = NonNullable<Awaited<ReturnType<typeof generateAllTournamentAmericanoGames>>>
    export type GenerateAllTournamentAmericanoGamesMutationBody = GenerateTournamentAmericanoGamesRequest
    export type GenerateAllTournamentAmericanoGamesMutationError = unknown

    export const useGenerateAllTournamentAmericanoGames = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateAllTournamentAmericanoGames>>, TError,{schoolId: string;tournamentId: string;categoryId: string;data: GenerateTournamentAmericanoGamesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateAllTournamentAmericanoGames>>,
        TError,
        {schoolId: string;tournamentId: string;categoryId: string;data: GenerateTournamentAmericanoGamesRequest},
        TContext
      > => {

      const mutationOptions = getGenerateAllTournamentAmericanoGamesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteUnstartedTournamentAmericanoGames = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}/americano/games/unstarted`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteUnstartedTournamentAmericanoGamesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUnstartedTournamentAmericanoGames>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUnstartedTournamentAmericanoGames>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext> => {

const mutationKey = ['deleteUnstartedTournamentAmericanoGames'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUnstartedTournamentAmericanoGames>>, {schoolId: string;tournamentId: string;categoryId: string}> = (props) => {
          const {schoolId,tournamentId,categoryId} = props ?? {};

          return  deleteUnstartedTournamentAmericanoGames(schoolId,tournamentId,categoryId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUnstartedTournamentAmericanoGamesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUnstartedTournamentAmericanoGames>>>
    
    export type DeleteUnstartedTournamentAmericanoGamesMutationError = unknown

    export const useDeleteUnstartedTournamentAmericanoGames = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUnstartedTournamentAmericanoGames>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUnstartedTournamentAmericanoGames>>,
        TError,
        {schoolId: string;tournamentId: string;categoryId: string},
        TContext
      > => {

      const mutationOptions = getDeleteUnstartedTournamentAmericanoGamesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const fillTournamentKnockout = (
    schoolId: string,
    tournamentId: string,
    categoryId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/categories/${categoryId}/knockout/fill`, method: 'POST', signal
    },
      options);
    }
  


export const getFillTournamentKnockoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fillTournamentKnockout>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof fillTournamentKnockout>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext> => {

const mutationKey = ['fillTournamentKnockout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fillTournamentKnockout>>, {schoolId: string;tournamentId: string;categoryId: string}> = (props) => {
          const {schoolId,tournamentId,categoryId} = props ?? {};

          return  fillTournamentKnockout(schoolId,tournamentId,categoryId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FillTournamentKnockoutMutationResult = NonNullable<Awaited<ReturnType<typeof fillTournamentKnockout>>>
    
    export type FillTournamentKnockoutMutationError = unknown

    export const useFillTournamentKnockout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fillTournamentKnockout>>, TError,{schoolId: string;tournamentId: string;categoryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof fillTournamentKnockout>>,
        TError,
        {schoolId: string;tournamentId: string;categoryId: string},
        TContext
      > => {

      const mutationOptions = getFillTournamentKnockoutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const callTournamentGame = (
    schoolId: string,
    tournamentId: string,
    gameId: string,
    callTournamentGameRequest: CallTournamentGameRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/games/${gameId}/call`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: callTournamentGameRequest, signal
    },
      options);
    }
  


export const getCallTournamentGameMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof callTournamentGame>>, TError,{schoolId: string;tournamentId: string;gameId: string;data: CallTournamentGameRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof callTournamentGame>>, TError,{schoolId: string;tournamentId: string;gameId: string;data: CallTournamentGameRequest}, TContext> => {

const mutationKey = ['callTournamentGame'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof callTournamentGame>>, {schoolId: string;tournamentId: string;gameId: string;data: CallTournamentGameRequest}> = (props) => {
          const {schoolId,tournamentId,gameId,data} = props ?? {};

          return  callTournamentGame(schoolId,tournamentId,gameId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CallTournamentGameMutationResult = NonNullable<Awaited<ReturnType<typeof callTournamentGame>>>
    export type CallTournamentGameMutationBody = CallTournamentGameRequest
    export type CallTournamentGameMutationError = unknown

    export const useCallTournamentGame = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof callTournamentGame>>, TError,{schoolId: string;tournamentId: string;gameId: string;data: CallTournamentGameRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof callTournamentGame>>,
        TError,
        {schoolId: string;tournamentId: string;gameId: string;data: CallTournamentGameRequest},
        TContext
      > => {

      const mutationOptions = getCallTournamentGameMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const startTournamentGame = (
    schoolId: string,
    tournamentId: string,
    gameId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/games/${gameId}/start`, method: 'POST', signal
    },
      options);
    }
  


export const getStartTournamentGameMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startTournamentGame>>, TError,{schoolId: string;tournamentId: string;gameId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof startTournamentGame>>, TError,{schoolId: string;tournamentId: string;gameId: string}, TContext> => {

const mutationKey = ['startTournamentGame'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startTournamentGame>>, {schoolId: string;tournamentId: string;gameId: string}> = (props) => {
          const {schoolId,tournamentId,gameId} = props ?? {};

          return  startTournamentGame(schoolId,tournamentId,gameId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartTournamentGameMutationResult = NonNullable<Awaited<ReturnType<typeof startTournamentGame>>>
    
    export type StartTournamentGameMutationError = unknown

    export const useStartTournamentGame = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startTournamentGame>>, TError,{schoolId: string;tournamentId: string;gameId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startTournamentGame>>,
        TError,
        {schoolId: string;tournamentId: string;gameId: string},
        TContext
      > => {

      const mutationOptions = getStartTournamentGameMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const unassignTournamentGame = (
    schoolId: string,
    tournamentId: string,
    gameId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/games/${gameId}/unassign`, method: 'POST', signal
    },
      options);
    }
  


export const getUnassignTournamentGameMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignTournamentGame>>, TError,{schoolId: string;tournamentId: string;gameId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unassignTournamentGame>>, TError,{schoolId: string;tournamentId: string;gameId: string}, TContext> => {

const mutationKey = ['unassignTournamentGame'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unassignTournamentGame>>, {schoolId: string;tournamentId: string;gameId: string}> = (props) => {
          const {schoolId,tournamentId,gameId} = props ?? {};

          return  unassignTournamentGame(schoolId,tournamentId,gameId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnassignTournamentGameMutationResult = NonNullable<Awaited<ReturnType<typeof unassignTournamentGame>>>
    
    export type UnassignTournamentGameMutationError = unknown

    export const useUnassignTournamentGame = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignTournamentGame>>, TError,{schoolId: string;tournamentId: string;gameId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unassignTournamentGame>>,
        TError,
        {schoolId: string;tournamentId: string;gameId: string},
        TContext
      > => {

      const mutationOptions = getUnassignTournamentGameMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateTournamentGameScore = (
    schoolId: string,
    tournamentId: string,
    gameId: string,
    updateTournamentGameScoreRequest: UpdateTournamentGameScoreRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/games/${gameId}/score`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTournamentGameScoreRequest
    },
      options);
    }
  


export const getUpdateTournamentGameScoreMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTournamentGameScore>>, TError,{schoolId: string;tournamentId: string;gameId: string;data: UpdateTournamentGameScoreRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTournamentGameScore>>, TError,{schoolId: string;tournamentId: string;gameId: string;data: UpdateTournamentGameScoreRequest}, TContext> => {

const mutationKey = ['updateTournamentGameScore'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTournamentGameScore>>, {schoolId: string;tournamentId: string;gameId: string;data: UpdateTournamentGameScoreRequest}> = (props) => {
          const {schoolId,tournamentId,gameId,data} = props ?? {};

          return  updateTournamentGameScore(schoolId,tournamentId,gameId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTournamentGameScoreMutationResult = NonNullable<Awaited<ReturnType<typeof updateTournamentGameScore>>>
    export type UpdateTournamentGameScoreMutationBody = UpdateTournamentGameScoreRequest
    export type UpdateTournamentGameScoreMutationError = unknown

    export const useUpdateTournamentGameScore = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTournamentGameScore>>, TError,{schoolId: string;tournamentId: string;gameId: string;data: UpdateTournamentGameScoreRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTournamentGameScore>>,
        TError,
        {schoolId: string;tournamentId: string;gameId: string;data: UpdateTournamentGameScoreRequest},
        TContext
      > => {

      const mutationOptions = getUpdateTournamentGameScoreMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const walkoverTournamentGame = (
    schoolId: string,
    tournamentId: string,
    gameId: string,
    tournamentSideRequest: TournamentSideRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/games/${gameId}/walkover`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tournamentSideRequest, signal
    },
      options);
    }
  


export const getWalkoverTournamentGameMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof walkoverTournamentGame>>, TError,{schoolId: string;tournamentId: string;gameId: string;data: TournamentSideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof walkoverTournamentGame>>, TError,{schoolId: string;tournamentId: string;gameId: string;data: TournamentSideRequest}, TContext> => {

const mutationKey = ['walkoverTournamentGame'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof walkoverTournamentGame>>, {schoolId: string;tournamentId: string;gameId: string;data: TournamentSideRequest}> = (props) => {
          const {schoolId,tournamentId,gameId,data} = props ?? {};

          return  walkoverTournamentGame(schoolId,tournamentId,gameId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WalkoverTournamentGameMutationResult = NonNullable<Awaited<ReturnType<typeof walkoverTournamentGame>>>
    export type WalkoverTournamentGameMutationBody = TournamentSideRequest
    export type WalkoverTournamentGameMutationError = unknown

    export const useWalkoverTournamentGame = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof walkoverTournamentGame>>, TError,{schoolId: string;tournamentId: string;gameId: string;data: TournamentSideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof walkoverTournamentGame>>,
        TError,
        {schoolId: string;tournamentId: string;gameId: string;data: TournamentSideRequest},
        TContext
      > => {

      const mutationOptions = getWalkoverTournamentGameMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const retireTournamentGame = (
    schoolId: string,
    tournamentId: string,
    gameId: string,
    tournamentSideRequest: TournamentSideRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/tournaments/${tournamentId}/games/${gameId}/retire`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tournamentSideRequest, signal
    },
      options);
    }
  


export const getRetireTournamentGameMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retireTournamentGame>>, TError,{schoolId: string;tournamentId: string;gameId: string;data: TournamentSideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof retireTournamentGame>>, TError,{schoolId: string;tournamentId: string;gameId: string;data: TournamentSideRequest}, TContext> => {

const mutationKey = ['retireTournamentGame'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retireTournamentGame>>, {schoolId: string;tournamentId: string;gameId: string;data: TournamentSideRequest}> = (props) => {
          const {schoolId,tournamentId,gameId,data} = props ?? {};

          return  retireTournamentGame(schoolId,tournamentId,gameId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RetireTournamentGameMutationResult = NonNullable<Awaited<ReturnType<typeof retireTournamentGame>>>
    export type RetireTournamentGameMutationBody = TournamentSideRequest
    export type RetireTournamentGameMutationError = unknown

    export const useRetireTournamentGame = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retireTournamentGame>>, TError,{schoolId: string;tournamentId: string;gameId: string;data: TournamentSideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retireTournamentGame>>,
        TError,
        {schoolId: string;tournamentId: string;gameId: string;data: TournamentSideRequest},
        TContext
      > => {

      const mutationOptions = getRetireTournamentGameMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listCamps = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampSummaryResponse[]>(
      {url: `/api/v1/schools/${schoolId}/camps`, method: 'GET', signal
    },
      options);
    }
  



export const getListCampsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/camps`
    ] as const;
    }

    
export const getListCampsQueryOptions = <TData = Awaited<ReturnType<typeof listCamps>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCamps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCampsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCamps>>> = ({ signal }) => listCamps(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCamps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCampsQueryResult = NonNullable<Awaited<ReturnType<typeof listCamps>>>
export type ListCampsQueryError = unknown


export function useListCamps<TData = Awaited<ReturnType<typeof listCamps>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCamps>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCamps>>,
          TError,
          Awaited<ReturnType<typeof listCamps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCamps<TData = Awaited<ReturnType<typeof listCamps>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCamps>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCamps>>,
          TError,
          Awaited<ReturnType<typeof listCamps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCamps<TData = Awaited<ReturnType<typeof listCamps>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCamps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCamps<TData = Awaited<ReturnType<typeof listCamps>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCamps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCampsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createCamp = (
    schoolId: string,
    createCampRequest: CreateCampRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampResponse>(
      {url: `/api/v1/schools/${schoolId}/camps`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCampRequest, signal
    },
      options);
    }
  


export const getCreateCampMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCamp>>, TError,{schoolId: string;data: CreateCampRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCamp>>, TError,{schoolId: string;data: CreateCampRequest}, TContext> => {

const mutationKey = ['createCamp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCamp>>, {schoolId: string;data: CreateCampRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createCamp(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCampMutationResult = NonNullable<Awaited<ReturnType<typeof createCamp>>>
    export type CreateCampMutationBody = CreateCampRequest
    export type CreateCampMutationError = unknown

    export const useCreateCamp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCamp>>, TError,{schoolId: string;data: CreateCampRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCamp>>,
        TError,
        {schoolId: string;data: CreateCampRequest},
        TContext
      > => {

      const mutationOptions = getCreateCampMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getCamp = (
    schoolId: string,
    campId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCampQueryKey = (schoolId?: string,
    campId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/camps/${campId}`
    ] as const;
    }

    
export const getGetCampQueryOptions = <TData = Awaited<ReturnType<typeof getCamp>>, TError = unknown>(schoolId: string,
    campId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCamp>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampQueryKey(schoolId,campId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCamp>>> = ({ signal }) => getCamp(schoolId,campId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && campId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCamp>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampQueryResult = NonNullable<Awaited<ReturnType<typeof getCamp>>>
export type GetCampQueryError = unknown


export function useGetCamp<TData = Awaited<ReturnType<typeof getCamp>>, TError = unknown>(
 schoolId: string,
    campId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCamp>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCamp>>,
          TError,
          Awaited<ReturnType<typeof getCamp>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCamp<TData = Awaited<ReturnType<typeof getCamp>>, TError = unknown>(
 schoolId: string,
    campId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCamp>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCamp>>,
          TError,
          Awaited<ReturnType<typeof getCamp>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCamp<TData = Awaited<ReturnType<typeof getCamp>>, TError = unknown>(
 schoolId: string,
    campId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCamp>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCamp<TData = Awaited<ReturnType<typeof getCamp>>, TError = unknown>(
 schoolId: string,
    campId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCamp>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampQueryOptions(schoolId,campId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateCamp = (
    schoolId: string,
    campId: string,
    updateCampRequest: UpdateCampRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CampResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCampRequest
    },
      options);
    }
  


export const getUpdateCampMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCamp>>, TError,{schoolId: string;campId: string;data: UpdateCampRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCamp>>, TError,{schoolId: string;campId: string;data: UpdateCampRequest}, TContext> => {

const mutationKey = ['updateCamp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCamp>>, {schoolId: string;campId: string;data: UpdateCampRequest}> = (props) => {
          const {schoolId,campId,data} = props ?? {};

          return  updateCamp(schoolId,campId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCampMutationResult = NonNullable<Awaited<ReturnType<typeof updateCamp>>>
    export type UpdateCampMutationBody = UpdateCampRequest
    export type UpdateCampMutationError = unknown

    export const useUpdateCamp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCamp>>, TError,{schoolId: string;campId: string;data: UpdateCampRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCamp>>,
        TError,
        {schoolId: string;campId: string;data: UpdateCampRequest},
        TContext
      > => {

      const mutationOptions = getUpdateCampMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteCamp = (
    schoolId: string,
    campId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCampMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCamp>>, TError,{schoolId: string;campId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCamp>>, TError,{schoolId: string;campId: string}, TContext> => {

const mutationKey = ['deleteCamp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCamp>>, {schoolId: string;campId: string}> = (props) => {
          const {schoolId,campId} = props ?? {};

          return  deleteCamp(schoolId,campId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCampMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCamp>>>
    
    export type DeleteCampMutationError = unknown

    export const useDeleteCamp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCamp>>, TError,{schoolId: string;campId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCamp>>,
        TError,
        {schoolId: string;campId: string},
        TContext
      > => {

      const mutationOptions = getDeleteCampMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const changeCampStatus = (
    schoolId: string,
    campId: string,
    changeCampStatusRequest: ChangeCampStatusRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changeCampStatusRequest, signal
    },
      options);
    }
  


export const getChangeCampStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeCampStatus>>, TError,{schoolId: string;campId: string;data: ChangeCampStatusRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changeCampStatus>>, TError,{schoolId: string;campId: string;data: ChangeCampStatusRequest}, TContext> => {

const mutationKey = ['changeCampStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeCampStatus>>, {schoolId: string;campId: string;data: ChangeCampStatusRequest}> = (props) => {
          const {schoolId,campId,data} = props ?? {};

          return  changeCampStatus(schoolId,campId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeCampStatusMutationResult = NonNullable<Awaited<ReturnType<typeof changeCampStatus>>>
    export type ChangeCampStatusMutationBody = ChangeCampStatusRequest
    export type ChangeCampStatusMutationError = unknown

    export const useChangeCampStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeCampStatus>>, TError,{schoolId: string;campId: string;data: ChangeCampStatusRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeCampStatus>>,
        TError,
        {schoolId: string;campId: string;data: ChangeCampStatusRequest},
        TContext
      > => {

      const mutationOptions = getChangeCampStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateCampPricing = (
    schoolId: string,
    campId: string,
    updateCampPricingRequest: UpdateCampPricingRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CampResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/pricing`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCampPricingRequest
    },
      options);
    }
  


export const getUpdateCampPricingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCampPricing>>, TError,{schoolId: string;campId: string;data: UpdateCampPricingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCampPricing>>, TError,{schoolId: string;campId: string;data: UpdateCampPricingRequest}, TContext> => {

const mutationKey = ['updateCampPricing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCampPricing>>, {schoolId: string;campId: string;data: UpdateCampPricingRequest}> = (props) => {
          const {schoolId,campId,data} = props ?? {};

          return  updateCampPricing(schoolId,campId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCampPricingMutationResult = NonNullable<Awaited<ReturnType<typeof updateCampPricing>>>
    export type UpdateCampPricingMutationBody = UpdateCampPricingRequest
    export type UpdateCampPricingMutationError = unknown

    export const useUpdateCampPricing = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCampPricing>>, TError,{schoolId: string;campId: string;data: UpdateCampPricingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCampPricing>>,
        TError,
        {schoolId: string;campId: string;data: UpdateCampPricingRequest},
        TContext
      > => {

      const mutationOptions = getUpdateCampPricingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateCampTermsDraft = (
    schoolId: string,
    campId: string,
    updateCampTermsDraftRequest: UpdateCampTermsDraftRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CampResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/terms/draft`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCampTermsDraftRequest
    },
      options);
    }
  


export const getUpdateCampTermsDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCampTermsDraft>>, TError,{schoolId: string;campId: string;data: UpdateCampTermsDraftRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCampTermsDraft>>, TError,{schoolId: string;campId: string;data: UpdateCampTermsDraftRequest}, TContext> => {

const mutationKey = ['updateCampTermsDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCampTermsDraft>>, {schoolId: string;campId: string;data: UpdateCampTermsDraftRequest}> = (props) => {
          const {schoolId,campId,data} = props ?? {};

          return  updateCampTermsDraft(schoolId,campId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCampTermsDraftMutationResult = NonNullable<Awaited<ReturnType<typeof updateCampTermsDraft>>>
    export type UpdateCampTermsDraftMutationBody = UpdateCampTermsDraftRequest
    export type UpdateCampTermsDraftMutationError = unknown

    export const useUpdateCampTermsDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCampTermsDraft>>, TError,{schoolId: string;campId: string;data: UpdateCampTermsDraftRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCampTermsDraft>>,
        TError,
        {schoolId: string;campId: string;data: UpdateCampTermsDraftRequest},
        TContext
      > => {

      const mutationOptions = getUpdateCampTermsDraftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const publishCampTerms = (
    schoolId: string,
    campId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/terms/publish`, method: 'POST', signal
    },
      options);
    }
  


export const getPublishCampTermsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishCampTerms>>, TError,{schoolId: string;campId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof publishCampTerms>>, TError,{schoolId: string;campId: string}, TContext> => {

const mutationKey = ['publishCampTerms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishCampTerms>>, {schoolId: string;campId: string}> = (props) => {
          const {schoolId,campId} = props ?? {};

          return  publishCampTerms(schoolId,campId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PublishCampTermsMutationResult = NonNullable<Awaited<ReturnType<typeof publishCampTerms>>>
    
    export type PublishCampTermsMutationError = unknown

    export const usePublishCampTerms = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishCampTerms>>, TError,{schoolId: string;campId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publishCampTerms>>,
        TError,
        {schoolId: string;campId: string},
        TContext
      > => {

      const mutationOptions = getPublishCampTermsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const previewCampTerms = (
    schoolId: string,
    campId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PublicCampTermsResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/terms/preview`, method: 'GET', signal
    },
      options);
    }
  



export const getPreviewCampTermsQueryKey = (schoolId?: string,
    campId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/camps/${campId}/terms/preview`
    ] as const;
    }

    
export const getPreviewCampTermsQueryOptions = <TData = Awaited<ReturnType<typeof previewCampTerms>>, TError = unknown>(schoolId: string,
    campId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewCampTerms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewCampTermsQueryKey(schoolId,campId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewCampTerms>>> = ({ signal }) => previewCampTerms(schoolId,campId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && campId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewCampTerms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewCampTermsQueryResult = NonNullable<Awaited<ReturnType<typeof previewCampTerms>>>
export type PreviewCampTermsQueryError = unknown


export function usePreviewCampTerms<TData = Awaited<ReturnType<typeof previewCampTerms>>, TError = unknown>(
 schoolId: string,
    campId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewCampTerms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewCampTerms>>,
          TError,
          Awaited<ReturnType<typeof previewCampTerms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewCampTerms<TData = Awaited<ReturnType<typeof previewCampTerms>>, TError = unknown>(
 schoolId: string,
    campId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewCampTerms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewCampTerms>>,
          TError,
          Awaited<ReturnType<typeof previewCampTerms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewCampTerms<TData = Awaited<ReturnType<typeof previewCampTerms>>, TError = unknown>(
 schoolId: string,
    campId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewCampTerms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePreviewCampTerms<TData = Awaited<ReturnType<typeof previewCampTerms>>, TError = unknown>(
 schoolId: string,
    campId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewCampTerms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewCampTermsQueryOptions(schoolId,campId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const upsertCampPromo = (
    schoolId: string,
    campId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/promo`, method: 'POST', signal
    },
      options);
    }
  


export const getUpsertCampPromoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertCampPromo>>, TError,{schoolId: string;campId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertCampPromo>>, TError,{schoolId: string;campId: string}, TContext> => {

const mutationKey = ['upsertCampPromo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertCampPromo>>, {schoolId: string;campId: string}> = (props) => {
          const {schoolId,campId} = props ?? {};

          return  upsertCampPromo(schoolId,campId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertCampPromoMutationResult = NonNullable<Awaited<ReturnType<typeof upsertCampPromo>>>
    
    export type UpsertCampPromoMutationError = unknown

    export const useUpsertCampPromo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertCampPromo>>, TError,{schoolId: string;campId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertCampPromo>>,
        TError,
        {schoolId: string;campId: string},
        TContext
      > => {

      const mutationOptions = getUpsertCampPromoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listCampParticipants = (
    schoolId: string,
    campId: string,
    params?: ListCampParticipantsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampParticipantListResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/participants`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListCampParticipantsQueryKey = (schoolId?: string,
    campId?: string,
    params?: ListCampParticipantsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/camps/${campId}/participants`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListCampParticipantsQueryOptions = <TData = Awaited<ReturnType<typeof listCampParticipants>>, TError = unknown>(schoolId: string,
    campId: string,
    params?: ListCampParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampParticipants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCampParticipantsQueryKey(schoolId,campId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCampParticipants>>> = ({ signal }) => listCampParticipants(schoolId,campId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && campId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCampParticipants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCampParticipantsQueryResult = NonNullable<Awaited<ReturnType<typeof listCampParticipants>>>
export type ListCampParticipantsQueryError = unknown


export function useListCampParticipants<TData = Awaited<ReturnType<typeof listCampParticipants>>, TError = unknown>(
 schoolId: string,
    campId: string,
    params: undefined |  ListCampParticipantsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampParticipants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampParticipants>>,
          TError,
          Awaited<ReturnType<typeof listCampParticipants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampParticipants<TData = Awaited<ReturnType<typeof listCampParticipants>>, TError = unknown>(
 schoolId: string,
    campId: string,
    params?: ListCampParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampParticipants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampParticipants>>,
          TError,
          Awaited<ReturnType<typeof listCampParticipants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampParticipants<TData = Awaited<ReturnType<typeof listCampParticipants>>, TError = unknown>(
 schoolId: string,
    campId: string,
    params?: ListCampParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampParticipants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCampParticipants<TData = Awaited<ReturnType<typeof listCampParticipants>>, TError = unknown>(
 schoolId: string,
    campId: string,
    params?: ListCampParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampParticipants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCampParticipantsQueryOptions(schoolId,campId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const addCampParticipant = (
    schoolId: string,
    campId: string,
    adminAddCampParticipantRequest: AdminAddCampParticipantRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampParticipantResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/participants`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminAddCampParticipantRequest, signal
    },
      options);
    }
  


export const getAddCampParticipantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCampParticipant>>, TError,{schoolId: string;campId: string;data: AdminAddCampParticipantRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addCampParticipant>>, TError,{schoolId: string;campId: string;data: AdminAddCampParticipantRequest}, TContext> => {

const mutationKey = ['addCampParticipant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCampParticipant>>, {schoolId: string;campId: string;data: AdminAddCampParticipantRequest}> = (props) => {
          const {schoolId,campId,data} = props ?? {};

          return  addCampParticipant(schoolId,campId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddCampParticipantMutationResult = NonNullable<Awaited<ReturnType<typeof addCampParticipant>>>
    export type AddCampParticipantMutationBody = AdminAddCampParticipantRequest
    export type AddCampParticipantMutationError = unknown

    export const useAddCampParticipant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCampParticipant>>, TError,{schoolId: string;campId: string;data: AdminAddCampParticipantRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addCampParticipant>>,
        TError,
        {schoolId: string;campId: string;data: AdminAddCampParticipantRequest},
        TContext
      > => {

      const mutationOptions = getAddCampParticipantMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const exportCampParticipants = (
    schoolId: string,
    campId: string,
    params?: ExportCampParticipantsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/participants/export`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getExportCampParticipantsQueryKey = (schoolId?: string,
    campId?: string,
    params?: ExportCampParticipantsParams,) => {
    return [
    `/api/v1/schools/${schoolId}/camps/${campId}/participants/export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getExportCampParticipantsQueryOptions = <TData = Awaited<ReturnType<typeof exportCampParticipants>>, TError = unknown>(schoolId: string,
    campId: string,
    params?: ExportCampParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCampParticipants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportCampParticipantsQueryKey(schoolId,campId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportCampParticipants>>> = ({ signal }) => exportCampParticipants(schoolId,campId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && campId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportCampParticipants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportCampParticipantsQueryResult = NonNullable<Awaited<ReturnType<typeof exportCampParticipants>>>
export type ExportCampParticipantsQueryError = unknown


export function useExportCampParticipants<TData = Awaited<ReturnType<typeof exportCampParticipants>>, TError = unknown>(
 schoolId: string,
    campId: string,
    params: undefined |  ExportCampParticipantsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCampParticipants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportCampParticipants>>,
          TError,
          Awaited<ReturnType<typeof exportCampParticipants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportCampParticipants<TData = Awaited<ReturnType<typeof exportCampParticipants>>, TError = unknown>(
 schoolId: string,
    campId: string,
    params?: ExportCampParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCampParticipants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportCampParticipants>>,
          TError,
          Awaited<ReturnType<typeof exportCampParticipants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportCampParticipants<TData = Awaited<ReturnType<typeof exportCampParticipants>>, TError = unknown>(
 schoolId: string,
    campId: string,
    params?: ExportCampParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCampParticipants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExportCampParticipants<TData = Awaited<ReturnType<typeof exportCampParticipants>>, TError = unknown>(
 schoolId: string,
    campId: string,
    params?: ExportCampParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCampParticipants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportCampParticipantsQueryOptions(schoolId,campId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateCampParticipant = (
    schoolId: string,
    campId: string,
    participantId: string,
    updateCampParticipantRequest: UpdateCampParticipantRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CampParticipantResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/participants/${participantId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCampParticipantRequest
    },
      options);
    }
  


export const getUpdateCampParticipantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCampParticipant>>, TError,{schoolId: string;campId: string;participantId: string;data: UpdateCampParticipantRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCampParticipant>>, TError,{schoolId: string;campId: string;participantId: string;data: UpdateCampParticipantRequest}, TContext> => {

const mutationKey = ['updateCampParticipant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCampParticipant>>, {schoolId: string;campId: string;participantId: string;data: UpdateCampParticipantRequest}> = (props) => {
          const {schoolId,campId,participantId,data} = props ?? {};

          return  updateCampParticipant(schoolId,campId,participantId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCampParticipantMutationResult = NonNullable<Awaited<ReturnType<typeof updateCampParticipant>>>
    export type UpdateCampParticipantMutationBody = UpdateCampParticipantRequest
    export type UpdateCampParticipantMutationError = unknown

    export const useUpdateCampParticipant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCampParticipant>>, TError,{schoolId: string;campId: string;participantId: string;data: UpdateCampParticipantRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCampParticipant>>,
        TError,
        {schoolId: string;campId: string;participantId: string;data: UpdateCampParticipantRequest},
        TContext
      > => {

      const mutationOptions = getUpdateCampParticipantMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const removeCampParticipant = (
    schoolId: string,
    campId: string,
    participantId: string,
    removeCampParticipantRequest: RemoveCampParticipantRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampParticipantStateResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/participants/${participantId}/remove`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: removeCampParticipantRequest, signal
    },
      options);
    }
  


export const getRemoveCampParticipantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCampParticipant>>, TError,{schoolId: string;campId: string;participantId: string;data: RemoveCampParticipantRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeCampParticipant>>, TError,{schoolId: string;campId: string;participantId: string;data: RemoveCampParticipantRequest}, TContext> => {

const mutationKey = ['removeCampParticipant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCampParticipant>>, {schoolId: string;campId: string;participantId: string;data: RemoveCampParticipantRequest}> = (props) => {
          const {schoolId,campId,participantId,data} = props ?? {};

          return  removeCampParticipant(schoolId,campId,participantId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveCampParticipantMutationResult = NonNullable<Awaited<ReturnType<typeof removeCampParticipant>>>
    export type RemoveCampParticipantMutationBody = RemoveCampParticipantRequest
    export type RemoveCampParticipantMutationError = unknown

    export const useRemoveCampParticipant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCampParticipant>>, TError,{schoolId: string;campId: string;participantId: string;data: RemoveCampParticipantRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeCampParticipant>>,
        TError,
        {schoolId: string;campId: string;participantId: string;data: RemoveCampParticipantRequest},
        TContext
      > => {

      const mutationOptions = getRemoveCampParticipantMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const restoreCampParticipant = (
    schoolId: string,
    campId: string,
    participantId: string,
    restoreCampParticipantRequest: RestoreCampParticipantRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampParticipantStateResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/participants/${participantId}/restore`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: restoreCampParticipantRequest, signal
    },
      options);
    }
  


export const getRestoreCampParticipantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreCampParticipant>>, TError,{schoolId: string;campId: string;participantId: string;data: RestoreCampParticipantRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreCampParticipant>>, TError,{schoolId: string;campId: string;participantId: string;data: RestoreCampParticipantRequest}, TContext> => {

const mutationKey = ['restoreCampParticipant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreCampParticipant>>, {schoolId: string;campId: string;participantId: string;data: RestoreCampParticipantRequest}> = (props) => {
          const {schoolId,campId,participantId,data} = props ?? {};

          return  restoreCampParticipant(schoolId,campId,participantId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RestoreCampParticipantMutationResult = NonNullable<Awaited<ReturnType<typeof restoreCampParticipant>>>
    export type RestoreCampParticipantMutationBody = RestoreCampParticipantRequest
    export type RestoreCampParticipantMutationError = unknown

    export const useRestoreCampParticipant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreCampParticipant>>, TError,{schoolId: string;campId: string;participantId: string;data: RestoreCampParticipantRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof restoreCampParticipant>>,
        TError,
        {schoolId: string;campId: string;participantId: string;data: RestoreCampParticipantRequest},
        TContext
      > => {

      const mutationOptions = getRestoreCampParticipantMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const sendCampWaitlistOffers = (
    schoolId: string,
    campId: string,
    sendCampWaitlistOffersRequest: SendCampWaitlistOffersRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampParticipantStateResponse[]>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/waitlist/offers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendCampWaitlistOffersRequest, signal
    },
      options);
    }
  


export const getSendCampWaitlistOffersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCampWaitlistOffers>>, TError,{schoolId: string;campId: string;data: SendCampWaitlistOffersRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendCampWaitlistOffers>>, TError,{schoolId: string;campId: string;data: SendCampWaitlistOffersRequest}, TContext> => {

const mutationKey = ['sendCampWaitlistOffers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendCampWaitlistOffers>>, {schoolId: string;campId: string;data: SendCampWaitlistOffersRequest}> = (props) => {
          const {schoolId,campId,data} = props ?? {};

          return  sendCampWaitlistOffers(schoolId,campId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendCampWaitlistOffersMutationResult = NonNullable<Awaited<ReturnType<typeof sendCampWaitlistOffers>>>
    export type SendCampWaitlistOffersMutationBody = SendCampWaitlistOffersRequest
    export type SendCampWaitlistOffersMutationError = unknown

    export const useSendCampWaitlistOffers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCampWaitlistOffers>>, TError,{schoolId: string;campId: string;data: SendCampWaitlistOffersRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendCampWaitlistOffers>>,
        TError,
        {schoolId: string;campId: string;data: SendCampWaitlistOffersRequest},
        TContext
      > => {

      const mutationOptions = getSendCampWaitlistOffersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const promoteCampParticipant = (
    schoolId: string,
    campId: string,
    participantId: string,
    promoteCampParticipantRequest: PromoteCampParticipantRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampParticipantStateResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/participants/${participantId}/promote`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: promoteCampParticipantRequest, signal
    },
      options);
    }
  


export const getPromoteCampParticipantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteCampParticipant>>, TError,{schoolId: string;campId: string;participantId: string;data: PromoteCampParticipantRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof promoteCampParticipant>>, TError,{schoolId: string;campId: string;participantId: string;data: PromoteCampParticipantRequest}, TContext> => {

const mutationKey = ['promoteCampParticipant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof promoteCampParticipant>>, {schoolId: string;campId: string;participantId: string;data: PromoteCampParticipantRequest}> = (props) => {
          const {schoolId,campId,participantId,data} = props ?? {};

          return  promoteCampParticipant(schoolId,campId,participantId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PromoteCampParticipantMutationResult = NonNullable<Awaited<ReturnType<typeof promoteCampParticipant>>>
    export type PromoteCampParticipantMutationBody = PromoteCampParticipantRequest
    export type PromoteCampParticipantMutationError = unknown

    export const usePromoteCampParticipant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteCampParticipant>>, TError,{schoolId: string;campId: string;participantId: string;data: PromoteCampParticipantRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof promoteCampParticipant>>,
        TError,
        {schoolId: string;campId: string;participantId: string;data: PromoteCampParticipantRequest},
        TContext
      > => {

      const mutationOptions = getPromoteCampParticipantMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listCampPayments = (
    schoolId: string,
    campId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampPaymentsResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/payments`, method: 'GET', signal
    },
      options);
    }
  



export const getListCampPaymentsQueryKey = (schoolId?: string,
    campId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/camps/${campId}/payments`
    ] as const;
    }

    
export const getListCampPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof listCampPayments>>, TError = unknown>(schoolId: string,
    campId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCampPaymentsQueryKey(schoolId,campId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCampPayments>>> = ({ signal }) => listCampPayments(schoolId,campId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && campId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCampPayments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCampPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof listCampPayments>>>
export type ListCampPaymentsQueryError = unknown


export function useListCampPayments<TData = Awaited<ReturnType<typeof listCampPayments>>, TError = unknown>(
 schoolId: string,
    campId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampPayments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampPayments>>,
          TError,
          Awaited<ReturnType<typeof listCampPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampPayments<TData = Awaited<ReturnType<typeof listCampPayments>>, TError = unknown>(
 schoolId: string,
    campId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampPayments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampPayments>>,
          TError,
          Awaited<ReturnType<typeof listCampPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampPayments<TData = Awaited<ReturnType<typeof listCampPayments>>, TError = unknown>(
 schoolId: string,
    campId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCampPayments<TData = Awaited<ReturnType<typeof listCampPayments>>, TError = unknown>(
 schoolId: string,
    campId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCampPaymentsQueryOptions(schoolId,campId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const confirmCampPaymentDeclaration = (
    schoolId: string,
    campId: string,
    declarationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampPaymentDeclarationResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/payment-declarations/${declarationId}/confirm`, method: 'POST', signal
    },
      options);
    }
  


export const getConfirmCampPaymentDeclarationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCampPaymentDeclaration>>, TError,{schoolId: string;campId: string;declarationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmCampPaymentDeclaration>>, TError,{schoolId: string;campId: string;declarationId: string}, TContext> => {

const mutationKey = ['confirmCampPaymentDeclaration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmCampPaymentDeclaration>>, {schoolId: string;campId: string;declarationId: string}> = (props) => {
          const {schoolId,campId,declarationId} = props ?? {};

          return  confirmCampPaymentDeclaration(schoolId,campId,declarationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmCampPaymentDeclarationMutationResult = NonNullable<Awaited<ReturnType<typeof confirmCampPaymentDeclaration>>>
    
    export type ConfirmCampPaymentDeclarationMutationError = unknown

    export const useConfirmCampPaymentDeclaration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCampPaymentDeclaration>>, TError,{schoolId: string;campId: string;declarationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmCampPaymentDeclaration>>,
        TError,
        {schoolId: string;campId: string;declarationId: string},
        TContext
      > => {

      const mutationOptions = getConfirmCampPaymentDeclarationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const rejectCampPaymentDeclaration = (
    schoolId: string,
    campId: string,
    declarationId: string,
    rejectCampPaymentDeclarationRequest: RejectCampPaymentDeclarationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampPaymentDeclarationResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/payment-declarations/${declarationId}/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rejectCampPaymentDeclarationRequest, signal
    },
      options);
    }
  


export const getRejectCampPaymentDeclarationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectCampPaymentDeclaration>>, TError,{schoolId: string;campId: string;declarationId: string;data: RejectCampPaymentDeclarationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectCampPaymentDeclaration>>, TError,{schoolId: string;campId: string;declarationId: string;data: RejectCampPaymentDeclarationRequest}, TContext> => {

const mutationKey = ['rejectCampPaymentDeclaration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectCampPaymentDeclaration>>, {schoolId: string;campId: string;declarationId: string;data: RejectCampPaymentDeclarationRequest}> = (props) => {
          const {schoolId,campId,declarationId,data} = props ?? {};

          return  rejectCampPaymentDeclaration(schoolId,campId,declarationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectCampPaymentDeclarationMutationResult = NonNullable<Awaited<ReturnType<typeof rejectCampPaymentDeclaration>>>
    export type RejectCampPaymentDeclarationMutationBody = RejectCampPaymentDeclarationRequest
    export type RejectCampPaymentDeclarationMutationError = unknown

    export const useRejectCampPaymentDeclaration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectCampPaymentDeclaration>>, TError,{schoolId: string;campId: string;declarationId: string;data: RejectCampPaymentDeclarationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectCampPaymentDeclaration>>,
        TError,
        {schoolId: string;campId: string;declarationId: string;data: RejectCampPaymentDeclarationRequest},
        TContext
      > => {

      const mutationOptions = getRejectCampPaymentDeclarationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const recordCampPayment = (
    schoolId: string,
    campId: string,
    participantId: string,
    recordCampPaymentRequest: RecordCampPaymentRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampParticipantPaymentsResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/participants/${participantId}/payments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: recordCampPaymentRequest, signal
    },
      options);
    }
  


export const getRecordCampPaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordCampPayment>>, TError,{schoolId: string;campId: string;participantId: string;data: RecordCampPaymentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof recordCampPayment>>, TError,{schoolId: string;campId: string;participantId: string;data: RecordCampPaymentRequest}, TContext> => {

const mutationKey = ['recordCampPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordCampPayment>>, {schoolId: string;campId: string;participantId: string;data: RecordCampPaymentRequest}> = (props) => {
          const {schoolId,campId,participantId,data} = props ?? {};

          return  recordCampPayment(schoolId,campId,participantId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RecordCampPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof recordCampPayment>>>
    export type RecordCampPaymentMutationBody = RecordCampPaymentRequest
    export type RecordCampPaymentMutationError = unknown

    export const useRecordCampPayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordCampPayment>>, TError,{schoolId: string;campId: string;participantId: string;data: RecordCampPaymentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordCampPayment>>,
        TError,
        {schoolId: string;campId: string;participantId: string;data: RecordCampPaymentRequest},
        TContext
      > => {

      const mutationOptions = getRecordCampPaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listCampCancellations = (
    schoolId: string,
    campId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampCancellationResponse[]>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/cancellations`, method: 'GET', signal
    },
      options);
    }
  



export const getListCampCancellationsQueryKey = (schoolId?: string,
    campId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/camps/${campId}/cancellations`
    ] as const;
    }

    
export const getListCampCancellationsQueryOptions = <TData = Awaited<ReturnType<typeof listCampCancellations>>, TError = unknown>(schoolId: string,
    campId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampCancellations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCampCancellationsQueryKey(schoolId,campId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCampCancellations>>> = ({ signal }) => listCampCancellations(schoolId,campId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && campId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCampCancellations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCampCancellationsQueryResult = NonNullable<Awaited<ReturnType<typeof listCampCancellations>>>
export type ListCampCancellationsQueryError = unknown


export function useListCampCancellations<TData = Awaited<ReturnType<typeof listCampCancellations>>, TError = unknown>(
 schoolId: string,
    campId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampCancellations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampCancellations>>,
          TError,
          Awaited<ReturnType<typeof listCampCancellations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampCancellations<TData = Awaited<ReturnType<typeof listCampCancellations>>, TError = unknown>(
 schoolId: string,
    campId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampCancellations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampCancellations>>,
          TError,
          Awaited<ReturnType<typeof listCampCancellations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampCancellations<TData = Awaited<ReturnType<typeof listCampCancellations>>, TError = unknown>(
 schoolId: string,
    campId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampCancellations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCampCancellations<TData = Awaited<ReturnType<typeof listCampCancellations>>, TError = unknown>(
 schoolId: string,
    campId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampCancellations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCampCancellationsQueryOptions(schoolId,campId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getCampRefundPreview = (
    schoolId: string,
    campId: string,
    participantId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampRefundPreviewResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/participants/${participantId}/refund-preview`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCampRefundPreviewQueryKey = (schoolId?: string,
    campId?: string,
    participantId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/camps/${campId}/participants/${participantId}/refund-preview`
    ] as const;
    }

    
export const getGetCampRefundPreviewQueryOptions = <TData = Awaited<ReturnType<typeof getCampRefundPreview>>, TError = unknown>(schoolId: string,
    campId: string,
    participantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampRefundPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampRefundPreviewQueryKey(schoolId,campId,participantId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampRefundPreview>>> = ({ signal }) => getCampRefundPreview(schoolId,campId,participantId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && campId && participantId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampRefundPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampRefundPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getCampRefundPreview>>>
export type GetCampRefundPreviewQueryError = unknown


export function useGetCampRefundPreview<TData = Awaited<ReturnType<typeof getCampRefundPreview>>, TError = unknown>(
 schoolId: string,
    campId: string,
    participantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampRefundPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampRefundPreview>>,
          TError,
          Awaited<ReturnType<typeof getCampRefundPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampRefundPreview<TData = Awaited<ReturnType<typeof getCampRefundPreview>>, TError = unknown>(
 schoolId: string,
    campId: string,
    participantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampRefundPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampRefundPreview>>,
          TError,
          Awaited<ReturnType<typeof getCampRefundPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampRefundPreview<TData = Awaited<ReturnType<typeof getCampRefundPreview>>, TError = unknown>(
 schoolId: string,
    campId: string,
    participantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampRefundPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCampRefundPreview<TData = Awaited<ReturnType<typeof getCampRefundPreview>>, TError = unknown>(
 schoolId: string,
    campId: string,
    participantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampRefundPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampRefundPreviewQueryOptions(schoolId,campId,participantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const cancelCampParticipant = (
    schoolId: string,
    campId: string,
    participantId: string,
    cancelCampParticipantRequest: CancelCampParticipantRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampCancellationResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/participants/${participantId}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelCampParticipantRequest, signal
    },
      options);
    }
  


export const getCancelCampParticipantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelCampParticipant>>, TError,{schoolId: string;campId: string;participantId: string;data: CancelCampParticipantRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelCampParticipant>>, TError,{schoolId: string;campId: string;participantId: string;data: CancelCampParticipantRequest}, TContext> => {

const mutationKey = ['cancelCampParticipant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelCampParticipant>>, {schoolId: string;campId: string;participantId: string;data: CancelCampParticipantRequest}> = (props) => {
          const {schoolId,campId,participantId,data} = props ?? {};

          return  cancelCampParticipant(schoolId,campId,participantId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelCampParticipantMutationResult = NonNullable<Awaited<ReturnType<typeof cancelCampParticipant>>>
    export type CancelCampParticipantMutationBody = CancelCampParticipantRequest
    export type CancelCampParticipantMutationError = unknown

    export const useCancelCampParticipant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelCampParticipant>>, TError,{schoolId: string;campId: string;participantId: string;data: CancelCampParticipantRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelCampParticipant>>,
        TError,
        {schoolId: string;campId: string;participantId: string;data: CancelCampParticipantRequest},
        TContext
      > => {

      const mutationOptions = getCancelCampParticipantMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listAvailableCamps = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AvailableCampResponse[]>(
      {url: `/api/v1/schools/${schoolId}/camps/available`, method: 'GET', signal
    },
      options);
    }
  



export const getListAvailableCampsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/camps/available`
    ] as const;
    }

    
export const getListAvailableCampsQueryOptions = <TData = Awaited<ReturnType<typeof listAvailableCamps>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableCamps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAvailableCampsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAvailableCamps>>> = ({ signal }) => listAvailableCamps(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAvailableCamps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAvailableCampsQueryResult = NonNullable<Awaited<ReturnType<typeof listAvailableCamps>>>
export type ListAvailableCampsQueryError = unknown


export function useListAvailableCamps<TData = Awaited<ReturnType<typeof listAvailableCamps>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableCamps>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableCamps>>,
          TError,
          Awaited<ReturnType<typeof listAvailableCamps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAvailableCamps<TData = Awaited<ReturnType<typeof listAvailableCamps>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableCamps>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableCamps>>,
          TError,
          Awaited<ReturnType<typeof listAvailableCamps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAvailableCamps<TData = Awaited<ReturnType<typeof listAvailableCamps>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableCamps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAvailableCamps<TData = Awaited<ReturnType<typeof listAvailableCamps>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableCamps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAvailableCampsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getCampRegistrationPage = (
    schoolId: string,
    slug: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampRegistrationPageResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/by-slug/${slug}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCampRegistrationPageQueryKey = (schoolId?: string,
    slug?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/camps/by-slug/${slug}`
    ] as const;
    }

    
export const getGetCampRegistrationPageQueryOptions = <TData = Awaited<ReturnType<typeof getCampRegistrationPage>>, TError = unknown>(schoolId: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampRegistrationPage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampRegistrationPageQueryKey(schoolId,slug);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampRegistrationPage>>> = ({ signal }) => getCampRegistrationPage(schoolId,slug, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && slug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampRegistrationPage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampRegistrationPageQueryResult = NonNullable<Awaited<ReturnType<typeof getCampRegistrationPage>>>
export type GetCampRegistrationPageQueryError = unknown


export function useGetCampRegistrationPage<TData = Awaited<ReturnType<typeof getCampRegistrationPage>>, TError = unknown>(
 schoolId: string,
    slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampRegistrationPage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampRegistrationPage>>,
          TError,
          Awaited<ReturnType<typeof getCampRegistrationPage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampRegistrationPage<TData = Awaited<ReturnType<typeof getCampRegistrationPage>>, TError = unknown>(
 schoolId: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampRegistrationPage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampRegistrationPage>>,
          TError,
          Awaited<ReturnType<typeof getCampRegistrationPage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampRegistrationPage<TData = Awaited<ReturnType<typeof getCampRegistrationPage>>, TError = unknown>(
 schoolId: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampRegistrationPage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCampRegistrationPage<TData = Awaited<ReturnType<typeof getCampRegistrationPage>>, TError = unknown>(
 schoolId: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampRegistrationPage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampRegistrationPageQueryOptions(schoolId,slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const quoteCampRegistration = (
    schoolId: string,
    campId: string,
    campRegistrationRequest: CampRegistrationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampQuoteResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/registrations/quote`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: campRegistrationRequest, signal
    },
      options);
    }
  


export const getQuoteCampRegistrationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quoteCampRegistration>>, TError,{schoolId: string;campId: string;data: CampRegistrationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof quoteCampRegistration>>, TError,{schoolId: string;campId: string;data: CampRegistrationRequest}, TContext> => {

const mutationKey = ['quoteCampRegistration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof quoteCampRegistration>>, {schoolId: string;campId: string;data: CampRegistrationRequest}> = (props) => {
          const {schoolId,campId,data} = props ?? {};

          return  quoteCampRegistration(schoolId,campId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type QuoteCampRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof quoteCampRegistration>>>
    export type QuoteCampRegistrationMutationBody = CampRegistrationRequest
    export type QuoteCampRegistrationMutationError = unknown

    export const useQuoteCampRegistration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quoteCampRegistration>>, TError,{schoolId: string;campId: string;data: CampRegistrationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof quoteCampRegistration>>,
        TError,
        {schoolId: string;campId: string;data: CampRegistrationRequest},
        TContext
      > => {

      const mutationOptions = getQuoteCampRegistrationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const submitCampRegistration = (
    schoolId: string,
    campId: string,
    campRegistrationRequest: CampRegistrationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampRegistrationResultResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/registrations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: campRegistrationRequest, signal
    },
      options);
    }
  


export const getSubmitCampRegistrationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCampRegistration>>, TError,{schoolId: string;campId: string;data: CampRegistrationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof submitCampRegistration>>, TError,{schoolId: string;campId: string;data: CampRegistrationRequest}, TContext> => {

const mutationKey = ['submitCampRegistration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitCampRegistration>>, {schoolId: string;campId: string;data: CampRegistrationRequest}> = (props) => {
          const {schoolId,campId,data} = props ?? {};

          return  submitCampRegistration(schoolId,campId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitCampRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof submitCampRegistration>>>
    export type SubmitCampRegistrationMutationBody = CampRegistrationRequest
    export type SubmitCampRegistrationMutationError = unknown

    export const useSubmitCampRegistration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCampRegistration>>, TError,{schoolId: string;campId: string;data: CampRegistrationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitCampRegistration>>,
        TError,
        {schoolId: string;campId: string;data: CampRegistrationRequest},
        TContext
      > => {

      const mutationOptions = getSubmitCampRegistrationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const inviteCampFriend = (
    schoolId: string,
    campId: string,
    inviteCampFriendRequest: InviteCampFriendRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/camps/${campId}/invitations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteCampFriendRequest, signal
    },
      options);
    }
  


export const getInviteCampFriendMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteCampFriend>>, TError,{schoolId: string;campId: string;data: InviteCampFriendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteCampFriend>>, TError,{schoolId: string;campId: string;data: InviteCampFriendRequest}, TContext> => {

const mutationKey = ['inviteCampFriend'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteCampFriend>>, {schoolId: string;campId: string;data: InviteCampFriendRequest}> = (props) => {
          const {schoolId,campId,data} = props ?? {};

          return  inviteCampFriend(schoolId,campId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InviteCampFriendMutationResult = NonNullable<Awaited<ReturnType<typeof inviteCampFriend>>>
    export type InviteCampFriendMutationBody = InviteCampFriendRequest
    export type InviteCampFriendMutationError = unknown

    export const useInviteCampFriend = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteCampFriend>>, TError,{schoolId: string;campId: string;data: InviteCampFriendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteCampFriend>>,
        TError,
        {schoolId: string;campId: string;data: InviteCampFriendRequest},
        TContext
      > => {

      const mutationOptions = getInviteCampFriendMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const payCampParticipantOnline = (
    schoolId: string,
    participantId: string,
    params: PayCampParticipantOnlineParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GatewayTransactionResult>(
      {url: `/api/v1/schools/${schoolId}/camps/participants/${participantId}/pay-online`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPayCampParticipantOnlineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof payCampParticipantOnline>>, TError,{schoolId: string;participantId: string;params: PayCampParticipantOnlineParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof payCampParticipantOnline>>, TError,{schoolId: string;participantId: string;params: PayCampParticipantOnlineParams}, TContext> => {

const mutationKey = ['payCampParticipantOnline'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof payCampParticipantOnline>>, {schoolId: string;participantId: string;params: PayCampParticipantOnlineParams}> = (props) => {
          const {schoolId,participantId,params} = props ?? {};

          return  payCampParticipantOnline(schoolId,participantId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PayCampParticipantOnlineMutationResult = NonNullable<Awaited<ReturnType<typeof payCampParticipantOnline>>>
    
    export type PayCampParticipantOnlineMutationError = unknown

    export const usePayCampParticipantOnline = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof payCampParticipantOnline>>, TError,{schoolId: string;participantId: string;params: PayCampParticipantOnlineParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof payCampParticipantOnline>>,
        TError,
        {schoolId: string;participantId: string;params: PayCampParticipantOnlineParams},
        TContext
      > => {

      const mutationOptions = getPayCampParticipantOnlineMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const declareCampPayment = (
    schoolId: string,
    participantId: string,
    declareCampPaymentRequest: DeclareCampPaymentRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampPaymentDeclarationSummaryResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/participants/${participantId}/payment-declarations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: declareCampPaymentRequest, signal
    },
      options);
    }
  


export const getDeclareCampPaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declareCampPayment>>, TError,{schoolId: string;participantId: string;data: DeclareCampPaymentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof declareCampPayment>>, TError,{schoolId: string;participantId: string;data: DeclareCampPaymentRequest}, TContext> => {

const mutationKey = ['declareCampPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declareCampPayment>>, {schoolId: string;participantId: string;data: DeclareCampPaymentRequest}> = (props) => {
          const {schoolId,participantId,data} = props ?? {};

          return  declareCampPayment(schoolId,participantId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeclareCampPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof declareCampPayment>>>
    export type DeclareCampPaymentMutationBody = DeclareCampPaymentRequest
    export type DeclareCampPaymentMutationError = unknown

    export const useDeclareCampPayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declareCampPayment>>, TError,{schoolId: string;participantId: string;data: DeclareCampPaymentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof declareCampPayment>>,
        TError,
        {schoolId: string;participantId: string;data: DeclareCampPaymentRequest},
        TContext
      > => {

      const mutationOptions = getDeclareCampPaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getMyCampRefundPreview = (
    schoolId: string,
    participantId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampRefundPreviewResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/participants/${participantId}/refund-preview`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMyCampRefundPreviewQueryKey = (schoolId?: string,
    participantId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/camps/participants/${participantId}/refund-preview`
    ] as const;
    }

    
export const getGetMyCampRefundPreviewQueryOptions = <TData = Awaited<ReturnType<typeof getMyCampRefundPreview>>, TError = unknown>(schoolId: string,
    participantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCampRefundPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyCampRefundPreviewQueryKey(schoolId,participantId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCampRefundPreview>>> = ({ signal }) => getMyCampRefundPreview(schoolId,participantId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && participantId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyCampRefundPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyCampRefundPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getMyCampRefundPreview>>>
export type GetMyCampRefundPreviewQueryError = unknown


export function useGetMyCampRefundPreview<TData = Awaited<ReturnType<typeof getMyCampRefundPreview>>, TError = unknown>(
 schoolId: string,
    participantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCampRefundPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyCampRefundPreview>>,
          TError,
          Awaited<ReturnType<typeof getMyCampRefundPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyCampRefundPreview<TData = Awaited<ReturnType<typeof getMyCampRefundPreview>>, TError = unknown>(
 schoolId: string,
    participantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCampRefundPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyCampRefundPreview>>,
          TError,
          Awaited<ReturnType<typeof getMyCampRefundPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyCampRefundPreview<TData = Awaited<ReturnType<typeof getMyCampRefundPreview>>, TError = unknown>(
 schoolId: string,
    participantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCampRefundPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyCampRefundPreview<TData = Awaited<ReturnType<typeof getMyCampRefundPreview>>, TError = unknown>(
 schoolId: string,
    participantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCampRefundPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyCampRefundPreviewQueryOptions(schoolId,participantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const requestCampCancellation = (
    schoolId: string,
    participantId: string,
    requestCampCancellationRequest: RequestCampCancellationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampRefundPreviewResponse>(
      {url: `/api/v1/schools/${schoolId}/camps/participants/${participantId}/cancel-request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestCampCancellationRequest, signal
    },
      options);
    }
  


export const getRequestCampCancellationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCampCancellation>>, TError,{schoolId: string;participantId: string;data: RequestCampCancellationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestCampCancellation>>, TError,{schoolId: string;participantId: string;data: RequestCampCancellationRequest}, TContext> => {

const mutationKey = ['requestCampCancellation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestCampCancellation>>, {schoolId: string;participantId: string;data: RequestCampCancellationRequest}> = (props) => {
          const {schoolId,participantId,data} = props ?? {};

          return  requestCampCancellation(schoolId,participantId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequestCampCancellationMutationResult = NonNullable<Awaited<ReturnType<typeof requestCampCancellation>>>
    export type RequestCampCancellationMutationBody = RequestCampCancellationRequest
    export type RequestCampCancellationMutationError = unknown

    export const useRequestCampCancellation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCampCancellation>>, TError,{schoolId: string;participantId: string;data: RequestCampCancellationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestCampCancellation>>,
        TError,
        {schoolId: string;participantId: string;data: RequestCampCancellationRequest},
        TContext
      > => {

      const mutationOptions = getRequestCampCancellationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getPublicCampTerms = (
    schoolId: string,
    slug: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PublicCampTermsResponse>(
      {url: `/api/v1/public/schools/${schoolId}/camps/${slug}/terms`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPublicCampTermsQueryKey = (schoolId?: string,
    slug?: string,) => {
    return [
    `/api/v1/public/schools/${schoolId}/camps/${slug}/terms`
    ] as const;
    }

    
export const getGetPublicCampTermsQueryOptions = <TData = Awaited<ReturnType<typeof getPublicCampTerms>>, TError = void>(schoolId: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCampTerms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicCampTermsQueryKey(schoolId,slug);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicCampTerms>>> = ({ signal }) => getPublicCampTerms(schoolId,slug, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && slug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicCampTerms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicCampTermsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicCampTerms>>>
export type GetPublicCampTermsQueryError = void


export function useGetPublicCampTerms<TData = Awaited<ReturnType<typeof getPublicCampTerms>>, TError = void>(
 schoolId: string,
    slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCampTerms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicCampTerms>>,
          TError,
          Awaited<ReturnType<typeof getPublicCampTerms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicCampTerms<TData = Awaited<ReturnType<typeof getPublicCampTerms>>, TError = void>(
 schoolId: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCampTerms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicCampTerms>>,
          TError,
          Awaited<ReturnType<typeof getPublicCampTerms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicCampTerms<TData = Awaited<ReturnType<typeof getPublicCampTerms>>, TError = void>(
 schoolId: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCampTerms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicCampTerms<TData = Awaited<ReturnType<typeof getPublicCampTerms>>, TError = void>(
 schoolId: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCampTerms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicCampTermsQueryOptions(schoolId,slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getPublicCampTermsVersion = (
    schoolId: string,
    slug: string,
    version: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PublicCampTermsResponse>(
      {url: `/api/v1/public/schools/${schoolId}/camps/${slug}/terms/versions/${version}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPublicCampTermsVersionQueryKey = (schoolId?: string,
    slug?: string,
    version?: number,) => {
    return [
    `/api/v1/public/schools/${schoolId}/camps/${slug}/terms/versions/${version}`
    ] as const;
    }

    
export const getGetPublicCampTermsVersionQueryOptions = <TData = Awaited<ReturnType<typeof getPublicCampTermsVersion>>, TError = void>(schoolId: string,
    slug: string,
    version: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCampTermsVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicCampTermsVersionQueryKey(schoolId,slug,version);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicCampTermsVersion>>> = ({ signal }) => getPublicCampTermsVersion(schoolId,slug,version, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId && slug && version), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicCampTermsVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicCampTermsVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicCampTermsVersion>>>
export type GetPublicCampTermsVersionQueryError = void


export function useGetPublicCampTermsVersion<TData = Awaited<ReturnType<typeof getPublicCampTermsVersion>>, TError = void>(
 schoolId: string,
    slug: string,
    version: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCampTermsVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicCampTermsVersion>>,
          TError,
          Awaited<ReturnType<typeof getPublicCampTermsVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicCampTermsVersion<TData = Awaited<ReturnType<typeof getPublicCampTermsVersion>>, TError = void>(
 schoolId: string,
    slug: string,
    version: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCampTermsVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicCampTermsVersion>>,
          TError,
          Awaited<ReturnType<typeof getPublicCampTermsVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicCampTermsVersion<TData = Awaited<ReturnType<typeof getPublicCampTermsVersion>>, TError = void>(
 schoolId: string,
    slug: string,
    version: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCampTermsVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicCampTermsVersion<TData = Awaited<ReturnType<typeof getPublicCampTermsVersion>>, TError = void>(
 schoolId: string,
    slug: string,
    version: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCampTermsVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicCampTermsVersionQueryOptions(schoolId,slug,version,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getRacketStringingSettings = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RacketStringingSettingsResponse>(
      {url: `/api/v1/schools/${schoolId}/racket-stringing/settings`, method: 'GET', signal
    },
      options);
    }
  



export const getGetRacketStringingSettingsQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/racket-stringing/settings`
    ] as const;
    }

    
export const getGetRacketStringingSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getRacketStringingSettings>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRacketStringingSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRacketStringingSettingsQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRacketStringingSettings>>> = ({ signal }) => getRacketStringingSettings(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRacketStringingSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRacketStringingSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getRacketStringingSettings>>>
export type GetRacketStringingSettingsQueryError = unknown


export function useGetRacketStringingSettings<TData = Awaited<ReturnType<typeof getRacketStringingSettings>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRacketStringingSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRacketStringingSettings>>,
          TError,
          Awaited<ReturnType<typeof getRacketStringingSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRacketStringingSettings<TData = Awaited<ReturnType<typeof getRacketStringingSettings>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRacketStringingSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRacketStringingSettings>>,
          TError,
          Awaited<ReturnType<typeof getRacketStringingSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRacketStringingSettings<TData = Awaited<ReturnType<typeof getRacketStringingSettings>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRacketStringingSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRacketStringingSettings<TData = Awaited<ReturnType<typeof getRacketStringingSettings>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRacketStringingSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRacketStringingSettingsQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateRacketStringingSettings = (
    schoolId: string,
    updateRacketStringingSettingsRequest: UpdateRacketStringingSettingsRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RacketStringingSettingsResponse>(
      {url: `/api/v1/schools/${schoolId}/racket-stringing/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateRacketStringingSettingsRequest
    },
      options);
    }
  


export const getUpdateRacketStringingSettingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRacketStringingSettings>>, TError,{schoolId: string;data: UpdateRacketStringingSettingsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRacketStringingSettings>>, TError,{schoolId: string;data: UpdateRacketStringingSettingsRequest}, TContext> => {

const mutationKey = ['updateRacketStringingSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRacketStringingSettings>>, {schoolId: string;data: UpdateRacketStringingSettingsRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  updateRacketStringingSettings(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateRacketStringingSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateRacketStringingSettings>>>
    export type UpdateRacketStringingSettingsMutationBody = UpdateRacketStringingSettingsRequest
    export type UpdateRacketStringingSettingsMutationError = unknown

    export const useUpdateRacketStringingSettings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRacketStringingSettings>>, TError,{schoolId: string;data: UpdateRacketStringingSettingsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRacketStringingSettings>>,
        TError,
        {schoolId: string;data: UpdateRacketStringingSettingsRequest},
        TContext
      > => {

      const mutationOptions = getUpdateRacketStringingSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listMyRacketStringingOrders = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RacketStringingOrderResponse[]>(
      {url: `/api/v1/schools/${schoolId}/racket-stringing/my-orders`, method: 'GET', signal
    },
      options);
    }
  



export const getListMyRacketStringingOrdersQueryKey = (schoolId?: string,) => {
    return [
    `/api/v1/schools/${schoolId}/racket-stringing/my-orders`
    ] as const;
    }

    
export const getListMyRacketStringingOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listMyRacketStringingOrders>>, TError = unknown>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyRacketStringingOrders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyRacketStringingOrdersQueryKey(schoolId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyRacketStringingOrders>>> = ({ signal }) => listMyRacketStringingOrders(schoolId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyRacketStringingOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMyRacketStringingOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listMyRacketStringingOrders>>>
export type ListMyRacketStringingOrdersQueryError = unknown


export function useListMyRacketStringingOrders<TData = Awaited<ReturnType<typeof listMyRacketStringingOrders>>, TError = unknown>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyRacketStringingOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyRacketStringingOrders>>,
          TError,
          Awaited<ReturnType<typeof listMyRacketStringingOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyRacketStringingOrders<TData = Awaited<ReturnType<typeof listMyRacketStringingOrders>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyRacketStringingOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyRacketStringingOrders>>,
          TError,
          Awaited<ReturnType<typeof listMyRacketStringingOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyRacketStringingOrders<TData = Awaited<ReturnType<typeof listMyRacketStringingOrders>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyRacketStringingOrders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListMyRacketStringingOrders<TData = Awaited<ReturnType<typeof listMyRacketStringingOrders>>, TError = unknown>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyRacketStringingOrders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyRacketStringingOrdersQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createRacketStringingOrder = (
    schoolId: string,
    createRacketStringingOrderRequest: CreateRacketStringingOrderRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RacketStringingOrderResponse>(
      {url: `/api/v1/schools/${schoolId}/racket-stringing/my-orders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRacketStringingOrderRequest, signal
    },
      options);
    }
  


export const getCreateRacketStringingOrderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRacketStringingOrder>>, TError,{schoolId: string;data: CreateRacketStringingOrderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createRacketStringingOrder>>, TError,{schoolId: string;data: CreateRacketStringingOrderRequest}, TContext> => {

const mutationKey = ['createRacketStringingOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRacketStringingOrder>>, {schoolId: string;data: CreateRacketStringingOrderRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createRacketStringingOrder(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateRacketStringingOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createRacketStringingOrder>>>
    export type CreateRacketStringingOrderMutationBody = CreateRacketStringingOrderRequest
    export type CreateRacketStringingOrderMutationError = unknown

    export const useCreateRacketStringingOrder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRacketStringingOrder>>, TError,{schoolId: string;data: CreateRacketStringingOrderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRacketStringingOrder>>,
        TError,
        {schoolId: string;data: CreateRacketStringingOrderRequest},
        TContext
      > => {

      const mutationOptions = getCreateRacketStringingOrderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const cancelMyRacketStringingOrder = (
    schoolId: string,
    orderId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RacketStringingOrderResponse>(
      {url: `/api/v1/schools/${schoolId}/racket-stringing/my-orders/${orderId}/cancel`, method: 'POST', signal
    },
      options);
    }
  


export const getCancelMyRacketStringingOrderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelMyRacketStringingOrder>>, TError,{schoolId: string;orderId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelMyRacketStringingOrder>>, TError,{schoolId: string;orderId: string}, TContext> => {

const mutationKey = ['cancelMyRacketStringingOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelMyRacketStringingOrder>>, {schoolId: string;orderId: string}> = (props) => {
          const {schoolId,orderId} = props ?? {};

          return  cancelMyRacketStringingOrder(schoolId,orderId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelMyRacketStringingOrderMutationResult = NonNullable<Awaited<ReturnType<typeof cancelMyRacketStringingOrder>>>
    
    export type CancelMyRacketStringingOrderMutationError = unknown

    export const useCancelMyRacketStringingOrder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelMyRacketStringingOrder>>, TError,{schoolId: string;orderId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelMyRacketStringingOrder>>,
        TError,
        {schoolId: string;orderId: string},
        TContext
      > => {

      const mutationOptions = getCancelMyRacketStringingOrderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listRacketStringingOrders = (
    schoolId: string,
    params?: ListRacketStringingOrdersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RacketStringingOrderListResponse>(
      {url: `/api/v1/schools/${schoolId}/racket-stringing/orders`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListRacketStringingOrdersQueryKey = (schoolId?: string,
    params?: ListRacketStringingOrdersParams,) => {
    return [
    `/api/v1/schools/${schoolId}/racket-stringing/orders`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListRacketStringingOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listRacketStringingOrders>>, TError = unknown>(schoolId: string,
    params?: ListRacketStringingOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRacketStringingOrders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRacketStringingOrdersQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRacketStringingOrders>>> = ({ signal }) => listRacketStringingOrders(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRacketStringingOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRacketStringingOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listRacketStringingOrders>>>
export type ListRacketStringingOrdersQueryError = unknown


export function useListRacketStringingOrders<TData = Awaited<ReturnType<typeof listRacketStringingOrders>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListRacketStringingOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRacketStringingOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRacketStringingOrders>>,
          TError,
          Awaited<ReturnType<typeof listRacketStringingOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRacketStringingOrders<TData = Awaited<ReturnType<typeof listRacketStringingOrders>>, TError = unknown>(
 schoolId: string,
    params?: ListRacketStringingOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRacketStringingOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRacketStringingOrders>>,
          TError,
          Awaited<ReturnType<typeof listRacketStringingOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRacketStringingOrders<TData = Awaited<ReturnType<typeof listRacketStringingOrders>>, TError = unknown>(
 schoolId: string,
    params?: ListRacketStringingOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRacketStringingOrders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListRacketStringingOrders<TData = Awaited<ReturnType<typeof listRacketStringingOrders>>, TError = unknown>(
 schoolId: string,
    params?: ListRacketStringingOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRacketStringingOrders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRacketStringingOrdersQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateRacketStringingOrder = (
    schoolId: string,
    orderId: string,
    updateRacketStringingOrderRequest: UpdateRacketStringingOrderRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RacketStringingOrderResponse>(
      {url: `/api/v1/schools/${schoolId}/racket-stringing/orders/${orderId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateRacketStringingOrderRequest
    },
      options);
    }
  


export const getUpdateRacketStringingOrderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRacketStringingOrder>>, TError,{schoolId: string;orderId: string;data: UpdateRacketStringingOrderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRacketStringingOrder>>, TError,{schoolId: string;orderId: string;data: UpdateRacketStringingOrderRequest}, TContext> => {

const mutationKey = ['updateRacketStringingOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRacketStringingOrder>>, {schoolId: string;orderId: string;data: UpdateRacketStringingOrderRequest}> = (props) => {
          const {schoolId,orderId,data} = props ?? {};

          return  updateRacketStringingOrder(schoolId,orderId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateRacketStringingOrderMutationResult = NonNullable<Awaited<ReturnType<typeof updateRacketStringingOrder>>>
    export type UpdateRacketStringingOrderMutationBody = UpdateRacketStringingOrderRequest
    export type UpdateRacketStringingOrderMutationError = unknown

    export const useUpdateRacketStringingOrder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRacketStringingOrder>>, TError,{schoolId: string;orderId: string;data: UpdateRacketStringingOrderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRacketStringingOrder>>,
        TError,
        {schoolId: string;orderId: string;data: UpdateRacketStringingOrderRequest},
        TContext
      > => {

      const mutationOptions = getUpdateRacketStringingOrderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listRacketStringers = (
    schoolId: string,
    params?: ListRacketStringersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RacketStringerResponse[]>(
      {url: `/api/v1/schools/${schoolId}/racket-stringing/stringers`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListRacketStringersQueryKey = (schoolId?: string,
    params?: ListRacketStringersParams,) => {
    return [
    `/api/v1/schools/${schoolId}/racket-stringing/stringers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListRacketStringersQueryOptions = <TData = Awaited<ReturnType<typeof listRacketStringers>>, TError = unknown>(schoolId: string,
    params?: ListRacketStringersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRacketStringers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRacketStringersQueryKey(schoolId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRacketStringers>>> = ({ signal }) => listRacketStringers(schoolId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(schoolId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRacketStringers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRacketStringersQueryResult = NonNullable<Awaited<ReturnType<typeof listRacketStringers>>>
export type ListRacketStringersQueryError = unknown


export function useListRacketStringers<TData = Awaited<ReturnType<typeof listRacketStringers>>, TError = unknown>(
 schoolId: string,
    params: undefined |  ListRacketStringersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRacketStringers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRacketStringers>>,
          TError,
          Awaited<ReturnType<typeof listRacketStringers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRacketStringers<TData = Awaited<ReturnType<typeof listRacketStringers>>, TError = unknown>(
 schoolId: string,
    params?: ListRacketStringersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRacketStringers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRacketStringers>>,
          TError,
          Awaited<ReturnType<typeof listRacketStringers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRacketStringers<TData = Awaited<ReturnType<typeof listRacketStringers>>, TError = unknown>(
 schoolId: string,
    params?: ListRacketStringersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRacketStringers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListRacketStringers<TData = Awaited<ReturnType<typeof listRacketStringers>>, TError = unknown>(
 schoolId: string,
    params?: ListRacketStringersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRacketStringers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRacketStringersQueryOptions(schoolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createRacketStringer = (
    schoolId: string,
    upsertRacketStringerRequest: UpsertRacketStringerRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RacketStringerResponse>(
      {url: `/api/v1/schools/${schoolId}/racket-stringing/stringers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertRacketStringerRequest, signal
    },
      options);
    }
  


export const getCreateRacketStringerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRacketStringer>>, TError,{schoolId: string;data: UpsertRacketStringerRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createRacketStringer>>, TError,{schoolId: string;data: UpsertRacketStringerRequest}, TContext> => {

const mutationKey = ['createRacketStringer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRacketStringer>>, {schoolId: string;data: UpsertRacketStringerRequest}> = (props) => {
          const {schoolId,data} = props ?? {};

          return  createRacketStringer(schoolId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateRacketStringerMutationResult = NonNullable<Awaited<ReturnType<typeof createRacketStringer>>>
    export type CreateRacketStringerMutationBody = UpsertRacketStringerRequest
    export type CreateRacketStringerMutationError = unknown

    export const useCreateRacketStringer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRacketStringer>>, TError,{schoolId: string;data: UpsertRacketStringerRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRacketStringer>>,
        TError,
        {schoolId: string;data: UpsertRacketStringerRequest},
        TContext
      > => {

      const mutationOptions = getCreateRacketStringerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateRacketStringer = (
    schoolId: string,
    stringerId: string,
    upsertRacketStringerRequest: UpsertRacketStringerRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RacketStringerResponse>(
      {url: `/api/v1/schools/${schoolId}/racket-stringing/stringers/${stringerId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertRacketStringerRequest
    },
      options);
    }
  


export const getUpdateRacketStringerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRacketStringer>>, TError,{schoolId: string;stringerId: string;data: UpsertRacketStringerRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRacketStringer>>, TError,{schoolId: string;stringerId: string;data: UpsertRacketStringerRequest}, TContext> => {

const mutationKey = ['updateRacketStringer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRacketStringer>>, {schoolId: string;stringerId: string;data: UpsertRacketStringerRequest}> = (props) => {
          const {schoolId,stringerId,data} = props ?? {};

          return  updateRacketStringer(schoolId,stringerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateRacketStringerMutationResult = NonNullable<Awaited<ReturnType<typeof updateRacketStringer>>>
    export type UpdateRacketStringerMutationBody = UpsertRacketStringerRequest
    export type UpdateRacketStringerMutationError = unknown

    export const useUpdateRacketStringer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRacketStringer>>, TError,{schoolId: string;stringerId: string;data: UpsertRacketStringerRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRacketStringer>>,
        TError,
        {schoolId: string;stringerId: string;data: UpsertRacketStringerRequest},
        TContext
      > => {

      const mutationOptions = getUpdateRacketStringerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteRacketStringer = (
    schoolId: string,
    stringerId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/schools/${schoolId}/racket-stringing/stringers/${stringerId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteRacketStringerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRacketStringer>>, TError,{schoolId: string;stringerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRacketStringer>>, TError,{schoolId: string;stringerId: string}, TContext> => {

const mutationKey = ['deleteRacketStringer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRacketStringer>>, {schoolId: string;stringerId: string}> = (props) => {
          const {schoolId,stringerId} = props ?? {};

          return  deleteRacketStringer(schoolId,stringerId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRacketStringerMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRacketStringer>>>
    
    export type DeleteRacketStringerMutationError = unknown

    export const useDeleteRacketStringer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRacketStringer>>, TError,{schoolId: string;stringerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRacketStringer>>,
        TError,
        {schoolId: string;stringerId: string},
        TContext
      > => {

      const mutationOptions = getDeleteRacketStringerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setCoachRacketStringingAccess = (
    schoolId: string,
    coachMemberId: string,
    updateCoachRacketStringingAccessRequest: UpdateCoachRacketStringingAccessRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CoachRacketStringingAccessResponse>(
      {url: `/api/v1/schools/${schoolId}/racket-stringing/coaches/${coachMemberId}/access`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCoachRacketStringingAccessRequest
    },
      options);
    }
  


export const getSetCoachRacketStringingAccessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCoachRacketStringingAccess>>, TError,{schoolId: string;coachMemberId: string;data: UpdateCoachRacketStringingAccessRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setCoachRacketStringingAccess>>, TError,{schoolId: string;coachMemberId: string;data: UpdateCoachRacketStringingAccessRequest}, TContext> => {

const mutationKey = ['setCoachRacketStringingAccess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setCoachRacketStringingAccess>>, {schoolId: string;coachMemberId: string;data: UpdateCoachRacketStringingAccessRequest}> = (props) => {
          const {schoolId,coachMemberId,data} = props ?? {};

          return  setCoachRacketStringingAccess(schoolId,coachMemberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetCoachRacketStringingAccessMutationResult = NonNullable<Awaited<ReturnType<typeof setCoachRacketStringingAccess>>>
    export type SetCoachRacketStringingAccessMutationBody = UpdateCoachRacketStringingAccessRequest
    export type SetCoachRacketStringingAccessMutationError = unknown

    export const useSetCoachRacketStringingAccess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCoachRacketStringingAccess>>, TError,{schoolId: string;coachMemberId: string;data: UpdateCoachRacketStringingAccessRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setCoachRacketStringingAccess>>,
        TError,
        {schoolId: string;coachMemberId: string;data: UpdateCoachRacketStringingAccessRequest},
        TContext
      > => {

      const mutationOptions = getSetCoachRacketStringingAccessMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
